// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 version=%271.1%27 width=%2732%27 height=%2724%27 viewBox=%270 0 32 24%27><polygon points=%270,0 32,0 16,24%27 style=%27fill: rgb%2851, 51, 51%29%27></polygon></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIpJREFUeNrEkckNgDAMBBfRkEt0ObRBBdsGXUDgmQfK4XhH2m8czQAAy27R3tsw4Qfe2x8uOO6oYLb6GlOor3GF+swURAOmUJ+RwtEJs9WvTGEYxBXqI1MQAZhCfUQKRzDMVj+TwrAIV6jvSUEkYAr1LSkcyTBb/V+KYfX7xAeusq3sLDtGH3kEGACPWIflNZfhRQAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/graphics/friends2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/graphics/crewForAll.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/heros/yarnMovement.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/wob2bge.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Foundation for Sites
 * Version 6.6.3
 * https://get.foundation
 * Licensed under MIT Open Source
 */
@media print, screen and (min-width: 40em) {
  .reveal.large, .reveal.small, .reveal.tiny, .reveal {
    right: auto;
    left: auto;
    margin: 0 auto;
  }
}
/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */
html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

pre {
  font-family: monospace, monospace;
  font-size: 1em;
}

a {
  background-color: transparent;
}

abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

b,
strong {
  font-weight: bolder;
}

code,
kbd,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

img {
  border-style: none;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

textarea {
  overflow: auto;
}

[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

details {
  display: block;
}

summary {
  display: list-item;
}

template {
  display: none;
}

[hidden] {
  display: none;
}

.foundation-mq {
  font-family: "small=0em&medium=40em&xmedium=52em&large=64em&xlarge=75em&xxlarge=90em";
}

html {
  box-sizing: border-box;
  font-size: 100%;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

body {
  margin: 0;
  padding: 0;
  background: #fff;
  font-family: "Europa", "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: normal;
  line-height: 1.4;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

img {
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  height: auto;
  -ms-interpolation-mode: bicubic;
}

textarea {
  height: auto;
  min-height: 50px;
  border-radius: 3px;
}

select {
  box-sizing: border-box;
  width: 100%;
  border-radius: 3px;
}

.map_canvas img,
.map_canvas embed,
.map_canvas object,
.mqa-display img,
.mqa-display embed,
.mqa-display object {
  max-width: none !important;
}

button {
  padding: 0;
  appearance: none;
  border: 0;
  border-radius: 3px;
  background: transparent;
  line-height: 1;
  cursor: auto;
}
[data-whatinput=mouse] button {
  outline: 0;
}

pre {
  overflow: auto;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
}

.is-visible {
  display: block !important;
}

.is-hidden {
  display: none !important;
}

[type=text], [type=password], [type=date], [type=datetime], [type=datetime-local], [type=month], [type=week], [type=email], [type=number], [type=search], [type=tel], [type=time], [type=url], [type=color],
textarea {
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 2.3375rem;
  margin: 0 0 1rem;
  padding: 0.5rem;
  border: 1px solid rgba(51, 51, 51, 0.5);
  border-radius: 3px;
  background-color: #fff;
  box-shadow: inset 0 1px 2px rgba(51, 51, 51, 0.1);
  font-family: inherit;
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.4;
  color: #333;
  transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
  appearance: none;
}
[type=text]:focus, [type=password]:focus, [type=date]:focus, [type=datetime]:focus, [type=datetime-local]:focus, [type=month]:focus, [type=week]:focus, [type=email]:focus, [type=number]:focus, [type=search]:focus, [type=tel]:focus, [type=time]:focus, [type=url]:focus, [type=color]:focus,
textarea:focus {
  outline: none;
  border: 1px solid rgba(51, 51, 51, 0.75);
  background-color: #fff;
  box-shadow: 0 0 5px rgba(51, 51, 51, 0.5);
  transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
}

textarea {
  max-width: 100%;
}
textarea[rows] {
  height: auto;
}

input:disabled, input[readonly],
textarea:disabled,
textarea[readonly] {
  background-color: rgba(51, 51, 51, 0.15);
  cursor: not-allowed;
}

[type=submit],
[type=button] {
  appearance: none;
  border-radius: 3px;
}

input[type=search] {
  box-sizing: border-box;
}

::placeholder {
  color: rgba(51, 51, 51, 0.5);
}

[type=file],
[type=checkbox],
[type=radio] {
  margin: 0 0 1rem;
}

[type=checkbox] + label,
[type=radio] + label {
  display: inline-block;
  vertical-align: baseline;
  margin-left: 0.5rem;
  margin-right: 1rem;
  margin-bottom: 0;
}
[type=checkbox] + label[for],
[type=radio] + label[for] {
  cursor: pointer;
}

label > [type=checkbox],
label > [type=radio] {
  margin-right: 0.5rem;
}

[type=file] {
  width: 100%;
}

label {
  display: block;
  margin: 0;
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1.8;
  color: #333;
}
label.middle {
  margin: 0 0 1rem;
  padding: 0.5625rem 0;
}

.help-text {
  margin-top: -0.5rem;
  font-size: 0.8125rem;
  font-style: italic;
  color: #333;
}

.input-group {
  display: flex;
  width: 100%;
  margin-bottom: 1rem;
  align-items: stretch;
}
.input-group > :first-child, .input-group > :first-child.input-group-button > * {
  border-radius: 3px 0 0 3px;
}
.input-group > :last-child, .input-group > :last-child.input-group-button > * {
  border-radius: 0 3px 3px 0;
}

.input-group-button a,
.input-group-button input,
.input-group-button button,
.input-group-button label, .input-group-button, .input-group-field, .input-group-label {
  margin: 0;
  white-space: nowrap;
}

.input-group-label {
  padding: 0 1rem;
  border: 1px solid rgba(51, 51, 51, 0.5);
  background: rgba(51, 51, 51, 0.15);
  color: #333;
  text-align: center;
  white-space: nowrap;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}
.input-group-label:first-child {
  border-right: 0;
}
.input-group-label:last-child {
  border-left: 0;
}

.input-group-field {
  border-radius: 0;
  flex: 1 1;
  min-width: 0;
}

.input-group-button {
  padding-top: 0;
  padding-bottom: 0;
  text-align: center;
  display: flex;
  flex: 0 0 auto;
}
.input-group-button a,
.input-group-button input,
.input-group-button button,
.input-group-button label {
  align-self: stretch;
  height: auto;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 1rem;
}

fieldset {
  margin: 0;
  padding: 0;
  border: 0;
}

legend {
  max-width: 100%;
  margin-bottom: 0.5rem;
}

.fieldset {
  margin: 1.125rem 0;
  padding: 1.25rem;
  border: 1px solid rgba(51, 51, 51, 0.5);
}
.fieldset legend {
  margin: 0;
  margin-left: -0.1875rem;
  padding: 0 0.1875rem;
}

select {
  height: 2.3375rem;
  margin: 0 0 1rem;
  padding: 0.5rem;
  appearance: none;
  border: 1px solid rgba(51, 51, 51, 0.5);
  border-radius: 3px;
  background-color: #fff;
  font-family: inherit;
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.4;
  color: #333;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-origin: content-box;
  background-position: right -1rem center;
  background-repeat: no-repeat;
  background-size: 9px 6px;
  padding-right: 1.5rem;
  transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
}
@media screen and (min-width: 0\\0 ) {
  select {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}
select:focus {
  outline: none;
  border: 1px solid rgba(51, 51, 51, 0.75);
  background-color: #fff;
  box-shadow: 0 0 5px rgba(51, 51, 51, 0.5);
  transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
}
select:disabled {
  background-color: rgba(51, 51, 51, 0.15);
  cursor: not-allowed;
}
select::-ms-expand {
  display: none;
}
select[multiple] {
  height: auto;
  background-image: none;
}
select:not([multiple]) {
  padding-top: 0;
  padding-bottom: 0;
}

.is-invalid-input:not(:focus) {
  border-color: #E31926;
  background-color: rgb(252.2, 232, 233.3);
}
.is-invalid-input:not(:focus)::placeholder {
  color: #E31926;
}

.is-invalid-label {
  color: #E31926;
}

.form-error {
  display: none;
  margin-top: -0.5rem;
  margin-bottom: 1rem;
  font-size: 0.75rem;
  font-weight: bold;
  color: #E31926;
}
.form-error.is-visible {
  display: block;
}

div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}

p {
  margin-bottom: 1rem;
  font-size: inherit;
  line-height: 1.4;
  text-rendering: optimizeLegibility;
}

em,
i {
  font-style: italic;
  line-height: inherit;
}

strong,
b {
  font-weight: bold;
  line-height: inherit;
}

small {
  font-size: 80%;
  line-height: inherit;
}

h1, .h1,
h2, .h2,
h3, .h3,
h4, .h4,
h5, .h5,
h6, .h6 {
  font-family: "Europa", "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  color: inherit;
  text-rendering: optimizeLegibility;
}
h1 small, .h1 small,
h2 small, .h2 small,
h3 small, .h3 small,
h4 small, .h4 small,
h5 small, .h5 small,
h6 small, .h6 small {
  line-height: 0;
  color: rgba(51, 51, 51, 0.5);
}

h1, .h1 {
  font-size: 1.625rem;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h2, .h2 {
  font-size: 1.5rem;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h3, .h3 {
  font-size: 1.25rem;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h4, .h4 {
  font-size: 1rem;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h5, .h5 {
  font-size: 0.875rem;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h6, .h6 {
  font-size: 1rem;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

@media print, screen and (min-width: 40em) {
  h1, .h1 {
    font-size: 2.25rem;
  }
  h2, .h2 {
    font-size: 2rem;
  }
  h3, .h3 {
    font-size: 1.5rem;
  }
  h4, .h4 {
    font-size: 1.25rem;
  }
  h5, .h5 {
    font-size: 1.125rem;
  }
  h6, .h6 {
    font-size: 1rem;
  }
}
@media print, screen and (min-width: 64em) {
  h1, .h1 {
    font-size: 3rem;
  }
  h2, .h2 {
    font-size: 2.25rem;
  }
  h3, .h3 {
    font-size: 2rem;
  }
  h4, .h4 {
    font-size: 1.5rem;
  }
  h5, .h5 {
    font-size: 1.25rem;
  }
  h6, .h6 {
    font-size: 1rem;
  }
}
@media screen and (min-width: 75em) {
  h1, .h1 {
    font-size: 3.5625rem;
  }
  h2, .h2 {
    font-size: 2.875rem;
  }
  h3, .h3 {
    font-size: 2.25rem;
  }
  h4, .h4 {
    font-size: 1.5rem;
  }
  h5, .h5 {
    font-size: 1.25rem;
  }
  h6, .h6 {
    font-size: 1rem;
  }
}
a {
  line-height: inherit;
  color: #333;
  text-decoration: none;
  cursor: pointer;
}
a:hover, a:focus {
  color: rgb(250.26, 0, 93.7046575342);
}
a img {
  border: 0;
}

hr {
  clear: both;
  max-width: 75rem;
  height: 0;
  margin: 1.25rem auto;
  border-top: 0;
  border-right: 0;
  border-bottom: 1px solid rgba(51, 51, 51, 0.5);
  border-left: 0;
}

ul,
ol,
dl {
  margin-bottom: 1rem;
  list-style-position: outside;
  line-height: 1.4;
}

li {
  font-size: inherit;
}

ul {
  margin-left: 1.25rem;
  list-style-type: disc;
}

ol {
  margin-left: 1.25rem;
}

ul ul, ul ol, ol ul, ol ol {
  margin-left: 1.25rem;
  margin-bottom: 0;
}

dl {
  margin-bottom: 1rem;
}
dl dt {
  margin-bottom: 0.3rem;
  font-weight: bold;
}

blockquote {
  margin: 0 0 1rem;
  padding: 0.5625rem 1.25rem 0 1.1875rem;
  border-left: 1px solid rgba(51, 51, 51, 0.5);
}
blockquote, blockquote p {
  line-height: 1.4;
  color: rgba(51, 51, 51, 0.75);
}

abbr, abbr[title] {
  border-bottom: 1px dotted #333;
  cursor: help;
  text-decoration: none;
}

figure {
  margin: 0;
}

kbd {
  margin: 0;
  padding: 0.125rem 0.25rem 0;
  background-color: rgba(51, 51, 51, 0.15);
  font-family: Consolas, "Liberation Mono", Courier, monospace;
  color: #333;
  border-radius: 3px;
}

.subheader {
  margin-top: 0.2rem;
  margin-bottom: 0.5rem;
  font-weight: normal;
  line-height: 1.4;
  color: rgba(51, 51, 51, 0.75);
}

.lead {
  font-size: 125%;
  line-height: 1.6;
}

.stat {
  font-size: 2.5rem;
  line-height: 1;
}
p + .stat {
  margin-top: -1rem;
}

ul.no-bullet, ol.no-bullet {
  margin-left: 0;
  list-style: none;
}

.cite-block, cite {
  display: block;
  color: rgba(51, 51, 51, 0.75);
  font-size: 0.8125rem;
}
.cite-block:before, cite:before {
  content: "— ";
}

.code-inline, code {
  border: 1px solid rgba(51, 51, 51, 0.5);
  background-color: rgba(51, 51, 51, 0.15);
  font-family: Consolas, "Liberation Mono", Courier, monospace;
  font-weight: normal;
  color: #333;
  display: inline;
  max-width: 100%;
  word-wrap: break-word;
  padding: 0.125rem 0.3125rem 0.0625rem;
}

.code-block {
  border: 1px solid rgba(51, 51, 51, 0.5);
  background-color: rgba(51, 51, 51, 0.15);
  font-family: Consolas, "Liberation Mono", Courier, monospace;
  font-weight: normal;
  color: #333;
  display: block;
  overflow: auto;
  white-space: pre;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.text-justify {
  text-align: justify;
}

@media print, screen and (min-width: 40em) {
  .medium-text-left {
    text-align: left;
  }
  .medium-text-right {
    text-align: right;
  }
  .medium-text-center {
    text-align: center;
  }
  .medium-text-justify {
    text-align: justify;
  }
}
@media print, screen and (min-width: 64em) {
  .large-text-left {
    text-align: left;
  }
  .large-text-right {
    text-align: right;
  }
  .large-text-center {
    text-align: center;
  }
  .large-text-justify {
    text-align: justify;
  }
}
.show-for-print {
  display: none !important;
}

@media print {
  * {
    background: transparent !important;
    color: black !important;
    -webkit-print-color-adjust: economy;
            color-adjust: economy;
    box-shadow: none !important;
    text-shadow: none !important;
  }
  .show-for-print {
    display: block !important;
  }
  .hide-for-print {
    display: none !important;
  }
  table.show-for-print {
    display: table !important;
  }
  thead.show-for-print {
    display: table-header-group !important;
  }
  tbody.show-for-print {
    display: table-row-group !important;
  }
  tr.show-for-print {
    display: table-row !important;
  }
  td.show-for-print {
    display: table-cell !important;
  }
  th.show-for-print {
    display: table-cell !important;
  }
  a,
  a:visited {
    text-decoration: underline;
  }
  a[href]:after {
    content: " (" attr(href) ")";
  }
  .ir a:after,
  a[href^="javascript:"]:after,
  a[href^="#"]:after {
    content: "";
  }
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
  pre,
  blockquote {
    border: 1px solid rgba(51, 51, 51, 0.75);
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  img {
    max-width: 100% !important;
  }
  @page {
    margin: 0.5cm;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  .print-break-inside {
    page-break-inside: auto;
  }
}
.grid-container {
  padding-right: 0.625rem;
  padding-left: 0.625rem;
  max-width: 75rem;
  margin-left: auto;
  margin-right: auto;
}
@media print, screen and (min-width: 40em) {
  .grid-container {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
.grid-container.fluid {
  padding-right: 0.625rem;
  padding-left: 0.625rem;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}
@media print, screen and (min-width: 40em) {
  .grid-container.fluid {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
.grid-container.full {
  padding-right: 0;
  padding-left: 0;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.grid-x {
  display: flex;
  flex-flow: row wrap;
}

.cell {
  flex: 0 0 auto;
  min-height: 0px;
  min-width: 0px;
  width: 100%;
}
.cell.auto {
  flex: 1 1;
}
.cell.shrink {
  flex: 0 0 auto;
}

.grid-x > .auto {
  width: auto;
}
.grid-x > .shrink {
  width: auto;
}

.grid-x > .small-shrink, .grid-x > .small-full, .grid-x > .small-1, .grid-x > .small-2, .grid-x > .small-3, .grid-x > .small-4, .grid-x > .small-5, .grid-x > .small-6, .grid-x > .small-7, .grid-x > .small-8, .grid-x > .small-9, .grid-x > .small-10, .grid-x > .small-11, .grid-x > .small-12 {
  flex-basis: auto;
}

@media print, screen and (min-width: 40em) {
  .grid-x > .medium-shrink, .grid-x > .medium-full, .grid-x > .medium-1, .grid-x > .medium-2, .grid-x > .medium-3, .grid-x > .medium-4, .grid-x > .medium-5, .grid-x > .medium-6, .grid-x > .medium-7, .grid-x > .medium-8, .grid-x > .medium-9, .grid-x > .medium-10, .grid-x > .medium-11, .grid-x > .medium-12 {
    flex-basis: auto;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-x > .large-shrink, .grid-x > .large-full, .grid-x > .large-1, .grid-x > .large-2, .grid-x > .large-3, .grid-x > .large-4, .grid-x > .large-5, .grid-x > .large-6, .grid-x > .large-7, .grid-x > .large-8, .grid-x > .large-9, .grid-x > .large-10, .grid-x > .large-11, .grid-x > .large-12 {
    flex-basis: auto;
  }
}
.grid-x > .small-12, .grid-x > .small-11, .grid-x > .small-10, .grid-x > .small-9, .grid-x > .small-8, .grid-x > .small-7, .grid-x > .small-6, .grid-x > .small-5, .grid-x > .small-4, .grid-x > .small-3, .grid-x > .small-2, .grid-x > .small-1 {
  flex: 0 0 auto;
}

.grid-x > .small-1 {
  width: 8.3333333333%;
}

.grid-x > .small-2 {
  width: 16.6666666667%;
}

.grid-x > .small-3 {
  width: 25%;
}

.grid-x > .small-4 {
  width: 33.3333333333%;
}

.grid-x > .small-5 {
  width: 41.6666666667%;
}

.grid-x > .small-6 {
  width: 50%;
}

.grid-x > .small-7 {
  width: 58.3333333333%;
}

.grid-x > .small-8 {
  width: 66.6666666667%;
}

.grid-x > .small-9 {
  width: 75%;
}

.grid-x > .small-10 {
  width: 83.3333333333%;
}

.grid-x > .small-11 {
  width: 91.6666666667%;
}

.grid-x > .small-12 {
  width: 100%;
}

@media print, screen and (min-width: 40em) {
  .grid-x > .medium-auto {
    flex: 1 1;
    width: auto;
  }
  .grid-x > .medium-12, .grid-x > .medium-11, .grid-x > .medium-10, .grid-x > .medium-9, .grid-x > .medium-8, .grid-x > .medium-7, .grid-x > .medium-6, .grid-x > .medium-5, .grid-x > .medium-4, .grid-x > .medium-3, .grid-x > .medium-2, .grid-x > .medium-1, .grid-x > .medium-shrink {
    flex: 0 0 auto;
  }
  .grid-x > .medium-shrink {
    width: auto;
  }
  .grid-x > .medium-1 {
    width: 8.3333333333%;
  }
  .grid-x > .medium-2 {
    width: 16.6666666667%;
  }
  .grid-x > .medium-3 {
    width: 25%;
  }
  .grid-x > .medium-4 {
    width: 33.3333333333%;
  }
  .grid-x > .medium-5 {
    width: 41.6666666667%;
  }
  .grid-x > .medium-6 {
    width: 50%;
  }
  .grid-x > .medium-7 {
    width: 58.3333333333%;
  }
  .grid-x > .medium-8 {
    width: 66.6666666667%;
  }
  .grid-x > .medium-9 {
    width: 75%;
  }
  .grid-x > .medium-10 {
    width: 83.3333333333%;
  }
  .grid-x > .medium-11 {
    width: 91.6666666667%;
  }
  .grid-x > .medium-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-x > .large-auto {
    flex: 1 1;
    width: auto;
  }
  .grid-x > .large-12, .grid-x > .large-11, .grid-x > .large-10, .grid-x > .large-9, .grid-x > .large-8, .grid-x > .large-7, .grid-x > .large-6, .grid-x > .large-5, .grid-x > .large-4, .grid-x > .large-3, .grid-x > .large-2, .grid-x > .large-1, .grid-x > .large-shrink {
    flex: 0 0 auto;
  }
  .grid-x > .large-shrink {
    width: auto;
  }
  .grid-x > .large-1 {
    width: 8.3333333333%;
  }
  .grid-x > .large-2 {
    width: 16.6666666667%;
  }
  .grid-x > .large-3 {
    width: 25%;
  }
  .grid-x > .large-4 {
    width: 33.3333333333%;
  }
  .grid-x > .large-5 {
    width: 41.6666666667%;
  }
  .grid-x > .large-6 {
    width: 50%;
  }
  .grid-x > .large-7 {
    width: 58.3333333333%;
  }
  .grid-x > .large-8 {
    width: 66.6666666667%;
  }
  .grid-x > .large-9 {
    width: 75%;
  }
  .grid-x > .large-10 {
    width: 83.3333333333%;
  }
  .grid-x > .large-11 {
    width: 91.6666666667%;
  }
  .grid-x > .large-12 {
    width: 100%;
  }
}
.grid-margin-x:not(.grid-x) > .cell {
  width: auto;
}

.grid-margin-y:not(.grid-y) > .cell {
  height: auto;
}

.grid-margin-x {
  margin-left: -0.625rem;
  margin-right: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-x {
    margin-left: -0.9375rem;
    margin-right: -0.9375rem;
  }
}
.grid-margin-x > .cell {
  width: calc(100% - 1.25rem);
  margin-left: 0.625rem;
  margin-right: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-x > .cell {
    width: calc(100% - 1.875rem);
    margin-left: 0.9375rem;
    margin-right: 0.9375rem;
  }
}
.grid-margin-x > .auto {
  width: auto;
}
.grid-margin-x > .shrink {
  width: auto;
}
.grid-margin-x > .small-1 {
  width: calc(8.3333333333% - 1.25rem);
}
.grid-margin-x > .small-2 {
  width: calc(16.6666666667% - 1.25rem);
}
.grid-margin-x > .small-3 {
  width: calc(25% - 1.25rem);
}
.grid-margin-x > .small-4 {
  width: calc(33.3333333333% - 1.25rem);
}
.grid-margin-x > .small-5 {
  width: calc(41.6666666667% - 1.25rem);
}
.grid-margin-x > .small-6 {
  width: calc(50% - 1.25rem);
}
.grid-margin-x > .small-7 {
  width: calc(58.3333333333% - 1.25rem);
}
.grid-margin-x > .small-8 {
  width: calc(66.6666666667% - 1.25rem);
}
.grid-margin-x > .small-9 {
  width: calc(75% - 1.25rem);
}
.grid-margin-x > .small-10 {
  width: calc(83.3333333333% - 1.25rem);
}
.grid-margin-x > .small-11 {
  width: calc(91.6666666667% - 1.25rem);
}
.grid-margin-x > .small-12 {
  width: calc(100% - 1.25rem);
}
@media print, screen and (min-width: 40em) {
  .grid-margin-x > .auto {
    width: auto;
  }
  .grid-margin-x > .shrink {
    width: auto;
  }
  .grid-margin-x > .small-1 {
    width: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-x > .small-2 {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x > .small-3 {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x > .small-4 {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x > .small-5 {
    width: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-x > .small-6 {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x > .small-7 {
    width: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-x > .small-8 {
    width: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-x > .small-9 {
    width: calc(75% - 1.875rem);
  }
  .grid-margin-x > .small-10 {
    width: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-x > .small-11 {
    width: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-x > .small-12 {
    width: calc(100% - 1.875rem);
  }
  .grid-margin-x > .medium-auto {
    width: auto;
  }
  .grid-margin-x > .medium-shrink {
    width: auto;
  }
  .grid-margin-x > .medium-1 {
    width: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-x > .medium-2 {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x > .medium-3 {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x > .medium-4 {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x > .medium-5 {
    width: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-x > .medium-6 {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x > .medium-7 {
    width: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-x > .medium-8 {
    width: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-x > .medium-9 {
    width: calc(75% - 1.875rem);
  }
  .grid-margin-x > .medium-10 {
    width: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-x > .medium-11 {
    width: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-x > .medium-12 {
    width: calc(100% - 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-x > .large-auto {
    width: auto;
  }
  .grid-margin-x > .large-shrink {
    width: auto;
  }
  .grid-margin-x > .large-1 {
    width: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-x > .large-2 {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x > .large-3 {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x > .large-4 {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x > .large-5 {
    width: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-x > .large-6 {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x > .large-7 {
    width: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-x > .large-8 {
    width: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-x > .large-9 {
    width: calc(75% - 1.875rem);
  }
  .grid-margin-x > .large-10 {
    width: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-x > .large-11 {
    width: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-x > .large-12 {
    width: calc(100% - 1.875rem);
  }
}

.grid-padding-x .grid-padding-x {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-padding-x .grid-padding-x {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}
.grid-container:not(.full) > .grid-padding-x {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-container:not(.full) > .grid-padding-x {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}
.grid-padding-x > .cell {
  padding-right: 0.625rem;
  padding-left: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-padding-x > .cell {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}

.small-up-1 > .cell {
  width: 100%;
}

.small-up-2 > .cell {
  width: 50%;
}

.small-up-3 > .cell {
  width: 33.3333333333%;
}

.small-up-4 > .cell {
  width: 25%;
}

.small-up-5 > .cell {
  width: 20%;
}

.small-up-6 > .cell {
  width: 16.6666666667%;
}

.small-up-7 > .cell {
  width: 14.2857142857%;
}

.small-up-8 > .cell {
  width: 12.5%;
}

@media print, screen and (min-width: 40em) {
  .medium-up-1 > .cell {
    width: 100%;
  }
  .medium-up-2 > .cell {
    width: 50%;
  }
  .medium-up-3 > .cell {
    width: 33.3333333333%;
  }
  .medium-up-4 > .cell {
    width: 25%;
  }
  .medium-up-5 > .cell {
    width: 20%;
  }
  .medium-up-6 > .cell {
    width: 16.6666666667%;
  }
  .medium-up-7 > .cell {
    width: 14.2857142857%;
  }
  .medium-up-8 > .cell {
    width: 12.5%;
  }
}
@media print, screen and (min-width: 64em) {
  .large-up-1 > .cell {
    width: 100%;
  }
  .large-up-2 > .cell {
    width: 50%;
  }
  .large-up-3 > .cell {
    width: 33.3333333333%;
  }
  .large-up-4 > .cell {
    width: 25%;
  }
  .large-up-5 > .cell {
    width: 20%;
  }
  .large-up-6 > .cell {
    width: 16.6666666667%;
  }
  .large-up-7 > .cell {
    width: 14.2857142857%;
  }
  .large-up-8 > .cell {
    width: 12.5%;
  }
}
.grid-margin-x.small-up-1 > .cell {
  width: calc(100% - 1.25rem);
}

.grid-margin-x.small-up-2 > .cell {
  width: calc(50% - 1.25rem);
}

.grid-margin-x.small-up-3 > .cell {
  width: calc(33.3333333333% - 1.25rem);
}

.grid-margin-x.small-up-4 > .cell {
  width: calc(25% - 1.25rem);
}

.grid-margin-x.small-up-5 > .cell {
  width: calc(20% - 1.25rem);
}

.grid-margin-x.small-up-6 > .cell {
  width: calc(16.6666666667% - 1.25rem);
}

.grid-margin-x.small-up-7 > .cell {
  width: calc(14.2857142857% - 1.25rem);
}

.grid-margin-x.small-up-8 > .cell {
  width: calc(12.5% - 1.25rem);
}

@media print, screen and (min-width: 40em) {
  .grid-margin-x.small-up-1 > .cell {
    width: calc(100% - 1.875rem);
  }
  .grid-margin-x.small-up-2 > .cell {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x.small-up-3 > .cell {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x.small-up-4 > .cell {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x.small-up-5 > .cell {
    width: calc(20% - 1.875rem);
  }
  .grid-margin-x.small-up-6 > .cell {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x.small-up-7 > .cell {
    width: calc(14.2857142857% - 1.875rem);
  }
  .grid-margin-x.small-up-8 > .cell {
    width: calc(12.5% - 1.875rem);
  }
  .grid-margin-x.medium-up-1 > .cell {
    width: calc(100% - 1.875rem);
  }
  .grid-margin-x.medium-up-2 > .cell {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x.medium-up-3 > .cell {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x.medium-up-4 > .cell {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x.medium-up-5 > .cell {
    width: calc(20% - 1.875rem);
  }
  .grid-margin-x.medium-up-6 > .cell {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x.medium-up-7 > .cell {
    width: calc(14.2857142857% - 1.875rem);
  }
  .grid-margin-x.medium-up-8 > .cell {
    width: calc(12.5% - 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-x.large-up-1 > .cell {
    width: calc(100% - 1.875rem);
  }
  .grid-margin-x.large-up-2 > .cell {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x.large-up-3 > .cell {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x.large-up-4 > .cell {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x.large-up-5 > .cell {
    width: calc(20% - 1.875rem);
  }
  .grid-margin-x.large-up-6 > .cell {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x.large-up-7 > .cell {
    width: calc(14.2857142857% - 1.875rem);
  }
  .grid-margin-x.large-up-8 > .cell {
    width: calc(12.5% - 1.875rem);
  }
}
.small-margin-collapse {
  margin-right: 0;
  margin-left: 0;
}
.small-margin-collapse > .cell {
  margin-right: 0;
  margin-left: 0;
}
.small-margin-collapse > .small-1 {
  width: 8.3333333333%;
}
.small-margin-collapse > .small-2 {
  width: 16.6666666667%;
}
.small-margin-collapse > .small-3 {
  width: 25%;
}
.small-margin-collapse > .small-4 {
  width: 33.3333333333%;
}
.small-margin-collapse > .small-5 {
  width: 41.6666666667%;
}
.small-margin-collapse > .small-6 {
  width: 50%;
}
.small-margin-collapse > .small-7 {
  width: 58.3333333333%;
}
.small-margin-collapse > .small-8 {
  width: 66.6666666667%;
}
.small-margin-collapse > .small-9 {
  width: 75%;
}
.small-margin-collapse > .small-10 {
  width: 83.3333333333%;
}
.small-margin-collapse > .small-11 {
  width: 91.6666666667%;
}
.small-margin-collapse > .small-12 {
  width: 100%;
}
@media print, screen and (min-width: 40em) {
  .small-margin-collapse > .medium-1 {
    width: 8.3333333333%;
  }
  .small-margin-collapse > .medium-2 {
    width: 16.6666666667%;
  }
  .small-margin-collapse > .medium-3 {
    width: 25%;
  }
  .small-margin-collapse > .medium-4 {
    width: 33.3333333333%;
  }
  .small-margin-collapse > .medium-5 {
    width: 41.6666666667%;
  }
  .small-margin-collapse > .medium-6 {
    width: 50%;
  }
  .small-margin-collapse > .medium-7 {
    width: 58.3333333333%;
  }
  .small-margin-collapse > .medium-8 {
    width: 66.6666666667%;
  }
  .small-margin-collapse > .medium-9 {
    width: 75%;
  }
  .small-margin-collapse > .medium-10 {
    width: 83.3333333333%;
  }
  .small-margin-collapse > .medium-11 {
    width: 91.6666666667%;
  }
  .small-margin-collapse > .medium-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .small-margin-collapse > .large-1 {
    width: 8.3333333333%;
  }
  .small-margin-collapse > .large-2 {
    width: 16.6666666667%;
  }
  .small-margin-collapse > .large-3 {
    width: 25%;
  }
  .small-margin-collapse > .large-4 {
    width: 33.3333333333%;
  }
  .small-margin-collapse > .large-5 {
    width: 41.6666666667%;
  }
  .small-margin-collapse > .large-6 {
    width: 50%;
  }
  .small-margin-collapse > .large-7 {
    width: 58.3333333333%;
  }
  .small-margin-collapse > .large-8 {
    width: 66.6666666667%;
  }
  .small-margin-collapse > .large-9 {
    width: 75%;
  }
  .small-margin-collapse > .large-10 {
    width: 83.3333333333%;
  }
  .small-margin-collapse > .large-11 {
    width: 91.6666666667%;
  }
  .small-margin-collapse > .large-12 {
    width: 100%;
  }
}

.small-padding-collapse {
  margin-right: 0;
  margin-left: 0;
}
.small-padding-collapse > .cell {
  padding-right: 0;
  padding-left: 0;
}

@media print, screen and (min-width: 40em) {
  .medium-margin-collapse {
    margin-right: 0;
    margin-left: 0;
  }
  .medium-margin-collapse > .cell {
    margin-right: 0;
    margin-left: 0;
  }
}
@media print, screen and (min-width: 40em) {
  .medium-margin-collapse > .small-1 {
    width: 8.3333333333%;
  }
  .medium-margin-collapse > .small-2 {
    width: 16.6666666667%;
  }
  .medium-margin-collapse > .small-3 {
    width: 25%;
  }
  .medium-margin-collapse > .small-4 {
    width: 33.3333333333%;
  }
  .medium-margin-collapse > .small-5 {
    width: 41.6666666667%;
  }
  .medium-margin-collapse > .small-6 {
    width: 50%;
  }
  .medium-margin-collapse > .small-7 {
    width: 58.3333333333%;
  }
  .medium-margin-collapse > .small-8 {
    width: 66.6666666667%;
  }
  .medium-margin-collapse > .small-9 {
    width: 75%;
  }
  .medium-margin-collapse > .small-10 {
    width: 83.3333333333%;
  }
  .medium-margin-collapse > .small-11 {
    width: 91.6666666667%;
  }
  .medium-margin-collapse > .small-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 40em) {
  .medium-margin-collapse > .medium-1 {
    width: 8.3333333333%;
  }
  .medium-margin-collapse > .medium-2 {
    width: 16.6666666667%;
  }
  .medium-margin-collapse > .medium-3 {
    width: 25%;
  }
  .medium-margin-collapse > .medium-4 {
    width: 33.3333333333%;
  }
  .medium-margin-collapse > .medium-5 {
    width: 41.6666666667%;
  }
  .medium-margin-collapse > .medium-6 {
    width: 50%;
  }
  .medium-margin-collapse > .medium-7 {
    width: 58.3333333333%;
  }
  .medium-margin-collapse > .medium-8 {
    width: 66.6666666667%;
  }
  .medium-margin-collapse > .medium-9 {
    width: 75%;
  }
  .medium-margin-collapse > .medium-10 {
    width: 83.3333333333%;
  }
  .medium-margin-collapse > .medium-11 {
    width: 91.6666666667%;
  }
  .medium-margin-collapse > .medium-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .medium-margin-collapse > .large-1 {
    width: 8.3333333333%;
  }
  .medium-margin-collapse > .large-2 {
    width: 16.6666666667%;
  }
  .medium-margin-collapse > .large-3 {
    width: 25%;
  }
  .medium-margin-collapse > .large-4 {
    width: 33.3333333333%;
  }
  .medium-margin-collapse > .large-5 {
    width: 41.6666666667%;
  }
  .medium-margin-collapse > .large-6 {
    width: 50%;
  }
  .medium-margin-collapse > .large-7 {
    width: 58.3333333333%;
  }
  .medium-margin-collapse > .large-8 {
    width: 66.6666666667%;
  }
  .medium-margin-collapse > .large-9 {
    width: 75%;
  }
  .medium-margin-collapse > .large-10 {
    width: 83.3333333333%;
  }
  .medium-margin-collapse > .large-11 {
    width: 91.6666666667%;
  }
  .medium-margin-collapse > .large-12 {
    width: 100%;
  }
}

@media print, screen and (min-width: 40em) {
  .medium-padding-collapse {
    margin-right: 0;
    margin-left: 0;
  }
  .medium-padding-collapse > .cell {
    padding-right: 0;
    padding-left: 0;
  }
}

@media print, screen and (min-width: 64em) {
  .large-margin-collapse {
    margin-right: 0;
    margin-left: 0;
  }
  .large-margin-collapse > .cell {
    margin-right: 0;
    margin-left: 0;
  }
}
@media print, screen and (min-width: 64em) {
  .large-margin-collapse > .small-1 {
    width: 8.3333333333%;
  }
  .large-margin-collapse > .small-2 {
    width: 16.6666666667%;
  }
  .large-margin-collapse > .small-3 {
    width: 25%;
  }
  .large-margin-collapse > .small-4 {
    width: 33.3333333333%;
  }
  .large-margin-collapse > .small-5 {
    width: 41.6666666667%;
  }
  .large-margin-collapse > .small-6 {
    width: 50%;
  }
  .large-margin-collapse > .small-7 {
    width: 58.3333333333%;
  }
  .large-margin-collapse > .small-8 {
    width: 66.6666666667%;
  }
  .large-margin-collapse > .small-9 {
    width: 75%;
  }
  .large-margin-collapse > .small-10 {
    width: 83.3333333333%;
  }
  .large-margin-collapse > .small-11 {
    width: 91.6666666667%;
  }
  .large-margin-collapse > .small-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .large-margin-collapse > .medium-1 {
    width: 8.3333333333%;
  }
  .large-margin-collapse > .medium-2 {
    width: 16.6666666667%;
  }
  .large-margin-collapse > .medium-3 {
    width: 25%;
  }
  .large-margin-collapse > .medium-4 {
    width: 33.3333333333%;
  }
  .large-margin-collapse > .medium-5 {
    width: 41.6666666667%;
  }
  .large-margin-collapse > .medium-6 {
    width: 50%;
  }
  .large-margin-collapse > .medium-7 {
    width: 58.3333333333%;
  }
  .large-margin-collapse > .medium-8 {
    width: 66.6666666667%;
  }
  .large-margin-collapse > .medium-9 {
    width: 75%;
  }
  .large-margin-collapse > .medium-10 {
    width: 83.3333333333%;
  }
  .large-margin-collapse > .medium-11 {
    width: 91.6666666667%;
  }
  .large-margin-collapse > .medium-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .large-margin-collapse > .large-1 {
    width: 8.3333333333%;
  }
  .large-margin-collapse > .large-2 {
    width: 16.6666666667%;
  }
  .large-margin-collapse > .large-3 {
    width: 25%;
  }
  .large-margin-collapse > .large-4 {
    width: 33.3333333333%;
  }
  .large-margin-collapse > .large-5 {
    width: 41.6666666667%;
  }
  .large-margin-collapse > .large-6 {
    width: 50%;
  }
  .large-margin-collapse > .large-7 {
    width: 58.3333333333%;
  }
  .large-margin-collapse > .large-8 {
    width: 66.6666666667%;
  }
  .large-margin-collapse > .large-9 {
    width: 75%;
  }
  .large-margin-collapse > .large-10 {
    width: 83.3333333333%;
  }
  .large-margin-collapse > .large-11 {
    width: 91.6666666667%;
  }
  .large-margin-collapse > .large-12 {
    width: 100%;
  }
}

@media print, screen and (min-width: 64em) {
  .large-padding-collapse {
    margin-right: 0;
    margin-left: 0;
  }
  .large-padding-collapse > .cell {
    padding-right: 0;
    padding-left: 0;
  }
}

.small-offset-0 {
  margin-left: 0%;
}

.grid-margin-x > .small-offset-0 {
  margin-left: calc(0% + 0.625rem);
}

.small-offset-1 {
  margin-left: 8.3333333333%;
}

.grid-margin-x > .small-offset-1 {
  margin-left: calc(8.3333333333% + 0.625rem);
}

.small-offset-2 {
  margin-left: 16.6666666667%;
}

.grid-margin-x > .small-offset-2 {
  margin-left: calc(16.6666666667% + 0.625rem);
}

.small-offset-3 {
  margin-left: 25%;
}

.grid-margin-x > .small-offset-3 {
  margin-left: calc(25% + 0.625rem);
}

.small-offset-4 {
  margin-left: 33.3333333333%;
}

.grid-margin-x > .small-offset-4 {
  margin-left: calc(33.3333333333% + 0.625rem);
}

.small-offset-5 {
  margin-left: 41.6666666667%;
}

.grid-margin-x > .small-offset-5 {
  margin-left: calc(41.6666666667% + 0.625rem);
}

.small-offset-6 {
  margin-left: 50%;
}

.grid-margin-x > .small-offset-6 {
  margin-left: calc(50% + 0.625rem);
}

.small-offset-7 {
  margin-left: 58.3333333333%;
}

.grid-margin-x > .small-offset-7 {
  margin-left: calc(58.3333333333% + 0.625rem);
}

.small-offset-8 {
  margin-left: 66.6666666667%;
}

.grid-margin-x > .small-offset-8 {
  margin-left: calc(66.6666666667% + 0.625rem);
}

.small-offset-9 {
  margin-left: 75%;
}

.grid-margin-x > .small-offset-9 {
  margin-left: calc(75% + 0.625rem);
}

.small-offset-10 {
  margin-left: 83.3333333333%;
}

.grid-margin-x > .small-offset-10 {
  margin-left: calc(83.3333333333% + 0.625rem);
}

.small-offset-11 {
  margin-left: 91.6666666667%;
}

.grid-margin-x > .small-offset-11 {
  margin-left: calc(91.6666666667% + 0.625rem);
}

@media print, screen and (min-width: 40em) {
  .medium-offset-0 {
    margin-left: 0%;
  }
  .grid-margin-x > .medium-offset-0 {
    margin-left: calc(0% + 0.9375rem);
  }
  .medium-offset-1 {
    margin-left: 8.3333333333%;
  }
  .grid-margin-x > .medium-offset-1 {
    margin-left: calc(8.3333333333% + 0.9375rem);
  }
  .medium-offset-2 {
    margin-left: 16.6666666667%;
  }
  .grid-margin-x > .medium-offset-2 {
    margin-left: calc(16.6666666667% + 0.9375rem);
  }
  .medium-offset-3 {
    margin-left: 25%;
  }
  .grid-margin-x > .medium-offset-3 {
    margin-left: calc(25% + 0.9375rem);
  }
  .medium-offset-4 {
    margin-left: 33.3333333333%;
  }
  .grid-margin-x > .medium-offset-4 {
    margin-left: calc(33.3333333333% + 0.9375rem);
  }
  .medium-offset-5 {
    margin-left: 41.6666666667%;
  }
  .grid-margin-x > .medium-offset-5 {
    margin-left: calc(41.6666666667% + 0.9375rem);
  }
  .medium-offset-6 {
    margin-left: 50%;
  }
  .grid-margin-x > .medium-offset-6 {
    margin-left: calc(50% + 0.9375rem);
  }
  .medium-offset-7 {
    margin-left: 58.3333333333%;
  }
  .grid-margin-x > .medium-offset-7 {
    margin-left: calc(58.3333333333% + 0.9375rem);
  }
  .medium-offset-8 {
    margin-left: 66.6666666667%;
  }
  .grid-margin-x > .medium-offset-8 {
    margin-left: calc(66.6666666667% + 0.9375rem);
  }
  .medium-offset-9 {
    margin-left: 75%;
  }
  .grid-margin-x > .medium-offset-9 {
    margin-left: calc(75% + 0.9375rem);
  }
  .medium-offset-10 {
    margin-left: 83.3333333333%;
  }
  .grid-margin-x > .medium-offset-10 {
    margin-left: calc(83.3333333333% + 0.9375rem);
  }
  .medium-offset-11 {
    margin-left: 91.6666666667%;
  }
  .grid-margin-x > .medium-offset-11 {
    margin-left: calc(91.6666666667% + 0.9375rem);
  }
}
@media print, screen and (min-width: 64em) {
  .large-offset-0 {
    margin-left: 0%;
  }
  .grid-margin-x > .large-offset-0 {
    margin-left: calc(0% + 0.9375rem);
  }
  .large-offset-1 {
    margin-left: 8.3333333333%;
  }
  .grid-margin-x > .large-offset-1 {
    margin-left: calc(8.3333333333% + 0.9375rem);
  }
  .large-offset-2 {
    margin-left: 16.6666666667%;
  }
  .grid-margin-x > .large-offset-2 {
    margin-left: calc(16.6666666667% + 0.9375rem);
  }
  .large-offset-3 {
    margin-left: 25%;
  }
  .grid-margin-x > .large-offset-3 {
    margin-left: calc(25% + 0.9375rem);
  }
  .large-offset-4 {
    margin-left: 33.3333333333%;
  }
  .grid-margin-x > .large-offset-4 {
    margin-left: calc(33.3333333333% + 0.9375rem);
  }
  .large-offset-5 {
    margin-left: 41.6666666667%;
  }
  .grid-margin-x > .large-offset-5 {
    margin-left: calc(41.6666666667% + 0.9375rem);
  }
  .large-offset-6 {
    margin-left: 50%;
  }
  .grid-margin-x > .large-offset-6 {
    margin-left: calc(50% + 0.9375rem);
  }
  .large-offset-7 {
    margin-left: 58.3333333333%;
  }
  .grid-margin-x > .large-offset-7 {
    margin-left: calc(58.3333333333% + 0.9375rem);
  }
  .large-offset-8 {
    margin-left: 66.6666666667%;
  }
  .grid-margin-x > .large-offset-8 {
    margin-left: calc(66.6666666667% + 0.9375rem);
  }
  .large-offset-9 {
    margin-left: 75%;
  }
  .grid-margin-x > .large-offset-9 {
    margin-left: calc(75% + 0.9375rem);
  }
  .large-offset-10 {
    margin-left: 83.3333333333%;
  }
  .grid-margin-x > .large-offset-10 {
    margin-left: calc(83.3333333333% + 0.9375rem);
  }
  .large-offset-11 {
    margin-left: 91.6666666667%;
  }
  .grid-margin-x > .large-offset-11 {
    margin-left: calc(91.6666666667% + 0.9375rem);
  }
}
.grid-y {
  display: flex;
  flex-flow: column nowrap;
}
.grid-y > .cell {
  height: auto;
  max-height: none;
}
.grid-y > .auto {
  height: auto;
}
.grid-y > .shrink {
  height: auto;
}
.grid-y > .small-shrink, .grid-y > .small-full, .grid-y > .small-1, .grid-y > .small-2, .grid-y > .small-3, .grid-y > .small-4, .grid-y > .small-5, .grid-y > .small-6, .grid-y > .small-7, .grid-y > .small-8, .grid-y > .small-9, .grid-y > .small-10, .grid-y > .small-11, .grid-y > .small-12 {
  flex-basis: auto;
}
@media print, screen and (min-width: 40em) {
  .grid-y > .medium-shrink, .grid-y > .medium-full, .grid-y > .medium-1, .grid-y > .medium-2, .grid-y > .medium-3, .grid-y > .medium-4, .grid-y > .medium-5, .grid-y > .medium-6, .grid-y > .medium-7, .grid-y > .medium-8, .grid-y > .medium-9, .grid-y > .medium-10, .grid-y > .medium-11, .grid-y > .medium-12 {
    flex-basis: auto;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-y > .large-shrink, .grid-y > .large-full, .grid-y > .large-1, .grid-y > .large-2, .grid-y > .large-3, .grid-y > .large-4, .grid-y > .large-5, .grid-y > .large-6, .grid-y > .large-7, .grid-y > .large-8, .grid-y > .large-9, .grid-y > .large-10, .grid-y > .large-11, .grid-y > .large-12 {
    flex-basis: auto;
  }
}
.grid-y > .small-12, .grid-y > .small-11, .grid-y > .small-10, .grid-y > .small-9, .grid-y > .small-8, .grid-y > .small-7, .grid-y > .small-6, .grid-y > .small-5, .grid-y > .small-4, .grid-y > .small-3, .grid-y > .small-2, .grid-y > .small-1 {
  flex: 0 0 auto;
}
.grid-y > .small-1 {
  height: 8.3333333333%;
}
.grid-y > .small-2 {
  height: 16.6666666667%;
}
.grid-y > .small-3 {
  height: 25%;
}
.grid-y > .small-4 {
  height: 33.3333333333%;
}
.grid-y > .small-5 {
  height: 41.6666666667%;
}
.grid-y > .small-6 {
  height: 50%;
}
.grid-y > .small-7 {
  height: 58.3333333333%;
}
.grid-y > .small-8 {
  height: 66.6666666667%;
}
.grid-y > .small-9 {
  height: 75%;
}
.grid-y > .small-10 {
  height: 83.3333333333%;
}
.grid-y > .small-11 {
  height: 91.6666666667%;
}
.grid-y > .small-12 {
  height: 100%;
}
@media print, screen and (min-width: 40em) {
  .grid-y > .medium-auto {
    flex: 1 1;
    height: auto;
  }
  .grid-y > .medium-12, .grid-y > .medium-11, .grid-y > .medium-10, .grid-y > .medium-9, .grid-y > .medium-8, .grid-y > .medium-7, .grid-y > .medium-6, .grid-y > .medium-5, .grid-y > .medium-4, .grid-y > .medium-3, .grid-y > .medium-2, .grid-y > .medium-1, .grid-y > .medium-shrink {
    flex: 0 0 auto;
  }
  .grid-y > .medium-shrink {
    height: auto;
  }
  .grid-y > .medium-1 {
    height: 8.3333333333%;
  }
  .grid-y > .medium-2 {
    height: 16.6666666667%;
  }
  .grid-y > .medium-3 {
    height: 25%;
  }
  .grid-y > .medium-4 {
    height: 33.3333333333%;
  }
  .grid-y > .medium-5 {
    height: 41.6666666667%;
  }
  .grid-y > .medium-6 {
    height: 50%;
  }
  .grid-y > .medium-7 {
    height: 58.3333333333%;
  }
  .grid-y > .medium-8 {
    height: 66.6666666667%;
  }
  .grid-y > .medium-9 {
    height: 75%;
  }
  .grid-y > .medium-10 {
    height: 83.3333333333%;
  }
  .grid-y > .medium-11 {
    height: 91.6666666667%;
  }
  .grid-y > .medium-12 {
    height: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-y > .large-auto {
    flex: 1 1;
    height: auto;
  }
  .grid-y > .large-12, .grid-y > .large-11, .grid-y > .large-10, .grid-y > .large-9, .grid-y > .large-8, .grid-y > .large-7, .grid-y > .large-6, .grid-y > .large-5, .grid-y > .large-4, .grid-y > .large-3, .grid-y > .large-2, .grid-y > .large-1, .grid-y > .large-shrink {
    flex: 0 0 auto;
  }
  .grid-y > .large-shrink {
    height: auto;
  }
  .grid-y > .large-1 {
    height: 8.3333333333%;
  }
  .grid-y > .large-2 {
    height: 16.6666666667%;
  }
  .grid-y > .large-3 {
    height: 25%;
  }
  .grid-y > .large-4 {
    height: 33.3333333333%;
  }
  .grid-y > .large-5 {
    height: 41.6666666667%;
  }
  .grid-y > .large-6 {
    height: 50%;
  }
  .grid-y > .large-7 {
    height: 58.3333333333%;
  }
  .grid-y > .large-8 {
    height: 66.6666666667%;
  }
  .grid-y > .large-9 {
    height: 75%;
  }
  .grid-y > .large-10 {
    height: 83.3333333333%;
  }
  .grid-y > .large-11 {
    height: 91.6666666667%;
  }
  .grid-y > .large-12 {
    height: 100%;
  }
}

.grid-padding-y .grid-padding-y {
  margin-top: -0.625rem;
  margin-bottom: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-padding-y .grid-padding-y {
    margin-top: -0.9375rem;
    margin-bottom: -0.9375rem;
  }
}
.grid-padding-y > .cell {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-padding-y > .cell {
    padding-top: 0.9375rem;
    padding-bottom: 0.9375rem;
  }
}

.grid-margin-y {
  margin-top: -0.625rem;
  margin-bottom: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y {
    margin-top: -0.9375rem;
    margin-bottom: -0.9375rem;
  }
}
.grid-margin-y > .cell {
  height: calc(100% - 1.25rem);
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y > .cell {
    height: calc(100% - 1.875rem);
    margin-top: 0.9375rem;
    margin-bottom: 0.9375rem;
  }
}
.grid-margin-y > .auto {
  height: auto;
}
.grid-margin-y > .shrink {
  height: auto;
}
.grid-margin-y > .small-1 {
  height: calc(8.3333333333% - 1.25rem);
}
.grid-margin-y > .small-2 {
  height: calc(16.6666666667% - 1.25rem);
}
.grid-margin-y > .small-3 {
  height: calc(25% - 1.25rem);
}
.grid-margin-y > .small-4 {
  height: calc(33.3333333333% - 1.25rem);
}
.grid-margin-y > .small-5 {
  height: calc(41.6666666667% - 1.25rem);
}
.grid-margin-y > .small-6 {
  height: calc(50% - 1.25rem);
}
.grid-margin-y > .small-7 {
  height: calc(58.3333333333% - 1.25rem);
}
.grid-margin-y > .small-8 {
  height: calc(66.6666666667% - 1.25rem);
}
.grid-margin-y > .small-9 {
  height: calc(75% - 1.25rem);
}
.grid-margin-y > .small-10 {
  height: calc(83.3333333333% - 1.25rem);
}
.grid-margin-y > .small-11 {
  height: calc(91.6666666667% - 1.25rem);
}
.grid-margin-y > .small-12 {
  height: calc(100% - 1.25rem);
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y > .auto {
    height: auto;
  }
  .grid-margin-y > .shrink {
    height: auto;
  }
  .grid-margin-y > .small-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .small-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .small-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .small-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-12 {
    height: calc(100% - 1.875rem);
  }
  .grid-margin-y > .medium-auto {
    height: auto;
  }
  .grid-margin-y > .medium-shrink {
    height: auto;
  }
  .grid-margin-y > .medium-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .medium-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .medium-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .medium-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-12 {
    height: calc(100% - 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-y > .large-auto {
    height: auto;
  }
  .grid-margin-y > .large-shrink {
    height: auto;
  }
  .grid-margin-y > .large-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .large-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .large-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .large-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-12 {
    height: calc(100% - 1.875rem);
  }
}

.grid-frame {
  overflow: hidden;
  position: relative;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100vw;
}

.cell .grid-frame {
  width: 100%;
}

.cell-block {
  overflow-x: auto;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.cell-block-y {
  overflow-y: auto;
  max-height: 100%;
  min-height: 100%;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.cell-block-container {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}
.cell-block-container > .grid-x {
  max-height: 100%;
  flex-wrap: nowrap;
}

@media print, screen and (min-width: 40em) {
  .medium-grid-frame {
    overflow: hidden;
    position: relative;
    flex-wrap: nowrap;
    align-items: stretch;
    width: 100vw;
  }
  .cell .medium-grid-frame {
    width: 100%;
  }
  .medium-cell-block {
    overflow-x: auto;
    max-width: 100%;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .medium-cell-block-container {
    display: flex;
    flex-direction: column;
    max-height: 100%;
  }
  .medium-cell-block-container > .grid-x {
    max-height: 100%;
    flex-wrap: nowrap;
  }
  .medium-cell-block-y {
    overflow-y: auto;
    max-height: 100%;
    min-height: 100%;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
}
@media print, screen and (min-width: 64em) {
  .large-grid-frame {
    overflow: hidden;
    position: relative;
    flex-wrap: nowrap;
    align-items: stretch;
    width: 100vw;
  }
  .cell .large-grid-frame {
    width: 100%;
  }
  .large-cell-block {
    overflow-x: auto;
    max-width: 100%;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .large-cell-block-container {
    display: flex;
    flex-direction: column;
    max-height: 100%;
  }
  .large-cell-block-container > .grid-x {
    max-height: 100%;
    flex-wrap: nowrap;
  }
  .large-cell-block-y {
    overflow-y: auto;
    max-height: 100%;
    min-height: 100%;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
}
.grid-y.grid-frame {
  width: auto;
  overflow: hidden;
  position: relative;
  flex-wrap: nowrap;
  align-items: stretch;
  height: 100vh;
}
@media print, screen and (min-width: 40em) {
  .grid-y.medium-grid-frame {
    width: auto;
    overflow: hidden;
    position: relative;
    flex-wrap: nowrap;
    align-items: stretch;
    height: 100vh;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-y.large-grid-frame {
    width: auto;
    overflow: hidden;
    position: relative;
    flex-wrap: nowrap;
    align-items: stretch;
    height: 100vh;
  }
}

.cell .grid-y.grid-frame {
  height: 100%;
}
@media print, screen and (min-width: 40em) {
  .cell .grid-y.medium-grid-frame {
    height: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .cell .grid-y.large-grid-frame {
    height: 100%;
  }
}

.grid-margin-y {
  margin-top: -0.625rem;
  margin-bottom: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y {
    margin-top: -0.9375rem;
    margin-bottom: -0.9375rem;
  }
}
.grid-margin-y > .cell {
  height: calc(100% - 1.25rem);
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y > .cell {
    height: calc(100% - 1.875rem);
    margin-top: 0.9375rem;
    margin-bottom: 0.9375rem;
  }
}
.grid-margin-y > .auto {
  height: auto;
}
.grid-margin-y > .shrink {
  height: auto;
}
.grid-margin-y > .small-1 {
  height: calc(8.3333333333% - 1.25rem);
}
.grid-margin-y > .small-2 {
  height: calc(16.6666666667% - 1.25rem);
}
.grid-margin-y > .small-3 {
  height: calc(25% - 1.25rem);
}
.grid-margin-y > .small-4 {
  height: calc(33.3333333333% - 1.25rem);
}
.grid-margin-y > .small-5 {
  height: calc(41.6666666667% - 1.25rem);
}
.grid-margin-y > .small-6 {
  height: calc(50% - 1.25rem);
}
.grid-margin-y > .small-7 {
  height: calc(58.3333333333% - 1.25rem);
}
.grid-margin-y > .small-8 {
  height: calc(66.6666666667% - 1.25rem);
}
.grid-margin-y > .small-9 {
  height: calc(75% - 1.25rem);
}
.grid-margin-y > .small-10 {
  height: calc(83.3333333333% - 1.25rem);
}
.grid-margin-y > .small-11 {
  height: calc(91.6666666667% - 1.25rem);
}
.grid-margin-y > .small-12 {
  height: calc(100% - 1.25rem);
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y > .auto {
    height: auto;
  }
  .grid-margin-y > .shrink {
    height: auto;
  }
  .grid-margin-y > .small-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .small-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .small-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .small-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-12 {
    height: calc(100% - 1.875rem);
  }
  .grid-margin-y > .medium-auto {
    height: auto;
  }
  .grid-margin-y > .medium-shrink {
    height: auto;
  }
  .grid-margin-y > .medium-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .medium-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .medium-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .medium-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-12 {
    height: calc(100% - 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-y > .large-auto {
    height: auto;
  }
  .grid-margin-y > .large-shrink {
    height: auto;
  }
  .grid-margin-y > .large-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .large-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .large-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .large-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-12 {
    height: calc(100% - 1.875rem);
  }
}

.grid-frame.grid-margin-y {
  height: calc(100vh + 1.25rem);
}
@media print, screen and (min-width: 40em) {
  .grid-frame.grid-margin-y {
    height: calc(100vh + 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-frame.grid-margin-y {
    height: calc(100vh + 1.875rem);
  }
}

@media print, screen and (min-width: 40em) {
  .grid-margin-y.medium-grid-frame {
    height: calc(100vh + 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-y.large-grid-frame {
    height: calc(100vh + 1.875rem);
  }
}
.button {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 1rem 0;
  padding: 0.85em 1em;
  border: 1px solid transparent;
  border-radius: 3px;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  -webkit-appearance: none;
  line-height: 1;
  text-align: center;
  cursor: pointer;
}
[data-whatinput=mouse] .button {
  outline: 0;
}
.button.tiny {
  font-size: 0.6rem;
}
.button.small {
  font-size: 0.75rem;
}
.button.large {
  font-size: 1.25rem;
}
.button.expanded {
  display: block;
  width: 100%;
  margin-right: 0;
  margin-left: 0;
}
.button, .button.disabled, .button[disabled], .button.disabled:hover, .button[disabled]:hover, .button.disabled:focus, .button[disabled]:focus {
  background-color: #FF2476;
  color: #fff;
}
.button:hover, .button:focus {
  background-color: rgb(247.35, 0, 92.6150684932);
  color: #fff;
}
.button.primary, .button.primary.disabled, .button.primary[disabled], .button.primary.disabled:hover, .button.primary[disabled]:hover, .button.primary.disabled:focus, .button.primary[disabled]:focus {
  background-color: #FF2476;
  color: #fff;
}
.button.primary:hover, .button.primary:focus {
  background-color: rgb(232.8, 0, 87.1671232877);
  color: #fff;
}
.button.secondary, .button.secondary.disabled, .button.secondary[disabled], .button.secondary.disabled:hover, .button.secondary[disabled]:hover, .button.secondary.disabled:focus, .button.secondary[disabled]:focus {
  background-color: #00BAEF;
  color: #333;
}
.button.secondary:hover, .button.secondary:focus {
  background-color: rgb(0, 148.8, 191.2);
  color: #333;
}
.button.default, .button.default.disabled, .button.default[disabled], .button.default.disabled:hover, .button.default[disabled]:hover, .button.default.disabled:focus, .button.default[disabled]:focus {
  background-color: #F2F3F4;
  color: #333;
}
.button.default:hover, .button.default:focus {
  background-color: rgb(189.35, 194.4, 199.45);
  color: #333;
}
.button.success, .button.success.disabled, .button.success[disabled], .button.success.disabled:hover, .button.success[disabled]:hover, .button.success.disabled:focus, .button.success[disabled]:focus {
  background-color: #0AC775;
  color: #333;
}
.button.success:hover, .button.success:focus {
  background-color: rgb(8, 159.2, 93.6);
  color: #333;
}
.button.warning, .button.warning.disabled, .button.warning[disabled], .button.warning.disabled:hover, .button.warning[disabled]:hover, .button.warning.disabled:focus, .button.warning[disabled]:focus {
  background-color: #FFA501;
  color: #333;
}
.button.warning:hover, .button.warning:focus {
  background-color: rgb(204.8, 132.2330708661, 0);
  color: #333;
}
.button.alert, .button.alert.disabled, .button.alert[disabled], .button.alert.disabled:hover, .button.alert[disabled]:hover, .button.alert.disabled:focus, .button.alert[disabled]:focus {
  background-color: #E31926;
  color: #fff;
}
.button.alert:hover, .button.alert:focus {
  background-color: rgb(181.6, 20, 30.4);
  color: #fff;
}
.button.white, .button.white.disabled, .button.white[disabled], .button.white.disabled:hover, .button.white[disabled]:hover, .button.white.disabled:focus, .button.white[disabled]:focus {
  background-color: #FFFFFF;
  color: #333;
}
.button.white:hover, .button.white:focus {
  background-color: #cccccc;
  color: #333;
}
.button.info, .button.info.disabled, .button.info[disabled], .button.info.disabled:hover, .button.info[disabled]:hover, .button.info.disabled:focus, .button.info[disabled]:focus {
  background-color: #1F7CC1;
  color: #fff;
}
.button.info:hover, .button.info:focus {
  background-color: rgb(24.8, 99.2, 154.4);
  color: #fff;
}
.button.black, .button.black.disabled, .button.black[disabled], .button.black.disabled:hover, .button.black[disabled]:hover, .button.black.disabled:focus, .button.black[disabled]:focus {
  background-color: #333333;
  color: #fff;
}
.button.black:hover, .button.black:focus {
  background-color: rgb(40.8, 40.8, 40.8);
  color: #fff;
}
.button.hollow, .button.hollow:hover, .button.hollow:focus, .button.hollow.disabled, .button.hollow.disabled:hover, .button.hollow.disabled:focus, .button.hollow[disabled], .button.hollow[disabled]:hover, .button.hollow[disabled]:focus {
  background-color: transparent;
}
.button.hollow, .button.hollow.disabled, .button.hollow[disabled], .button.hollow.disabled:hover, .button.hollow[disabled]:hover, .button.hollow.disabled:focus, .button.hollow[disabled]:focus {
  border: 1px solid #FF2476;
  color: #FF2476;
}
.button.hollow:hover, .button.hollow:focus {
  border-color: rgb(145.5, 0, 54.4794520548);
  color: rgb(145.5, 0, 54.4794520548);
}
.button.hollow.primary, .button.hollow.primary.disabled, .button.hollow.primary[disabled], .button.hollow.primary.disabled:hover, .button.hollow.primary[disabled]:hover, .button.hollow.primary.disabled:focus, .button.hollow.primary[disabled]:focus {
  border: 1px solid #FF2476;
  color: #FF2476;
}
.button.hollow.primary:hover, .button.hollow.primary:focus {
  border-color: rgb(145.5, 0, 54.4794520548);
  color: rgb(145.5, 0, 54.4794520548);
}
.button.hollow.secondary, .button.hollow.secondary.disabled, .button.hollow.secondary[disabled], .button.hollow.secondary.disabled:hover, .button.hollow.secondary[disabled]:hover, .button.hollow.secondary.disabled:focus, .button.hollow.secondary[disabled]:focus {
  border: 1px solid #00BAEF;
  color: #00BAEF;
}
.button.hollow.secondary:hover, .button.hollow.secondary:focus {
  border-color: rgb(0, 93, 119.5);
  color: rgb(0, 93, 119.5);
}
.button.hollow.default, .button.hollow.default.disabled, .button.hollow.default[disabled], .button.hollow.default.disabled:hover, .button.hollow.default[disabled]:hover, .button.hollow.default.disabled:focus, .button.hollow.default[disabled]:focus {
  border: 1px solid #F2F3F4;
  color: #F2F3F4;
}
.button.hollow.default:hover, .button.hollow.default:focus {
  border-color: rgb(111.375, 121.5, 131.625);
  color: rgb(111.375, 121.5, 131.625);
}
.button.hollow.success, .button.hollow.success.disabled, .button.hollow.success[disabled], .button.hollow.success.disabled:hover, .button.hollow.success[disabled]:hover, .button.hollow.success.disabled:focus, .button.hollow.success[disabled]:focus {
  border: 1px solid #0AC775;
  color: #0AC775;
}
.button.hollow.success:hover, .button.hollow.success:focus {
  border-color: rgb(5, 99.5, 58.5);
  color: rgb(5, 99.5, 58.5);
}
.button.hollow.warning, .button.hollow.warning.disabled, .button.hollow.warning[disabled], .button.hollow.warning.disabled:hover, .button.hollow.warning[disabled]:hover, .button.hollow.warning.disabled:focus, .button.hollow.warning[disabled]:focus {
  border: 1px solid #FFA501;
  color: #FFA501;
}
.button.hollow.warning:hover, .button.hollow.warning:focus {
  border-color: rgb(128, 82.6456692913, 0);
  color: rgb(128, 82.6456692913, 0);
}
.button.hollow.alert, .button.hollow.alert.disabled, .button.hollow.alert[disabled], .button.hollow.alert.disabled:hover, .button.hollow.alert[disabled]:hover, .button.hollow.alert.disabled:focus, .button.hollow.alert[disabled]:focus {
  border: 1px solid #E31926;
  color: #E31926;
}
.button.hollow.alert:hover, .button.hollow.alert:focus {
  border-color: rgb(113.5, 12.5, 19);
  color: rgb(113.5, 12.5, 19);
}
.button.hollow.white, .button.hollow.white.disabled, .button.hollow.white[disabled], .button.hollow.white.disabled:hover, .button.hollow.white[disabled]:hover, .button.hollow.white.disabled:focus, .button.hollow.white[disabled]:focus {
  border: 1px solid #FFFFFF;
  color: #FFFFFF;
}
.button.hollow.white:hover, .button.hollow.white:focus {
  border-color: rgb(127.5, 127.5, 127.5);
  color: rgb(127.5, 127.5, 127.5);
}
.button.hollow.info, .button.hollow.info.disabled, .button.hollow.info[disabled], .button.hollow.info.disabled:hover, .button.hollow.info[disabled]:hover, .button.hollow.info.disabled:focus, .button.hollow.info[disabled]:focus {
  border: 1px solid #1F7CC1;
  color: #1F7CC1;
}
.button.hollow.info:hover, .button.hollow.info:focus {
  border-color: rgb(15.5, 62, 96.5);
  color: rgb(15.5, 62, 96.5);
}
.button.hollow.black, .button.hollow.black.disabled, .button.hollow.black[disabled], .button.hollow.black.disabled:hover, .button.hollow.black[disabled]:hover, .button.hollow.black.disabled:focus, .button.hollow.black[disabled]:focus {
  border: 1px solid #333333;
  color: #333333;
}
.button.hollow.black:hover, .button.hollow.black:focus {
  border-color: rgb(25.5, 25.5, 25.5);
  color: rgb(25.5, 25.5, 25.5);
}
.button.clear, .button.clear:hover, .button.clear:focus, .button.clear.disabled, .button.clear.disabled:hover, .button.clear.disabled:focus, .button.clear[disabled], .button.clear[disabled]:hover, .button.clear[disabled]:focus {
  border-color: transparent;
  background-color: transparent;
}
.button.clear, .button.clear.disabled, .button.clear[disabled], .button.clear.disabled:hover, .button.clear[disabled]:hover, .button.clear.disabled:focus, .button.clear[disabled]:focus {
  color: #FF2476;
}
.button.clear:hover, .button.clear:focus {
  color: rgb(145.5, 0, 54.4794520548);
}
.button.clear.primary, .button.clear.primary.disabled, .button.clear.primary[disabled], .button.clear.primary.disabled:hover, .button.clear.primary[disabled]:hover, .button.clear.primary.disabled:focus, .button.clear.primary[disabled]:focus {
  color: #FF2476;
}
.button.clear.primary:hover, .button.clear.primary:focus {
  color: rgb(145.5, 0, 54.4794520548);
}
.button.clear.secondary, .button.clear.secondary.disabled, .button.clear.secondary[disabled], .button.clear.secondary.disabled:hover, .button.clear.secondary[disabled]:hover, .button.clear.secondary.disabled:focus, .button.clear.secondary[disabled]:focus {
  color: #00BAEF;
}
.button.clear.secondary:hover, .button.clear.secondary:focus {
  color: rgb(0, 93, 119.5);
}
.button.clear.default, .button.clear.default.disabled, .button.clear.default[disabled], .button.clear.default.disabled:hover, .button.clear.default[disabled]:hover, .button.clear.default.disabled:focus, .button.clear.default[disabled]:focus {
  color: #F2F3F4;
}
.button.clear.default:hover, .button.clear.default:focus {
  color: rgb(111.375, 121.5, 131.625);
}
.button.clear.success, .button.clear.success.disabled, .button.clear.success[disabled], .button.clear.success.disabled:hover, .button.clear.success[disabled]:hover, .button.clear.success.disabled:focus, .button.clear.success[disabled]:focus {
  color: #0AC775;
}
.button.clear.success:hover, .button.clear.success:focus {
  color: rgb(5, 99.5, 58.5);
}
.button.clear.warning, .button.clear.warning.disabled, .button.clear.warning[disabled], .button.clear.warning.disabled:hover, .button.clear.warning[disabled]:hover, .button.clear.warning.disabled:focus, .button.clear.warning[disabled]:focus {
  color: #FFA501;
}
.button.clear.warning:hover, .button.clear.warning:focus {
  color: rgb(128, 82.6456692913, 0);
}
.button.clear.alert, .button.clear.alert.disabled, .button.clear.alert[disabled], .button.clear.alert.disabled:hover, .button.clear.alert[disabled]:hover, .button.clear.alert.disabled:focus, .button.clear.alert[disabled]:focus {
  color: #E31926;
}
.button.clear.alert:hover, .button.clear.alert:focus {
  color: rgb(113.5, 12.5, 19);
}
.button.clear.white, .button.clear.white.disabled, .button.clear.white[disabled], .button.clear.white.disabled:hover, .button.clear.white[disabled]:hover, .button.clear.white.disabled:focus, .button.clear.white[disabled]:focus {
  color: #FFFFFF;
}
.button.clear.white:hover, .button.clear.white:focus {
  color: rgb(127.5, 127.5, 127.5);
}
.button.clear.info, .button.clear.info.disabled, .button.clear.info[disabled], .button.clear.info.disabled:hover, .button.clear.info[disabled]:hover, .button.clear.info.disabled:focus, .button.clear.info[disabled]:focus {
  color: #1F7CC1;
}
.button.clear.info:hover, .button.clear.info:focus {
  color: rgb(15.5, 62, 96.5);
}
.button.clear.black, .button.clear.black.disabled, .button.clear.black[disabled], .button.clear.black.disabled:hover, .button.clear.black[disabled]:hover, .button.clear.black.disabled:focus, .button.clear.black[disabled]:focus {
  color: #333333;
}
.button.clear.black:hover, .button.clear.black:focus {
  color: rgb(25.5, 25.5, 25.5);
}
.button.disabled, .button[disabled] {
  opacity: 0.25;
  cursor: not-allowed;
}
.button.dropdown::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 0.4em;
  content: "";
  border-bottom-width: 0;
  border-top-style: solid;
  border-color: #fff transparent transparent;
  position: relative;
  top: 0.4em;
  display: inline-block;
  float: right;
  margin-left: 1em;
}
.button.dropdown.hollow::after, .button.dropdown.clear::after {
  border-top-color: #FF2476;
}
.button.dropdown.hollow.primary::after, .button.dropdown.clear.primary::after {
  border-top-color: #FF2476;
}
.button.dropdown.hollow.secondary::after, .button.dropdown.clear.secondary::after {
  border-top-color: #00BAEF;
}
.button.dropdown.hollow.default::after, .button.dropdown.clear.default::after {
  border-top-color: #F2F3F4;
}
.button.dropdown.hollow.success::after, .button.dropdown.clear.success::after {
  border-top-color: #0AC775;
}
.button.dropdown.hollow.warning::after, .button.dropdown.clear.warning::after {
  border-top-color: #FFA501;
}
.button.dropdown.hollow.alert::after, .button.dropdown.clear.alert::after {
  border-top-color: #E31926;
}
.button.dropdown.hollow.white::after, .button.dropdown.clear.white::after {
  border-top-color: #FFFFFF;
}
.button.dropdown.hollow.info::after, .button.dropdown.clear.info::after {
  border-top-color: #1F7CC1;
}
.button.dropdown.hollow.black::after, .button.dropdown.clear.black::after {
  border-top-color: #333333;
}
.button.arrow-only::after {
  top: -0.1em;
  float: none;
  margin-left: 0;
}

a.button:hover, a.button:focus {
  text-decoration: none;
}

.button-group {
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  flex-grow: 1;
}
.button-group::before, .button-group::after {
  display: table;
  content: " ";
  flex-basis: 0;
  order: 1;
}
.button-group::after {
  clear: both;
}
.button-group::before, .button-group::after {
  display: none;
}
.button-group .button {
  margin: 0;
  margin-right: 1px;
  margin-bottom: 1px;
  font-size: 0.9rem;
  flex: 0 0 auto;
}
.button-group .button:last-child {
  margin-right: 0;
}
.button-group.tiny .button {
  font-size: 0.6rem;
}
.button-group.small .button {
  font-size: 0.75rem;
}
.button-group.large .button {
  font-size: 1.25rem;
}
.button-group.expanded .button {
  flex: 1 1;
  margin-right: 0;
}
.button-group.primary .button, .button-group.primary .button.disabled, .button-group.primary .button[disabled], .button-group.primary .button.disabled:hover, .button-group.primary .button[disabled]:hover, .button-group.primary .button.disabled:focus, .button-group.primary .button[disabled]:focus {
  background-color: #FF2476;
  color: #fff;
}
.button-group.primary .button:hover, .button-group.primary .button:focus {
  background-color: rgb(232.8, 0, 87.1671232877);
  color: #fff;
}
.button-group.secondary .button, .button-group.secondary .button.disabled, .button-group.secondary .button[disabled], .button-group.secondary .button.disabled:hover, .button-group.secondary .button[disabled]:hover, .button-group.secondary .button.disabled:focus, .button-group.secondary .button[disabled]:focus {
  background-color: #00BAEF;
  color: #333;
}
.button-group.secondary .button:hover, .button-group.secondary .button:focus {
  background-color: rgb(0, 148.8, 191.2);
  color: #333;
}
.button-group.default .button, .button-group.default .button.disabled, .button-group.default .button[disabled], .button-group.default .button.disabled:hover, .button-group.default .button[disabled]:hover, .button-group.default .button.disabled:focus, .button-group.default .button[disabled]:focus {
  background-color: #F2F3F4;
  color: #333;
}
.button-group.default .button:hover, .button-group.default .button:focus {
  background-color: rgb(189.35, 194.4, 199.45);
  color: #333;
}
.button-group.success .button, .button-group.success .button.disabled, .button-group.success .button[disabled], .button-group.success .button.disabled:hover, .button-group.success .button[disabled]:hover, .button-group.success .button.disabled:focus, .button-group.success .button[disabled]:focus {
  background-color: #0AC775;
  color: #333;
}
.button-group.success .button:hover, .button-group.success .button:focus {
  background-color: rgb(8, 159.2, 93.6);
  color: #333;
}
.button-group.warning .button, .button-group.warning .button.disabled, .button-group.warning .button[disabled], .button-group.warning .button.disabled:hover, .button-group.warning .button[disabled]:hover, .button-group.warning .button.disabled:focus, .button-group.warning .button[disabled]:focus {
  background-color: #FFA501;
  color: #333;
}
.button-group.warning .button:hover, .button-group.warning .button:focus {
  background-color: rgb(204.8, 132.2330708661, 0);
  color: #333;
}
.button-group.alert .button, .button-group.alert .button.disabled, .button-group.alert .button[disabled], .button-group.alert .button.disabled:hover, .button-group.alert .button[disabled]:hover, .button-group.alert .button.disabled:focus, .button-group.alert .button[disabled]:focus {
  background-color: #E31926;
  color: #fff;
}
.button-group.alert .button:hover, .button-group.alert .button:focus {
  background-color: rgb(181.6, 20, 30.4);
  color: #fff;
}
.button-group.white .button, .button-group.white .button.disabled, .button-group.white .button[disabled], .button-group.white .button.disabled:hover, .button-group.white .button[disabled]:hover, .button-group.white .button.disabled:focus, .button-group.white .button[disabled]:focus {
  background-color: #FFFFFF;
  color: #333;
}
.button-group.white .button:hover, .button-group.white .button:focus {
  background-color: #cccccc;
  color: #333;
}
.button-group.info .button, .button-group.info .button.disabled, .button-group.info .button[disabled], .button-group.info .button.disabled:hover, .button-group.info .button[disabled]:hover, .button-group.info .button.disabled:focus, .button-group.info .button[disabled]:focus {
  background-color: #1F7CC1;
  color: #fff;
}
.button-group.info .button:hover, .button-group.info .button:focus {
  background-color: rgb(24.8, 99.2, 154.4);
  color: #fff;
}
.button-group.black .button, .button-group.black .button.disabled, .button-group.black .button[disabled], .button-group.black .button.disabled:hover, .button-group.black .button[disabled]:hover, .button-group.black .button.disabled:focus, .button-group.black .button[disabled]:focus {
  background-color: #333333;
  color: #fff;
}
.button-group.black .button:hover, .button-group.black .button:focus {
  background-color: rgb(40.8, 40.8, 40.8);
  color: #fff;
}
.button-group.hollow .button, .button-group.hollow .button:hover, .button-group.hollow .button:focus, .button-group.hollow .button.disabled, .button-group.hollow .button.disabled:hover, .button-group.hollow .button.disabled:focus, .button-group.hollow .button[disabled], .button-group.hollow .button[disabled]:hover, .button-group.hollow .button[disabled]:focus {
  background-color: transparent;
}
.button-group.hollow .button, .button-group.hollow .button.disabled, .button-group.hollow .button[disabled], .button-group.hollow .button.disabled:hover, .button-group.hollow .button[disabled]:hover, .button-group.hollow .button.disabled:focus, .button-group.hollow .button[disabled]:focus {
  border: 1px solid #FF2476;
  color: #FF2476;
}
.button-group.hollow .button:hover, .button-group.hollow .button:focus {
  border-color: rgb(145.5, 0, 54.4794520548);
  color: rgb(145.5, 0, 54.4794520548);
}
.button-group.hollow.primary .button, .button-group.hollow.primary .button.disabled, .button-group.hollow.primary .button[disabled], .button-group.hollow.primary .button.disabled:hover, .button-group.hollow.primary .button[disabled]:hover, .button-group.hollow.primary .button.disabled:focus, .button-group.hollow.primary .button[disabled]:focus, .button-group.hollow .button.primary, .button-group.hollow .button.primary.disabled, .button-group.hollow .button.primary[disabled], .button-group.hollow .button.primary.disabled:hover, .button-group.hollow .button.primary[disabled]:hover, .button-group.hollow .button.primary.disabled:focus, .button-group.hollow .button.primary[disabled]:focus {
  border: 1px solid #FF2476;
  color: #FF2476;
}
.button-group.hollow.primary .button:hover, .button-group.hollow.primary .button:focus, .button-group.hollow .button.primary:hover, .button-group.hollow .button.primary:focus {
  border-color: rgb(145.5, 0, 54.4794520548);
  color: rgb(145.5, 0, 54.4794520548);
}
.button-group.hollow.secondary .button, .button-group.hollow.secondary .button.disabled, .button-group.hollow.secondary .button[disabled], .button-group.hollow.secondary .button.disabled:hover, .button-group.hollow.secondary .button[disabled]:hover, .button-group.hollow.secondary .button.disabled:focus, .button-group.hollow.secondary .button[disabled]:focus, .button-group.hollow .button.secondary, .button-group.hollow .button.secondary.disabled, .button-group.hollow .button.secondary[disabled], .button-group.hollow .button.secondary.disabled:hover, .button-group.hollow .button.secondary[disabled]:hover, .button-group.hollow .button.secondary.disabled:focus, .button-group.hollow .button.secondary[disabled]:focus {
  border: 1px solid #00BAEF;
  color: #00BAEF;
}
.button-group.hollow.secondary .button:hover, .button-group.hollow.secondary .button:focus, .button-group.hollow .button.secondary:hover, .button-group.hollow .button.secondary:focus {
  border-color: rgb(0, 93, 119.5);
  color: rgb(0, 93, 119.5);
}
.button-group.hollow.default .button, .button-group.hollow.default .button.disabled, .button-group.hollow.default .button[disabled], .button-group.hollow.default .button.disabled:hover, .button-group.hollow.default .button[disabled]:hover, .button-group.hollow.default .button.disabled:focus, .button-group.hollow.default .button[disabled]:focus, .button-group.hollow .button.default, .button-group.hollow .button.default.disabled, .button-group.hollow .button.default[disabled], .button-group.hollow .button.default.disabled:hover, .button-group.hollow .button.default[disabled]:hover, .button-group.hollow .button.default.disabled:focus, .button-group.hollow .button.default[disabled]:focus {
  border: 1px solid #F2F3F4;
  color: #F2F3F4;
}
.button-group.hollow.default .button:hover, .button-group.hollow.default .button:focus, .button-group.hollow .button.default:hover, .button-group.hollow .button.default:focus {
  border-color: rgb(111.375, 121.5, 131.625);
  color: rgb(111.375, 121.5, 131.625);
}
.button-group.hollow.success .button, .button-group.hollow.success .button.disabled, .button-group.hollow.success .button[disabled], .button-group.hollow.success .button.disabled:hover, .button-group.hollow.success .button[disabled]:hover, .button-group.hollow.success .button.disabled:focus, .button-group.hollow.success .button[disabled]:focus, .button-group.hollow .button.success, .button-group.hollow .button.success.disabled, .button-group.hollow .button.success[disabled], .button-group.hollow .button.success.disabled:hover, .button-group.hollow .button.success[disabled]:hover, .button-group.hollow .button.success.disabled:focus, .button-group.hollow .button.success[disabled]:focus {
  border: 1px solid #0AC775;
  color: #0AC775;
}
.button-group.hollow.success .button:hover, .button-group.hollow.success .button:focus, .button-group.hollow .button.success:hover, .button-group.hollow .button.success:focus {
  border-color: rgb(5, 99.5, 58.5);
  color: rgb(5, 99.5, 58.5);
}
.button-group.hollow.warning .button, .button-group.hollow.warning .button.disabled, .button-group.hollow.warning .button[disabled], .button-group.hollow.warning .button.disabled:hover, .button-group.hollow.warning .button[disabled]:hover, .button-group.hollow.warning .button.disabled:focus, .button-group.hollow.warning .button[disabled]:focus, .button-group.hollow .button.warning, .button-group.hollow .button.warning.disabled, .button-group.hollow .button.warning[disabled], .button-group.hollow .button.warning.disabled:hover, .button-group.hollow .button.warning[disabled]:hover, .button-group.hollow .button.warning.disabled:focus, .button-group.hollow .button.warning[disabled]:focus {
  border: 1px solid #FFA501;
  color: #FFA501;
}
.button-group.hollow.warning .button:hover, .button-group.hollow.warning .button:focus, .button-group.hollow .button.warning:hover, .button-group.hollow .button.warning:focus {
  border-color: rgb(128, 82.6456692913, 0);
  color: rgb(128, 82.6456692913, 0);
}
.button-group.hollow.alert .button, .button-group.hollow.alert .button.disabled, .button-group.hollow.alert .button[disabled], .button-group.hollow.alert .button.disabled:hover, .button-group.hollow.alert .button[disabled]:hover, .button-group.hollow.alert .button.disabled:focus, .button-group.hollow.alert .button[disabled]:focus, .button-group.hollow .button.alert, .button-group.hollow .button.alert.disabled, .button-group.hollow .button.alert[disabled], .button-group.hollow .button.alert.disabled:hover, .button-group.hollow .button.alert[disabled]:hover, .button-group.hollow .button.alert.disabled:focus, .button-group.hollow .button.alert[disabled]:focus {
  border: 1px solid #E31926;
  color: #E31926;
}
.button-group.hollow.alert .button:hover, .button-group.hollow.alert .button:focus, .button-group.hollow .button.alert:hover, .button-group.hollow .button.alert:focus {
  border-color: rgb(113.5, 12.5, 19);
  color: rgb(113.5, 12.5, 19);
}
.button-group.hollow.white .button, .button-group.hollow.white .button.disabled, .button-group.hollow.white .button[disabled], .button-group.hollow.white .button.disabled:hover, .button-group.hollow.white .button[disabled]:hover, .button-group.hollow.white .button.disabled:focus, .button-group.hollow.white .button[disabled]:focus, .button-group.hollow .button.white, .button-group.hollow .button.white.disabled, .button-group.hollow .button.white[disabled], .button-group.hollow .button.white.disabled:hover, .button-group.hollow .button.white[disabled]:hover, .button-group.hollow .button.white.disabled:focus, .button-group.hollow .button.white[disabled]:focus {
  border: 1px solid #FFFFFF;
  color: #FFFFFF;
}
.button-group.hollow.white .button:hover, .button-group.hollow.white .button:focus, .button-group.hollow .button.white:hover, .button-group.hollow .button.white:focus {
  border-color: rgb(127.5, 127.5, 127.5);
  color: rgb(127.5, 127.5, 127.5);
}
.button-group.hollow.info .button, .button-group.hollow.info .button.disabled, .button-group.hollow.info .button[disabled], .button-group.hollow.info .button.disabled:hover, .button-group.hollow.info .button[disabled]:hover, .button-group.hollow.info .button.disabled:focus, .button-group.hollow.info .button[disabled]:focus, .button-group.hollow .button.info, .button-group.hollow .button.info.disabled, .button-group.hollow .button.info[disabled], .button-group.hollow .button.info.disabled:hover, .button-group.hollow .button.info[disabled]:hover, .button-group.hollow .button.info.disabled:focus, .button-group.hollow .button.info[disabled]:focus {
  border: 1px solid #1F7CC1;
  color: #1F7CC1;
}
.button-group.hollow.info .button:hover, .button-group.hollow.info .button:focus, .button-group.hollow .button.info:hover, .button-group.hollow .button.info:focus {
  border-color: rgb(15.5, 62, 96.5);
  color: rgb(15.5, 62, 96.5);
}
.button-group.hollow.black .button, .button-group.hollow.black .button.disabled, .button-group.hollow.black .button[disabled], .button-group.hollow.black .button.disabled:hover, .button-group.hollow.black .button[disabled]:hover, .button-group.hollow.black .button.disabled:focus, .button-group.hollow.black .button[disabled]:focus, .button-group.hollow .button.black, .button-group.hollow .button.black.disabled, .button-group.hollow .button.black[disabled], .button-group.hollow .button.black.disabled:hover, .button-group.hollow .button.black[disabled]:hover, .button-group.hollow .button.black.disabled:focus, .button-group.hollow .button.black[disabled]:focus {
  border: 1px solid #333333;
  color: #333333;
}
.button-group.hollow.black .button:hover, .button-group.hollow.black .button:focus, .button-group.hollow .button.black:hover, .button-group.hollow .button.black:focus {
  border-color: rgb(25.5, 25.5, 25.5);
  color: rgb(25.5, 25.5, 25.5);
}
.button-group.clear .button, .button-group.clear .button:hover, .button-group.clear .button:focus, .button-group.clear .button.disabled, .button-group.clear .button.disabled:hover, .button-group.clear .button.disabled:focus, .button-group.clear .button[disabled], .button-group.clear .button[disabled]:hover, .button-group.clear .button[disabled]:focus {
  border-color: transparent;
  background-color: transparent;
}
.button-group.clear .button, .button-group.clear .button.disabled, .button-group.clear .button[disabled], .button-group.clear .button.disabled:hover, .button-group.clear .button[disabled]:hover, .button-group.clear .button.disabled:focus, .button-group.clear .button[disabled]:focus {
  color: #FF2476;
}
.button-group.clear .button:hover, .button-group.clear .button:focus {
  color: rgb(145.5, 0, 54.4794520548);
}
.button-group.clear.primary .button, .button-group.clear.primary .button.disabled, .button-group.clear.primary .button[disabled], .button-group.clear.primary .button.disabled:hover, .button-group.clear.primary .button[disabled]:hover, .button-group.clear.primary .button.disabled:focus, .button-group.clear.primary .button[disabled]:focus, .button-group.clear .button.primary, .button-group.clear .button.primary.disabled, .button-group.clear .button.primary[disabled], .button-group.clear .button.primary.disabled:hover, .button-group.clear .button.primary[disabled]:hover, .button-group.clear .button.primary.disabled:focus, .button-group.clear .button.primary[disabled]:focus {
  color: #FF2476;
}
.button-group.clear.primary .button:hover, .button-group.clear.primary .button:focus, .button-group.clear .button.primary:hover, .button-group.clear .button.primary:focus {
  color: rgb(145.5, 0, 54.4794520548);
}
.button-group.clear.secondary .button, .button-group.clear.secondary .button.disabled, .button-group.clear.secondary .button[disabled], .button-group.clear.secondary .button.disabled:hover, .button-group.clear.secondary .button[disabled]:hover, .button-group.clear.secondary .button.disabled:focus, .button-group.clear.secondary .button[disabled]:focus, .button-group.clear .button.secondary, .button-group.clear .button.secondary.disabled, .button-group.clear .button.secondary[disabled], .button-group.clear .button.secondary.disabled:hover, .button-group.clear .button.secondary[disabled]:hover, .button-group.clear .button.secondary.disabled:focus, .button-group.clear .button.secondary[disabled]:focus {
  color: #00BAEF;
}
.button-group.clear.secondary .button:hover, .button-group.clear.secondary .button:focus, .button-group.clear .button.secondary:hover, .button-group.clear .button.secondary:focus {
  color: rgb(0, 93, 119.5);
}
.button-group.clear.default .button, .button-group.clear.default .button.disabled, .button-group.clear.default .button[disabled], .button-group.clear.default .button.disabled:hover, .button-group.clear.default .button[disabled]:hover, .button-group.clear.default .button.disabled:focus, .button-group.clear.default .button[disabled]:focus, .button-group.clear .button.default, .button-group.clear .button.default.disabled, .button-group.clear .button.default[disabled], .button-group.clear .button.default.disabled:hover, .button-group.clear .button.default[disabled]:hover, .button-group.clear .button.default.disabled:focus, .button-group.clear .button.default[disabled]:focus {
  color: #F2F3F4;
}
.button-group.clear.default .button:hover, .button-group.clear.default .button:focus, .button-group.clear .button.default:hover, .button-group.clear .button.default:focus {
  color: rgb(111.375, 121.5, 131.625);
}
.button-group.clear.success .button, .button-group.clear.success .button.disabled, .button-group.clear.success .button[disabled], .button-group.clear.success .button.disabled:hover, .button-group.clear.success .button[disabled]:hover, .button-group.clear.success .button.disabled:focus, .button-group.clear.success .button[disabled]:focus, .button-group.clear .button.success, .button-group.clear .button.success.disabled, .button-group.clear .button.success[disabled], .button-group.clear .button.success.disabled:hover, .button-group.clear .button.success[disabled]:hover, .button-group.clear .button.success.disabled:focus, .button-group.clear .button.success[disabled]:focus {
  color: #0AC775;
}
.button-group.clear.success .button:hover, .button-group.clear.success .button:focus, .button-group.clear .button.success:hover, .button-group.clear .button.success:focus {
  color: rgb(5, 99.5, 58.5);
}
.button-group.clear.warning .button, .button-group.clear.warning .button.disabled, .button-group.clear.warning .button[disabled], .button-group.clear.warning .button.disabled:hover, .button-group.clear.warning .button[disabled]:hover, .button-group.clear.warning .button.disabled:focus, .button-group.clear.warning .button[disabled]:focus, .button-group.clear .button.warning, .button-group.clear .button.warning.disabled, .button-group.clear .button.warning[disabled], .button-group.clear .button.warning.disabled:hover, .button-group.clear .button.warning[disabled]:hover, .button-group.clear .button.warning.disabled:focus, .button-group.clear .button.warning[disabled]:focus {
  color: #FFA501;
}
.button-group.clear.warning .button:hover, .button-group.clear.warning .button:focus, .button-group.clear .button.warning:hover, .button-group.clear .button.warning:focus {
  color: rgb(128, 82.6456692913, 0);
}
.button-group.clear.alert .button, .button-group.clear.alert .button.disabled, .button-group.clear.alert .button[disabled], .button-group.clear.alert .button.disabled:hover, .button-group.clear.alert .button[disabled]:hover, .button-group.clear.alert .button.disabled:focus, .button-group.clear.alert .button[disabled]:focus, .button-group.clear .button.alert, .button-group.clear .button.alert.disabled, .button-group.clear .button.alert[disabled], .button-group.clear .button.alert.disabled:hover, .button-group.clear .button.alert[disabled]:hover, .button-group.clear .button.alert.disabled:focus, .button-group.clear .button.alert[disabled]:focus {
  color: #E31926;
}
.button-group.clear.alert .button:hover, .button-group.clear.alert .button:focus, .button-group.clear .button.alert:hover, .button-group.clear .button.alert:focus {
  color: rgb(113.5, 12.5, 19);
}
.button-group.clear.white .button, .button-group.clear.white .button.disabled, .button-group.clear.white .button[disabled], .button-group.clear.white .button.disabled:hover, .button-group.clear.white .button[disabled]:hover, .button-group.clear.white .button.disabled:focus, .button-group.clear.white .button[disabled]:focus, .button-group.clear .button.white, .button-group.clear .button.white.disabled, .button-group.clear .button.white[disabled], .button-group.clear .button.white.disabled:hover, .button-group.clear .button.white[disabled]:hover, .button-group.clear .button.white.disabled:focus, .button-group.clear .button.white[disabled]:focus {
  color: #FFFFFF;
}
.button-group.clear.white .button:hover, .button-group.clear.white .button:focus, .button-group.clear .button.white:hover, .button-group.clear .button.white:focus {
  color: rgb(127.5, 127.5, 127.5);
}
.button-group.clear.info .button, .button-group.clear.info .button.disabled, .button-group.clear.info .button[disabled], .button-group.clear.info .button.disabled:hover, .button-group.clear.info .button[disabled]:hover, .button-group.clear.info .button.disabled:focus, .button-group.clear.info .button[disabled]:focus, .button-group.clear .button.info, .button-group.clear .button.info.disabled, .button-group.clear .button.info[disabled], .button-group.clear .button.info.disabled:hover, .button-group.clear .button.info[disabled]:hover, .button-group.clear .button.info.disabled:focus, .button-group.clear .button.info[disabled]:focus {
  color: #1F7CC1;
}
.button-group.clear.info .button:hover, .button-group.clear.info .button:focus, .button-group.clear .button.info:hover, .button-group.clear .button.info:focus {
  color: rgb(15.5, 62, 96.5);
}
.button-group.clear.black .button, .button-group.clear.black .button.disabled, .button-group.clear.black .button[disabled], .button-group.clear.black .button.disabled:hover, .button-group.clear.black .button[disabled]:hover, .button-group.clear.black .button.disabled:focus, .button-group.clear.black .button[disabled]:focus, .button-group.clear .button.black, .button-group.clear .button.black.disabled, .button-group.clear .button.black[disabled], .button-group.clear .button.black.disabled:hover, .button-group.clear .button.black[disabled]:hover, .button-group.clear .button.black.disabled:focus, .button-group.clear .button.black[disabled]:focus {
  color: #333333;
}
.button-group.clear.black .button:hover, .button-group.clear.black .button:focus, .button-group.clear .button.black:hover, .button-group.clear .button.black:focus {
  color: rgb(25.5, 25.5, 25.5);
}
.button-group.no-gaps .button {
  margin-right: -0.0625rem;
}
.button-group.no-gaps .button + .button {
  border-left-color: transparent;
}
.button-group.stacked, .button-group.stacked-for-small, .button-group.stacked-for-medium {
  flex-wrap: wrap;
}
.button-group.stacked .button, .button-group.stacked-for-small .button, .button-group.stacked-for-medium .button {
  flex: 0 0 100%;
}
.button-group.stacked .button:last-child, .button-group.stacked-for-small .button:last-child, .button-group.stacked-for-medium .button:last-child {
  margin-bottom: 0;
}
.button-group.stacked.expanded .button, .button-group.stacked-for-small.expanded .button, .button-group.stacked-for-medium.expanded .button {
  flex: 1 1;
  margin-right: 0;
}
@media print, screen and (min-width: 40em) {
  .button-group.stacked-for-small .button {
    flex: 0 0 auto;
    margin-bottom: 0;
  }
}
@media print, screen and (min-width: 64em) {
  .button-group.stacked-for-medium .button {
    flex: 0 0 auto;
    margin-bottom: 0;
  }
}
@media print, screen and (max-width: 39.99875em) {
  .button-group.stacked-for-small.expanded {
    display: block;
  }
  .button-group.stacked-for-small.expanded .button {
    display: block;
    margin-right: 0;
  }
}
@media print, screen and (max-width: 51.99875em) {
  .button-group.stacked-for-medium.expanded {
    display: block;
  }
  .button-group.stacked-for-medium.expanded .button {
    display: block;
    margin-right: 0;
  }
}

.close-button {
  position: absolute;
  z-index: 10;
  color: rgba(51, 51, 51, 0.75);
  cursor: pointer;
}
[data-whatinput=mouse] .close-button {
  outline: 0;
}
.close-button:hover, .close-button:focus {
  color: #333;
}
.close-button.small {
  right: 0.66rem;
  top: 0.33em;
  font-size: 1.5em;
  line-height: 1;
}

.close-button, .close-button.medium {
  right: 1rem;
  top: 0.5rem;
  font-size: 2em;
  line-height: 1;
}

.label {
  display: inline-block;
  padding: 0.33333rem 0.5rem;
  border-radius: 3px;
  font-size: 0.8rem;
  line-height: 1;
  white-space: nowrap;
  cursor: default;
  background: #FF2476;
  color: #fff;
}
.label.primary {
  background: #FF2476;
  color: #fff;
}
.label.secondary {
  background: #00BAEF;
  color: #333;
}
.label.default {
  background: #F2F3F4;
  color: #333;
}
.label.success {
  background: #0AC775;
  color: #333;
}
.label.warning {
  background: #FFA501;
  color: #333;
}
.label.alert {
  background: #E31926;
  color: #fff;
}
.label.white {
  background: #FFFFFF;
  color: #333;
}
.label.info {
  background: #1F7CC1;
  color: #fff;
}
.label.black {
  background: #333333;
  color: #fff;
}

.progress {
  height: 1rem;
  margin-bottom: 1rem;
  border-radius: 3px;
  background-color: rgba(51, 51, 51, 0.5);
}
.progress.primary .progress-meter {
  background-color: #FF2476;
}
.progress.secondary .progress-meter {
  background-color: #00BAEF;
}
.progress.default .progress-meter {
  background-color: #F2F3F4;
}
.progress.success .progress-meter {
  background-color: #0AC775;
}
.progress.warning .progress-meter {
  background-color: #FFA501;
}
.progress.alert .progress-meter {
  background-color: #E31926;
}
.progress.white .progress-meter {
  background-color: #FFFFFF;
}
.progress.info .progress-meter {
  background-color: #1F7CC1;
}
.progress.black .progress-meter {
  background-color: #333333;
}

.progress-meter {
  position: relative;
  display: block;
  width: 0%;
  height: 100%;
  background-color: #FF2476;
  border-radius: 3px;
}

.progress-meter-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 0.75rem;
  font-weight: bold;
  color: #fff;
  white-space: nowrap;
  border-radius: 3px;
}

.slider {
  position: relative;
  height: 0.5rem;
  margin-top: 1.25rem;
  margin-bottom: 2.25rem;
  background-color: rgba(51, 51, 51, 0.15);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
}

.slider-fill {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  max-width: 100%;
  height: 0.5rem;
  background-color: rgba(51, 51, 51, 0.5);
  transition: all 0.2s ease-in-out;
}
.slider-fill.is-dragging {
  transition: all 0s linear;
}

.slider-handle {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  z-index: 1;
  display: inline-block;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 3px;
  background-color: #FF2476;
  transition: all 0.2s ease-in-out;
  touch-action: manipulation;
}
[data-whatinput=mouse] .slider-handle {
  outline: 0;
}
.slider-handle:hover {
  background-color: rgb(247.35, 0, 92.6150684932);
}
.slider-handle.is-dragging {
  transition: all 0s linear;
}

.slider.disabled,
.slider[disabled] {
  opacity: 0.25;
  cursor: not-allowed;
}

.slider.vertical {
  display: inline-block;
  width: 0.5rem;
  height: 12.5rem;
  margin: 0 1.25rem;
  transform: scale(1, -1);
}
.slider.vertical .slider-fill {
  top: 0;
  width: 0.5rem;
  max-height: 100%;
}
.slider.vertical .slider-handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 1.4rem;
  height: 1.4rem;
  transform: translateX(-50%);
}

.switch {
  height: 2rem;
  position: relative;
  margin-bottom: 1rem;
  outline: 0;
  font-size: 0.875rem;
  font-weight: bold;
  color: #fff;
  -webkit-user-select: none;
          user-select: none;
}

.switch-input {
  position: absolute;
  margin-bottom: 0;
  opacity: 0;
}

.switch-paddle {
  position: relative;
  display: block;
  width: 4rem;
  height: 2rem;
  border-radius: 3px;
  background: rgba(51, 51, 51, 0.5);
  transition: all 0.25s ease-out;
  font-weight: inherit;
  color: inherit;
  cursor: pointer;
}
input + .switch-paddle {
  margin: 0;
}
.switch-paddle::after {
  position: absolute;
  top: 0.25rem;
  left: 0.25rem;
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  transform: translate3d(0, 0, 0);
  border-radius: 3px;
  background: #fff;
  transition: all 0.25s ease-out;
  content: "";
}
input:checked ~ .switch-paddle {
  background: #FF2476;
}
input:checked ~ .switch-paddle::after {
  left: 2.25rem;
}
input:disabled ~ .switch-paddle {
  cursor: not-allowed;
  opacity: 0.5;
}
[data-whatinput=mouse] input:focus ~ .switch-paddle {
  outline: 0;
}

.switch-inactive, .switch-active {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.switch-active {
  left: 8%;
  display: none;
}
input:checked + label > .switch-active {
  display: block;
}

.switch-inactive {
  right: 15%;
}
input:checked + label > .switch-inactive {
  display: none;
}

.switch.tiny {
  height: 1.5rem;
}
.switch.tiny .switch-paddle {
  width: 3rem;
  height: 1.5rem;
  font-size: 0.625rem;
}
.switch.tiny .switch-paddle::after {
  top: 0.25rem;
  left: 0.25rem;
  width: 1rem;
  height: 1rem;
}
.switch.tiny input:checked ~ .switch-paddle::after {
  left: 1.75rem;
}

.switch.small {
  height: 1.75rem;
}
.switch.small .switch-paddle {
  width: 3.5rem;
  height: 1.75rem;
  font-size: 0.75rem;
}
.switch.small .switch-paddle::after {
  top: 0.25rem;
  left: 0.25rem;
  width: 1.25rem;
  height: 1.25rem;
}
.switch.small input:checked ~ .switch-paddle::after {
  left: 2rem;
}

.switch.large {
  height: 2.5rem;
}
.switch.large .switch-paddle {
  width: 5rem;
  height: 2.5rem;
  font-size: 1rem;
}
.switch.large .switch-paddle::after {
  top: 0.25rem;
  left: 0.25rem;
  width: 2rem;
  height: 2rem;
}
.switch.large input:checked ~ .switch-paddle::after {
  left: 2.75rem;
}

table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 1rem;
  border-radius: 3px;
}
thead,
tbody,
tfoot {
  border: 1px solid rgb(242.25, 242.25, 242.25);
  background-color: #fff;
}

caption {
  padding: 0.5rem 0.625rem 0.625rem;
  font-weight: bold;
}

thead {
  background: rgb(248.625, 248.625, 248.625);
  color: #333;
}

tfoot {
  background: rgb(242.25, 242.25, 242.25);
  color: #333;
}

thead tr,
tfoot tr {
  background: transparent;
}
thead th,
thead td,
tfoot th,
tfoot td {
  padding: 0.5rem 0.625rem 0.625rem;
  font-weight: bold;
  text-align: left;
}

tbody th,
tbody td {
  padding: 0.5rem 0.625rem 0.625rem;
}

tbody tr:nth-child(even) {
  border-bottom: 0;
  background-color: rgb(242.25, 242.25, 242.25);
}

table.unstriped tbody {
  background-color: #fff;
}
table.unstriped tbody tr {
  border-bottom: 0;
  border-bottom: 1px solid rgb(242.25, 242.25, 242.25);
  background-color: #fff;
}

@media print, screen and (max-width: 51.99875em) {
  table.stack thead {
    display: none;
  }
  table.stack tfoot {
    display: none;
  }
  table.stack tr,
  table.stack th,
  table.stack td {
    display: block;
  }
  table.stack td {
    border-top: 0;
  }
}

table.scroll {
  display: block;
  width: 100%;
  overflow-x: auto;
}

table.hover thead tr:hover {
  background-color: rgb(243.525, 243.525, 243.525);
}
table.hover tfoot tr:hover {
  background-color: rgb(237.15, 237.15, 237.15);
}
table.hover tbody tr:hover {
  background-color: rgb(249.9, 249.9, 249.9);
}
table.hover:not(.unstriped) tr:nth-of-type(even):hover {
  background-color: rgb(237.15, 237.15, 237.15);
}

.table-scroll {
  overflow-x: auto;
}

.badge {
  display: inline-block;
  min-width: 2.1em;
  padding: 0.3em;
  border-radius: 50%;
  font-size: 0.6rem;
  text-align: center;
  background: #FF2476;
  color: #fff;
}
.badge.primary {
  background: #FF2476;
  color: #fff;
}
.badge.secondary {
  background: #00BAEF;
  color: #333;
}
.badge.default {
  background: #F2F3F4;
  color: #333;
}
.badge.success {
  background: #0AC775;
  color: #333;
}
.badge.warning {
  background: #FFA501;
  color: #333;
}
.badge.alert {
  background: #E31926;
  color: #fff;
}
.badge.white {
  background: #FFFFFF;
  color: #333;
}
.badge.info {
  background: #1F7CC1;
  color: #fff;
}
.badge.black {
  background: #333333;
  color: #fff;
}

.breadcrumbs {
  margin: 0 0 1rem 0;
  list-style: none;
}
.breadcrumbs::before, .breadcrumbs::after {
  display: table;
  content: " ";
  flex-basis: 0;
  order: 1;
}
.breadcrumbs::after {
  clear: both;
}
.breadcrumbs li {
  float: left;
  font-size: 0.6875rem;
  color: #333;
  cursor: default;
  text-transform: uppercase;
}
.breadcrumbs li:not(:last-child)::after {
  position: relative;
  margin: 0 0.75rem;
  opacity: 1;
  content: "/";
  color: rgba(51, 51, 51, 0.5);
}
.breadcrumbs a {
  color: #FF2476;
}
.breadcrumbs a:hover {
  text-decoration: underline;
}
.breadcrumbs .disabled {
  color: rgba(51, 51, 51, 0.5);
  cursor: not-allowed;
}

.callout {
  position: relative;
  margin: 0 0 1rem 0;
  padding: 1rem;
  border: 1px solid rgba(51, 51, 51, 0.25);
  border-radius: 3px;
  background-color: white;
  color: #333;
}
.callout > :first-child {
  margin-top: 0;
}
.callout > :last-child {
  margin-bottom: 0;
}
.callout.primary {
  background-color: rgb(255, 222.15, 234.45);
  color: #333;
}
.callout.secondary {
  background-color: rgb(214.35, 245.9855648536, 255);
  color: #333;
}
.callout.default {
  background-color: rgb(253.05, 253.2, 253.35);
  color: #333;
}
.callout.success {
  background-color: rgb(212.0102870813, 252.8397129187, 235.1253588517);
  color: #333;
}
.callout.warning {
  background-color: rgb(255, 241.5, 216.9);
  color: #333;
}
.callout.alert {
  background-color: rgb(251.1607142857, 220.1392857143, 222.1357142857);
  color: #333;
}
.callout.white {
  background-color: white;
  color: #333;
}
.callout.info {
  background-color: rgb(218.0370535714, 235.8482142857, 249.0629464286);
  color: #333;
}
.callout.black {
  background-color: rgb(224.4, 224.4, 224.4);
  color: #333;
}
.callout.small {
  padding-top: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
}
.callout.large {
  padding-top: 3rem;
  padding-right: 3rem;
  padding-bottom: 3rem;
  padding-left: 3rem;
}

.card {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-bottom: 1rem;
  border: 1px solid rgba(51, 51, 51, 0.15);
  border-radius: 3px;
  background: #fff;
  box-shadow: none;
  overflow: hidden;
  color: #333;
}
.card > :last-child {
  margin-bottom: 0;
}

.card-divider {
  display: flex;
  flex: 0 1 auto;
  padding: 1rem;
  background: rgba(51, 51, 51, 0.15);
}
.card-divider > :last-child {
  margin-bottom: 0;
}

.card-section {
  flex: 1 0 auto;
  padding: 1rem;
}
.card-section > :last-child {
  margin-bottom: 0;
}

.card-image {
  min-height: 1px;
}

.dropdown-pane {
  position: absolute;
  z-index: 10;
  display: none;
  width: 300px;
  padding: 1rem;
  visibility: hidden;
  border: 1px solid rgba(51, 51, 51, 0.5);
  border-radius: 3px;
  background-color: #fff;
  font-size: 1rem;
}
.dropdown-pane.is-opening {
  display: block;
}
.dropdown-pane.is-open {
  display: block;
  visibility: visible;
}

.dropdown-pane.tiny {
  width: 100px;
}

.dropdown-pane.small {
  width: 200px;
}

.dropdown-pane.large {
  width: 400px;
}

.pagination {
  margin-left: 0;
  margin-bottom: 1rem;
}
.pagination::before, .pagination::after {
  display: table;
  content: " ";
  flex-basis: 0;
  order: 1;
}
.pagination::after {
  clear: both;
}
.pagination li {
  margin-right: 0.0625rem;
  border-radius: 3px;
  font-size: 0.875rem;
  display: none;
}
.pagination li:last-child, .pagination li:first-child {
  display: inline-block;
}
@media print, screen and (min-width: 40em) {
  .pagination li {
    display: inline-block;
  }
}
.pagination a,
.pagination button {
  display: block;
  padding: 0.1875rem 0.625rem;
  border-radius: 3px;
  color: #333;
}
.pagination a:hover,
.pagination button:hover {
  background: rgba(51, 51, 51, 0.15);
}
.pagination .current {
  padding: 0.1875rem 0.625rem;
  background: #FF2476;
  color: #fff;
  cursor: default;
}
.pagination .disabled {
  padding: 0.1875rem 0.625rem;
  color: rgba(51, 51, 51, 0.5);
  cursor: not-allowed;
}
.pagination .disabled:hover {
  background: transparent;
}
.pagination .ellipsis::after {
  padding: 0.1875rem 0.625rem;
  content: "…";
  color: #333;
}

.pagination-previous a::before,
.pagination-previous.disabled::before {
  display: inline-block;
  margin-right: 0.5rem;
  content: "«";
}

.pagination-next a::after,
.pagination-next.disabled::after {
  display: inline-block;
  margin-left: 0.5rem;
  content: "»";
}

.has-tip {
  position: relative;
  display: inline-block;
  border-bottom: dotted 1px rgba(51, 51, 51, 0.75);
  font-weight: bold;
  cursor: help;
}

.tooltip {
  position: absolute;
  top: calc(100% + 0.6495rem);
  z-index: 1200;
  max-width: 10rem;
  padding: 0.75rem;
  border-radius: 3px;
  background-color: #333;
  font-size: 80%;
  color: #fff;
}
.tooltip::before {
  position: absolute;
}
.tooltip.bottom::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 0.75rem;
  content: "";
  border-top-width: 0;
  border-bottom-style: solid;
  border-color: transparent transparent #333;
  bottom: 100%;
}
.tooltip.bottom.align-center::before {
  left: 50%;
  transform: translateX(-50%);
}
.tooltip.top::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 0.75rem;
  content: "";
  border-bottom-width: 0;
  border-top-style: solid;
  border-color: #333 transparent transparent;
  top: 100%;
  bottom: auto;
}
.tooltip.top.align-center::before {
  left: 50%;
  transform: translateX(-50%);
}
.tooltip.left::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 0.75rem;
  content: "";
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #333;
  left: 100%;
}
.tooltip.left.align-center::before {
  bottom: auto;
  top: 50%;
  transform: translateY(-50%);
}
.tooltip.right::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 0.75rem;
  content: "";
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #333 transparent transparent;
  right: 100%;
  left: auto;
}
.tooltip.right.align-center::before {
  bottom: auto;
  top: 50%;
  transform: translateY(-50%);
}
.tooltip.align-top::before {
  bottom: auto;
  top: 10%;
}
.tooltip.align-bottom::before {
  bottom: 10%;
  top: auto;
}
.tooltip.align-left::before {
  left: 10%;
  right: auto;
}
.tooltip.align-right::before {
  left: auto;
  right: 10%;
}

.accordion {
  margin-left: 0;
  background: #fff;
  list-style-type: none;
}
.accordion[disabled] .accordion-title {
  cursor: not-allowed;
}

.accordion-item:first-child > :first-child {
  border-radius: 3px 3px 0 0;
}
.accordion-item:last-child > :last-child {
  border-radius: 0 0 3px 3px;
}

.accordion-title {
  position: relative;
  display: block;
  padding: 1.25rem 1rem;
  border: 1px solid rgba(51, 51, 51, 0.15);
  border-bottom: 0;
  font-size: 0.75rem;
  line-height: 1;
  color: #FF2476;
}
:last-child:not(.is-active) > .accordion-title {
  border-bottom: 1px solid rgba(51, 51, 51, 0.15);
  border-radius: 0 0 3px 3px;
}
.accordion-title:hover, .accordion-title:focus {
  background-color: rgba(51, 51, 51, 0.15);
}
.accordion-title::before {
  position: absolute;
  top: 50%;
  right: 1rem;
  margin-top: -0.5rem;
  content: "+";
}
.is-active > .accordion-title::before {
  content: "–";
}

.accordion-content {
  display: none;
  padding: 1rem;
  border: 1px solid rgba(51, 51, 51, 0.15);
  border-bottom: 0;
  background-color: #fff;
  color: #333;
}
:last-child > .accordion-content:last-child {
  border-bottom: 1px solid rgba(51, 51, 51, 0.15);
}

.media-object {
  display: flex;
  margin-bottom: 1rem;
  flex-wrap: nowrap;
}
.media-object img {
  max-width: none;
}
@media print, screen and (max-width: 39.99875em) {
  .media-object.stack-for-small {
    flex-wrap: wrap;
  }
}

.media-object-section {
  flex: 0 1 auto;
}
.media-object-section:first-child {
  padding-right: 1rem;
}
.media-object-section:last-child:not(:nth-child(2)) {
  padding-left: 1rem;
}
.media-object-section > :last-child {
  margin-bottom: 0;
}
@media print, screen and (max-width: 39.99875em) {
  .stack-for-small .media-object-section {
    padding: 0;
    padding-bottom: 1rem;
    flex-basis: 100%;
    max-width: 100%;
  }
  .stack-for-small .media-object-section img {
    width: 100%;
  }
}
.media-object-section.main-section {
  flex: 1 1;
}

.orbit {
  position: relative;
}

.orbit-container {
  position: relative;
  height: 0;
  margin: 0;
  list-style: none;
  overflow: hidden;
}

.orbit-slide {
  width: 100%;
  position: absolute;
}
.orbit-slide.no-motionui.is-active {
  top: 0;
  left: 0;
}

.orbit-figure {
  margin: 0;
}

.orbit-image {
  width: 100%;
  max-width: 100%;
  margin: 0;
}

.orbit-caption {
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-bottom: 0;
  padding: 1rem;
  background-color: rgba(51, 51, 51, 0.5);
  color: #fff;
}

.orbit-next, .orbit-previous {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  padding: 1rem;
  color: #fff;
}
[data-whatinput=mouse] .orbit-next, [data-whatinput=mouse] .orbit-previous {
  outline: 0;
}
.orbit-next:hover, .orbit-previous:hover, .orbit-next:active, .orbit-previous:active, .orbit-next:focus, .orbit-previous:focus {
  background-color: rgba(51, 51, 51, 0.5);
}

.orbit-previous {
  left: 0;
}

.orbit-next {
  left: auto;
  right: 0;
}

.orbit-bullets {
  position: relative;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  text-align: center;
}
[data-whatinput=mouse] .orbit-bullets {
  outline: 0;
}
.orbit-bullets button {
  width: 1.2rem;
  height: 1.2rem;
  margin: 0.1rem;
  border-radius: 50%;
  background-color: rgba(51, 51, 51, 0.5);
}
.orbit-bullets button:hover {
  background-color: rgba(51, 51, 51, 0.75);
}
.orbit-bullets button.is-active {
  background-color: rgba(51, 51, 51, 0.75);
}

.responsive-embed,
.flex-video {
  position: relative;
  height: 0;
  margin-bottom: 1rem;
  padding-bottom: 75%;
  overflow: hidden;
}
.responsive-embed iframe,
.responsive-embed object,
.responsive-embed embed,
.responsive-embed video,
.flex-video iframe,
.flex-video object,
.flex-video embed,
.flex-video video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.responsive-embed.widescreen,
.flex-video.widescreen {
  padding-bottom: 56.25%;
}

.tabs {
  margin: 0;
  border: 1px solid rgba(51, 51, 51, 0.15);
  background: #fff;
  list-style-type: none;
}
.tabs::before, .tabs::after {
  display: table;
  content: " ";
  flex-basis: 0;
  order: 1;
}
.tabs::after {
  clear: both;
}

.tabs.vertical > li {
  display: block;
  float: none;
  width: auto;
}

.tabs.simple > li > a {
  padding: 0;
}
.tabs.simple > li > a:hover {
  background: transparent;
}

.tabs.primary {
  background: #FF2476;
}
.tabs.primary > li > a {
  color: #fff;
}
.tabs.primary > li > a:hover, .tabs.primary > li > a:focus {
  background: rgb(255, 21.45, 108.8979452055);
}

.tabs-title {
  float: left;
}
.tabs-title > a {
  display: block;
  padding: 1.25rem 1.5rem;
  font-size: 0.75rem;
  line-height: 1;
  color: #FF2476;
}
[data-whatinput=mouse] .tabs-title > a {
  outline: 0;
}
.tabs-title > a:hover {
  background: #fff;
  color: rgb(250.26, 0, 93.7046575342);
}
.tabs-title > a:focus, .tabs-title > a[aria-selected=true] {
  background: rgba(51, 51, 51, 0.15);
  color: #FF2476;
}

.tabs-content {
  border: 1px solid rgba(51, 51, 51, 0.15);
  border-top: 0;
  background: #fff;
  color: #333;
  transition: all 0.5s ease;
}

.tabs-content.vertical {
  border: 1px solid rgba(51, 51, 51, 0.15);
  border-left: 0;
}

.tabs-panel {
  display: none;
  padding: 1rem;
}
.tabs-panel.is-active {
  display: block;
}

.thumbnail {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 1rem;
  border: 4px solid #fff;
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(51, 51, 51, 0.2);
  line-height: 0;
}

a.thumbnail {
  transition: box-shadow 200ms ease-out;
}
a.thumbnail:hover, a.thumbnail:focus {
  box-shadow: 0 0 6px 1px rgba(255, 36, 118, 0.5);
}
a.thumbnail image {
  box-shadow: none;
}

.menu {
  padding: 0;
  margin: 0;
  list-style: none;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
[data-whatinput=mouse] .menu li {
  outline: 0;
}
.menu a,
.menu .button {
  line-height: 1;
  text-decoration: none;
  display: block;
  padding: 0.7rem 1rem;
}
.menu input,
.menu select,
.menu a,
.menu button {
  margin-bottom: 0;
}
.menu input {
  display: inline-block;
}
.menu, .menu.horizontal {
  flex-wrap: wrap;
  flex-direction: row;
}
.menu.vertical {
  flex-wrap: nowrap;
  flex-direction: column;
}
.menu.expanded li {
  flex: 1 1;
}
.menu.simple {
  align-items: center;
}
.menu.simple li + li {
  margin-left: 1rem;
}
.menu.simple a {
  padding: 0;
}
@media print, screen and (min-width: 40em) {
  .menu.medium-horizontal {
    flex-wrap: wrap;
    flex-direction: row;
  }
  .menu.medium-vertical {
    flex-wrap: nowrap;
    flex-direction: column;
  }
  .menu.medium-expanded li {
    flex: 1 1;
  }
  .menu.medium-simple li {
    flex: 1 1;
  }
}
@media print, screen and (min-width: 64em) {
  .menu.large-horizontal {
    flex-wrap: wrap;
    flex-direction: row;
  }
  .menu.large-vertical {
    flex-wrap: nowrap;
    flex-direction: column;
  }
  .menu.large-expanded li {
    flex: 1 1;
  }
  .menu.large-simple li {
    flex: 1 1;
  }
}
.menu.nested {
  margin-right: 0;
  margin-left: 1rem;
}
.menu.icons a {
  display: flex;
}
.menu.icon-top a, .menu.icon-right a, .menu.icon-bottom a, .menu.icon-left a {
  display: flex;
}
.menu.icon-left li a {
  flex-flow: row nowrap;
}
.menu.icon-left li a img,
.menu.icon-left li a i,
.menu.icon-left li a svg {
  margin-right: 0.25rem;
}
.menu.icon-right li a {
  flex-flow: row nowrap;
}
.menu.icon-right li a img,
.menu.icon-right li a i,
.menu.icon-right li a svg {
  margin-left: 0.25rem;
}
.menu.icon-top li a {
  flex-flow: column nowrap;
}
.menu.icon-top li a img,
.menu.icon-top li a i,
.menu.icon-top li a svg {
  align-self: stretch;
  margin-bottom: 0.25rem;
  text-align: center;
}
.menu.icon-bottom li a {
  flex-flow: column nowrap;
}
.menu.icon-bottom li a img,
.menu.icon-bottom li a i,
.menu.icon-bottom li a svg {
  align-self: stretch;
  margin-bottom: 0.25rem;
  text-align: center;
}
.menu .is-active > a {
  background: #FF2476;
  color: #fff;
}
.menu .active > a {
  background: #FF2476;
  color: #fff;
}
.menu.align-left {
  justify-content: flex-start;
}
.menu.align-right li {
  display: flex;
  justify-content: flex-end;
}
.menu.align-right li .submenu li {
  justify-content: flex-start;
}
.menu.align-right.vertical li {
  display: block;
  text-align: right;
}
.menu.align-right.vertical li .submenu li {
  text-align: right;
}
.menu.align-right .nested {
  margin-right: 1rem;
  margin-left: 0;
}
.menu.align-center li {
  display: flex;
  justify-content: center;
}
.menu.align-center li .submenu li {
  justify-content: flex-start;
}
.menu .menu-text {
  padding: 0.7rem 1rem;
  font-weight: bold;
  line-height: 1;
  color: inherit;
}

.menu-centered > .menu {
  justify-content: center;
}
.menu-centered > .menu li {
  display: flex;
  justify-content: center;
}
.menu-centered > .menu li .submenu li {
  justify-content: flex-start;
}

.no-js [data-responsive-menu] ul {
  display: none;
}

.menu-icon {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 16px;
  cursor: pointer;
}
.menu-icon::after {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 2px;
  background: #fff;
  box-shadow: 0 7px 0 #fff, 0 14px 0 #fff;
  content: "";
}
.menu-icon:hover::after {
  background: rgba(51, 51, 51, 0.5);
  box-shadow: 0 7px 0 rgba(51, 51, 51, 0.5), 0 14px 0 rgba(51, 51, 51, 0.5);
}

.menu-icon.dark {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 16px;
  cursor: pointer;
}
.menu-icon.dark::after {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 2px;
  background: #333;
  box-shadow: 0 7px 0 #333, 0 14px 0 #333;
  content: "";
}
.menu-icon.dark:hover::after {
  background: rgba(51, 51, 51, 0.75);
  box-shadow: 0 7px 0 rgba(51, 51, 51, 0.75), 0 14px 0 rgba(51, 51, 51, 0.75);
}

.accordion-menu li {
  width: 100%;
}
.accordion-menu a {
  padding: 0.7rem 1rem;
}
.accordion-menu .is-accordion-submenu a {
  padding: 0.7rem 1rem;
}
.accordion-menu .nested.is-accordion-submenu {
  margin-right: 0;
  margin-left: 1rem;
}
.accordion-menu.align-right .nested.is-accordion-submenu {
  margin-right: 1rem;
  margin-left: 0;
}
.accordion-menu .is-accordion-submenu-parent:not(.has-submenu-toggle) > a {
  position: relative;
}
.accordion-menu .is-accordion-submenu-parent:not(.has-submenu-toggle) > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-bottom-width: 0;
  border-top-style: solid;
  border-color: #FF2476 transparent transparent;
  position: absolute;
  top: 50%;
  margin-top: -3px;
  right: 1rem;
}
.accordion-menu.align-left .is-accordion-submenu-parent > a::after {
  right: 1rem;
  left: auto;
}
.accordion-menu.align-right .is-accordion-submenu-parent > a::after {
  right: auto;
  left: 1rem;
}
.accordion-menu .is-accordion-submenu-parent[aria-expanded=true] > a::after {
  transform: rotate(180deg);
  transform-origin: 50% 50%;
}

.is-accordion-submenu-parent {
  position: relative;
}

.has-submenu-toggle > a {
  margin-right: 40px;
}

.submenu-toggle {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.submenu-toggle::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-bottom-width: 0;
  border-top-style: solid;
  border-color: #FF2476 transparent transparent;
  top: 0;
  bottom: 0;
  margin: auto;
}

.submenu-toggle[aria-expanded=true]::after {
  transform: scaleY(-1);
  transform-origin: 50% 50%;
}

.submenu-toggle-text {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.is-drilldown {
  position: relative;
  overflow: hidden;
}
.is-drilldown li {
  display: block;
}
.is-drilldown.animate-height {
  transition: height 0.5s;
}

.drilldown a {
  padding: 0.7rem 1rem;
  background: #fff;
}
.drilldown .is-drilldown-submenu {
  position: absolute;
  top: 0;
  left: 100%;
  z-index: -1;
  width: 100%;
  background: #fff;
  transition: transform 0.15s linear;
}
.drilldown .is-drilldown-submenu.is-active {
  z-index: 1;
  display: block;
  transform: translateX(-100%);
}
.drilldown .is-drilldown-submenu.is-closing {
  transform: translateX(100%);
}
.drilldown .is-drilldown-submenu a {
  padding: 0.7rem 1rem;
}
.drilldown .nested.is-drilldown-submenu {
  margin-right: 0;
  margin-left: 0;
}
.drilldown .drilldown-submenu-cover-previous {
  min-height: 100%;
}
.drilldown .is-drilldown-submenu-parent > a {
  position: relative;
}
.drilldown .is-drilldown-submenu-parent > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #FF2476;
  position: absolute;
  top: 50%;
  margin-top: -6px;
  right: 1rem;
}
.drilldown.align-left .is-drilldown-submenu-parent > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #333;
  right: 1rem;
  left: auto;
}
.drilldown.align-right .is-drilldown-submenu-parent > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #333 transparent transparent;
  right: auto;
  left: 1rem;
}
.drilldown .js-drilldown-back > a::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #FF2476 transparent transparent;
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.75rem;
}

.dropdown.menu > li.opens-left > .is-dropdown-submenu {
  top: 100%;
  right: 0;
  left: auto;
}
.dropdown.menu > li.opens-right > .is-dropdown-submenu {
  top: 100%;
  right: auto;
  left: 0;
}
.dropdown.menu > li.is-dropdown-submenu-parent > a {
  position: relative;
  padding-right: 1.5rem;
}
.dropdown.menu > li.is-dropdown-submenu-parent > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-bottom-width: 0;
  border-top-style: solid;
  border-color: #333 transparent transparent;
  right: 5px;
  left: auto;
  margin-top: -3px;
}
[data-whatinput=mouse] .dropdown.menu a {
  outline: 0;
}
.dropdown.menu > li > a {
  padding: 0.7rem 1rem;
}
.dropdown.menu > li.is-active > a {
  background: transparent;
  color: #FF2476;
}
.no-js .dropdown.menu ul {
  display: none;
}
.dropdown.menu .nested.is-dropdown-submenu {
  margin-right: 0;
  margin-left: 0;
}
.dropdown.menu.vertical > li .is-dropdown-submenu {
  top: 0;
}
.dropdown.menu.vertical > li.opens-left > .is-dropdown-submenu {
  top: 0;
  right: 100%;
  left: auto;
}
.dropdown.menu.vertical > li.opens-right > .is-dropdown-submenu {
  right: auto;
  left: 100%;
}
.dropdown.menu.vertical > li > a::after {
  right: 14px;
}
.dropdown.menu.vertical > li.opens-left > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #333 transparent transparent;
  right: auto;
  left: 5px;
}
.dropdown.menu.vertical > li.opens-right > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #333;
}
@media print, screen and (min-width: 40em) {
  .dropdown.menu.medium-horizontal > li.opens-left > .is-dropdown-submenu {
    top: 100%;
    right: 0;
    left: auto;
  }
  .dropdown.menu.medium-horizontal > li.opens-right > .is-dropdown-submenu {
    top: 100%;
    right: auto;
    left: 0;
  }
  .dropdown.menu.medium-horizontal > li.is-dropdown-submenu-parent > a {
    position: relative;
    padding-right: 1.5rem;
  }
  .dropdown.menu.medium-horizontal > li.is-dropdown-submenu-parent > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: "";
    border-bottom-width: 0;
    border-top-style: solid;
    border-color: #333 transparent transparent;
    right: 5px;
    left: auto;
    margin-top: -3px;
  }
  .dropdown.menu.medium-vertical > li .is-dropdown-submenu {
    top: 0;
  }
  .dropdown.menu.medium-vertical > li.opens-left > .is-dropdown-submenu {
    top: 0;
    right: 100%;
    left: auto;
  }
  .dropdown.menu.medium-vertical > li.opens-right > .is-dropdown-submenu {
    right: auto;
    left: 100%;
  }
  .dropdown.menu.medium-vertical > li > a::after {
    right: 14px;
  }
  .dropdown.menu.medium-vertical > li.opens-left > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: "";
    border-left-width: 0;
    border-right-style: solid;
    border-color: transparent #333 transparent transparent;
    right: auto;
    left: 5px;
  }
  .dropdown.menu.medium-vertical > li.opens-right > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: "";
    border-right-width: 0;
    border-left-style: solid;
    border-color: transparent transparent transparent #333;
  }
}
@media print, screen and (min-width: 64em) {
  .dropdown.menu.large-horizontal > li.opens-left > .is-dropdown-submenu {
    top: 100%;
    right: 0;
    left: auto;
  }
  .dropdown.menu.large-horizontal > li.opens-right > .is-dropdown-submenu {
    top: 100%;
    right: auto;
    left: 0;
  }
  .dropdown.menu.large-horizontal > li.is-dropdown-submenu-parent > a {
    position: relative;
    padding-right: 1.5rem;
  }
  .dropdown.menu.large-horizontal > li.is-dropdown-submenu-parent > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: "";
    border-bottom-width: 0;
    border-top-style: solid;
    border-color: #333 transparent transparent;
    right: 5px;
    left: auto;
    margin-top: -3px;
  }
  .dropdown.menu.large-vertical > li .is-dropdown-submenu {
    top: 0;
  }
  .dropdown.menu.large-vertical > li.opens-left > .is-dropdown-submenu {
    top: 0;
    right: 100%;
    left: auto;
  }
  .dropdown.menu.large-vertical > li.opens-right > .is-dropdown-submenu {
    right: auto;
    left: 100%;
  }
  .dropdown.menu.large-vertical > li > a::after {
    right: 14px;
  }
  .dropdown.menu.large-vertical > li.opens-left > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: "";
    border-left-width: 0;
    border-right-style: solid;
    border-color: transparent #333 transparent transparent;
    right: auto;
    left: 5px;
  }
  .dropdown.menu.large-vertical > li.opens-right > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: "";
    border-right-width: 0;
    border-left-style: solid;
    border-color: transparent transparent transparent #333;
  }
}
.dropdown.menu.align-right .is-dropdown-submenu.first-sub {
  top: 100%;
  right: 0;
  left: auto;
}

.is-dropdown-menu.vertical {
  width: 100px;
}
.is-dropdown-menu.vertical.align-right {
  float: right;
}

.is-dropdown-submenu-parent {
  position: relative;
}
.is-dropdown-submenu-parent a::after {
  position: absolute;
  top: 50%;
  right: 5px;
  left: auto;
  margin-top: -6px;
}
.is-dropdown-submenu-parent.opens-inner > .is-dropdown-submenu {
  top: 100%;
  left: auto;
}
.is-dropdown-submenu-parent.opens-left > .is-dropdown-submenu {
  right: 100%;
  left: auto;
}
.is-dropdown-submenu-parent.opens-right > .is-dropdown-submenu {
  right: auto;
  left: 100%;
}

.is-dropdown-submenu {
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 1;
  display: none;
  min-width: 200px;
  border: 1px solid rgba(51, 51, 51, 0.5);
  background: #fff;
}
.dropdown .is-dropdown-submenu a {
  padding: 0.7rem 1rem;
}
.is-dropdown-submenu .is-dropdown-submenu-parent > a::after {
  right: 14px;
}
.is-dropdown-submenu .is-dropdown-submenu-parent.opens-left > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #333 transparent transparent;
  right: auto;
  left: 5px;
}
.is-dropdown-submenu .is-dropdown-submenu-parent.opens-right > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: "";
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #333;
}
.is-dropdown-submenu .is-dropdown-submenu {
  margin-top: -1px;
}
.is-dropdown-submenu > li {
  width: 100%;
}
.is-dropdown-submenu.js-dropdown-active {
  display: block;
}

.is-off-canvas-open {
  overflow: hidden;
}

.js-off-canvas-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease, visibility 0.5s ease;
  background: rgba(255, 255, 255, 0.25);
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
}
.js-off-canvas-overlay.is-visible {
  opacity: 1;
  visibility: visible;
}
.js-off-canvas-overlay.is-closable {
  cursor: pointer;
}
.js-off-canvas-overlay.is-overlay-absolute {
  position: absolute;
}
.js-off-canvas-overlay.is-overlay-fixed {
  position: fixed;
}

.off-canvas-wrapper {
  position: relative;
  overflow: hidden;
}

.off-canvas {
  position: fixed;
  z-index: 12;
  transition: transform 0.5s ease;
  backface-visibility: hidden;
  background: rgba(51, 51, 51, 0.15);
}
[data-whatinput=mouse] .off-canvas {
  outline: 0;
}
.off-canvas.is-transition-push {
  z-index: 12;
}
.off-canvas.is-closed {
  visibility: hidden;
}
.off-canvas.is-transition-overlap {
  z-index: 13;
}
.off-canvas.is-transition-overlap.is-open {
  box-shadow: 0 0 10px rgba(51, 51, 51, 0.7);
}
.off-canvas.is-open {
  transform: translate(0, 0);
}
.off-canvas-absolute {
  position: absolute;
  z-index: 12;
  transition: transform 0.5s ease;
  backface-visibility: hidden;
  background: rgba(51, 51, 51, 0.15);
}
[data-whatinput=mouse] .off-canvas-absolute {
  outline: 0;
}
.off-canvas-absolute.is-transition-push {
  z-index: 12;
}
.off-canvas-absolute.is-closed {
  visibility: hidden;
}
.off-canvas-absolute.is-transition-overlap {
  z-index: 13;
}
.off-canvas-absolute.is-transition-overlap.is-open {
  box-shadow: 0 0 10px rgba(51, 51, 51, 0.7);
}
.off-canvas-absolute.is-open {
  transform: translate(0, 0);
}

.position-left {
  top: 0;
  left: 0;
  height: 100%;
  overflow-y: auto;
  width: 250px;
  transform: translateX(-250px);
}
.off-canvas-content .off-canvas.position-left {
  transform: translateX(-250px);
}
.off-canvas-content .off-canvas.position-left.is-transition-overlap.is-open {
  transform: translate(0, 0);
}

.off-canvas-content.is-open-left.has-transition-push {
  transform: translateX(250px);
}

.position-left.is-transition-push {
  box-shadow: inset -13px 0 20px -13px rgba(51, 51, 51, 0.25);
}

.position-right {
  top: 0;
  right: 0;
  height: 100%;
  overflow-y: auto;
  width: 250px;
  transform: translateX(250px);
}
.off-canvas-content .off-canvas.position-right {
  transform: translateX(250px);
}
.off-canvas-content .off-canvas.position-right.is-transition-overlap.is-open {
  transform: translate(0, 0);
}

.off-canvas-content.is-open-right.has-transition-push {
  transform: translateX(-250px);
}

.position-right.is-transition-push {
  box-shadow: inset 13px 0 20px -13px rgba(51, 51, 51, 0.25);
}

.position-top {
  top: 0;
  left: 0;
  width: 100%;
  overflow-x: auto;
  height: 250px;
  transform: translateY(-250px);
}
.off-canvas-content .off-canvas.position-top {
  transform: translateY(-250px);
}
.off-canvas-content .off-canvas.position-top.is-transition-overlap.is-open {
  transform: translate(0, 0);
}

.off-canvas-content.is-open-top.has-transition-push {
  transform: translateY(250px);
}

.position-top.is-transition-push {
  box-shadow: inset 0 -13px 20px -13px rgba(51, 51, 51, 0.25);
}

.position-bottom {
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: auto;
  height: 250px;
  transform: translateY(250px);
}
.off-canvas-content .off-canvas.position-bottom {
  transform: translateY(250px);
}
.off-canvas-content .off-canvas.position-bottom.is-transition-overlap.is-open {
  transform: translate(0, 0);
}

.off-canvas-content.is-open-bottom.has-transition-push {
  transform: translateY(-250px);
}

.position-bottom.is-transition-push {
  box-shadow: inset 0 13px 20px -13px rgba(51, 51, 51, 0.25);
}

.off-canvas-content {
  transform: none;
  backface-visibility: hidden;
}
.off-canvas-content.has-transition-overlap, .off-canvas-content.has-transition-push {
  transition: transform 0.5s ease;
}
.off-canvas-content.has-transition-push {
  transform: translate(0, 0);
}
.off-canvas-content .off-canvas.is-open {
  transform: translate(0, 0);
}

@media print, screen and (min-width: 40em) {
  .position-left.reveal-for-medium {
    transform: none;
    z-index: 12;
    transition: none;
    visibility: visible;
  }
  .position-left.reveal-for-medium .close-button {
    display: none;
  }
  .off-canvas-content .position-left.reveal-for-medium {
    transform: none;
  }
  .off-canvas-content.has-reveal-left {
    margin-left: 250px;
  }
  .position-left.reveal-for-medium ~ .off-canvas-content {
    margin-left: 250px;
  }
  .position-right.reveal-for-medium {
    transform: none;
    z-index: 12;
    transition: none;
    visibility: visible;
  }
  .position-right.reveal-for-medium .close-button {
    display: none;
  }
  .off-canvas-content .position-right.reveal-for-medium {
    transform: none;
  }
  .off-canvas-content.has-reveal-right {
    margin-right: 250px;
  }
  .position-right.reveal-for-medium ~ .off-canvas-content {
    margin-right: 250px;
  }
  .position-top.reveal-for-medium {
    transform: none;
    z-index: 12;
    transition: none;
    visibility: visible;
  }
  .position-top.reveal-for-medium .close-button {
    display: none;
  }
  .off-canvas-content .position-top.reveal-for-medium {
    transform: none;
  }
  .off-canvas-content.has-reveal-top {
    margin-top: 250px;
  }
  .position-top.reveal-for-medium ~ .off-canvas-content {
    margin-top: 250px;
  }
  .position-bottom.reveal-for-medium {
    transform: none;
    z-index: 12;
    transition: none;
    visibility: visible;
  }
  .position-bottom.reveal-for-medium .close-button {
    display: none;
  }
  .off-canvas-content .position-bottom.reveal-for-medium {
    transform: none;
  }
  .off-canvas-content.has-reveal-bottom {
    margin-bottom: 250px;
  }
  .position-bottom.reveal-for-medium ~ .off-canvas-content {
    margin-bottom: 250px;
  }
}
@media print, screen and (min-width: 64em) {
  .position-left.reveal-for-large {
    transform: none;
    z-index: 12;
    transition: none;
    visibility: visible;
  }
  .position-left.reveal-for-large .close-button {
    display: none;
  }
  .off-canvas-content .position-left.reveal-for-large {
    transform: none;
  }
  .off-canvas-content.has-reveal-left {
    margin-left: 250px;
  }
  .position-left.reveal-for-large ~ .off-canvas-content {
    margin-left: 250px;
  }
  .position-right.reveal-for-large {
    transform: none;
    z-index: 12;
    transition: none;
    visibility: visible;
  }
  .position-right.reveal-for-large .close-button {
    display: none;
  }
  .off-canvas-content .position-right.reveal-for-large {
    transform: none;
  }
  .off-canvas-content.has-reveal-right {
    margin-right: 250px;
  }
  .position-right.reveal-for-large ~ .off-canvas-content {
    margin-right: 250px;
  }
  .position-top.reveal-for-large {
    transform: none;
    z-index: 12;
    transition: none;
    visibility: visible;
  }
  .position-top.reveal-for-large .close-button {
    display: none;
  }
  .off-canvas-content .position-top.reveal-for-large {
    transform: none;
  }
  .off-canvas-content.has-reveal-top {
    margin-top: 250px;
  }
  .position-top.reveal-for-large ~ .off-canvas-content {
    margin-top: 250px;
  }
  .position-bottom.reveal-for-large {
    transform: none;
    z-index: 12;
    transition: none;
    visibility: visible;
  }
  .position-bottom.reveal-for-large .close-button {
    display: none;
  }
  .off-canvas-content .position-bottom.reveal-for-large {
    transform: none;
  }
  .off-canvas-content.has-reveal-bottom {
    margin-bottom: 250px;
  }
  .position-bottom.reveal-for-large ~ .off-canvas-content {
    margin-bottom: 250px;
  }
}
@media print, screen and (min-width: 40em) {
  .off-canvas.in-canvas-for-medium {
    visibility: visible;
    height: auto;
    position: static;
    background: none;
    width: auto;
    overflow: visible;
    transition: none;
  }
  .off-canvas.in-canvas-for-medium.position-left, .off-canvas.in-canvas-for-medium.position-right, .off-canvas.in-canvas-for-medium.position-top, .off-canvas.in-canvas-for-medium.position-bottom {
    box-shadow: none;
    transform: none;
  }
  .off-canvas.in-canvas-for-medium .close-button {
    display: none;
  }
}
@media print, screen and (min-width: 64em) {
  .off-canvas.in-canvas-for-large {
    visibility: visible;
    height: auto;
    position: static;
    background: none;
    width: auto;
    overflow: visible;
    transition: none;
  }
  .off-canvas.in-canvas-for-large.position-left, .off-canvas.in-canvas-for-large.position-right, .off-canvas.in-canvas-for-large.position-top, .off-canvas.in-canvas-for-large.position-bottom {
    box-shadow: none;
    transform: none;
  }
  .off-canvas.in-canvas-for-large .close-button {
    display: none;
  }
}
html.is-reveal-open {
  position: fixed;
  width: 100%;
  overflow-y: hidden;
}
html.is-reveal-open.zf-has-scroll {
  overflow-y: scroll;
}
html.is-reveal-open body {
  overflow-y: hidden;
}

.reveal-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1005;
  display: none;
  background-color: rgba(51, 51, 51, 0.45);
  overflow-y: auto;
}

.reveal {
  z-index: 1006;
  backface-visibility: hidden;
  display: none;
  padding: 1rem;
  border: 1px solid rgba(51, 51, 51, 0.5);
  border-radius: 3px;
  background-color: #fff;
  position: relative;
  top: 100px;
  margin-right: auto;
  margin-left: auto;
  overflow-y: auto;
}
[data-whatinput=mouse] .reveal {
  outline: 0;
}
@media print, screen and (min-width: 40em) {
  .reveal {
    min-height: 0;
  }
}
.reveal .column {
  min-width: 0;
}
.reveal > :last-child {
  margin-bottom: 0;
}
@media print, screen and (min-width: 40em) {
  .reveal {
    width: 600px;
    max-width: 75rem;
  }
}
.reveal.collapse {
  padding: 0;
}
@media print, screen and (min-width: 40em) {
  .reveal.tiny {
    width: 30%;
    max-width: 75rem;
  }
}
@media print, screen and (min-width: 40em) {
  .reveal.small {
    width: 50%;
    max-width: 75rem;
  }
}
@media print, screen and (min-width: 40em) {
  .reveal.large {
    width: 90%;
    max-width: 75rem;
  }
}
.reveal.full {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: none;
  height: 100%;
  min-height: 100%;
  margin-left: 0;
  border: 0;
  border-radius: 0;
}
@media print, screen and (max-width: 39.99875em) {
  .reveal {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: none;
    height: 100%;
    min-height: 100%;
    margin-left: 0;
    border: 0;
    border-radius: 0;
  }
}
.reveal.without-overlay {
  position: fixed;
}

.sticky-container {
  position: relative;
}

.sticky {
  position: relative;
  z-index: 0;
  transform: translate3d(0, 0, 0);
}

.sticky.is-stuck {
  position: fixed;
  z-index: 5;
  width: 100%;
}
.sticky.is-stuck.is-at-top {
  top: 0;
}
.sticky.is-stuck.is-at-bottom {
  bottom: 0;
}

.sticky.is-anchored {
  position: relative;
  right: auto;
  left: auto;
}
.sticky.is-anchored.is-at-bottom {
  bottom: 0;
}

.title-bar {
  padding: 0.5rem;
  background: #333;
  color: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.title-bar .menu-icon {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.title-bar-left,
.title-bar-right {
  flex: 1 1;
}

.title-bar-right {
  text-align: right;
}

.title-bar-title {
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
}

.top-bar {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  flex-wrap: wrap;
}
.top-bar,
.top-bar ul {
  background-color: rgba(51, 51, 51, 0.15);
}
.top-bar input {
  max-width: 200px;
  margin-right: 1rem;
}
.top-bar .input-group-field {
  width: 100%;
  margin-right: 0;
}
.top-bar input.button {
  width: auto;
}
.top-bar .top-bar-left,
.top-bar .top-bar-right {
  flex: 0 0 100%;
  max-width: 100%;
}
@media print, screen and (min-width: 40em) {
  .top-bar {
    flex-wrap: nowrap;
  }
  .top-bar .top-bar-left {
    flex: 1 1 auto;
    margin-right: auto;
  }
  .top-bar .top-bar-right {
    flex: 0 1 auto;
    margin-left: auto;
  }
}
@media print, screen and (max-width: 51.99875em) {
  .top-bar.stacked-for-medium {
    flex-wrap: wrap;
  }
  .top-bar.stacked-for-medium .top-bar-left,
  .top-bar.stacked-for-medium .top-bar-right {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media print, screen and (max-width: 74.99875em) {
  .top-bar.stacked-for-large {
    flex-wrap: wrap;
  }
  .top-bar.stacked-for-large .top-bar-left,
  .top-bar.stacked-for-large .top-bar-right {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.top-bar-title {
  flex: 0 0 auto;
  margin: 0.5rem 1rem 0.5rem 0;
}

.top-bar-left,
.top-bar-right {
  flex: 0 0 auto;
}

.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-center {
  display: block;
  margin-right: auto;
  margin-left: auto;
}

.clearfix::before, .clearfix::after {
  display: table;
  content: " ";
  flex-basis: 0;
  order: 1;
}
.clearfix::after {
  clear: both;
}

.align-left {
  justify-content: flex-start;
}

.align-right {
  justify-content: flex-end;
}

.align-center {
  justify-content: center;
}

.align-justify {
  justify-content: space-between;
}

.align-spaced {
  justify-content: space-around;
}

.align-left.vertical.menu > li > a {
  justify-content: flex-start;
}

.align-right.vertical.menu > li > a {
  justify-content: flex-end;
}

.align-center.vertical.menu > li > a {
  justify-content: center;
}

.align-top {
  align-items: flex-start;
}

.align-self-top {
  align-self: flex-start;
}

.align-bottom {
  align-items: flex-end;
}

.align-self-bottom {
  align-self: flex-end;
}

.align-middle {
  align-items: center;
}

.align-self-middle {
  align-self: center;
}

.align-stretch {
  align-items: stretch;
}

.align-self-stretch {
  align-self: stretch;
}

.align-center-middle {
  justify-content: center;
  align-items: center;
  align-content: center;
}

.small-order-1 {
  order: 1;
}

.small-order-2 {
  order: 2;
}

.small-order-3 {
  order: 3;
}

.small-order-4 {
  order: 4;
}

.small-order-5 {
  order: 5;
}

.small-order-6 {
  order: 6;
}

@media print, screen and (min-width: 40em) {
  .medium-order-1 {
    order: 1;
  }
  .medium-order-2 {
    order: 2;
  }
  .medium-order-3 {
    order: 3;
  }
  .medium-order-4 {
    order: 4;
  }
  .medium-order-5 {
    order: 5;
  }
  .medium-order-6 {
    order: 6;
  }
}
@media print, screen and (min-width: 64em) {
  .large-order-1 {
    order: 1;
  }
  .large-order-2 {
    order: 2;
  }
  .large-order-3 {
    order: 3;
  }
  .large-order-4 {
    order: 4;
  }
  .large-order-5 {
    order: 5;
  }
  .large-order-6 {
    order: 6;
  }
}
.flex-container {
  display: flex;
}

.flex-child-auto {
  flex: 1 1 auto;
}

.flex-child-grow {
  flex: 1 0 auto;
}

.flex-child-shrink {
  flex: 0 1 auto;
}

.flex-dir-row {
  flex-direction: row;
}

.flex-dir-row-reverse {
  flex-direction: row-reverse;
}

.flex-dir-column {
  flex-direction: column;
}

.flex-dir-column-reverse {
  flex-direction: column-reverse;
}

@media print, screen and (min-width: 40em) {
  .medium-flex-container {
    display: flex;
  }
  .medium-flex-child-auto {
    flex: 1 1 auto;
  }
  .medium-flex-child-grow {
    flex: 1 0 auto;
  }
  .medium-flex-child-shrink {
    flex: 0 1 auto;
  }
  .medium-flex-dir-row {
    flex-direction: row;
  }
  .medium-flex-dir-row-reverse {
    flex-direction: row-reverse;
  }
  .medium-flex-dir-column {
    flex-direction: column;
  }
  .medium-flex-dir-column-reverse {
    flex-direction: column-reverse;
  }
}
@media print, screen and (min-width: 64em) {
  .large-flex-container {
    display: flex;
  }
  .large-flex-child-auto {
    flex: 1 1 auto;
  }
  .large-flex-child-grow {
    flex: 1 0 auto;
  }
  .large-flex-child-shrink {
    flex: 0 1 auto;
  }
  .large-flex-dir-row {
    flex-direction: row;
  }
  .large-flex-dir-row-reverse {
    flex-direction: row-reverse;
  }
  .large-flex-dir-column {
    flex-direction: column;
  }
  .large-flex-dir-column-reverse {
    flex-direction: column-reverse;
  }
}
.hide {
  display: none !important;
}

.invisible {
  visibility: hidden;
}

@media print, screen and (max-width: 39.99875em) {
  .hide-for-small-only {
    display: none !important;
  }
}

@media screen and (max-width: 0em), screen and (min-width: 40em) {
  .show-for-small-only {
    display: none !important;
  }
}

@media print, screen and (min-width: 40em) {
  .hide-for-medium {
    display: none !important;
  }
}

@media screen and (max-width: 39.99875em) {
  .show-for-medium {
    display: none !important;
  }
}

@media print, screen and (min-width: 40em) and (max-width: 51.99875em) {
  .hide-for-medium-only {
    display: none !important;
  }
}

@media screen and (max-width: 39.99875em), screen and (min-width: 52em) {
  .show-for-medium-only {
    display: none !important;
  }
}

@media print, screen and (min-width: 64em) {
  .hide-for-large {
    display: none !important;
  }
}

@media screen and (max-width: 63.99875em) {
  .show-for-large {
    display: none !important;
  }
}

@media print, screen and (min-width: 64em) and (max-width: 74.99875em) {
  .hide-for-large-only {
    display: none !important;
  }
}

@media screen and (max-width: 63.99875em), screen and (min-width: 75em) {
  .show-for-large-only {
    display: none !important;
  }
}

.show-for-sr,
.show-on-focus {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.show-on-focus:active, .show-on-focus:focus {
  position: static !important;
  width: auto !important;
  height: auto !important;
  overflow: visible !important;
  clip: auto !important;
  white-space: normal !important;
}

.show-for-landscape,
.hide-for-portrait {
  display: block !important;
}
@media screen and (orientation: landscape) {
  .show-for-landscape,
  .hide-for-portrait {
    display: block !important;
  }
}
@media screen and (orientation: portrait) {
  .show-for-landscape,
  .hide-for-portrait {
    display: none !important;
  }
}

.hide-for-landscape,
.show-for-portrait {
  display: none !important;
}
@media screen and (orientation: landscape) {
  .hide-for-landscape,
  .show-for-portrait {
    display: none !important;
  }
}
@media screen and (orientation: portrait) {
  .hide-for-landscape,
  .show-for-portrait {
    display: block !important;
  }
}

@keyframes headerTransition {
  0% {
    background-color: transparent;
  }
  35% {
    background-color: rgba(255, 255, 255, 0.5);
    color: rgba(51, 51, 51, 0.5);
    fill: rgba(51, 51, 51, 0.5);
  }
  100% {
    background-color: #FFF;
    color: #333;
    fill: rgba(51, 51, 51, 0.5);
  }
}
.u-hidden {
  display: none;
}

@media print, screen and (min-width: 40em) {
  p {
    font-size: 1.25rem;
  }
}

a {
  transition: 300ms ease all;
}

input[type=text] {
  box-sizing: border-box;
  width: 100%;
  height: 2.3375rem;
  margin: 0 0 1rem;
  padding: 0.5rem;
  border: 1px solid rgba(51, 51, 51, 0.2);
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: inset 0 1px 2px rgba(51, 51, 51, 0.1);
}

input[type=submit] {
  height: 2.3375rem;
  vertical-align: middle;
}

.c-feature__title {
  transition: 300ms ease all;
}
.c-feature__title .c-icon {
  transition: 300ms ease all;
}

.u-link--primary-hover {
  color: inherit;
  transition: 300ms ease all;
}
.u-link--primary-hover:hover {
  color: #FF2476;
}

.u-title {
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.u-title--small {
  font-size: 1rem;
}

.u-subtitle {
  opacity: 0.5;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.u-subtitle.white {
  opacity: 0.5;
  color: #FFFFFF;
}

.u-bold {
  font-weight: 600;
}

.u-text--white {
  color: #FFFFFF;
}

.u-text--o70 {
  opacity: 0.7;
}

.u-text--o50 {
  opacity: 0.5;
}

.u-text--light {
  color: rgba(51, 51, 51, 0.5);
}

.u-center {
  text-align: center;
}

.u-text--secondary {
  color: #00BAEF;
}

.u-text--small {
  font-size: 1rem;
}

.u-text--success {
  color: #0AC775;
}

.u-text--alert {
  color: #E31926;
}

.u-text--info {
  color: #1F7CC1;
}

.u-text--primary {
  color: #FF2476;
}

.u-description {
  margin-top: 1rem;
}

.u-description--center {
  text-align: center;
  margin: 0 auto 1rem;
  max-width: 800px;
}

.u-text--large {
  font-size: 1.25rem;
}

.u-link--underline {
  text-decoration: underline;
}

.u-text--mt50 {
  margin-top: 0.5rem;
}

.u-text--mb0 {
  margin-bottom: 0;
}

.u-text--mb50 {
  margin-bottom: 0.5rem;
}

.u-text--mb1 {
  margin-bottom: 1rem;
}

.u-text--mb2 {
  margin-bottom: 2rem;
}

.u-text--mr1 {
  margin-right: 1rem;
}

.u-text-block {
  margin: 0.5rem;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.u-gradient--home {
  background: linear-gradient(-45deg, rgb(7, 200, 122), rgb(0, 186, 239), #00BAEF, #8338EC);
  background: linear-gradient(-45deg, rgb(7, 200, 122), rgb(0, 186, 239), #00BAEF, #8338EC);
  background: linear-gradient(-45deg, rgb(7, 200, 122), rgb(0, 186, 239), #00BAEF, #8338EC);
  background-size: 400% 400%;
  animation: gradient 10s ease infinite;
}

.u-gradient--crewForAll {
  background: linear-gradient(-45deg, rgb(250, 136, 0), rgb(254, 203, 0), #FA5700, #FFBA00);
  background: linear-gradient(-45deg, rgb(250, 136, 0), rgb(254, 203, 0) #FA5700, #FFBA00);
  background: linear-gradient(-45deg, rgb(250, 136, 0), rgb(254, 203, 0) #FA5700, #FFBA00);
  background-size: 400% 400%;
  animation: gradient 10s ease infinite;
}

.u-gradient--about {
  background: rgb(255, 126, 69);
  background: linear-gradient(90deg, rgb(255, 126, 69) 0%, rgb(254, 122, 75) 33%, rgb(248, 88, 118) 63%, rgb(244, 66, 147) 100%);
}

.u-gradient--membership {
  background: linear-gradient(-45deg, rgb(11, 124, 227), rgb(38, 148, 238), rgb(90, 97, 237), rgb(131, 56, 236));
  background: linear-gradient(-45deg, rgb(11, 124, 227), rgb(38, 148, 238), rgb(90, 97, 237), rgb(131, 56, 236));
  background: linear-gradient(-45deg, rgb(11, 124, 227), rgb(38, 148, 238), rgb(90, 97, 237), rgb(131, 56, 236));
  background-size: 400% 400%;
  animation: gradient 10s ease infinite;
}

.u-gradient--features {
  background: rgb(255, 255, 255);
  background: radial-gradient(circle, rgb(255, 255, 255) 0%, rgb(255, 255, 240) 25%, rgb(249, 249, 239) 50%, rgb(255, 255, 240) 75%, rgb(255, 255, 255) 100%);
  background-size: 400% 400%;
}

.u-gradient--gray {
  background: linear-gradient(-45deg, #f2f3f4, #f3f3f3);
}

.u-gradient--turquoiseGreen {
  background: linear-gradient(-45deg, rgb(7, 200, 122), rgb(0, 186, 239));
}

.u-gradient--pinkOrange {
  background: linear-gradient(-45deg, rgb(251, 55, 128), rgb(250, 136, 0));
}

.u-gradient--pinkPurple {
  background: linear-gradient(-45deg, rgb(251, 55, 128), rgb(131, 35, 236));
}

.u-background--white {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 1rem;
  border-radius: 5px;
}

.u-flex-bottom {
  align-self: flex-end;
}

.u-flex-center {
  padding: 0.5rem;
  align-self: center;
}

.o-section--large {
  padding: 4rem 3rem;
}

.o-section--medium {
  padding: 2rem;
}

.o-section--small {
  padding: 1rem;
}

.o-section--image {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
}

.o-section--center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.o-section--center.top {
  justify-content: flex-start;
}
.o-section--center.space-between {
  justify-content: space-between;
}

.o-row-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.o-row-section.medium {
  flex-direction: column;
}
@media print, screen and (min-width: 40em) {
  .o-row-section.medium {
    flex-direction: row;
    justify-content: center;
  }
}
.o-row-section.left {
  align-items: flex-start;
  justify-content: flex-start;
}

.o-inner-section {
  width: 100%;
}

.c-wrapper--900 {
  max-width: 900px;
}

.o-section__headline {
  max-width: 700px;
}
@media screen and (min-width: 75em) {
  .o-section__headline {
    max-width: 1000px;
  }
}

.sticky {
  padding-top: 76.15px;
}

.o-spectrum {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.c-banner--info {
  background-color: rgba(31, 124, 193, 0.1);
  color: #1F7CC1;
  padding: 1rem;
  border-radius: 0;
  width: 100%;
}

.c-banner--default {
  background-color: rgba(51, 51, 51, 0.1);
  color: #333;
  padding: 1rem;
  border-radius: 3px;
  width: 100%;
}

.c-banner--success {
  background-color: rgba(10, 199, 117, 0.1);
  color: #0AC775;
  padding: 1rem;
  border-radius: 3px;
  width: 100%;
  margin-bottom: 1rem;
}

.c-big-statement {
  position: relative;
  z-index: 1;
}

.c-big-statement__wrapper {
  display: flex;
  flex-direction: column;
}
@media print, screen and (min-width: 40em) {
  .c-big-statement__wrapper.horizontal {
    flex-direction: row;
    align-items: center;
  }
}

.button.primary:hover, .button.primary:focus, .button.primary:active,
a.button.primary:hover,
a.button.primary:focus,
a.button.primary:active {
  color: #FFFFFF;
  background-color: rgb(214.5, 0, 80.3150684932);
}

.c-button--center {
  display: block;
  margin: 0 auto 1rem;
}
.c-button--center.expanded {
  width: 100%;
}

.button.primary-inverse {
  color: #FF2476;
  background-color: #FFFFFF;
  transition: 600ms ease all;
}
.button.primary-inverse:hover {
  background-color: #FF2476;
  color: #FFFFFF;
  border: #FF2476 1px solid;
}
.button.primary-inverse.border {
  border: #FF2476 1px solid;
}

.c-button-group .button {
  width: 100%;
  margin-bottom: 1rem;
}
@media screen and (min-width: 65.625em) {
  .c-button-group .button {
    width: auto;
    margin-bottom: 0;
  }
  .c-button-group .button + .button {
    margin-left: 1rem;
  }
}

.c-card {
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
}
@media print, screen and (min-width: 40em) {
  .c-card {
    margin: 1rem;
  }
}
.c-card.center {
  align-items: center;
  justify-items: center;
}
.c-card.horizontal {
  flex-direction: row;
}
.c-card.horizontal .c-icon--main {
  margin-right: 1rem;
}
.c-card.success {
  background-color: rgba(10, 199, 117, 0.2);
}
.c-card.alert {
  background-color: rgba(227, 25, 38, 0.2);
}

.c-card__header {
  border-radius: 10px 10px 0 0;
  padding: 1rem;
  width: 100%;
}

.c-card__body {
  padding: 1rem;
  height: 100%;
}

.c-card__footer {
  width: 100%;
  padding: 0 1rem;
}

.c-card--column {
  border: 1px solid rgba(51, 51, 51, 0.15);
  border-radius: 10px;
  margin: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.c-card--column .c-card__header {
  border-radius: 10px 10px 0 0;
  min-height: 200px;
}

.c-card--shadow {
  transition: 500ms ease all;
  padding: 1rem;
  box-shadow: 0 1px 4px rgba(51, 51, 51, 0.5);
  border-radius: 5px;
}

.c-card-button {
  margin-bottom: 2rem;
  padding: 1rem 0;
  border-radius: 3px;
  transition: 300ms ease all;
}
.c-card-button .c-card {
  margin: 0;
}

button.c-card-button:hover {
  cursor: pointer;
  background-color: #F2F3F4;
  opacity: 1;
}

button.c-card-button.active {
  cursor: pointer;
  background-color: #F2F3F4;
  opacity: 1;
}

.c-feature__title:hover, .c-feature__link.active .c-feature__title {
  opacity: 1;
  cursor: pointer;
  color: #FF2476;
}
.c-feature__title:hover .c-icon, .c-feature__link.active .c-feature__title .c-icon {
  fill: #FF2476;
}

.c-feature__graphic-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

.c-feature__link {
  padding: 0.7rem 1rem;
  transition: 500ms ease all;
}
.c-feature__link.active {
  box-shadow: 0 1px 4px rgba(51, 51, 51, 0.5);
  margin: 0.3rem 0;
}
.c-feature__link.active .c-feature__title {
  margin-bottom: 0.25rem;
}

.c-feature__title {
  font-weight: 600;
  display: flex;
  text-align: left;
  line-height: 1.3;
  align-items: center;
  opacity: 0.4;
}
.c-feature__description {
  opacity: 0.4;
}

.c-feature__graphic {
  transition: 500ms ease all;
}

.c-header {
  padding: 1rem;
  display: flex;
  align-items: center;
}
.c-header a {
  transition: 300ms ease all;
}

.c-header__dropdown {
  display: none;
}

.c-header__dropdown.is-active {
  display: block;
}

.c-header__wrapper {
  position: fixed;
  width: 100%;
  z-index: 10;
}

.c-header.dark a:hover(&:not(.c-header__cta)) {
  color: #FF2476;
}
.c-header.dark .active {
  color: #FF2476;
}
.c-header.dark .logo-wrapper path {
  fill: #333;
}

.c-header.light a {
  color: #FFFFFF;
}
.c-header.light a:hover {
  color: #FFFFFF;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.c-header.light .c-header__button {
  color: #FFFFFF;
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
}
.c-header.light .c-header__button:hover {
  color: #FF2476;
  background-color: white;
}
.c-header.light .active {
  color: #FFFFFF;
  background-color: rgba(255, 255, 255, 0.2);
}
.c-header.light .logo-wrapper path {
  fill: #FFF;
}
.c-header.light .logo-wrapper:hover {
  background-color: transparent;
}

.c-header__cta {
  margin-left: auto;
  display: inline-flex;
}

.c-header__button.primary-inverse {
  border: 1px solid #FF2476;
}

.scrollHeader {
  transition: transform 6s ease;
  background-color: #FFFFFF;
  box-shadow: 0 3px 4px rgba(51, 51, 51, 0.3);
  animation: headerTransition 500ms;
}
.scrollHeader .c-header.light .logo-wrapper path {
  fill: #333;
}
.scrollHeader .c-header.light a {
  color: #333;
}
.scrollHeader .c-header.light a:hover {
  color: #FF2476;
}
.scrollHeader .c-header.light .c-header__button {
  background-color: #FF2476;
  color: #FFFFFF;
}
.scrollHeader .c-header.light .c-header__button:hover {
  background-color: rgb(214.5, 0, 80.3150684932);
  color: #FFFFFF;
}
.scrollHeader .c-header.light .c-header__button.primary-inverse {
  background-color: #FFFFFF;
  color: #FF2476;
  border: 1px solid #FF2476;
}
.scrollHeader .c-header.light .c-header__button.primary-inverse:hover {
  background-color: #FF2476;
  color: #FFFFFF;
}

.c-footer__wrapper {
  background-color: #333;
  color: #FFFFFF;
  padding: 1rem;
}

.c-footer-row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.c-footer__menu {
  color: #FFFFFF;
}
.c-footer__menu .logo-wrapper path {
  fill: #FFFFFF;
}

.c-footer__link {
  color: #FFFFFF;
  transition: 300ms ease all;
  border-radius: 3px;
}
.c-footer__link:hover {
  color: #FFFFFF;
  background-color: rgba(255, 255, 255, 0.2);
}

.c-footer__icon-link {
  opacity: 0.5;
  transition: 300ms ease all;
  margin: 0.5rem;
  padding: 0 !important;
}
.c-footer__icon-link:hover {
  opacity: 1;
}

.c-footer__item {
  padding: 0.7rem 1rem;
}

.c-image-hero__headline {
  position: absolute;
  max-width: 790px;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 30%;
  padding: 0 1rem;
}

.c-image-hero {
  position: relative;
  width: 100%;
  max-height: 550px;
  overflow-y: hidden;
}

.c-image-hero__caption {
  font-size: 0.75rem;
  background-color: #F2F3F4;
  padding: 0.5rem;
  width: 100%;
}
@media print, screen and (min-width: 40em) {
  .c-image-hero__caption {
    background-color: transparent;
    padding: 0;
    position: absolute;
    max-width: 350px;
    font-size: 0.875rem;
    text-align: right;
    color: #FFFFFF;
    font-weight: 600;
    left: auto;
    bottom: 1rem;
    right: 1rem;
  }
}

.logo {
  width: 100px;
  max-width: 100px;
}

.c-icon {
  display: inline-block;
  vertical-align: middle;
}

.c-icon--white {
  fill: #FFFFFF;
}

.c-icon--w1 {
  width: 1rem;
  height: 1rem;
}

.c-icon--w1_5 {
  width: 1.5rem;
  height: 1.5rem;
}

.c-icon--w2 {
  width: 2rem;
  height: 2rem;
}

.c-icon--w2_5 {
  width: 2.5rem;
  height: 2.5rem;
}

.c-icon--w3 {
  width: 3rem;
  height: 3rem;
}

.c-icon--w4 {
  width: 4rem;
  height: 4rem;
}

.c-icon--left {
  margin-right: 0.3rem;
}

.c-icon--main {
  margin-bottom: 1rem;
  display: block;
}

.c-icon--center {
  display: block;
  margin-right: auto;
  margin-left: auto;
}

.c-responsive-image {
  width: 100%;
}

.c-image--150 {
  max-width: 150px;
  max-height: 150px;
}

.c-image--main {
  margin-bottom: 1rem;
}

.c-image--100 {
  min-width: 100px;
  max-width: 100px;
  height: auto;
}

.c-image--200 {
  max-width: 200px;
  max-height: 200px;
}

.c-image--300 {
  max-width: 300px;
  max-height: 300px;
}

.c-image--400 {
  max-width: 400px;
  max-height: 400px;
}

.c-image--500 {
  max-width: 500px;
  max-height: 500px;
}

.c-image--rounded {
  border-radius: 10px;
}

.c-image--friends {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  min-height: 600px;
}

.c-image--crewForAll {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@media print, screen and (min-width: 64em) {
  .c-image--crewForAll {
    min-height: 800px;
  }
}

.c-image--yarnMovement {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  object-fit: cover;
  background-position: -200px center;
  min-height: 300px;
  transition: 300ms ease margin-top;
}
@media screen and (min-width: 93.75em) {
  .c-image--yarnMovement {
    background-size: cover;
    object-fit: none;
    background-repeat: no-repeat;
    background-position: center center;
    min-height: 550px;
    margin-top: -6rem;
  }
}

.menu a.c-menu-link--inline {
  display: inline;
  padding: 0;
}

.c-menu--nested {
  margin-left: 1rem;
}

.c-menu--bullets li {
  list-style-type: circle;
}

.c-menu--nested.menu.vertical li {
  padding: 0.7rem 1rem;
}

.c-dropdown-menu {
  background-color: #FFFFFF;
  padding: 0.5rem;
  position: absolute;
  top: 100%;
  right: 1rem;
  width: 250px;
  z-index: 2;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);
}

.c-overlay {
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.c-modal {
  background-color: #FFFFFF;
  padding: 2rem;
  width: 42rem;
  border-radius: 5px;
  position: relative;
}

.c-modal__close {
  position: absolute;
  padding: 1rem;
  top: 0;
  right: 0;
  cursor: pointer;
  font-size: 2rem;
  color: #333;
  line-height: 0.5;
  opacity: 0.5;
  transition: 500ms ease all;
}
.c-modal__close:hover {
  opacity: 1;
}

.c-form--one-field {
  max-width: 400px;
}

.c-input__sign-up {
  display: flex;
  margin: 0 auto;
}
.c-input__sign-up input[type=email] {
  border-radius: 3px 0 0 3px;
  border: 1px solid rgba(51, 51, 51, 0.15);
}
.c-input__sign-up input[type=submit] {
  border-radius: 0 3px 3px 0;
}

.c-testimonial {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
}
@media screen and (min-width: 52em) {
  .c-testimonial {
    flex-direction: row;
  }
}
.c-testimonial--bubbles {
  margin: 4rem 0;
}

.c-card.c-testimonial__card {
  margin-left: 1rem;
  padding: 2rem;
  background-color: #FFFFFF;
  max-width: 700px;
  z-index: 1;
}

.c-testimonial__left-bubble {
  width: 100%;
  max-width: 300px;
  position: absolute;
  left: -5rem;
}

.c-testimonial__right-bubble {
  width: 100%;
  max-width: 100px;
  position: absolute;
  right: -2rem;
  bottom: -1rem;
}`, "",{"version":3,"sources":["webpack://./src/scss/App.scss","webpack://./node_modules/foundation-sites/scss/foundation.scss","webpack://./node_modules/foundation-sites/scss/util/_breakpoint.scss","webpack://./node_modules/foundation-sites/scss/components/_reveal.scss","webpack://./node_modules/foundation-sites/scss/vendor/normalize.scss","webpack://./node_modules/foundation-sites/scss/_global.scss","webpack://./src/scss/_settings.scss","webpack://./node_modules/foundation-sites/scss/util/_mixins.scss","webpack://./node_modules/foundation-sites/scss/forms/_text.scss","webpack://./node_modules/foundation-sites/scss/forms/_checkbox.scss","webpack://./node_modules/foundation-sites/scss/forms/_label.scss","webpack://./node_modules/foundation-sites/scss/forms/_help-text.scss","webpack://./node_modules/foundation-sites/scss/forms/_input-group.scss","webpack://./node_modules/foundation-sites/scss/forms/_fieldset.scss","webpack://./node_modules/foundation-sites/scss/forms/_select.scss","webpack://./node_modules/foundation-sites/scss/forms/_error.scss","webpack://./node_modules/foundation-sites/scss/typography/_base.scss","webpack://./node_modules/foundation-sites/scss/typography/_helpers.scss","webpack://./node_modules/foundation-sites/scss/typography/_alignment.scss","webpack://./node_modules/foundation-sites/scss/typography/_print.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_classes.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_gutters.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_grid.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_cell.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_layout.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_collapse.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_position.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_frame.scss","webpack://./node_modules/foundation-sites/scss/components/_button.scss","webpack://./node_modules/foundation-sites/scss/util/_color.scss","webpack://./node_modules/foundation-sites/scss/components/_button-group.scss","webpack://./node_modules/foundation-sites/scss/components/_close-button.scss","webpack://./node_modules/foundation-sites/scss/components/_label.scss","webpack://./node_modules/foundation-sites/scss/components/_progress-bar.scss","webpack://./node_modules/foundation-sites/scss/components/_slider.scss","webpack://./node_modules/foundation-sites/scss/components/_switch.scss","webpack://./node_modules/foundation-sites/scss/components/_table.scss","webpack://./node_modules/foundation-sites/scss/components/_badge.scss","webpack://./node_modules/foundation-sites/scss/components/_breadcrumbs.scss","webpack://./node_modules/foundation-sites/scss/components/_callout.scss","webpack://./node_modules/foundation-sites/scss/components/_card.scss","webpack://./node_modules/foundation-sites/scss/components/_dropdown.scss","webpack://./node_modules/foundation-sites/scss/components/_pagination.scss","webpack://./node_modules/foundation-sites/scss/components/_tooltip.scss","webpack://./node_modules/foundation-sites/scss/components/_accordion.scss","webpack://./node_modules/foundation-sites/scss/components/_media-object.scss","webpack://./node_modules/foundation-sites/scss/components/_orbit.scss","webpack://./node_modules/foundation-sites/scss/components/_responsive-embed.scss","webpack://./node_modules/foundation-sites/scss/components/_tabs.scss","webpack://./node_modules/foundation-sites/scss/components/_thumbnail.scss","webpack://./node_modules/foundation-sites/scss/components/_menu.scss","webpack://./node_modules/foundation-sites/scss/components/_menu-icon.scss","webpack://./node_modules/foundation-sites/scss/components/_accordion-menu.scss","webpack://./node_modules/foundation-sites/scss/components/_drilldown.scss","webpack://./node_modules/foundation-sites/scss/components/_dropdown-menu.scss","webpack://./node_modules/foundation-sites/scss/components/_off-canvas.scss","webpack://./node_modules/foundation-sites/scss/components/_sticky.scss","webpack://./node_modules/foundation-sites/scss/components/_title-bar.scss","webpack://./node_modules/foundation-sites/scss/components/_top-bar.scss","webpack://./node_modules/foundation-sites/scss/components/_float.scss","webpack://./node_modules/foundation-sites/scss/components/_flex.scss","webpack://./node_modules/foundation-sites/scss/util/_flex.scss","webpack://./node_modules/foundation-sites/scss/components/_visibility.scss","webpack://./src/scss/tools/_t-animations.scss","webpack://./src/scss/tools/_tools.scss","webpack://./src/scss/elements/_elements.scss","webpack://./src/scss/tools/_t-variables.scss","webpack://./src/scss/utilities/_u-typography.scss","webpack://./src/scss/utilities/_u-colors.scss","webpack://./src/scss/utilities/_utilities.scss","webpack://./src/scss/objects/_o-section.scss","webpack://./src/scss/objects/_objects.scss","webpack://./src/scss/components/_c-banner.scss","webpack://./src/scss/components/_c-big-statement.scss","webpack://./src/scss/components/_c-button.scss","webpack://./src/scss/components/_c-card.scss","webpack://./src/scss/components/_c-feature.scss","webpack://./src/scss/components/_c-header-footer.scss","webpack://./src/scss/components/_c-hero.scss","webpack://./src/scss/components/_c-icon.scss","webpack://./src/scss/components/_c-image.scss","webpack://./src/scss/components/_c-menu.scss","webpack://./src/scss/components/_c-modal.scss","webpack://./src/scss/components/_c-form.scss","webpack://./src/scss/components/_c-testimonial.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;EAAA;ACgLQ;ECnIN;IACE,WAAA;IACA,UAAA;IACA,cAAA;EHnCF;AACF;AIbE,2EAAA;AAQA;EACE,iBAAA;EACA,8BAAA;AJQJ;;AIAE;EACE,SAAA;AJGJ;;AIGE;EACE,cAAA;EACA,gBAAA;AJAJ;;AISE;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AJNJ;;AIYE;EACE,iCAAA;EACA,cAAA;AJTJ;;AIiBE;EACE,6BAAA;AJdJ;;AIoBE;EACE,mBAAA;EACA,0BAAA;EACA,yCAAA;UAAA,iCAAA;AJjBJ;;AIsBE;;EAEE,mBAAA;AJnBJ;;AIyBE;;;EAGE,iCAAA;EACA,cAAA;AJtBJ;;AI2BE;EACE,cAAA;AJxBJ;;AI8BE;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AJ3BJ;;AI8BE;EACE,eAAA;AJ3BJ;;AI8BE;EACE,WAAA;AJ3BJ;;AImCE;EACE,kBAAA;AJhCJ;;AIyCE;;;;;EAKE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AJtCJ;;AI4CE;;EAEE,iBAAA;AJzCJ;;AI+CE;;EAEE,oBAAA;AJ5CJ;;AIiDE;;;;EAIE,0BAAA;AJ9CJ;;AImDE;;;;EAIE,kBAAA;EACA,UAAA;AJhDJ;;AIqDE;;;;EAIE,8BAAA;AJlDJ;;AIuDE;EACE,8BAAA;AJpDJ;;AI4DE;EACE,sBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;AJzDJ;;AI8DE;EACE,wBAAA;AJ3DJ;;AIgEE;EACE,cAAA;AJ7DJ;;AImEE;;EAEE,sBAAA;EACA,UAAA;AJhEJ;;AIqEE;;EAEE,YAAA;AJlEJ;;AIwEE;EACE,6BAAA;EACA,oBAAA;AJrEJ;;AI0EE;EACE,wBAAA;AJvEJ;;AI6EE;EACE,0BAAA;EACA,aAAA;AJ1EJ;;AIkFE;EACE,cAAA;AJ/EJ;;AIoFE;EACE,kBAAA;AJjFJ;;AIyFE;EACE,aAAA;AJtFJ;;AI2FE;EACE,aAAA;AJxFJ;;AKnDE;EACE,qFAAA;ALsDJ;;AKnDE;EACE,sBAAA;EACA,eC9Ee;ANoInB;;AKlDE;;;EAGE,mBAAA;ALqDJ;;AKjDE;EACE,SAAA;EACA,UAAA;EAEA,gBC3EI;ED6EJ,+EC1Ee;ED2Ef,mBCtEmB;EDuEnB,gBC/FgB;EDgGhB,WCjFI;EDoFF,mCAAA;EACA,kCAAA;ALgDN;;AK5CE;EAEE,qBAAA;EACA,sBAAA;EAGA,eAAA;EACA,YAAA;EACA,+BAAA;AL4CJ;;AKxCE;EACE,YAAA;EACA,gBAAA;EACA,kBC7FY;ANwIhB;;AKvCE;EACE,sBAAA;EACA,WAAA;EACA,kBCpGY;AN8IhB;;AKnCI;;;;;;EAGE,0BAAA;ALyCN;;AKpCE;EAEE,UAAA;EACA,gBAAA;EACA,SAAA;EACA,kBCxHY;EDyHZ,uBAAA;EACA,cAAA;EACA,YCrHmB;AN2JvB;AOvDE;EACE,UAAA;APyDJ;;AKrCE;EACE,cAAA;ALwCJ;;AKpCE;;;;;EAKE,oBAAA;ALuCJ;;AKnCE;EACE,yBAAA;ALsCJ;;AKnCE;EACE,wBAAA;ALsCJ;;AQ3JE;;EArCA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,iBALS;EAMT,gBAAA;EACA,eFyYc;EEvYd,uCFqYa;EEpYb,kBAAA;EACA,sBFXM;EEYN,iDFqYa;EEnYb,oBFyXkB;EExXlB,eFyXgB;EExXhB,mBFRqB;EESrB,gBFjCkB;EEkClB,WFnBM;EEsBJ,2DF+Xe;EE1Wf,gBAAA;AR6KJ;AQ9LE;;EACE,aAAA;EACA,wCFoXiB;EEnXjB,sBF5BI;EE6BJ,yCFqXiB;EElXf,2DFoXa;ANrLnB;;AQjLE;EACE,eAAA;ARoLJ;AQlLI;EACE,YAAA;ARoLN;;AQ7KI;;;EAEE,wCF/DO;EEgEP,mBFuVkB;ANtKxB;;AQ5KE;;EAEE,gBAAA;EACA,kBF1DY;ANyOhB;;AQ3KE;EACE,sBAAA;AR8KJ;;AQ7JE;EACE,4BF9FU;AN8Pd;;ASvUE;;;EAGE,gBAAA;AT0UJ;;AStUE;;EAEE,qBAAA;EACA,wBAAA;EAEA,mBAAA;EACA,kBHqbW;EGpbX,gBAAA;ATwUJ;AStUI;;EACE,eAAA;ATyUN;;ASpUE;;EAEE,oBAAA;ATuUJ;;ASnUE;EACE,WAAA;ATsUJ;;AUlUE;EAjBA,cAAA;EACA,SAAA;EAEA,mBJwbqB;EIvbrB,mBJgEqB;EI/DrB,gBJwbuB;EIvbvB,WJqDM;ANiSR;AUxUI;EARF,gBAAA;EACA,oBAAA;AVmVF;;AWpWE;EAGE,mBAFa;EAGb,oBLobiB;EKnbjB,kBLobkB;EKnblB,WLyDI;AN4SR;;AYtWE;EACE,aAAA;EACA,WAAA;EACA,mBN8aW;EM3aT,oBAAA;AZuWN;AYnWM;EACE,0BAAA;AZqWR;AYhWM;EACE,0BAAA;AZkWR;;AY7VE;;;;EACE,SAAA;EACA,mBAAA;AZmWJ;;AY3VE;EAEE,eAAA;EACA,uCNoZkB;EMnZlB,kCNmBS;EMjBT,WNoBI;EMnBJ,kBAAA;EACA,mBAAA;EAGE,aAAA;EACA,cAAA;EACA,mBAAA;AZ0VN;AYlVM;EACE,eAAA;AZoVR;AYjVM;EACE,cAAA;AZmVR;;AY9UE;EAEE,gBAAA;EAGE,SAAA;EACA,YAAA;AZ8UN;;AY1UE;EAEE,cAAA;EACA,iBAAA;EACA,kBAAA;EAGE,aAAA;EACA,cAAA;AZ0UN;AYnUI;;;;EAOI,mBAAA;EACA,YAAA;EAKF,cAAA;EACA,iBAAA;EACA,eN4VY;AN9BlB;;AazZE;EACE,SAAA;EACA,UAAA;EACA,SAAA;Ab4ZJ;;AazZE;EACE,eAAA;EACA,qBAAA;Ab4ZJ;;AazZE;EAxBA,kBPgbgB;EO/ahB,gBP8aiB;EO7ajB,uCP4agB;ANSlB;AanbE;EAEE,SAAA;EACA,uBAAA;EACA,oBPyaa;ANWjB;;Ac/XE;EA/DA,iBAFS;EAGT,gBAAA;EACA,eR4cc;EQ1cd,gBAAA;EACA,uCRuca;EQtcb,kBRkEc;EQjEd,sBRuDM;EQrDN,oBR4bkB;EQ3blB,eR4bgB;EQ3bhB,mBR2DqB;EQ1DrB,gBRkCkB;EQjClB,WRgDM;ECkEN,yDAAA;EO9GE,8BAAA;EACA,uCAAA;EACA,4BAAA;EACA,wBAAA;EAEA,qBAAA;EAIA,2DRwbe;ANEnB;AOnVE;EOlEA;IPqEI,yDAAA;EPoVJ;AACF;Ac3bE;EACE,aAAA;EACA,wCR6aiB;EQ5ajB,sBR6BI;EQ5BJ,yCR8aiB;EQ3af,2DR6aa;ANcnB;ActbE;EACE,wCReS;EQdT,mBRqaoB;ANmBxB;AcpbE;EACE,aAAA;AdsbJ;AcnbE;EACE,YAAA;EACA,sBAAA;AdqbJ;AcnbE;EACE,cAAA;EACA,iBAAA;AdqbJ;;Ae1dE;EACE,qBT4MuB;ES3MvB,wCAAA;Af6dJ;Ae3dI;EACE,cTwMqB;ANqR3B;;AencI;EACE,cT8KqB;ANwR3B;;AejcE;EAzBA,aAAA;EACA,mBAAA;EACA,mBTiZa;ES/Yb,kBTgMsB;ES/LtB,iBTiCmB;EShCnB,cT6LkB;ANgSpB;AevcI;EACE,cAAA;AfycN;;AgB3TE;;;;;;;;;;;;;;;;;;;EAmBE,SAAA;EACA,UAAA;AhB8TJ;;AgB1TE;EACE,mBV7DsB;EU+DtB,kBAAA;EACA,gBVjEmB;EUkEnB,kCVhEuB;AN4X3B;;AgBxTE;;EAEE,kBAAA;EACA,oBAAA;AhB2TJ;;AgBvTE;;EAEE,iBV/KiB;EUgLjB,oBAAA;AhB0TJ;;AgBtTE;EACE,cVvFc;EUwFd,oBAAA;AhByTJ;;AgBrTE;;;;;;EAME,+EVtMe;EUuMf,kBV5IgB;EU6IhB,mBVnMmB;EUoMnB,cV5IW;EU6IX,kCVvGoB;AN+ZxB;AgBtTI;;;;;;EACE,cAAA;EACA,4BVpNQ;ANihBd;;AgBpTQ;EAII,mBADiB;EAajB,gBAAA;EAQA,aAAA;EAOA,qBAAA;AhB4RZ;;AgB3TQ;EAII,iBADiB;EAajB,gBAAA;EAQA,aAAA;EAOA,qBAAA;AhBmSZ;;AgBlUQ;EAII,kBADiB;EAajB,gBAAA;EAQA,aAAA;EAOA,qBAAA;AhB0SZ;;AgBzUQ;EAII,eADiB;EAajB,gBAAA;EAQA,aAAA;EAOA,qBAAA;AhBiTZ;;AgBhVQ;EAII,mBADiB;EAajB,gBAAA;EAQA,aAAA;EAOA,qBAAA;AhBwTZ;;AgBvVQ;EAII,eADiB;EAajB,gBAAA;EAQA,aAAA;EAOA,qBAAA;AhB+TZ;;AE7dQ;Ec+HA;IAII,kBADiB;EhBgW3B;EgBnWM;IAII,eADiB;EhBmW3B;EgBtWM;IAII,iBADiB;EhBsW3B;EgBzWM;IAII,kBADiB;EhByW3B;EgB5WM;IAII,mBADiB;EhB4W3B;EgB/WM;IAII,eADiB;EhB+W3B;AACF;AElfQ;Ec+HA;IAII,eADiB;EhBoX3B;EgBvXM;IAII,kBADiB;EhBuX3B;EgB1XM;IAII,eADiB;EhB0X3B;EgB7XM;IAII,iBADiB;EhB6X3B;EgBhYM;IAII,kBADiB;EhBgY3B;EgBnYM;IAII,eADiB;EhBmY3B;AACF;AEjgBQ;Ec0HA;IAII,oBADiB;EhBwY3B;EgB3YM;IAII,mBADiB;EhB2Y3B;EgB9YM;IAII,kBADiB;EhB8Y3B;EgBjZM;IAII,iBADiB;EhBiZ3B;EgBpZM;IAII,kBADiB;EhBoZ3B;EgBvZM;IAII,eADiB;EhBuZ3B;AACF;AgBpXE;EACE,oBAAA;EACA,WVpQI;EUqQJ,qBVrJqB;EUuJrB,eAAA;AhBqXJ;AgBnXI;EAEE,oCV5Je;ANghBrB;AgB9WI;EACE,SAAA;AhBgXN;;AgB3WE;EACE,WAAA;EAEA,gBV1SW;EU2SX,SAAA;EACA,oBVxKQ;EU0KR,aAAA;EACA,eAAA;EACA,8CV7KQ;EU8KR,cAAA;AhB4WJ;;AgBxWE;;;EAGE,mBV7LsB;EU8LtB,4BVjLkB;EUkLlB,gBVhMmB;AN2iBvB;;AgBvWE;EACE,kBAAA;AhB0WJ;;AgBtWE;EACE,oBV3Le;EU4Lf,qBV9Lc;ANuiBlB;;AgBrWE;EACE,oBVjMe;ANyiBnB;;AgBnWI;EACE,oBVtMoB;EUuMpB,gBAAA;AhBsWN;;AgBjWE;EACE,mBV5MqB;ANgjBzB;AgBlWI;EACE,qBV7MwB;EU8MxB,iBVjUe;ANqqBrB;;AgB/VE;EACE,gBAAA;EACA,sCVnNiB;EUoNjB,4CVnNgB;ANqjBpB;AgBhWI;EACE,gBV5OiB;EU6OjB,6BVxVM;AN0rBZ;;AgBpVE;EACE,8BV/Na;EUgOb,YAAA;EACA,qBAAA;AhBuVJ;;AgBnVE;EACE,SAAA;AhBsVJ;;AgB3UE;EACE,SAAA;EACA,2BVrPgB;EUuPhB,wCV/XS;EUiYT,4DV9ToB;EU+TpB,WV/XI;EUkYF,kBVvXU;ANisBhB;;AiB3pBE;EACE,kBX+FmB;EW9FnB,qBX+FsB;EW7FtB,mBX5CmB;EW6CnB,gBXwFmB;EWvFnB,6BXxDQ;ANqtBZ;;AiBzpBE;EACE,eXgFa;EW/Eb,gBXgFc;AN4kBlB;;AiBxpBE;EACE,iBXiFa;EWhFb,cAAA;AjB2pBJ;AiBzpBI;EACE,iBAAA;AjB2pBN;;AiBrpBI;EACE,cAAA;EACA,gBAAA;AjBwpBN;;AiBppBE;EAjFA,cAAA;EACA,6BXHU;EWIV,oBXkJe;ANulBjB;AiBvuBE;EACE,aXgJkB;ANylBtB;;AiBzpBE;EAzEA,uCX8IY;EW7IZ,wCXjBW;EWmBX,4DXgDsB;EW/CtB,mBXRqB;EWSrB,WXlBM;EWwBN,eAAA;EACA,eAAA;EACA,qBAAA;EAEA,qCXgIa;AN+lBf;;AiBhqBE;EA9EA,uCX8IY;EW7IZ,wCXjBW;EWmBX,4DXgDsB;EW/CtB,mBXRqB;EWSrB,WXlBM;EWkCN,cAAA;EACA,cAAA;EACA,gBAAA;EAEA,aXuHmB;EWtHnB,qBXuHyB;AN0mB3B;;AkB90BU;EACE,gBARU;AlBy1BtB;;AkBl1BU;EACE,iBARU;AlB61BtB;;AkBt1BU;EACE,kBARU;AlBi2BtB;;AkB11BU;EACE,mBARU;AlBq2BtB;;AE5rBQ;EgBvKE;IACE,gBAHU;ElB02BpB;EkBx2BQ;IACE,iBAHU;ElB62BpB;EkB32BQ;IACE,kBAHU;ElBg3BpB;EkB92BQ;IACE,mBAHU;ElBm3BpB;AACF;AE3sBQ;EgBvKE;IACE,gBAHU;ElBw3BpB;EkBt3BQ;IACE,iBAHU;ElB23BpB;EkBz3BQ;IACE,kBAHU;ElB83BpB;EkB53BQ;IACE,mBAHU;ElBi4BpB;AACF;AmBx3BE;EAAkB,wBAAA;AnB23BpB;;AmBz3BE;EACE;IAII,kCAAA;IACA,uBAAA;IACA,mCAAA;YAAA,qBAAA;IAOF,2BAAA;IACA,4BAAA;EnBm3BJ;EmBh3BE;IAAkB,yBAAA;EnBm3BpB;EmBl3BE;IAAkB,wBAAA;EnBq3BpB;EmBn3BE;IAAuB,yBAAA;EnBs3BzB;EmBr3BE;IAAuB,sCAAA;EnBw3BzB;EmBv3BE;IAAuB,mCAAA;EnB03BzB;EmBz3BE;IAAoB,6BAAA;EnB43BtB;EmB33BE;IAAoB,8BAAA;EnB83BtB;EmB73BE;IAAoB,8BAAA;EnBg4BtB;EmB73BE;;IACY,0BAAA;EnBg4Bd;EmB93BI;IAAgB,4BAAA;EnBi4BpB;EmB73BE;;;IAEqB,WAAA;EnBg4BvB;EmB73BE;IAAoB,6BAAA;EnBg4BtB;EmB73BE;;IAEE,wCAAA;IACA,wBAAA;EnB+3BJ;EmB33BE;IAAQ,2BAAA;EnB83BV;EmB53BE;;IACM,wBAAA;EnB+3BR;EmB73BE;IAAM,0BAAA;EnBg4BR;EmB93BE;IAAQ,aAAA;EnBi4BV;EmB/3BE;;;IAGE,UAAA;IACA,SAAA;EnBi4BJ;EmB73BE;;IACK,uBAAA;EnBg4BP;EmB73BE;IACE,uBAAA;EnB+3BJ;AACF;AoBh9BE;ECoBM,uBAAA;EAAA,sBAAA;ECdN,gBhBkDa;EgBjDb,iBAAA;EACA,kBAAA;AtB+8BF;AEnzBQ;EkBpKN;ICoBM,wBAAA;IAAA,uBAAA;ErBw8BN;AACF;AoB19BI;ECiBI,uBAAA;EAAA,sBAAA;ECdN,eFF+B;EEG/B,iBAAA;EACA,kBAAA;AtB49BF;AEh0BQ;EkBjKJ;ICiBI,wBAAA;IAAA,uBAAA;ErBq9BN;AACF;AoBn+BI;ECsBE,gBAAA;EAAA,eAAA;ECvBJ,eFE+B;EED/B,iBAAA;EACA,kBAAA;AtBy+BF;;AoBp+BE;EESA,aAAA;EACA,mBAAA;AtB+9BF;;AoBr+BE;EG4FA,cAAA;EAIE,eAAA;EACA,cAAA;EAsCA,WATM;AvB82BV;AoBz+BI;EGyFF,SAAA;AvBm5BF;AoBx+BI;EGqFF,cAAA;AvBs5BF;;AoBr+BI;EG0HA,WATM;AvBw3BV;AoBr+BI;EGsHA,WATM;AvB23BV;;AoBx9BM;EACE,gBAAA;ApB29BR;;AE12BQ;EkBlHF;IACE,gBAAA;EpBg+BN;AACF;AEh3BQ;EkBlHF;IACE,gBAAA;EpBq+BN;AACF;AoBz9BI;EG6CF,cAAA;AvB+6BF;;AoB78BM;EGyEF,oBATM;AvBi5BV;;AoBj9BM;EGyEF,qBATM;AvBq5BV;;AoBr9BM;EGyEF,UATM;AvBy5BV;;AoBz9BM;EGyEF,qBATM;AvB65BV;;AoB79BM;EGyEF,qBATM;AvBi6BV;;AoBj+BM;EGyEF,UATM;AvBq6BV;;AoBr+BM;EGyEF,qBATM;AvBy6BV;;AoBz+BM;EGyEF,qBATM;AvB66BV;;AoB7+BM;EGyEF,UATM;AvBi7BV;;AoBj/BM;EGyEF,qBATM;AvBq7BV;;AoBr/BM;EGyEF,qBATM;AvBy7BV;;AoBz/BM;EGyEF,WATM;AvB67BV;;AEx6BQ;EkBzGF;IGkDJ,SAAA;IA2CE,WATM;EvBm8BR;EoBlhCE;IG6CF,cAAA;EvBw+BA;EoB/gCI;IGkFF,WATM;EvBy8BR;EoBzgCI;IGyEF,oBATM;EvB48BR;EoB5gCI;IGyEF,qBATM;EvB+8BR;EoB/gCI;IGyEF,UATM;EvBk9BR;EoBlhCI;IGyEF,qBATM;EvBq9BR;EoBrhCI;IGyEF,qBATM;EvBw9BR;EoBxhCI;IGyEF,UATM;EvB29BR;EoB3hCI;IGyEF,qBATM;EvB89BR;EoB9hCI;IGyEF,qBATM;EvBi+BR;EoBjiCI;IGyEF,UATM;EvBo+BR;EoBpiCI;IGyEF,qBATM;EvBu+BR;EoBviCI;IGyEF,qBATM;EvB0+BR;EoB1iCI;IGyEF,WATM;EvB6+BR;AACF;AEz9BQ;EkBzGF;IGkDJ,SAAA;IA2CE,WATM;EvBm/BR;EoBlkCE;IG6CF,cAAA;EvBwhCA;EoB/jCI;IGkFF,WATM;EvBy/BR;EoBzjCI;IGyEF,oBATM;EvB4/BR;EoB5jCI;IGyEF,qBATM;EvB+/BR;EoB/jCI;IGyEF,UATM;EvBkgCR;EoBlkCI;IGyEF,qBATM;EvBqgCR;EoBrkCI;IGyEF,qBATM;EvBwgCR;EoBxkCI;IGyEF,UATM;EvB2gCR;EoB3kCI;IGyEF,qBATM;EvB8gCR;EoB9kCI;IGyEF,qBATM;EvBihCR;EoBjlCI;IGyEF,UATM;EvBohCR;EoBplCI;IGyEF,qBATM;EvBuhCR;EoBvlCI;IGyEF,qBATM;EvB0hCR;EoB1lCI;IGyEF,WATM;EvB6hCR;AACF;AoBtlCE;EACE,WAAA;ApBwlCJ;;AoBplCE;EACE,YAAA;ApBulCJ;;AoBzjCE;ECvGM,sBAAA;EAAA,uBAAA;ArBqqCR;AErhCQ;EkBzCN;ICvGM,uBAAA;IAAA,wBAAA;ErB0qCN;AACF;AoBhkCI;EGyBA,2BATM;EFlHJ,qBAAA;EAAA,sBAAA;ArBuqCN;AEhiCQ;EkB9BA;IGkBJ,4BATM;IFlHJ,sBAAA;IAAA,uBAAA;ErB6qCJ;AACF;AoBxmCE;EGqDE,WATM;AvB+jCV;AoBvmCE;EGiDE,WATM;AvBkkCV;AoBlmCI;EGyCA,oCATM;AvBqkCV;AoBrmCI;EGyCA,qCATM;AvBwkCV;AoBxmCI;EGyCA,0BATM;AvB2kCV;AoB3mCI;EGyCA,qCATM;AvB8kCV;AoB9mCI;EGyCA,qCATM;AvBilCV;AoBjnCI;EGyCA,0BATM;AvBolCV;AoBpnCI;EGyCA,qCATM;AvBulCV;AoBvnCI;EGyCA,qCATM;AvB0lCV;AoB1nCI;EGyCA,0BATM;AvB6lCV;AoB7nCI;EGyCA,qCATM;AvBgmCV;AoBhoCI;EGyCA,qCATM;AvBmmCV;AoBnoCI;EGyCA,2BATM;AvBsmCV;AEjlCQ;EkBjEN;IGqDE,WATM;EvB0mCR;EoBlpCA;IGiDE,WATM;EvB6mCR;EoB7oCE;IGyCA,qCATM;EvBgnCR;EoBhpCE;IGyCA,sCATM;EvBmnCR;EoBnpCE;IGyCA,2BATM;EvBsnCR;EoBtpCE;IGyCA,sCATM;EvBynCR;EoBzpCE;IGyCA,sCATM;EvB4nCR;EoB5pCE;IGyCA,2BATM;EvB+nCR;EoB/pCE;IGyCA,sCATM;EvBkoCR;EoBlqCE;IGyCA,sCATM;EvBqoCR;EoBrqCE;IGyCA,2BATM;EvBwoCR;EoBxqCE;IGyCA,sCATM;EvB2oCR;EoB3qCE;IGyCA,sCATM;EvB8oCR;EoB9qCE;IGyCA,4BATM;EvBipCR;EoB7rCA;IGqDE,WATM;EvBopCR;EoB5rCA;IGiDE,WATM;EvBupCR;EoBvrCE;IGyCA,qCATM;EvB0pCR;EoB1rCE;IGyCA,sCATM;EvB6pCR;EoB7rCE;IGyCA,2BATM;EvBgqCR;EoBhsCE;IGyCA,sCATM;EvBmqCR;EoBnsCE;IGyCA,sCATM;EvBsqCR;EoBtsCE;IGyCA,2BATM;EvByqCR;EoBzsCE;IGyCA,sCATM;EvB4qCR;EoB5sCE;IGyCA,sCATM;EvB+qCR;EoB/sCE;IGyCA,2BATM;EvBkrCR;EoBltCE;IGyCA,sCATM;EvBqrCR;EoBrtCE;IGyCA,sCATM;EvBwrCR;EoBxtCE;IGyCA,4BATM;EvB2rCR;AACF;AEvqCQ;EkBjEN;IGqDE,WATM;EvBgsCR;EoBxuCA;IGiDE,WATM;EvBmsCR;EoBnuCE;IGyCA,qCATM;EvBssCR;EoBtuCE;IGyCA,sCATM;EvBysCR;EoBzuCE;IGyCA,2BATM;EvB4sCR;EoB5uCE;IGyCA,sCATM;EvB+sCR;EoB/uCE;IGyCA,sCATM;EvBktCR;EoBlvCE;IGyCA,2BATM;EvBqtCR;EoBrvCE;IGyCA,sCATM;EvBwtCR;EoBxvCE;IGyCA,sCATM;EvB2tCR;EoB3vCE;IGyCA,2BATM;EvB8tCR;EoB9vCE;IGyCA,sCATM;EvBiuCR;EoBjwCE;IGyCA,sCATM;EvBouCR;EoBpwCE;IGyCA,4BATM;EvBuuCR;AACF;;AoBrtCI;EC9II,uBAAA;EAAA,sBAAA;ArBw2CR;AExtCQ;EkBFJ;IC9II,wBAAA;IAAA,uBAAA;ErB62CN;AACF;AoB1tCI;ECpJI,uBAAA;EAAA,sBAAA;ArBk3CR;AEluCQ;EkBIJ;ICpJI,wBAAA;IAAA,uBAAA;ErBu3CN;AACF;AoB/tCI;ECzJI,uBAAA;EAAA,sBAAA;ArB43CR;AE5uCQ;EkBSJ;ICzJI,wBAAA;IAAA,uBAAA;ErBi4CN;AACF;;AwBl4CE;EDoIE,WATM;AvB2wCV;;AwBt4CE;EDoIE,UATM;AvB+wCV;;AwB14CE;EDoIE,qBATM;AvBmxCV;;AwB94CE;EDoIE,UATM;AvBuxCV;;AwBl5CE;EDoIE,UATM;AvB2xCV;;AwBt5CE;EDoIE,qBATM;AvB+xCV;;AwB15CE;EDoIE,qBATM;AvBmyCV;;AwB95CE;EDoIE,YATM;AvBuyCV;;AElxCQ;EsBhJN;IDoIE,WATM;EvB4yCR;EwBv6CA;IDoIE,UATM;EvB+yCR;EwB16CA;IDoIE,qBATM;EvBkzCR;EwB76CA;IDoIE,UATM;EvBqzCR;EwBh7CA;IDoIE,UATM;EvBwzCR;EwBn7CA;IDoIE,qBATM;EvB2zCR;EwBt7CA;IDoIE,qBATM;EvB8zCR;EwBz7CA;IDoIE,YATM;EvBi0CR;AACF;AE7yCQ;EsBhJN;IDoIE,WATM;EvBs0CR;EwBj8CA;IDoIE,UATM;EvBy0CR;EwBp8CA;IDoIE,qBATM;EvB40CR;EwBv8CA;IDoIE,UATM;EvB+0CR;EwB18CA;IDoIE,UATM;EvBk1CR;EwB78CA;IDoIE,qBATM;EvBq1CR;EwBh9CA;IDoIE,qBATM;EvBw1CR;EwBn9CA;IDoIE,YATM;EvB21CR;AACF;AwBv9CE;EDoIE,2BATM;AvB+1CV;;AwB19CE;EDoIE,0BATM;AvBm2CV;;AwB99CE;EDoIE,qCATM;AvBu2CV;;AwBl+CE;EDoIE,0BATM;AvB22CV;;AwBt+CE;EDoIE,0BATM;AvB+2CV;;AwB1+CE;EDoIE,qCATM;AvBm3CV;;AwB9+CE;EDoIE,qCATM;AvBu3CV;;AwBl/CE;EDoIE,4BATM;AvB23CV;;AEt2CQ;EsBhJN;IDoIE,4BATM;EvBg4CR;EwB3/CA;IDoIE,2BATM;EvBm4CR;EwB9/CA;IDoIE,sCATM;EvBs4CR;EwBjgDA;IDoIE,2BATM;EvBy4CR;EwBpgDA;IDoIE,2BATM;EvB44CR;EwBvgDA;IDoIE,sCATM;EvB+4CR;EwB1gDA;IDoIE,sCATM;EvBk5CR;EwB7gDA;IDoIE,6BATM;EvBq5CR;EwBhhDA;IDoIE,4BATM;EvBw5CR;EwBnhDA;IDoIE,2BATM;EvB25CR;EwBthDA;IDoIE,sCATM;EvB85CR;EwBzhDA;IDoIE,2BATM;EvBi6CR;EwB5hDA;IDoIE,2BATM;EvBo6CR;EwB/hDA;IDoIE,sCATM;EvBu6CR;EwBliDA;IDoIE,sCATM;EvB06CR;EwBriDA;IDoIE,6BATM;EvB66CR;AACF;AEz5CQ;EsBhJN;IDoIE,4BATM;EvBk7CR;EwB7iDA;IDoIE,2BATM;EvBq7CR;EwBhjDA;IDoIE,sCATM;EvBw7CR;EwBnjDA;IDoIE,2BATM;EvB27CR;EwBtjDA;IDoIE,2BATM;EvB87CR;EwBzjDA;IDoIE,sCATM;EvBi8CR;EwB5jDA;IDoIE,sCATM;EvBo8CR;EwB/jDA;IDoIE,6BATM;EvBu8CR;AACF;AoB53CM;EK9ME,eAAA;EAAA,cAAA;AzB8kDR;AyB3kDM;EAEI,eAAA;EAAA,cAAA;AzB6kDV;AyBvjDY;EFgHR,oBATM;AvBm9CV;AyB1jDY;EFgHR,qBATM;AvBs9CV;AyB7jDY;EFgHR,UATM;AvBy9CV;AyBhkDY;EFgHR,qBATM;AvB49CV;AyBnkDY;EFgHR,qBATM;AvB+9CV;AyBtkDY;EFgHR,UATM;AvBk+CV;AyBzkDY;EFgHR,qBATM;AvBq+CV;AyB5kDY;EFgHR,qBATM;AvBw+CV;AyB/kDY;EFgHR,UATM;AvB2+CV;AyBllDY;EFgHR,qBATM;AvB8+CV;AyBrlDY;EFgHR,qBATM;AvBi/CV;AyBxlDY;EFgHR,WATM;AvBo/CV;AE/9CQ;EuB5HI;IFgHR,oBATM;EvBw/CR;EyB/lDU;IFgHR,qBATM;EvB2/CR;EyBlmDU;IFgHR,UATM;EvB8/CR;EyBrmDU;IFgHR,qBATM;EvBigDR;EyBxmDU;IFgHR,qBATM;EvBogDR;EyB3mDU;IFgHR,UATM;EvBugDR;EyB9mDU;IFgHR,qBATM;EvB0gDR;EyBjnDU;IFgHR,qBATM;EvB6gDR;EyBpnDU;IFgHR,UATM;EvBghDR;EyBvnDU;IFgHR,qBATM;EvBmhDR;EyB1nDU;IFgHR,qBATM;EvBshDR;EyB7nDU;IFgHR,WATM;EvByhDR;AACF;AErgDQ;EuB5HI;IFgHR,oBATM;EvB8hDR;EyBroDU;IFgHR,qBATM;EvBiiDR;EyBxoDU;IFgHR,UATM;EvBoiDR;EyB3oDU;IFgHR,qBATM;EvBuiDR;EyB9oDU;IFgHR,qBATM;EvB0iDR;EyBjpDU;IFgHR,UATM;EvB6iDR;EyBppDU;IFgHR,qBATM;EvBgjDR;EyBvpDU;IFgHR,qBATM;EvBmjDR;EyB1pDU;IFgHR,UATM;EvBsjDR;EyB7pDU;IFgHR,qBATM;EvByjDR;EyBhqDU;IFgHR,qBATM;EvB4jDR;EyBnqDU;IFgHR,WATM;EvB+jDR;AACF;;AoB9+CM;EK7KE,eAAA;EAAA,cAAA;AzBgqDR;AyB7pDM;EAEI,gBAAA;EAAA,eAAA;AzB+pDV;;AEpjDQ;EkBuDF;IK9ME,eAAA;IAAA,cAAA;EzBitDN;EyB9sDI;IAEI,eAAA;IAAA,cAAA;EzBgtDR;AACF;AE/jDQ;EuBrII;IFyHR,oBATM;EvBwlDR;EyBxsDU;IFyHR,qBATM;EvB2lDR;EyB3sDU;IFyHR,UATM;EvB8lDR;EyB9sDU;IFyHR,qBATM;EvBimDR;EyBjtDU;IFyHR,qBATM;EvBomDR;EyBptDU;IFyHR,UATM;EvBumDR;EyBvtDU;IFyHR,qBATM;EvB0mDR;EyB1tDU;IFyHR,qBATM;EvB6mDR;EyB7tDU;IFyHR,UATM;EvBgnDR;EyBhuDU;IFyHR,qBATM;EvBmnDR;EyBnuDU;IFyHR,qBATM;EvBsnDR;EyBtuDU;IFyHR,WATM;EvBynDR;AACF;AErmDQ;EuB5HI;IFgHR,oBATM;EvB8nDR;EyBruDU;IFgHR,qBATM;EvBioDR;EyBxuDU;IFgHR,UATM;EvBooDR;EyB3uDU;IFgHR,qBATM;EvBuoDR;EyB9uDU;IFgHR,qBATM;EvB0oDR;EyBjvDU;IFgHR,UATM;EvB6oDR;EyBpvDU;IFgHR,qBATM;EvBgpDR;EyBvvDU;IFgHR,qBATM;EvBmpDR;EyB1vDU;IFgHR,UATM;EvBspDR;EyB7vDU;IFgHR,qBATM;EvBypDR;EyBhwDU;IFgHR,qBATM;EvB4pDR;EyBnwDU;IFgHR,WATM;EvB+pDR;AACF;AE3oDQ;EuB5HI;IFgHR,oBATM;EvBoqDR;EyB3wDU;IFgHR,qBATM;EvBuqDR;EyB9wDU;IFgHR,UATM;EvB0qDR;EyBjxDU;IFgHR,qBATM;EvB6qDR;EyBpxDU;IFgHR,qBATM;EvBgrDR;EyBvxDU;IFgHR,UATM;EvBmrDR;EyB1xDU;IFgHR,qBATM;EvBsrDR;EyB7xDU;IFgHR,qBATM;EvByrDR;EyBhyDU;IFgHR,UATM;EvB4rDR;EyBnyDU;IFgHR,qBATM;EvB+rDR;EyBtyDU;IFgHR,qBATM;EvBksDR;EyBzyDU;IFgHR,WATM;EvBqsDR;AACF;;AEjrDQ;EkB6DF;IK7KE,eAAA;IAAA,cAAA;EzBuyDN;EyBpyDI;IAEI,gBAAA;IAAA,eAAA;EzBsyDR;AACF;;AE5rDQ;EkBuDF;IK9ME,eAAA;IAAA,cAAA;EzBy1DN;EyBt1DI;IAEI,eAAA;IAAA,cAAA;EzBw1DR;AACF;AEvsDQ;EuBrII;IFyHR,oBATM;EvBguDR;EyBh1DU;IFyHR,qBATM;EvBmuDR;EyBn1DU;IFyHR,UATM;EvBsuDR;EyBt1DU;IFyHR,qBATM;EvByuDR;EyBz1DU;IFyHR,qBATM;EvB4uDR;EyB51DU;IFyHR,UATM;EvB+uDR;EyB/1DU;IFyHR,qBATM;EvBkvDR;EyBl2DU;IFyHR,qBATM;EvBqvDR;EyBr2DU;IFyHR,UATM;EvBwvDR;EyBx2DU;IFyHR,qBATM;EvB2vDR;EyB32DU;IFyHR,qBATM;EvB8vDR;EyB92DU;IFyHR,WATM;EvBiwDR;AACF;AE7uDQ;EuBrII;IFyHR,oBATM;EvBswDR;EyBt3DU;IFyHR,qBATM;EvBywDR;EyBz3DU;IFyHR,UATM;EvB4wDR;EyB53DU;IFyHR,qBATM;EvB+wDR;EyB/3DU;IFyHR,qBATM;EvBkxDR;EyBl4DU;IFyHR,UATM;EvBqxDR;EyBr4DU;IFyHR,qBATM;EvBwxDR;EyBx4DU;IFyHR,qBATM;EvB2xDR;EyB34DU;IFyHR,UATM;EvB8xDR;EyB94DU;IFyHR,qBATM;EvBiyDR;EyBj5DU;IFyHR,qBATM;EvBoyDR;EyBp5DU;IFyHR,WATM;EvBuyDR;AACF;AEnxDQ;EuB5HI;IFgHR,oBATM;EvB4yDR;EyBn5DU;IFgHR,qBATM;EvB+yDR;EyBt5DU;IFgHR,UATM;EvBkzDR;EyBz5DU;IFgHR,qBATM;EvBqzDR;EyB55DU;IFgHR,qBATM;EvBwzDR;EyB/5DU;IFgHR,UATM;EvB2zDR;EyBl6DU;IFgHR,qBATM;EvB8zDR;EyBr6DU;IFgHR,qBATM;EvBi0DR;EyBx6DU;IFgHR,UATM;EvBo0DR;EyB36DU;IFgHR,qBATM;EvBu0DR;EyB96DU;IFgHR,qBATM;EvB00DR;EyBj7DU;IFgHR,WATM;EvB60DR;AACF;;AEzzDQ;EkB6DF;IK7KE,eAAA;IAAA,cAAA;EzB+6DN;EyB56DI;IAEI,gBAAA;IAAA,eAAA;EzB86DR;AACF;;AoBzvDM;EMvMF,eAAA;A1Bo8DJ;;AoBzvDM;EM3MF,gCAAA;A1Bw8DJ;;AoBjwDM;EMvMF,0BAAA;A1B48DJ;;AoBjwDM;EM3MF,2CAAA;A1Bg9DJ;;AoBzwDM;EMvMF,2BAAA;A1Bo9DJ;;AoBzwDM;EM3MF,4CAAA;A1Bw9DJ;;AoBjxDM;EMvMF,gBAAA;A1B49DJ;;AoBjxDM;EM3MF,iCAAA;A1Bg+DJ;;AoBzxDM;EMvMF,2BAAA;A1Bo+DJ;;AoBzxDM;EM3MF,4CAAA;A1Bw+DJ;;AoBjyDM;EMvMF,2BAAA;A1B4+DJ;;AoBjyDM;EM3MF,4CAAA;A1Bg/DJ;;AoBzyDM;EMvMF,gBAAA;A1Bo/DJ;;AoBzyDM;EM3MF,iCAAA;A1Bw/DJ;;AoBjzDM;EMvMF,2BAAA;A1B4/DJ;;AoBjzDM;EM3MF,4CAAA;A1BggEJ;;AoBzzDM;EMvMF,2BAAA;A1BogEJ;;AoBzzDM;EM3MF,4CAAA;A1BwgEJ;;AoBj0DM;EMvMF,gBAAA;A1B4gEJ;;AoBj0DM;EM3MF,iCAAA;A1BghEJ;;AoBz0DM;EMvMF,2BAAA;A1BohEJ;;AoBz0DM;EM3MF,4CAAA;A1BwhEJ;;AoBj1DM;EMvMF,2BAAA;A1B4hEJ;;AoBj1DM;EM3MF,4CAAA;A1BgiEJ;;AEp6DQ;EkB2EF;IMvMF,eAAA;E1BqiEF;EoB11DI;IM3MF,iCAAA;E1BwiEF;EoBj2DI;IMvMF,0BAAA;E1B2iEF;EoBh2DI;IM3MF,4CAAA;E1B8iEF;EoBv2DI;IMvMF,2BAAA;E1BijEF;EoBt2DI;IM3MF,6CAAA;E1BojEF;EoB72DI;IMvMF,gBAAA;E1BujEF;EoB52DI;IM3MF,kCAAA;E1B0jEF;EoBn3DI;IMvMF,2BAAA;E1B6jEF;EoBl3DI;IM3MF,6CAAA;E1BgkEF;EoBz3DI;IMvMF,2BAAA;E1BmkEF;EoBx3DI;IM3MF,6CAAA;E1BskEF;EoB/3DI;IMvMF,gBAAA;E1BykEF;EoB93DI;IM3MF,kCAAA;E1B4kEF;EoBr4DI;IMvMF,2BAAA;E1B+kEF;EoBp4DI;IM3MF,6CAAA;E1BklEF;EoB34DI;IMvMF,2BAAA;E1BqlEF;EoB14DI;IM3MF,6CAAA;E1BwlEF;EoBj5DI;IMvMF,gBAAA;E1B2lEF;EoBh5DI;IM3MF,kCAAA;E1B8lEF;EoBv5DI;IMvMF,2BAAA;E1BimEF;EoBt5DI;IM3MF,6CAAA;E1BomEF;EoB75DI;IMvMF,2BAAA;E1BumEF;EoB55DI;IM3MF,6CAAA;E1B0mEF;AACF;AE/+DQ;EkB2EF;IMvMF,eAAA;E1B+mEF;EoBp6DI;IM3MF,iCAAA;E1BknEF;EoB36DI;IMvMF,0BAAA;E1BqnEF;EoB16DI;IM3MF,4CAAA;E1BwnEF;EoBj7DI;IMvMF,2BAAA;E1B2nEF;EoBh7DI;IM3MF,6CAAA;E1B8nEF;EoBv7DI;IMvMF,gBAAA;E1BioEF;EoBt7DI;IM3MF,kCAAA;E1BooEF;EoB77DI;IMvMF,2BAAA;E1BuoEF;EoB57DI;IM3MF,6CAAA;E1B0oEF;EoBn8DI;IMvMF,2BAAA;E1B6oEF;EoBl8DI;IM3MF,6CAAA;E1BgpEF;EoBz8DI;IMvMF,gBAAA;E1BmpEF;EoBx8DI;IM3MF,kCAAA;E1BspEF;EoB/8DI;IMvMF,2BAAA;E1BypEF;EoB98DI;IM3MF,6CAAA;E1B4pEF;EoBr9DI;IMvMF,2BAAA;E1B+pEF;EoBp9DI;IM3MF,6CAAA;E1BkqEF;EoB39DI;IMvMF,gBAAA;E1BqqEF;EoB19DI;IM3MF,kCAAA;E1BwqEF;EoBj+DI;IMvMF,2BAAA;E1B2qEF;EoBh+DI;IM3MF,6CAAA;E1B8qEF;EoBv+DI;IMvMF,2BAAA;E1BirEF;EoBt+DI;IM3MF,6CAAA;E1BorEF;AACF;AoBx9DE;EE/OA,aAAA;EACA,wBAAA;AtB0sEF;AoBx9DI;EG9IF,YAAA;EACA,gBAAA;AvBymEF;AoBx9DI;EGrHA,YATM;AvBylEV;AoBv9DI;EGzHA,YATM;AvB4lEV;AoB58DM;EACE,gBAAA;ApB88DR;AE1kEQ;EkB2HF;IACE,gBAAA;EpBk9DN;AACF;AE/kEQ;EkB2HF;IACE,gBAAA;EpBu9DN;AACF;AoB58DM;EG/LJ,cAAA;AvB8oEF;AoBh8DQ;EGnKJ,qBATM;AvB+mEV;AoBn8DQ;EGnKJ,sBATM;AvBknEV;AoBt8DQ;EGnKJ,WATM;AvBqnEV;AoBz8DQ;EGnKJ,sBATM;AvBwnEV;AoB58DQ;EGnKJ,sBATM;AvB2nEV;AoB/8DQ;EGnKJ,WATM;AvB8nEV;AoBl9DQ;EGnKJ,sBATM;AvBioEV;AoBr9DQ;EGnKJ,sBATM;AvBooEV;AoBx9DQ;EGnKJ,WATM;AvBuoEV;AoB39DQ;EGnKJ,sBATM;AvB0oEV;AoB99DQ;EGnKJ,sBATM;AvB6oEV;AoBj+DQ;EGnKJ,YATM;AvBgpEV;AE3nEQ;EkBmIA;IG1LN,SAAA;IA2CE,YATM;EvBqpER;EoBx/DI;IG/LJ,cAAA;EvB0rEA;EoBr/DM;IG1JJ,YATM;EvB2pER;EoB/+DM;IGnKJ,qBATM;EvB8pER;EoBl/DM;IGnKJ,sBATM;EvBiqER;EoBr/DM;IGnKJ,WATM;EvBoqER;EoBx/DM;IGnKJ,sBATM;EvBuqER;EoB3/DM;IGnKJ,sBATM;EvB0qER;EoB9/DM;IGnKJ,WATM;EvB6qER;EoBjgEM;IGnKJ,sBATM;EvBgrER;EoBpgEM;IGnKJ,sBATM;EvBmrER;EoBvgEM;IGnKJ,WATM;EvBsrER;EoB1gEM;IGnKJ,sBATM;EvByrER;EoB7gEM;IGnKJ,sBATM;EvB4rER;EoBhhEM;IGnKJ,YATM;EvB+rER;AACF;AE3qEQ;EkBmIA;IG1LN,SAAA;IA2CE,YATM;EvBqsER;EoBxiEI;IG/LJ,cAAA;EvB0uEA;EoBriEM;IG1JJ,YATM;EvB2sER;EoB/hEM;IGnKJ,qBATM;EvB8sER;EoBliEM;IGnKJ,sBATM;EvBitER;EoBriEM;IGnKJ,WATM;EvBotER;EoBxiEM;IGnKJ,sBATM;EvButER;EoB3iEM;IGnKJ,sBATM;EvB0tER;EoB9iEM;IGnKJ,WATM;EvB6tER;EoBjjEM;IGnKJ,sBATM;EvBguER;EoBpjEM;IGnKJ,sBATM;EvBmuER;EoBvjEM;IGnKJ,WATM;EvBsuER;EoB1jEM;IGnKJ,sBATM;EvByuER;EoB7jEM;IGnKJ,sBATM;EvB4uER;EoBhkEM;IGnKJ,YATM;EvB+uER;AACF;;AoBxjEM;ECnTE,qBAAA;EAAA,wBAAA;ArBg3ER;AEhuEQ;EkBmKF;ICnTE,sBAAA;IAAA,yBAAA;ErBq3EN;AACF;AoB9jEM;ECxTE,qBAAA;EAAA,wBAAA;ArB03ER;AE1uEQ;EkBwKF;ICxTE,sBAAA;IAAA,yBAAA;ErB+3EN;AACF;;AoBzxEE;ECvGM,qBAAA;EAAA,wBAAA;ArBq4ER;AErvEQ;EkBzCN;ICvGM,sBAAA;IAAA,yBAAA;ErB04EN;AACF;AoBhyEI;EGyBA,4BATM;EFlHJ,oBAAA;EAAA,uBAAA;ArBu4EN;AEhwEQ;EkB9BA;IGkBJ,6BATM;IFlHJ,qBAAA;IAAA,wBAAA;ErB64EJ;AACF;AoBx0EE;EGqDE,YATM;AvB+xEV;AoBv0EE;EGiDE,YATM;AvBkyEV;AoBl0EI;EGyCA,qCATM;AvBqyEV;AoBr0EI;EGyCA,sCATM;AvBwyEV;AoBx0EI;EGyCA,2BATM;AvB2yEV;AoB30EI;EGyCA,sCATM;AvB8yEV;AoB90EI;EGyCA,sCATM;AvBizEV;AoBj1EI;EGyCA,2BATM;AvBozEV;AoBp1EI;EGyCA,sCATM;AvBuzEV;AoBv1EI;EGyCA,sCATM;AvB0zEV;AoB11EI;EGyCA,2BATM;AvB6zEV;AoB71EI;EGyCA,sCATM;AvBg0EV;AoBh2EI;EGyCA,sCATM;AvBm0EV;AoBn2EI;EGyCA,4BATM;AvBs0EV;AEjzEQ;EkBjEN;IGqDE,YATM;EvB00ER;EoBl3EA;IGiDE,YATM;EvB60ER;EoB72EE;IGyCA,sCATM;EvBg1ER;EoBh3EE;IGyCA,uCATM;EvBm1ER;EoBn3EE;IGyCA,4BATM;EvBs1ER;EoBt3EE;IGyCA,uCATM;EvBy1ER;EoBz3EE;IGyCA,uCATM;EvB41ER;EoB53EE;IGyCA,4BATM;EvB+1ER;EoB/3EE;IGyCA,uCATM;EvBk2ER;EoBl4EE;IGyCA,uCATM;EvBq2ER;EoBr4EE;IGyCA,4BATM;EvBw2ER;EoBx4EE;IGyCA,uCATM;EvB22ER;EoB34EE;IGyCA,uCATM;EvB82ER;EoB94EE;IGyCA,6BATM;EvBi3ER;EoB75EA;IGqDE,YATM;EvBo3ER;EoB55EA;IGiDE,YATM;EvBu3ER;EoBv5EE;IGyCA,sCATM;EvB03ER;EoB15EE;IGyCA,uCATM;EvB63ER;EoB75EE;IGyCA,4BATM;EvBg4ER;EoBh6EE;IGyCA,uCATM;EvBm4ER;EoBn6EE;IGyCA,uCATM;EvBs4ER;EoBt6EE;IGyCA,4BATM;EvBy4ER;EoBz6EE;IGyCA,uCATM;EvB44ER;EoB56EE;IGyCA,uCATM;EvB+4ER;EoB/6EE;IGyCA,4BATM;EvBk5ER;EoBl7EE;IGyCA,uCATM;EvBq5ER;EoBr7EE;IGyCA,uCATM;EvBw5ER;EoBx7EE;IGyCA,6BATM;EvB25ER;AACF;AEv4EQ;EkBjEN;IGqDE,YATM;EvBg6ER;EoBx8EA;IGiDE,YATM;EvBm6ER;EoBn8EE;IGyCA,sCATM;EvBs6ER;EoBt8EE;IGyCA,uCATM;EvBy6ER;EoBz8EE;IGyCA,4BATM;EvB46ER;EoB58EE;IGyCA,uCATM;EvB+6ER;EoB/8EE;IGyCA,uCATM;EvBk7ER;EoBl9EE;IGyCA,4BATM;EvBq7ER;EoBr9EE;IGyCA,uCATM;EvBw7ER;EoBx9EE;IGyCA,uCATM;EvB27ER;EoB39EE;IGyCA,4BATM;EvB87ER;EoB99EE;IGyCA,uCATM;EvBi8ER;EoBj+EE;IGyCA,uCATM;EvBo8ER;EoBp+EE;IGyCA,6BATM;EvBu8ER;AACF;;AoB7vEE;EOtVE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EA2BI,YAAA;A3B6jFR;;AoBjwEE;EACE,WAAA;ApBowEJ;;AoBjwEE;EO7SE,gBAAA;EACA,eAAA;EAGF,iCAAA;EACA,4CAAA;A3BgjFF;;AoBpwEE;EOrTE,gBAAA;EACA,gBAAA;EACA,gBAAA;EAMF,iCAAA;EACA,4CAAA;A3BwjFF;;AoBvwEE;EO1SA,aAAA;EACA,sBAAA;EACA,gBAAA;A3BqjFF;A2BnjFE;EACE,gBAAA;EACA,iBAAA;A3BqjFJ;;AEx9EQ;EkB8MJ;IO9WA,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IA2BI,YAAA;E3BmmFN;EoB/wEE;IACE,WAAA;EpBixEJ;EoB9wEE;IOrUA,gBAAA;IACA,eAAA;IAGF,iCAAA;IACA,4CAAA;E3BolFA;EoBhxEE;IO7TF,aAAA;IACA,sBAAA;IACA,gBAAA;E3BglFA;E2B9kFA;IACE,gBAAA;IACA,iBAAA;E3BglFF;EoBrxEE;IOjVA,gBAAA;IACA,gBAAA;IACA,gBAAA;IAMF,iCAAA;IACA,4CAAA;E3BomFA;AACF;AE3/EQ;EkB8MJ;IO9WA,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IA2BI,YAAA;E3BqoFN;EoBjzEE;IACE,WAAA;EpBmzEJ;EoBhzEE;IOrUA,gBAAA;IACA,eAAA;IAGF,iCAAA;IACA,4CAAA;E3BsnFA;EoBlzEE;IO7TF,aAAA;IACA,sBAAA;IACA,gBAAA;E3BknFA;E2BhnFA;IACE,gBAAA;IACA,iBAAA;E3BknFF;EoBvzEE;IOjVA,gBAAA;IACA,gBAAA;IACA,gBAAA;IAMF,iCAAA;IACA,4CAAA;E3BsoFA;AACF;AoBxzEM;EACE,WAAA;EOtYJ,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EAyBI,aAAA;A3ByqFR;AEriFQ;EkB2OA;IACE,WAAA;IO5YN,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IAyBI,aAAA;E3BkrFN;AACF;AE/iFQ;EkB2OA;IACE,WAAA;IO5YN,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IAyBI,aAAA;E3B4rFN;AACF;;AoBt0EM;EACE,YAAA;ApBy0ER;AE7jFQ;EkBuPA;IACE,YAAA;EpBy0ER;AACF;AElkFQ;EkBuPA;IACE,YAAA;EpB80ER;AACF;;AoBhnFE;ECvGM,qBAAA;EAAA,wBAAA;ArB4tFR;AE5kFQ;EkBzCN;ICvGM,sBAAA;IAAA,yBAAA;ErBiuFN;AACF;AoBvnFI;EGyBA,4BATM;EFlHJ,oBAAA;EAAA,uBAAA;ArB8tFN;AEvlFQ;EkB9BA;IGkBJ,6BATM;IFlHJ,qBAAA;IAAA,wBAAA;ErBouFJ;AACF;AoB/pFE;EGqDE,YATM;AvBsnFV;AoB9pFE;EGiDE,YATM;AvBynFV;AoBzpFI;EGyCA,qCATM;AvB4nFV;AoB5pFI;EGyCA,sCATM;AvB+nFV;AoB/pFI;EGyCA,2BATM;AvBkoFV;AoBlqFI;EGyCA,sCATM;AvBqoFV;AoBrqFI;EGyCA,sCATM;AvBwoFV;AoBxqFI;EGyCA,2BATM;AvB2oFV;AoB3qFI;EGyCA,sCATM;AvB8oFV;AoB9qFI;EGyCA,sCATM;AvBipFV;AoBjrFI;EGyCA,2BATM;AvBopFV;AoBprFI;EGyCA,sCATM;AvBupFV;AoBvrFI;EGyCA,sCATM;AvB0pFV;AoB1rFI;EGyCA,4BATM;AvB6pFV;AExoFQ;EkBjEN;IGqDE,YATM;EvBiqFR;EoBzsFA;IGiDE,YATM;EvBoqFR;EoBpsFE;IGyCA,sCATM;EvBuqFR;EoBvsFE;IGyCA,uCATM;EvB0qFR;EoB1sFE;IGyCA,4BATM;EvB6qFR;EoB7sFE;IGyCA,uCATM;EvBgrFR;EoBhtFE;IGyCA,uCATM;EvBmrFR;EoBntFE;IGyCA,4BATM;EvBsrFR;EoBttFE;IGyCA,uCATM;EvByrFR;EoBztFE;IGyCA,uCATM;EvB4rFR;EoB5tFE;IGyCA,4BATM;EvB+rFR;EoB/tFE;IGyCA,uCATM;EvBksFR;EoBluFE;IGyCA,uCATM;EvBqsFR;EoBruFE;IGyCA,6BATM;EvBwsFR;EoBpvFA;IGqDE,YATM;EvB2sFR;EoBnvFA;IGiDE,YATM;EvB8sFR;EoB9uFE;IGyCA,sCATM;EvBitFR;EoBjvFE;IGyCA,uCATM;EvBotFR;EoBpvFE;IGyCA,4BATM;EvButFR;EoBvvFE;IGyCA,uCATM;EvB0tFR;EoB1vFE;IGyCA,uCATM;EvB6tFR;EoB7vFE;IGyCA,4BATM;EvBguFR;EoBhwFE;IGyCA,uCATM;EvBmuFR;EoBnwFE;IGyCA,uCATM;EvBsuFR;EoBtwFE;IGyCA,4BATM;EvByuFR;EoBzwFE;IGyCA,uCATM;EvB4uFR;EoB5wFE;IGyCA,uCATM;EvB+uFR;EoB/wFE;IGyCA,6BATM;EvBkvFR;AACF;AE9tFQ;EkBjEN;IGqDE,YATM;EvBuvFR;EoB/xFA;IGiDE,YATM;EvB0vFR;EoB1xFE;IGyCA,sCATM;EvB6vFR;EoB7xFE;IGyCA,uCATM;EvBgwFR;EoBhyFE;IGyCA,4BATM;EvBmwFR;EoBnyFE;IGyCA,uCATM;EvBswFR;EoBtyFE;IGyCA,uCATM;EvBywFR;EoBzyFE;IGyCA,4BATM;EvB4wFR;EoB5yFE;IGyCA,uCATM;EvB+wFR;EoB/yFE;IGyCA,uCATM;EvBkxFR;EoBlzFE;IGyCA,4BATM;EvBqxFR;EoBrzFE;IGyCA,uCATM;EvBwxFR;EoBxzFE;IGyCA,uCATM;EvB2xFR;EoB3zFE;IGyCA,6BATM;EvB8xFR;AACF;;AoB3gFI;EO5YI,6BAAA;A3B25FR;AE9wFQ;EkB+PJ;IO5YI,8BAAA;E3B+5FN;AACF;AEnxFQ;EkB+PJ;IO5YI,8BAAA;E3Bo6FN;AACF;;AExxFQ;EkBmQF;IOhZE,8BAAA;E3B06FN;AACF;AE9xFQ;EkBmQF;IOhZE,8BAAA;E3B+6FN;AACF;A4BvoFE;EA1OA,qBAAA;EACA,sBAAA;EACA,kBtB2Nc;EsBjNZ,mBtBgNa;EsB7Mf,6BtBqNc;EsBpNd,kBtBnBc;EsBoBd,iEtB+NkB;EsB9NlB,oBtBwMmB;EsBvMnB,iBAAA;EACA,gBtBuMmB;EsBtMnB,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;A5By2FF;AO1xFE;EACE,UAAA;AP4xFJ;A4BrpFM;EACE,iBAFmB;A5BypF3B;A4BxpFM;EACE,kBAFmB;A5B4pF3B;A4B3pFM;EACE,kBAFmB;A5B+pF3B;A4BzpFI;EArNA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;A5Bi3FJ;A4BhzFE;EAIE,yBCvFgB;EDwFhB,WtBrHI;ANo6FR;A4B5yFE;EACE,+CtBoHsB;EsBnHtB,WtB1HI;ANw6FR;A4BxzFE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5Bo0FZ;A4BpzFE;EACE,8CAbmB;EAcnB,WAlBQ;A5Bw0FZ;A4Bh0FE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5B40FZ;A4B5zFE;EACE,sCAbmB;EAcnB,WAlBQ;A5Bg1FZ;A4Bx0FE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5Bo1FZ;A4Bp0FE;EACE,4CAbmB;EAcnB,WAlBQ;A5Bw1FZ;A4Bh1FE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5B41FZ;A4B50FE;EACE,qCAbmB;EAcnB,WAlBQ;A5Bg2FZ;A4Bx1FE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5Bo2FZ;A4Bp1FE;EACE,+CAbmB;EAcnB,WAlBQ;A5Bw2FZ;A4Bh2FE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5B42FZ;A4B51FE;EACE,sCAbmB;EAcnB,WAlBQ;A5Bg3FZ;A4Bx2FE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5Bo3FZ;A4Bp2FE;EACE,yBAbmB;EAcnB,WAlBQ;A5Bw3FZ;A4Bh3FE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5B43FZ;A4B52FE;EACE,wCAbmB;EAcnB,WAlBQ;A5Bg4FZ;A4Bx3FE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5Bo4FZ;A4Bp3FE;EACE,uCAbmB;EAcnB,WAlBQ;A5Bw4FZ;A4B92FI;EACE,6BAAA;A5Bg3FN;A4B/1FE;EAIE,yBAAA;EACA,cC5HgB;A7B09FpB;A4B31FE;EACE,0CAZY;EAaZ,mCAbY;A5B02FhB;A4Bv2FE;EAIE,yBAAA;EACA,ctBxKiB;AN8gGrB;A4Bn2FE;EACE,0CAZY;EAaZ,mCAbY;A5Bk3FhB;A4B/2FE;EAIE,yBAAA;EACA,ctBxKiB;ANshGrB;A4B32FE;EACE,+BAZY;EAaZ,wBAbY;A5B03FhB;A4Bv3FE;EAIE,yBAAA;EACA,ctBxKiB;AN8hGrB;A4Bn3FE;EACE,0CAZY;EAaZ,mCAbY;A5Bk4FhB;A4B/3FE;EAIE,yBAAA;EACA,ctBxKiB;ANsiGrB;A4B33FE;EACE,gCAZY;EAaZ,yBAbY;A5B04FhB;A4Bv4FE;EAIE,yBAAA;EACA,ctBxKiB;AN8iGrB;A4Bn4FE;EACE,wCAZY;EAaZ,iCAbY;A5Bk5FhB;A4B/4FE;EAIE,yBAAA;EACA,ctBxKiB;ANsjGrB;A4B34FE;EACE,kCAZY;EAaZ,2BAbY;A5B05FhB;A4Bv5FE;EAIE,yBAAA;EACA,ctBxKiB;AN8jGrB;A4Bn5FE;EACE,sCAZY;EAaZ,+BAbY;A5Bk6FhB;A4B/5FE;EAIE,yBAAA;EACA,ctBxKiB;ANskGrB;A4B35FE;EACE,iCAZY;EAaZ,0BAbY;A5B06FhB;A4Bv6FE;EAIE,yBAAA;EACA,ctBxKiB;AN8kGrB;A4Bn6FE;EACE,mCAZY;EAaZ,4BAbY;A5Bk7FhB;A4B75FI;EACE,yBAAA;EACA,6BAAA;A5B+5FN;A4Bh5FE;EAIE,cC9JgB;A7B6iGpB;A4B54FE;EACE,mCAXY;A5By5FhB;A4Bt5FE;EAIE,ctB1MiB;AN+lGrB;A4Bl5FE;EACE,mCAXY;A5B+5FhB;A4B55FE;EAIE,ctB1MiB;ANqmGrB;A4Bx5FE;EACE,wBAXY;A5Bq6FhB;A4Bl6FE;EAIE,ctB1MiB;AN2mGrB;A4B95FE;EACE,mCAXY;A5B26FhB;A4Bx6FE;EAIE,ctB1MiB;ANinGrB;A4Bp6FE;EACE,yBAXY;A5Bi7FhB;A4B96FE;EAIE,ctB1MiB;ANunGrB;A4B16FE;EACE,iCAXY;A5Bu7FhB;A4Bp7FE;EAIE,ctB1MiB;AN6nGrB;A4Bh7FE;EACE,2BAXY;A5B67FhB;A4B17FE;EAIE,ctB1MiB;ANmoGrB;A4Bt7FE;EACE,+BAXY;A5Bm8FhB;A4Bh8FE;EAIE,ctB1MiB;ANyoGrB;A4B57FE;EACE,0BAXY;A5By8FhB;A4Bt8FE;EAIE,ctB1MiB;AN+oGrB;A4Bl8FE;EACE,4BAXY;A5B+8FhB;A4Bx1FI;EAnGF,atBkDwB;EsBjDxB,mBAAA;A5B87FF;A4Bl7FE;ErBhQA,cAAA;EACA,QAAA;EACA,SAAA;EAEA,mBAAA;EAEA,WAAA;EAGE,sBAAA;EACA,uBAAA;EACA,0CAAA;EqBuPA,kBAAA;EACA,UAAA;EAEA,qBAAA;EACA,YAAA;EACA,gBATO;A5Bm8FX;A4B51FQ;EACE,yBC9RU;A7B4nGpB;A4Bz1FY;EACE,yBtBhVO;AN2qGrB;A4B51FY;EACE,yBtBhVO;AN8qGrB;A4B/1FY;EACE,yBtBhVO;ANirGrB;A4Bl2FY;EACE,yBtBhVO;ANorGrB;A4Br2FY;EACE,yBtBhVO;ANurGrB;A4Bx2FY;EACE,yBtBhVO;AN0rGrB;A4B32FY;EACE,yBtBhVO;AN6rGrB;A4B92FY;EACE,yBtBhVO;ANgsGrB;A4Bj3FY;EACE,yBtBhVO;ANmsGrB;A4B32FI;EACE,WAAA;EACA,WAAA;EACA,cAAA;A5B62FN;;A4Bx2FI;EAEE,qBAAA;A5B02FN;;A8B1jGE;EApLA,mBxBoTmB;EwBjTjB,aAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;A9BgvGJ;AOjnGE;EAEE,cAAA;EACA,YAAA;EAGE,aAAA;EACA,QAAA;APgnGN;AO5mGE;EACE,WAAA;AP8mGJ;A8BvvGI;EAEE,aAAA;A9BwvGN;A8BjvGE;EACE,SAAA;EACA,iBxBkSkB;EwBjSlB,kBxBiSkB;EwBhSlB,iBAAA;EAGE,cAAA;A9BivGN;A8B9uGI;EACE,eAAA;A9BgvGN;A8BnlGM;EACE,iBAFmB;A9BulG3B;A8BtlGM;EACE,kBAFmB;A9B0lG3B;A8BzlGM;EACE,kBAFmB;A9B6lG3B;A8BtsGE;EAEI,SAAA;EACA,eAAA;A9BusGN;A4BxnGE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5BooGZ;A4BpnGE;EACE,8CAbmB;EAcnB,WAlBQ;A5BwoGZ;A4BhoGE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5B4oGZ;A4B5nGE;EACE,sCAbmB;EAcnB,WAlBQ;A5BgpGZ;A4BxoGE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5BopGZ;A4BpoGE;EACE,4CAbmB;EAcnB,WAlBQ;A5BwpGZ;A4BhpGE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5B4pGZ;A4B5oGE;EACE,qCAbmB;EAcnB,WAlBQ;A5BgqGZ;A4BxpGE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5BoqGZ;A4BppGE;EACE,+CAbmB;EAcnB,WAlBQ;A5BwqGZ;A4BhqGE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5B4qGZ;A4B5pGE;EACE,sCAbmB;EAcnB,WAlBQ;A5BgrGZ;A4BxqGE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5BorGZ;A4BpqGE;EACE,yBAbmB;EAcnB,WAlBQ;A5BwrGZ;A4BhrGE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5B4rGZ;A4B5qGE;EACE,wCAbmB;EAcnB,WAlBQ;A5BgsGZ;A4BxrGE;EAIE,yBtBnIiB;EsBoIjB,WAbQ;A5BosGZ;A4BprGE;EACE,uCAbmB;EAcnB,WAlBQ;A5BwsGZ;A4B9qGI;EACE,6BAAA;A5BgrGN;A4B/pGE;EAIE,yBAAA;EACA,cC5HgB;A7B0xGpB;A4B3pGE;EACE,0CAZY;EAaZ,mCAbY;A5B0qGhB;A4BvqGE;EAIE,yBAAA;EACA,ctBxKiB;AN80GrB;A4BnqGE;EACE,0CAZY;EAaZ,mCAbY;A5BkrGhB;A4B/qGE;EAIE,yBAAA;EACA,ctBxKiB;ANs1GrB;A4B3qGE;EACE,+BAZY;EAaZ,wBAbY;A5B0rGhB;A4BvrGE;EAIE,yBAAA;EACA,ctBxKiB;AN81GrB;A4BnrGE;EACE,0CAZY;EAaZ,mCAbY;A5BksGhB;A4B/rGE;EAIE,yBAAA;EACA,ctBxKiB;ANs2GrB;A4B3rGE;EACE,gCAZY;EAaZ,yBAbY;A5B0sGhB;A4BvsGE;EAIE,yBAAA;EACA,ctBxKiB;AN82GrB;A4BnsGE;EACE,wCAZY;EAaZ,iCAbY;A5BktGhB;A4B/sGE;EAIE,yBAAA;EACA,ctBxKiB;ANs3GrB;A4B3sGE;EACE,kCAZY;EAaZ,2BAbY;A5B0tGhB;A4BvtGE;EAIE,yBAAA;EACA,ctBxKiB;AN83GrB;A4BntGE;EACE,sCAZY;EAaZ,+BAbY;A5BkuGhB;A4B/tGE;EAIE,yBAAA;EACA,ctBxKiB;ANs4GrB;A4B3tGE;EACE,iCAZY;EAaZ,0BAbY;A5B0uGhB;A4BvuGE;EAIE,yBAAA;EACA,ctBxKiB;AN84GrB;A4BnuGE;EACE,mCAZY;EAaZ,4BAbY;A5BkvGhB;A4B7tGI;EACE,yBAAA;EACA,6BAAA;A5B+tGN;A4BhtGE;EAIE,cC9JgB;A7B62GpB;A4B5sGE;EACE,mCAXY;A5BytGhB;A4BttGE;EAIE,ctB1MiB;AN+5GrB;A4BltGE;EACE,mCAXY;A5B+tGhB;A4B5tGE;EAIE,ctB1MiB;ANq6GrB;A4BxtGE;EACE,wBAXY;A5BquGhB;A4BluGE;EAIE,ctB1MiB;AN26GrB;A4B9tGE;EACE,mCAXY;A5B2uGhB;A4BxuGE;EAIE,ctB1MiB;ANi7GrB;A4BpuGE;EACE,yBAXY;A5BivGhB;A4B9uGE;EAIE,ctB1MiB;ANu7GrB;A4B1uGE;EACE,iCAXY;A5BuvGhB;A4BpvGE;EAIE,ctB1MiB;AN67GrB;A4BhvGE;EACE,2BAXY;A5B6vGhB;A4B1vGE;EAIE,ctB1MiB;ANm8GrB;A4BtvGE;EACE,+BAXY;A5BmwGhB;A4BhwGE;EAIE,ctB1MiB;ANy8GrB;A4B5vGE;EACE,0BAXY;A5BywGhB;A4BtwGE;EAIE,ctB1MiB;AN+8GrB;A4BlwGE;EACE,4BAXY;A5B+wGhB;A8B/7GE;EACE,wBAAA;A9Bi8GJ;A8B/7GI;EACE,8BAAA;A9Bi8GN;A8B3xGI;EA3GA,eAAA;A9By4GJ;A8Bt4GE;EAEI,cAAA;A9Bu4GN;A8Bj4GI;EACE,gBAAA;A9Bm4GN;A8Bp7GE;EAEI,SAAA;EACA,eAAA;A9Bq7GN;AE33GQ;E4BaN;IAEI,cAAA;IAKF,gBAAA;E9B42GF;AACF;AEj4GQ;E4BaN;IAEI,cAAA;IAKF,gBAAA;E9Bk3GF;AACF;AEv4GQ;E4ByGJ;IAEI,cAAA;E9BgyGN;E8B9xGM;IACE,cAAA;IACA,eAAA;E9BgyGR;AACF;AEh5GQ;E4BoHJ;IAEI,cAAA;E9B8xGN;E8B5xGM;IACE,cAAA;IACA,eAAA;E9B8xGR;AACF;;A+B99GE;EAZA,kBAAA;EACA,WzB+RoB;EyB9RpB,6BzBdU;EyBeV,eAAA;A/B8+GF;AOv4GE;EACE,UAAA;APy4GJ;A+B/+GE;EAEE,WzBlBI;ANkgHR;A+Br+GQ;EA9BN,cAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;A/BsgHF;;A+B3+GQ;EA9BN,WAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;A/B6gHF;;AgCjjHE;EAZA,qBAAA;EACA,0B1B+cc;E0B7cd,kB1BsDc;E0BpDd,iB1B0cgB;E0BzchB,cAAA;EACA,mBAAA;EACA,eAAA;EAOE,mBH6DgB;EG5DhB,W1B+BI;AN0hHR;AgCtjHM;EACE,mB1BYa;E0BXb,WAAA;AhCwjHR;AgC1jHM;EACE,mB1BYa;E0BXb,WAAA;AhC4jHR;AgC9jHM;EACE,mB1BYa;E0BXb,WAAA;AhCgkHR;AgClkHM;EACE,mB1BYa;E0BXb,WAAA;AhCokHR;AgCtkHM;EACE,mB1BYa;E0BXb,WAAA;AhCwkHR;AgC1kHM;EACE,mB1BYa;E0BXb,WAAA;AhC4kHR;AgC9kHM;EACE,mB1BYa;E0BXb,WAAA;AhCglHR;AgCllHM;EACE,mB1BYa;E0BXb,WAAA;AhColHR;AgCtlHM;EACE,mB1BYa;E0BXb,WAAA;AhCwlHR;;AiC1mHE;EAnCA,Y3BglBgB;E2B/kBhB,mB3BmFc;E2BlFd,kB3BuFc;E2BtFd,uC3ByEY;ANwkHd;AiC5mHQ;EACE,yB3BuBW;ANulHrB;AiC/mHQ;EACE,yB3BuBW;AN0lHrB;AiClnHQ;EACE,yB3BuBW;AN6lHrB;AiCrnHQ;EACE,yB3BuBW;ANgmHrB;AiCxnHQ;EACE,yB3BuBW;ANmmHrB;AiC3nHQ;EACE,yB3BuBW;ANsmHrB;AiC9nHQ;EACE,yB3BuBW;ANymHrB;AiCjoHQ;EACE,yB3BuBW;AN4mHrB;AiCpoHQ;EACE,yB3BuBW;AN+mHrB;;AiC/nHE;EAxCA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,yBJgGkB;EI7FhB,kB3B0EY;AN+lHhB;;AiCnoHE;E1ByMA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;E0B3OA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,W3BsDM;E2BrDN,mBAAA;EAGE,kB3B4DY;AN4mHhB;;AkClmHE;EApFA,kBAAA;EACA,c5BiwBc;E4BhwBd,mBAAA;EACA,sBAAA;EAEA,wC5BuDW;E4BtDX,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AlCyrHF;;AkCxmHE;EA5EA,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,qBAAA;EACA,eAAA;EACA,c5B+uBc;E4B7uBd,uC5BwCY;E4BvCZ,gC5B2uBkB;AN28FpB;AkCprHE;EACE,yBAAA;AlCsrHJ;;AkCjnHE;E3BiIA,kBAAA;EACA,QAAA;EACA,2BAAA;E2BhMA,OAAA;EACA,UAAA;EAEA,qBAAA;EACA,a5BiuBoB;E4BhuBpB,c5B+tBqB;E4B7tBrB,kB5BkCc;E4BjCd,yBLoDkB;EKnDlB,gC5ButBkB;E4BttBlB,0BAAA;AlCmrHF;AO1iHE;EACE,UAAA;AP4iHJ;AkCprHE;EACE,+CAAA;AlCsrHJ;AkCnrHE;EACE,yBAAA;AlCqrHJ;;AkCpoHE;;EA5CA,a5BitBwB;E4BhtBxB,mBAAA;AlCqrHF;;AkCpoHE;EA7CA,qBAAA;EACA,a5BmsBsB;E4BlsBtB,eAAA;EACA,iBAAA;EACA,uBAAA;AlCqrHF;AkCnrHE;EACE,MAAA;EACA,a5B4rBoB;E4B3rBpB,gBAAA;AlCqrHJ;AkClrHE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,a5ByrBmB;E4BxrBnB,c5ByrBkB;E4BxrBlB,2BAAA;AlCorHJ;;AmC/jHE;EACE,Y7B4kBY;E6B/tBd,kBAAA;EACA,mB7BmBc;E6BlBd,UAAA;EAGA,mBAAA;EACA,iBAAA;EACA,W7BQM;E6BNN,yBAAA;UAAA,iBAAA;AnCmtHF;;AmCpkHE;EA1IA,kBAAA;EACA,gBAAA;EACA,UAAA;AnCktHF;;AmCrkHE;EAnIA,kBAAA;EACA,cAAA;EACA,WAPe;EAQf,Y7BksBc;E6BhsBd,kB7BNc;E6BOd,iC7BpBY;E6BqBZ,8B7BusByB;E6BpsBzB,oBAAA;EACA,cAAA;EAEA,eAAA;AnCwsHF;AmCrsHE;EACE,SAAA;AnCusHJ;AmCnsHE;EACE,kBAAA;EACA,Y7BqrBmB;E6BprBnB,a7BorBmB;E6BlrBnB,cAAA;EACA,aA9Ba;EA+Bb,cAhCc;EAkCd,+BAAA;EACA,kB7BhCY;E6BiCZ,gB7B3CI;E6B4CJ,8B7B6qBuB;E6B5qBvB,WAAA;AnCmsHJ;AmC/rHE;EACE,mBNrBgB;A7BstHpB;AmC/rHI;EACE,aA5CmB;AnC6uHzB;AmC5rHE;EACE,mB7BgqBqB;E6B/pBrB,Y7B8pBsB;ANgiG1B;AOtoHE;EACE,UAAA;APwoHJ;;AmC1mHE;EA7EA,kBAAA;EACA,QAAA;EACA,2BAAA;AnC2rHF;;AmC3mHE;EA3EA,QAAA;EACA,aAAA;AnC0rHF;AmCxrHE;EACE,cAAA;AnC0rHJ;;AmC7mHE;EAvEA,UAAA;AnCwrHF;AmCtrHE;EACE,aAAA;AnCwrHJ;;AmC9mHE;EAvDA,c7BomBmB;ANqkGrB;AmCvqHE;EACE,WARa;EASb,c7BgmBiB;E6B/lBjB,mBAmDqB;AnCsnHzB;AmCtqHE;EACE,Y7BimBmB;E6BhmBnB,a7BgmBmB;E6B/lBnB,WAfa;EAgBb,YAfc;AnCurHlB;AmCrqHE;EACE,aAlBqB;AnCyrHzB;;AmC5nHE;EA3DA,e7BqmBoB;ANslGtB;AmCzrHE;EACE,aARa;EASb,e7BimBkB;E6BhmBlB,kBAuDqB;AnCooHzB;AmCxrHE;EACE,Y7BimBmB;E6BhmBnB,a7BgmBmB;E6B/lBnB,cAfa;EAgBb,eAfc;AnCysHlB;AmCvrHE;EACE,UAlBqB;AnC2sHzB;;AmC1oHE;EA/DA,c7BsmBoB;ANumGtB;AmC3sHE;EACE,WARa;EASb,c7BkmBkB;E6BjmBlB,eA2DqB;AnCkpHzB;AmC1sHE;EACE,Y7BimBmB;E6BhmBnB,a7BgmBmB;E6B/lBnB,WAfa;EAgBb,YAfc;AnC2tHlB;AmCzsHE;EACE,aAlBqB;AnC6tHzB;;AoC5mHE;EA9GA,yBAAA;EACA,WAAA;EACA,mB9B3Gc;E8B4Gd,kB9BvGc;ANq0HhB;AoCtzHE;;;EAGE,6C9BssBW;E8BrsBX,sB9B7BI;ANq1HR;;AoCpzHE;EACE,iC9BisBY;E8BhsBZ,iB9B1BiB;ANi1HrB;;AoCnzHE;EACE,0C9BksBoB;E8BjsBpB,W9B1CI;ANg2HR;;AoClzHE;EACE,uC9B8rBoB;E8B7rBpB,W9BhDI;ANq2HR;;AoC9yHI;;EACE,uBAAA;ApCkzHN;AoC9yHI;;;;EAEE,iC9BsqBU;E8BrqBV,iB9BrDe;E8BsDf,gBAAA;ApCkzHN;;AoC5yHI;;EAEE,iC9B4pBU;ANmpGhB;;AoCr3HM;EACE,gBAAA;EACA,6C9BquBmB;ANmpG3B;;AoCzyHM;EAEE,sB9BpFA;AN+3HR;AoC92HE;EACE,gBAAA;EACA,oD9B+sBW;E8B9sBX,sB9BpBI;ANo4HR;;AEzyHQ;EkC4GJ;IACE,aAAA;EpCisHJ;EoC7rHA;IACE,aAAA;EpC+rHF;EoC5rHA;;;IAGE,cAAA;EpC8rHF;EoC3rHA;IACE,aAAA;EpC6rHF;AACF;;AoC/qHE;EAvGA,cAAA;EACA,WAAA;EACA,gBAAA;ApC0xHF;;AoCnxHI;EACE,gD9BkmBiB;ANorGvB;AoChxHI;EACE,6C9B6lBiB;ANqrGvB;AoC5wHI;EACE,0C9B8kBY;ANgsGlB;AoCvwHM;EACE,6C9BukBiB;ANksGzB;;AoC1rHE;EACE,gBAAA;ApC6rHJ;;AqCh9HE;EAXA,qBAAA;EACA,gB/BgQe;E+B/Pf,c/B8Pc;E+B5Pd,kBAAA;EAEA,iB/B4PgB;E+B3PhB,kBAAA;EAOE,mBR8DgB;EQ7DhB,W/BgCI;ANu7HR;AqCp9HM;EACE,mB/Baa;E+BZb,WAAA;ArCs9HR;AqCx9HM;EACE,mB/Baa;E+BZb,WAAA;ArC09HR;AqC59HM;EACE,mB/Baa;E+BZb,WAAA;ArC89HR;AqCh+HM;EACE,mB/Baa;E+BZb,WAAA;ArCk+HR;AqCp+HM;EACE,mB/Baa;E+BZb,WAAA;ArCs+HR;AqCx+HM;EACE,mB/Baa;E+BZb,WAAA;ArC0+HR;AqC5+HM;EACE,mB/Baa;E+BZb,WAAA;ArC8+HR;AqCh/HM;EACE,mB/Baa;E+BZb,WAAA;ArCk/HR;AqCp/HM;EACE,mB/Baa;E+BZb,WAAA;ArCs/HR;;AsCl8HE;EA7CA,kBhC4OmB;EgC3OnB,gBAAA;AtCm/HF;AO54HE;EAEE,cAAA;EACA,YAAA;EAGE,aAAA;EACA,QAAA;AP24HN;AOv4HE;EACE,WAAA;APy4HJ;AsCz/HE;EACE,WAAA;EAEA,oBhCsOyB;EgCrOzB,WhCWI;EgCVJ,eAAA;EAGE,yBAAA;AtCw/HN;AsCh/HQ;EACE,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAPQ;EAQR,4BhCRI;AN0/Hd;AsCx+HE;EACE,cTagB;A7B69HpB;AsCx+HI;EACE,0BAAA;AtC0+HN;AsCj+HI;EACE,4BhChCQ;EgCiCR,mBAAA;AtCm+HN;;AuC1/HE;EA1CA,kBAAA;EACA,kBjCiTe;EiChTf,aAAA;EAEA,wCjC6Se;EiC5Sf,kBjCwCc;EiCvBd,uBAFa;EAGb,WAAA;AvCuhIF;AuCtiIE;EACE,aAAA;AvCwiIJ;AuCriIE;EACE,gBAAA;AvCuiIJ;AuCtgIM;EAxBJ,0CAFa;EAGb,WAAA;AvCiiIF;AuC1gIM;EAxBJ,kDAFa;EAGb,WAAA;AvCqiIF;AuC9gIM;EAxBJ,4CAFa;EAGb,WAAA;AvCyiIF;AuClhIM;EAxBJ,qEAFa;EAGb,WAAA;AvC6iIF;AuCthIM;EAxBJ,wCAFa;EAGb,WAAA;AvCijIF;AuC1hIM;EAxBJ,qEAFa;EAGb,WAAA;AvCqjIF;AuC9hIM;EAxBJ,uBAFa;EAGb,WAAA;AvCyjIF;AuCliIM;EAxBJ,qEAFa;EAGb,WAAA;AvC6jIF;AuCtiIM;EAxBJ,0CAFa;EAGb,WAAA;AvCikIF;AuCpiIM;EAzBJ,mBAwB2B;EAvB3B,qBAuB2B;EAtB3B,sBAsB2B;EArB3B,oBAqB2B;AvC2iI7B;AuC1iIM;EAzBJ,iBAwB2B;EAvB3B,mBAuB2B;EAtB3B,oBAsB2B;EArB3B,kBAqB2B;AvCijI7B;;AwCviIE;EAvDE,aAAA;EACA,sBAAA;EACA,YAAA;EAGF,mBlC6Bc;EkC3Bd,wClCsTY;EkCrTZ,kBlC+Bc;EkC7Bd,gBlCmBM;EkClBN,gBlCmTY;EkCjTZ,gBAAA;EACA,WlCcM;AN+kIR;AwC3lIE;EACE,gBAAA;AxC6lIJ;;AwCnjIE;EAhCE,aAAA;EACA,cAAA;EAGF,alCIe;EkCHf,kClCPW;AN4lIb;AwCnlIE;EACE,gBAAA;AxCqlIJ;;AwCzjIE;EAnBE,cAAA;EAGF,alCZe;AN0lIjB;AwC5kIE;EACE,gBAAA;AxC8kIJ;;AwC3jIE;EACE,eAAA;AxC8jIJ;;AyCtnIE;EA5BA,kBAAA;EACA,WAAA;EAEA,aAAA;EAEA,YnCsXe;EmCrXf,anCiXiB;EmC/WjB,kBAAA;EACA,uCnCgXgB;EmC/WhB,kBnC2Cc;EmC1Cd,sBnCgCM;EmC9BN,enC6WmB;ANqyHrB;AyC9oIE;EACE,cAAA;AzCgpIJ;AyC7oIE;EACE,cAAA;EACA,mBAAA;AzC+oIJ;;AyCpoIM;EACE,YnC0VS;AN6yHjB;;AyCxoIM;EACE,YnC0VS;ANizHjB;;AyC5oIM;EACE,YnC0VS;ANqzHjB;;A0CnjIE;EAnFA,cAAA;EACA,mBpCGc;ANuoIhB;AOxjIE;EAEE,cAAA;EACA,YAAA;EAGE,aAAA;EACA,QAAA;APujIN;AOnjIE;EACE,WAAA;APqjIJ;A0ChpIE;EACE,uBpC2esB;EoC1etB,kBpCGY;EoCFZ,mBpCqemB;EoC/djB,aAAA;A1C6oIN;A0C3oIM;EAEE,qBAAA;A1C4oIR;AEnkIQ;EwCtFN;IAuBM,qBAAA;E1CsoIN;AACF;A0CjoIE;;EAEE,cAAA;EACA,2BpC2csB;EoC1ctB,kBpC5BY;EoC6BZ,WpCxCI;AN2qIR;A0CjoII;;EACE,kCpC9CO;ANkrIb;A0CvlII;EAlCF,2BpC2bwB;EoC1bxB,mBbzBkB;Ea0BlB,WpCvDM;EoCwDN,eAAA;A1C4nIF;A0CzlII;EA3BF,2BpCgbwB;EoC/axB,4BpCpEY;EoCqEZ,mBAAA;A1CunIF;A0CrnIE;EACE,uBAAA;A1CunIJ;A0C7lII;EAjBF,2BpCkawB;EoCjaxB,YAAA;EACA,WpCjFM;ANksIR;;A0C5lII;;EAEE,qBAAA;EACA,oBAAA;EACA,YpCkZsB;AN6sH5B;;A0C5lII;;EAEE,qBAAA;EACA,mBAAA;EACA,YpC4YkB;ANmtHxB;;A2C5oIE;EAnGA,kBAAA;EACA,qBAAA;EAEA,gDrC0zBsB;EqCzzBtB,iBrCqCmB;EqCpCnB,YrCszBe;AN47GjB;;A2ChpIE;EA9FA,kBAAA;EACA,2BAAA;EACA,aAAA;EAEA,gBrCozBkB;EqCnzBlB,gBrCkzBgB;EqChzBhB,kBrC0Bc;EqCzBd,sBrCcM;EqCbN,crCqHgB;EqCpHhB,WrCaM;ANmuIR;A2C9uIE;EACE,kBAAA;A3CgvIJ;A2C5uII;EpCrCF,cAAA;EACA,QAAA;EACA,SAAA;EAEA,qBAAA;EAEA,WAAA;EAQE,mBAAA;EACA,0BAAA;EACA,0CAAA;EoCuBE,YAAA;A3CqvIN;A2ClvII;EACE,SAAA;EACA,2BAAA;A3CovIN;A2C/uII;EpCjDF,cAAA;EACA,QAAA;EACA,SAAA;EAEA,qBAAA;EAEA,WAAA;EAGE,sBAAA;EACA,uBAAA;EACA,0CAAA;EoCwCE,SAAA;EACA,YAAA;A3CwvIN;A2CrvII;EACE,SAAA;EACA,2BAAA;A3CuvIN;A2ClvII;EpC9DF,cAAA;EACA,QAAA;EACA,SAAA;EAEA,qBAAA;EAEA,WAAA;EAaE,qBAAA;EACA,wBAAA;EACA,sDAAA;EoC2CE,UAAA;A3C2vIN;A2CxvII;EACE,YAAA;EACA,QAAA;EACA,2BAAA;A3C0vIN;A2CrvII;EpC3EF,cAAA;EACA,QAAA;EACA,SAAA;EAEA,qBAAA;EAEA,WAAA;EAkBE,oBAAA;EACA,yBAAA;EACA,sDAAA;EoCmDE,WAAA;EACA,UAAA;A3C8vIN;A2C3vII;EACE,YAAA;EACA,QAAA;EACA,2BAAA;A3C6vIN;A2CzvIE;EACE,YAAA;EACA,QAAA;A3C2vIJ;A2CxvIE;EACE,WAAA;EACA,SAAA;A3C0vIJ;A2CvvIE;EACE,SAAA;EACA,WAAA;A3CyvIJ;A2CtvIE;EACE,UAAA;EACA,UAAA;A3CwvIJ;;A4CvvIE;EAxFA,cAAA;EACA,gBtCwBM;EsCvBN,qBAAA;A5Cm1IF;A4Ch1II;EACE,mBAAA;A5Ck1IN;;A4C30IE;EACE,0BAAA;A5C80IJ;A4C30IE;EACE,0BAAA;A5C60IJ;;A4C/vIE;EAlEA,kBAAA;EACA,cAAA;EACA,qBtC6KuB;EsC3KvB,wCtC6KyB;EsC5KzB,gBAAA;EAEA,kBtCqK0B;EsCpK1B,cAAA;EACA,cfekB;A7BozIpB;A4Cj0IE;EACE,+CtCqKuB;EsCpKvB,0BAAA;A5Cm0IJ;A4Ch0IE;EAEE,wCtC3BS;AN41Ib;A4C7zII;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,YtC+ImB;ANgrIzB;A4C5zII;EACE,YtC4IoB;ANkrI1B;;A4CvxIE;EA3BA,aAAA;EACA,atCuI0B;EsCrI1B,wCtCmIyB;EsClIzB,gBAAA;EACA,sBtCrDM;EsCuDN,WtCxDM;AN42IR;A4ClzIE;EACE,+CtC4HuB;ANwrI3B;;A6Cz1IE;EApFA,aAAA;EACA,mBvCmEc;EuChEZ,iBAAA;A7C+6IJ;A6C56IE;EACE,eAAA;A7C86IJ;AE5xIQ;E2C9IJ;IAEI,eAAA;E7C46IN;AACF;;A6Cn2IE;EAhEE,cAAA;A7Cu6IJ;A6Ch6IE;EACE,mBvCqCa;AN63IjB;A6C/5IE;EACE,kBvCiCa;ANg4IjB;A6C95IE;EACE,gBAAA;A7Cg6IJ;AE9yIQ;E2C/GN;IAwBA,UAAA;IACA,oBvCCe;IuCEb,gBAAA;IACA,eAAA;E7Cu4IF;E6Cj4IA;IACE,WvCyZ8B;EN0+HhC;AACF;A6Cj6II;EACE,SAAA;A7Cm6IN;;A8Cj1IE;EArGA,kBAAA;A9C07IF;;A8Cj1IE;EApGA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;A9Cy7IF;;A8Cr1IE;EA/FA,WAAA;EACA,kBAAA;A9Cw7IF;A8Cr7II;EACE,MAAA;EACA,OAAA;A9Cu7IN;;A8C11IE;EAvFA,SAAA;A9Cq7IF;;A8C11IE;EAtFA,WAAA;EACA,eAAA;EACA,SAAA;A9Co7IF;;A8C51IE;EAnFA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,axC0dsB;EwCxdtB,uCxCudyB;EwCtdzB,WAAA;A9Ck7IF;;A8Cl2IE;EvCiEA,kBAAA;EACA,QAAA;EACA,2BAAA;EuC5IA,WxCmdqB;EwCldrB,axCidsB;EwChdtB,WxCvBM;ANy8IR;AOr1IE;EACE,UAAA;APu1IJ;A8Cn7IE;EAGE,uCxC0c6B;ANy+HjC;;A8C72IE;EAhEA,OAAA;A9Ci7IF;;A8C52IE;EAhEA,UAAA;EACA,QAAA;A9Cg7IF;;A8C52IE;EA9DA,kBAAA;EACA,kBxCmbwB;EwClbxB,qBxCmb2B;EwClb3B,kBAAA;A9C86IF;AO32IE;EACE,UAAA;AP62IJ;A8C/6IE;EACE,axC4aoB;EwC3apB,cxC2aoB;EwC1apB,cxC2akB;EwCzalB,kBAAA;EACA,uCxC5DU;AN4+Id;A8C96II;EACE,wCxC9DM;AN8+IZ;A8C76II;EACE,wCxClEM;ANi/IZ;;A+CxhJE;;EAnBA,kBAAA;EACA,SAAA;EACA,mBzCquB+B;EyCpuB/B,mBAAA;EACA,gBAAA;A/CgjJF;A+C9iJE;;;;;;;;EAIE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/CojJJ;A+CxiJM;;EACE,sBAAA;A/C2iJR;;AgDh9IE;EAjFA,S1C6wBW;E0C5wBX,wCAAA;EACA,gB1CqBM;E0CpBN,qBAAA;AhDqiJF;AO77IE;EAEE,cAAA;EACA,YAAA;EAGE,aAAA;EACA,QAAA;AP47IN;AOx7IE;EACE,WAAA;AP07IJ;;AgDziJE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AhD4iJJ;;AgD39II;EACE,UAAA;AhD89IN;AgD59IM;EACE,uBAAA;AhD89IR;;AgDx9IE;EACE,mBnBnDgB;A7B8gJpB;AgDz9II;EACE,WAAA;AhD29IN;AgDz9IM;EAEE,2CAAA;AhD09IR;;AgDr9IE;EA3FA,WAAA;AhDojJF;AgDljJE;EAEE,cAAA;EACA,uB1CuvBe;E0CtvBf,kB1CovBiB;E0CnvBjB,cAAA;EACA,cnBoBgB;A7B+hJpB;AOx8IE;EACE,UAAA;AP08IJ;AgDpjJI;EACE,gB1CZE;E0CaF,oCAAA;AhDsjJN;AgDnjJI;EAEE,kC1CtBO;E0CuBP,cnBUc;A7B0iJpB;;AgDv+IE;EAlEA,wCAAA;EACA,aAAA;EACA,gB1ChCM;E0CiCN,W1ClCM;E0CmCN,yBAAA;AhD6iJF;;AgD3+IE;EA3DA,wCAAA;EACA,cAAA;AhD0iJF;;AgD5+IE;EAvDA,aAAA;EACA,a1C+sBoB;ANw1HtB;AgDriJE;EACE,cAAA;AhDuiJJ;;AiDtnJE;EAzBA,qBAAA;EACA,eAAA;EACA,mB3CsDc;E2CpDd,sB3CqzBiB;E2CpzBjB,kB3CwDc;E2CvDd,2C3CqzBiB;E2CnzBjB,cAAA;AjDipJF;;AiD5nJE;EAjBA,qC3CizBqB;ANg2HvB;AiD/oJE;EAEE,+C3C4yBqB;ANo2HzB;AiD7oJE;EACE,gBAAA;AjD+oJJ;;AkD71IE;EA/SA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EAGE,aAAA;EACA,eAAA;AlD8oJJ;AOrgJE;EACE,UAAA;APugJJ;AkD1oJE;;EAEE,cAAA;EACA,qBAAA;EACA,cAAA;EACA,oB5CoBkB;ANwnJtB;AkDxoJE;;;;EAIE,gBAAA;AlD0oJJ;AkDvoJE;EACE,qBAAA;AlDyoJJ;AkDr3II;EAxLE,eAAA;EACA,mBAAA;AlDgjJN;AkDp3II;EAlLE,iBAAA;EACA,sBAAA;AlDyiJN;AkD1oJI;EACE,SAAA;AlD4oJN;AkDj3II;EAzKA,mBAAA;AlD6hJJ;AkD1hJE;EACE,iB5CgTiB;AN4uIrB;AkDzhJE;EACE,UAAA;AlD2hJJ;AErkJQ;EgDiNF;IA7MA,eAAA;IACA,mBAAA;ElDqkJJ;EkDr3II;IAtMA,iBAAA;IACA,sBAAA;ElD8jJJ;EkD/pJE;IACE,SAAA;ElDiqJJ;EkDlqJE;IACE,SAAA;ElDoqJJ;AACF;AErlJQ;EgDiNF;IA7MA,eAAA;IACA,mBAAA;ElDqlJJ;EkDr4II;IAtMA,iBAAA;IACA,sBAAA;ElD8kJJ;EkD/qJE;IACE,SAAA;ElDirJJ;EkDlrJE;IACE,SAAA;ElDorJJ;AACF;AkDl4II;EAzKA,eAAA;EACA,iB5C1IwB;ANwrJ5B;AkDtiJI;EACE,aAAA;AlDwiJN;AkDziJI;EACE,aAAA;AlD2iJN;AkDxhJI;EAEI,qBAAA;AlDyhJR;AkDthJM;;;EAGE,qB5C2PY;AN6xIpB;AkD/gJI;EAEI,qBAAA;AlDghJR;AkD7gJM;;;EAGE,oB5C0OY;ANqyIpB;AkDtgJI;EAEI,wBAAA;AlDugJR;AkDjgJM;;;EAQI,mBAAA;EACA,sB5CgNU;E4C/MV,kBAAA;AlD8/IV;AkDx/II;EAEI,wBAAA;AlDy/IR;AkDn/IM;;;EAQI,mBAAA;EACA,sB5CwLU;E4CvLV,kBAAA;AlDg/IV;AkDx4II;EAxFF,mB5CsK4B;E4CrK5B,WAAA;AlDm+IF;AkDt4IM;EA9FJ,mB5CsK4B;E4CrK5B,WAAA;AlDu+IF;AkDp4II;EArVE,2BAAA;AlD4tJN;AkDptJM;EACE,aAAA;EACA,yBAAA;AlDstJR;AkDptJQ;EACE,2BAAA;AlDstJV;AkDltJM;EACE,cAAA;EACA,iB7CVO;AL8tJf;AkDltJQ;EACE,iB7CbK;ALiuJf;AkD74IM;EAzOF,kB5CrIwB;E4CsIxB,cAAA;AlDynJJ;AkDpsJM;EACE,aAAA;EACA,uBAAA;AlDssJR;AkDpsJQ;EACE,2BAAA;AlDssJV;AkD94II;EA9HF,oB5C3PoB;E4C6PpB,iBAAA;EACA,cAAA;EACA,cAAA;AlD8gJF;;AkD74IM;EAEI,uBAAA;AlD+4IV;AkDrtJM;EACE,aAAA;EACA,uBAAA;AlDutJR;AkDrtJQ;EACE,2BAAA;AlDutJV;;AkD74IE;EACE,aAAA;AlDg5IJ;;AmD33JE;E5CwGA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAzBQ;EA0BR,YAzBS;EA0BT,eAAA;APuxJF;AOpxJE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,cAAA;EACA,WAAA;EACA,WAnCO;EAqCP,gBDrCI;ECsCJ,uCAtBS;EAwBT,WAAA;APmxJJ;AOxwJI;EACE,iCDvDQ;ECwDR,yEALe;AP+wJrB;;AmD/4JE;E5CoGA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAzBQ;EA0BR,YAzBS;EA0BT,eAAA;AP+yJF;AO5yJE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,cAAA;EACA,WAAA;EACA,WAnCO;EAqCP,gBDtCI;ECuCJ,uCAtBS;EAwBT,WAAA;AP2yJJ;AOhyJI;EACE,kCDtDM;ECuDN,2EALe;APuyJrB;;AoD11JI;EAME,WAAA;ApDw1JN;AoDr1JI;EAIE,oB9CCgB;ANm1JtB;AoDj1JI;EACE,oB9CHgB;ANs1JtB;AoDh1JI;EFoIA,eAAA;EACA,iB5C1IwB;ANy1J5B;AoD/0JM;EF2HF,kB5CrIwB;E4CsIxB,cAAA;AlDutJJ;AoDz4JE;EACE,kBAAA;ApD24JJ;AoDz4JI;E7CdF,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAGE,sBAAA;EACA,uBAAA;EACA,6CAAA;E6CKE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;ApDk5JN;AoD94JE;EACE,WAAA;EACA,UAAA;ApDg5JJ;AoD74JE;EACE,WAAA;EACA,UAAA;ApD+4JJ;AoDp2JM;EACE,yBAAA;EACA,yBAAA;ApDs2JR;;AoD11JE;EACE,kBAAA;ApD61JJ;;AoD11JE;EACE,kB9CqJiC;ANwsJrC;;AoDz1JE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EAEA,W9C4IiC;E8C3IjC,Y9C2IiC;E8CzIjC,eAAA;ApD01JJ;AoDj1JI;E7CjHF,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAGE,sBAAA;EACA,uBAAA;EACA,6CAAA;E6CyGE,MAAA;EACA,SAAA;EACA,YAAA;ApDy1JN;;AoDp1JE;EACE,qBAAA;EACA,yBAAA;ApDu1JJ;;AoDp1JE;E7C8CA,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AP0yJF;;AqDh8JE;EACE,kBAAA;EACA,gBAAA;ArDm8JJ;AqDj8JI;EACE,cAAA;ArDm8JN;AqDh8JI;EACE,uBAAA;ArDk8JN;;AqD57JI;EACE,oB/COgB;E+CNhB,gB/CLE;ANo8JR;AqD37JI;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EAEA,WAAA;EACA,gB/ChBE;E+CiBF,kC/C8SiB;AN8oJvB;AqD17JM;EACE,UAAA;EACA,cAAA;EACA,4BAAA;ArD47JR;AqDz7JM;EACE,2BAAA;ArD27JR;AqDv7JM;EACE,oB/CpBc;AN68JtB;AqDr7JI;EHkHA,eAAA;EACA,c5C4KsB;AN0pJ1B;AqDr7JI;EACE,gBAAA;ArDu7JN;AqDvgKE;EACE,kBAAA;ArDygKJ;AqDvgKI;E9CNF,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAaE,qBAAA;EACA,wBAAA;EACA,yDAAA;E8CbE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;ArDghKN;AqD5gKE;E9CfA,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAaE,qBAAA;EACA,wBAAA;EACA,sDAAA;E8CJA,WAAA;EACA,UAAA;ArDqhKJ;AqDlhKE;E9CrBA,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAkBE,oBAAA;EACA,yBAAA;EACA,sDAAA;E8CHA,WAAA;EACA,UAAA;ArD2hKJ;AqD19JM;E9CzFJ,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAkBE,oBAAA;EACA,yBAAA;EACA,yDAAA;E8CiEI,qBAAA;EACA,sBAAA;EACA,qBAAA;ArDm+JR;;AsDthKM;EACE,SAAA;EACA,QAAA;EACA,UAAA;AtDyhKR;AsDphKM;EACE,SAAA;EACA,WAAA;EACA,OAAA;AtDshKR;AsDjhKM;EACE,kBAAA;EACA,qBhD6UqB;ANssJ7B;AsDhhKM;E/C/DJ,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAGE,sBAAA;EACA,uBAAA;EACA,0CAAA;E+CsDI,UAAA;EACA,UAAA;EACA,gBAAA;AtDyhKR;AO77JE;EACE,UAAA;AP+7JJ;AsDh/JI;EAEE,oBhD3DgB;AN4iKtB;AsD7+JI;EACE,uBhD4RiC;EgD3RjC,chD0R4B;ANqtJlC;AsD5+JI;EACE,aAAA;AtD8+JN;AsD3+JI;EJkEA,eAAA;EACA,c5C6MyB;AN+tJ7B;AsDpiKM;EACE,MAAA;AtDsiKR;AsDliKQ;EACE,MAAA;EACA,WAAA;EACA,UAAA;AtDoiKV;AsD/hKQ;EACE,WAAA;EACA,UAAA;AtDiiKV;AsDjmKE;EACE,WAAA;AtDmmKJ;AsDhmKE;E/C5BA,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAkBE,oBAAA;EACA,yBAAA;EACA,sDAAA;E+CIA,WAAA;EACA,SAAA;AtDymKJ;AsDtmKE;E/ClCA,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAaE,qBAAA;EACA,wBAAA;EACA,sDAAA;AP6nKJ;AE5gKQ;EoD5FF;IACE,SAAA;IACA,QAAA;IACA,UAAA;EtD2mKN;EsDtmKI;IACE,SAAA;IACA,WAAA;IACA,OAAA;EtDwmKN;EsDnmKI;IACE,kBAAA;IACA,qBhD6UqB;ENwxJ3B;EsDlmKI;I/C/DJ,cAAA;IACA,QAAA;IACA,SAAA;IAEA,iBAAA;IAEA,WAAA;IAGE,sBAAA;IACA,uBAAA;IACA,0CAAA;I+CsDI,UAAA;IACA,UAAA;IACA,gBAAA;EtD2mKN;EsDrmKI;IACE,MAAA;EtDumKN;EsDnmKM;IACE,MAAA;IACA,WAAA;IACA,UAAA;EtDqmKR;EsDhmKM;IACE,WAAA;IACA,UAAA;EtDkmKR;EsDlqKA;IACE,WAAA;EtDoqKF;EsDjqKA;I/C5BA,cAAA;IACA,QAAA;IACA,SAAA;IAEA,iBAAA;IAEA,WAAA;IAkBE,oBAAA;IACA,yBAAA;IACA,sDAAA;I+CIA,WAAA;IACA,SAAA;EtD0qKF;EsDvqKA;I/ClCA,cAAA;IACA,QAAA;IACA,SAAA;IAEA,iBAAA;IAEA,WAAA;IAaE,qBAAA;IACA,wBAAA;IACA,sDAAA;EP8rKF;AACF;AE9kKQ;EoD5FF;IACE,SAAA;IACA,QAAA;IACA,UAAA;EtD6qKN;EsDxqKI;IACE,SAAA;IACA,WAAA;IACA,OAAA;EtD0qKN;EsDrqKI;IACE,kBAAA;IACA,qBhD6UqB;EN01J3B;EsDpqKI;I/C/DJ,cAAA;IACA,QAAA;IACA,SAAA;IAEA,iBAAA;IAEA,WAAA;IAGE,sBAAA;IACA,uBAAA;IACA,0CAAA;I+CsDI,UAAA;IACA,UAAA;IACA,gBAAA;EtD6qKN;EsDvqKI;IACE,MAAA;EtDyqKN;EsDrqKM;IACE,MAAA;IACA,WAAA;IACA,UAAA;EtDuqKR;EsDlqKM;IACE,WAAA;IACA,UAAA;EtDoqKR;EsDpuKA;IACE,WAAA;EtDsuKF;EsDnuKA;I/C5BA,cAAA;IACA,QAAA;IACA,SAAA;IAEA,iBAAA;IAEA,WAAA;IAkBE,oBAAA;IACA,yBAAA;IACA,sDAAA;I+CIA,WAAA;IACA,SAAA;EtD4uKF;EsDzuKA;I/ClCA,cAAA;IACA,QAAA;IACA,SAAA;IAEA,iBAAA;IAEA,WAAA;IAaE,qBAAA;IACA,wBAAA;IACA,sDAAA;EPgwKF;AACF;AsDjoKM;EACE,SAAA;EACA,QAAA;EACA,UAAA;AtDmoKR;;AsD9nKE;EACE,YAAA;AtDioKJ;AsD/nKI;EACE,YAAA;AtDioKN;;AsD7nKE;EACE,kBAAA;AtDgoKJ;AsD9nKI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;AtDgoKN;AsD7nKI;EAEE,SAAA;EAKE,UAAA;AtD0nKR;AsDtnKI;EACE,WAAA;EACA,UAAA;AtDwnKN;AsDrnKI;EACE,WAAA;EACA,UAAA;AtDunKN;;AsDnnKE;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EAEA,aAAA;EACA,gBhD6LqB;EgD3LrB,uChDiMkB;EgDhMlB,gBhDrKI;ANyxKR;AsDlnKI;EACE,oBhD7JgB;ANixKtB;AsD/yKE;EACE,WAAA;AtDizKJ;AsD9yKE;E/C5BA,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAkBE,oBAAA;EACA,yBAAA;EACA,sDAAA;E+CIA,WAAA;EACA,SAAA;AtDuzKJ;AsDpzKE;E/ClCA,cAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EAEA,WAAA;EAaE,qBAAA;EACA,wBAAA;EACA,sDAAA;AP20KJ;AsDnoKM;EACE,gBAAA;AtDqoKR;AsDjoKI;EACE,WAAA;AtDmoKN;AsD9nKI;EACE,cAAA;AtDgoKN;;AuDxzKE;EACE,gBAAA;AvD2zKJ;;AuDvzKE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WjDkcuB;EiDhcvB,WAAA;EACA,YAAA;EAEA,mDAAA;EAEA,qCjDkcwB;EiDhcxB,UAAA;EACA,kBAAA;EAEA,gBAAA;AvDqzKJ;AuDnzKI;EACE,UAAA;EACA,mBAAA;AvDqzKN;AuDlzKI;EACE,eAAA;AvDozKN;AuDjzKI;EACE,kBAAA;AvDmzKN;AuDhzKI;EACE,eAAA;AvDkzKN;;AuDp/JE;EAvTA,kBAAA;EACA,gBAAA;AvD+yKF;;AuDp/JE;EA/SE,eAAA;EAOF,WjD4YsB;EiDrYtB,+BAAA;EACA,2BAAA;EAEA,kCjDpFW;AN82Kb;AOtvKE;EACE,UAAA;APwvKJ;AuDpyKE;EACE,WjDwYoB;AN85JxB;AuD7xKE;EACE,kBAAA;AvD+xKJ;AuD3xKE;EACE,WjD0XuB;ANm6J3B;AuD3xKI;EACE,0CjDkXa;AN26JnB;AuDxxKE;EACE,0BAAA;AvD0xKJ;AuDngKE;EAvTE,kBAAA;EAIF,WjD4YsB;EiDrYtB,+BAAA;EACA,2BAAA;EAEA,kCjDpFW;ANu4Kb;AO/wKE;EACE,UAAA;APixKJ;AuD7zKE;EACE,WjDwYoB;ANu7JxB;AuDtzKE;EACE,kBAAA;AvDwzKJ;AuDpzKE;EACE,WjD0XuB;AN47J3B;AuDpzKI;EACE,0CjDkXa;ANo8JnB;AuDjzKE;EACE,0BAAA;AvDmzKJ;;AuDvhKE;EAjRE,MAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EAII,YAVE;EAWF,6BAAA;AvDyyKR;AuDpyKa;EAIH,6BAAA;AvDmyKV;AuDhyKM;EACE,0BAAA;AvDkyKR;;AuD5xKM;EAGM,4BAAA;AvD6xKZ;;AuDtqKI;EhD7TA,2DAAA;APu+KJ;;AuD7iKE;EA7OE,MAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EAII,YA/CE;EAgDF,4BAAA;AvD2xKR;AuDtxKa;EAIH,4BAAA;AvDqxKV;AuDlxKM;EACE,0BAAA;AvDoxKR;;AuD9wKM;EAGM,6BAAA;AvD+wKZ;;AuD7rKI;EhD/TA,0DAAA;APggLJ;;AuDnkKE;EAzME,MAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EAII,aApFE;EAqFF,6BAAA;AvD6wKR;AuDxwKa;EAGH,6BAAA;AvDwwKV;AuDrwKM;EACE,0BAAA;AvDuwKR;;AuDjwKM;EAGM,4BAAA;AvDkwKZ;;AuDptKI;EhD3TA,2DAAA;APmhLJ;;AuDzlKE;EAtKE,SAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EAII,aAxHE;EAyHF,4BAAA;AvDgwKR;AuD3vKa;EAGH,4BAAA;AvD2vKV;AuDxvKM;EACE,0BAAA;AvD0vKR;;AuDpvKM;EAGM,6BAAA;AvDqvKZ;;AuD3uKI;EhDjUA,0DAAA;APgjLJ;;AuD9mKE;EA7GA,eAAA;EACA,2BAAA;AvD+tKF;AuD5tKE;EAEE,+BAAA;AvD6tKJ;AuDztKE;EACE,0BAAA;AvD2tKJ;AuDvtKE;EACE,0BAAA;AvDytKJ;;AEp6KQ;EqDgTA;IA1FN,eAAA;IACA,WjDkKwB;IiDjKxB,gBAAA;IACA,mBAAA;EvDmtKA;EuD7sKA;IACE,aAAA;EvD+sKF;EuD3sKA;IACE,eAAA;EvD6sKF;EuD1sKS;IACP,kBAAA;EvD4sKF;EuDxsKA;IACE,kBAAA;EvD0sKF;EuDpoKM;IA9FN,eAAA;IACA,WjDkKwB;IiDjKxB,gBAAA;IACA,mBAAA;EvDquKA;EuD/tKA;IACE,aAAA;EvDiuKF;EuD7tKA;IACE,eAAA;EvD+tKF;EuD5tKS;IACP,mBAAA;EvD8tKF;EuD1tKA;IACE,mBAAA;EvD4tKF;EuDlpKM;IAlGN,eAAA;IACA,WjDkKwB;IiDjKxB,gBAAA;IACA,mBAAA;EvDuvKA;EuDjvKA;IACE,aAAA;EvDmvKF;EuD/uKA;IACE,eAAA;EvDivKF;EuD9uKS;IACP,iBAAA;EvDgvKF;EuD5uKA;IACE,iBAAA;EvD8uKF;EuDhqKM;IAtGN,eAAA;IACA,WjDkKwB;IiDjKxB,gBAAA;IACA,mBAAA;EvDywKA;EuDnwKA;IACE,aAAA;EvDqwKF;EuDjwKA;IACE,eAAA;EvDmwKF;EuDhwKS;IACP,oBAAA;EvDkwKF;EuD9vKA;IACE,oBAAA;EvDgwKF;AACF;AE/+KQ;EqDgTA;IA1FN,eAAA;IACA,WjDkKwB;IiDjKxB,gBAAA;IACA,mBAAA;EvD6xKA;EuDvxKA;IACE,aAAA;EvDyxKF;EuDrxKA;IACE,eAAA;EvDuxKF;EuDpxKS;IACP,kBAAA;EvDsxKF;EuDlxKA;IACE,kBAAA;EvDoxKF;EuD9sKM;IA9FN,eAAA;IACA,WjDkKwB;IiDjKxB,gBAAA;IACA,mBAAA;EvD+yKA;EuDzyKA;IACE,aAAA;EvD2yKF;EuDvyKA;IACE,eAAA;EvDyyKF;EuDtyKS;IACP,mBAAA;EvDwyKF;EuDpyKA;IACE,mBAAA;EvDsyKF;EuD5tKM;IAlGN,eAAA;IACA,WjDkKwB;IiDjKxB,gBAAA;IACA,mBAAA;EvDi0KA;EuD3zKA;IACE,aAAA;EvD6zKF;EuDzzKA;IACE,eAAA;EvD2zKF;EuDxzKS;IACP,iBAAA;EvD0zKF;EuDtzKA;IACE,iBAAA;EvDwzKF;EuD1uKM;IAtGN,eAAA;IACA,WjDkKwB;IiDjKxB,gBAAA;IACA,mBAAA;EvDm1KA;EuD70KA;IACE,aAAA;EvD+0KF;EuD30KA;IACE,eAAA;EvD60KF;EuD10KS;IACP,oBAAA;EvD40KF;EuDx0KA;IACE,oBAAA;EvD00KF;AACF;AEzjLQ;EqDuUA;IAnFN,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,iBAAA;IACA,gBAAA;EvDy0KA;EuDt0KA;IAIE,gBAAA;IACA,eAAA;EvDq0KF;EuDl0KA;IACE,aAAA;EvDo0KF;AACF;AE3kLQ;EqDuUA;IAnFN,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,iBAAA;IACA,gBAAA;EvD21KA;EuDx1KA;IAIE,gBAAA;IACA,eAAA;EvDu1KF;EuDp1KA;IACE,aAAA;EvDs1KF;AACF;AGzoLE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AH2oLJ;AGzoLI;EACE,kBAAA;AH2oLN;AGxoLI;EACE,kBAAA;AH0oLN;;AGroLE;EA3FA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aGktBc;EHhtBd,aAAA;EACA,wCGgtB0B;EH/sB1B,gBAAA;AHmuLF;;AG5oLE;EAjFA,aAAA;EAEA,2BAAA;EAEA,aAAA;EACA,aGee;EHbf,uCG+rBc;EH9rBd,kBGgBc;EHfd,sBGKM;EHsEJ,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AHopLJ;AO1mLE;EACE,UAAA;AP4mLJ;AEtoLQ;ECxBN;IArEE,aAAA;EHuuLF;AACF;AGpuLE;EACE,YAAA;AHsuLJ;AGluLE;EACE,gBAAA;AHouLJ;AEjpLQ;ECxBN;IA7CE,YG+pBW;IH9pBX,gBGxCW;ENkwLb;AACF;AGrqLI;EACE,UAAA;AHuqLN;AE1pLQ;ECTJ;IA5DA,UA4DsC;IA3DtC,gBGxCW;EN2wLb;AACF;AEhqLQ;ECRJ;IA7DA,UA6DsC;IA5DtC,gBGxCW;ENixLb;AACF;AEtqLQ;ECPJ;IA9DA,UA8DsC;IA7DtC,gBGxCW;ENuxLb;AACF;AGhrLI;EA1DF,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EAEA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EAEA,SAAA;EACA,gBAAA;AH2uLF;AEzrLQ;ECxBN;IAtCA,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;IAEA,WAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;IACA,cAAA;IAEA,SAAA;IACA,gBAAA;EHyvLA;AACF;AGpsLI;EACE,eAAA;AHssLN;;AwDt3LE;EACE,kBAAA;AxDy3LJ;;AwDt3LE;EACE,kBAAA;EACA,UAAA;EACA,+BAAA;AxDy3LJ;;AwDt3LE;EACE,eAAA;EACA,UAAA;EACA,WAAA;AxDy3LJ;AwDv3LI;EACE,MAAA;AxDy3LN;AwDt3LI;EACE,SAAA;AxDw3LN;;AwDp3LE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AxDu3LJ;AwDr3LI;EACE,SAAA;AxDu3LN;;AyDr3LE;EACE,enDi0Be;EmDh0Bf,gBnD6CI;EmD5CJ,WnD6CI;EmD1CF,aAAA;EACA,2BAAA;EACA,mBAAA;AzDs3LN;AyDh3LI;EACE,oBnDuzBkB;EmDtzBlB,qBnDszBkB;AN4jKxB;;AyD72LI;;EAEE,SAAA;AzDg3LN;;AyD72LI;EACE,iBAAA;AzDg3LN;;AyDl2LE;EACE,qBAAA;EACA,sBAAA;EACA,iBnDuxBwB;AN8kK5B;;A0D7zLE;EAtFE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EAMF,epDm1Be;EoDjzBb,eAAA;A1Di3LJ;A0Dj5LE;;EAEE,wCpDiCS;ANk3Lb;A0Dx4LE;EACE,gBpDu0BiB;EoDt0BjB,kBAAA;A1D04LJ;A0Dt4LE;EACE,WAAA;EACA,eAAA;A1Dw4LJ;A0Dr4LE;EACE,WAAA;A1Du4LJ;A0D73LI;;EAEE,cAAA;EACA,eAAA;A1D+3LN;AEnyLQ;EwDvDN;IAtBE,iBAAA;E1Do3LF;E0Dl3LE;IACE,cAAA;IACA,kBAAA;E1Do3LJ;E0Dj3LE;IACE,cAAA;IACA,iBAAA;E1Dm3LJ;AACF;AEhzLQ;EwD1CA;IAxDJ,eAAA;E1Ds5LF;E0Dn5LE;;IAEE,cAAA;IACA,eAAA;E1Dq5LJ;AACF;AE1zLQ;EwD1CA;IAxDJ,eAAA;E1Dg6LF;E0D75LE;;IAEE,cAAA;IACA,eAAA;E1D+5LJ;AACF;;A0Dn2LI;EACE,cAAA;EACA,4BpD+uBiB;ANunKvB;;A0Dn2LI;;EAEE,cAAA;A1Ds2LN;;A2Dr/LE;EACE,sBAAA;A3Dw/LJ;;A2Dr/LE;EACE,uBAAA;A3Dw/LJ;;A2Dr/LE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;A3Dw/LJ;;AOn2LE;EAEE,cAAA;EACA,YAAA;EAGE,aAAA;EACA,QAAA;APm2LN;AO/1LE;EACE,WAAA;APi2LJ;;A4D58LI;ECnBF,2BAhBQ;A7Dm/LV;;A4Dh9LI;ECnBF,yBAhBQ;A7Du/LV;;A4Dp9LI;ECnBF,uBAhBQ;A7D2/LV;;A4Dx9LI;ECnBF,8BAhBQ;A7D+/LV;;A4D59LI;ECnBF,6BAhBQ;A7DmgMV;;A4Dv9LQ;EC5BN,2BAhBQ;A7DugMV;;A4D39LQ;EC5BN,yBAhBQ;A7D2gMV;;A4D/9LQ;EC5BN,uBAhBQ;A7D+gMV;;A4D19LI;ECpCF,uBARQ;A7D0gMV;;A4D19LI;ECxBF,sBAPQ;A7D6/LV;;A4Dl+LI;ECpCF,qBARQ;A7DkhMV;;A4Dl+LI;ECxBF,oBAPQ;A7DqgMV;;A4D1+LI;ECpCF,mBARQ;A7D0hMV;;A4D1+LI;ECxBF,kBAPQ;A7D6gMV;;A4Dl/LI;ECpCF,oBARQ;A7DkiMV;;A4Dl/LI;ECxBF,mBAPQ;A7DqhMV;;A4Dh/LE;EC/CA,uBAhBQ;EAiBR,mBARQ;EDwDN,qBAAA;A5Do/LJ;;A4D9+LM;EChCJ,QD+Be;A5Dm/LjB;;A4Dl/LM;EChCJ,QD+Be;A5Du/LjB;;A4Dt/LM;EChCJ,QD+Be;A5D2/LjB;;A4D1/LM;EChCJ,QD+Be;A5D+/LjB;;A4D9/LM;EChCJ,QD+Be;A5DmgMjB;;A4DlgMM;EChCJ,QD+Be;A5DugMjB;;AEp8LQ;E0DlEF;IChCJ,QD+Be;E5D4gMf;E4D3gMI;IChCJ,QD+Be;E5D+gMf;E4D9gMI;IChCJ,QD+Be;E5DkhMf;E4DjhMI;IChCJ,QD+Be;E5DqhMf;E4DphMI;IChCJ,QD+Be;E5DwhMf;E4DvhMI;IChCJ,QD+Be;E5D2hMf;AACF;AEz9LQ;E0DlEF;IChCJ,QD+Be;E5DgiMf;E4D/hMI;IChCJ,QD+Be;E5DmiMf;E4DliMI;IChCJ,QD+Be;E5DsiMf;E4DriMI;IChCJ,QD+Be;E5DyiMf;E4DxiMI;IChCJ,QD+Be;E5D4iMf;E4D3iMI;IChCJ,QD+Be;E5D+iMf;AACF;A4D5oME;ECYA,aAAA;A7DmoMF;;A4D3oME;EACE,cAAA;A5D8oMJ;;A4D3oME;EACE,cAAA;A5D8oMJ;;A4D3oME;EACE,cAAA;A5D8oMJ;;A4D1oMI;ECsDF,mBApEmB;A7D4pMrB;;A4D9oMI;ECsDF,2BApEmB;A7DgqMrB;;A4DlpMI;ECsDF,sBApEmB;A7DoqMrB;;A4DtpMI;ECsDF,8BApEmB;A7DwqMrB;;AE5gMQ;E0DpIE;ICfR,aAAA;E7DoqMA;E4DjpMQ;IACE,cAAA;E5DmpMV;E4DhpMQ;IACE,cAAA;E5DkpMV;E4D/oMQ;IACE,cAAA;E5DipMV;E4D7oMU;IC2BV,mBApEmB;E7DyrMnB;E4DhpMU;IC2BV,2BApEmB;E7D4rMnB;E4DnpMU;IC2BV,sBApEmB;E7D+rMnB;E4DtpMU;IC2BV,8BApEmB;E7DksMnB;AACF;AEviMQ;E0DpIE;ICfR,aAAA;E7D8rMA;E4D3qMQ;IACE,cAAA;E5D6qMV;E4D1qMQ;IACE,cAAA;E5D4qMV;E4DzqMQ;IACE,cAAA;E5D2qMV;E4DvqMU;IC2BV,mBApEmB;E7DmtMnB;E4D1qMU;IC2BV,2BApEmB;E7DstMnB;E4D7qMU;IC2BV,sBApEmB;E7DytMnB;E4DhrMU;IC2BV,8BApEmB;E7D4tMnB;AACF;A8DjrME;EACE,wBAAA;A9DmrMJ;;A8DhrME;EACE,kBAAA;A9DmrMJ;;AExkMQ;E4D5FJ;IA1BA,wBAAA;E9DmsMF;AACF;;A8DvtMI;EAiDA;IAhDE,wBAAA;E9D2tMJ;AACF;;AEplMQ;E4DrGF;IAzBF,wBAAA;E9DutMF;AACF;;AErlMQ;E4DtGF;IAjEF,wBAAA;E9DiwMF;AACF;;AEhmMQ;E4D5FJ;IA1BA,wBAAA;E9D2tMF;AACF;;A8D/uMI;EAiDA;IAhDE,wBAAA;E9DmvMJ;AACF;;AE5mMQ;E4DrGF;IAzBF,wBAAA;E9D+uMF;AACF;;AE7mMQ;E4DtGF;IAjEF,wBAAA;E9DyxMF;AACF;;AExnMQ;E4D5FJ;IA1BA,wBAAA;E9DmvMF;AACF;;A8DvwMI;EAiDA;IAhDE,wBAAA;E9D2wMJ;AACF;;A8DrtME;;EvDyHA,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;APimMF;;A8D1tMI;EvDmIF,2BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,qBAAA;EACA,8BAAA;AP2lMF;;A8D5tME;;EAEE,yBAAA;A9D+tMJ;AEzpMQ;E4DxEN;;IAKI,yBAAA;E9DiuMJ;AACF;AE/pMQ;E4DxEN;;IASI,wBAAA;E9DmuMJ;AACF;;A8DhuME;;EAEE,wBAAA;A9DmuMJ;AE1qMQ;E4D3DN;;IAKI,wBAAA;E9DquMJ;AACF;AEhrMQ;E4D3DN;;IASI,yBAAA;E9DuuMJ;AACF;;A+D32MA;EACE;IACE,6BAAA;E/D82MF;E+D52MA;IACE,0CAAA;IACA,4BAAA;IACA,2BAAA;E/D82MF;E+D52MA;IACE,sBAAA;IACA,WAAA;IACA,2BAAA;E/D82MF;AACF;AgEx3MA;EACC,aAAA;AhE03MD;;AE9sMQ;E+DhLR;IAEI,kBCCS;ElEg4MX;AACF;;AiE93MA;EACE,0BAAA;AjEi4MF;;AiE93MA;EACE,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,yBAAA;EACA,iDAAA;AjEi4MF;;AiE93MA;EACE,iBAAA;EACA,sBAAA;AjEi4MF;;AmEz5MA;EACE,0BAAA;AnE45MF;AmE15ME;EACE,0BAAA;AnE45MJ;;AmEx5MA;EACE,cAAA;EACA,0BAAA;AnE25MF;AmE15ME;EACE,ctCsGgB;A7BszMpB;;AmEx5MA;EACE,qBAAA;EACA,gBDlBO;AlE66MT;;AmEx5MA;EACE,eAAA;AnE25MF;;AmEv5MA;EACE,YAAA;EACA,yBAAA;EACA,gBD7BO;EC8BP,qBAAA;AnE05MF;AmEx5ME;EACE,YAAA;EACA,cDjCI;AlE27MR;;AmEt5MA;EACE,gBDvCO;AlEg8MT;;AmEt5MA;EACE,cD1CM;AlEm8MR;;AmEt5MA;EACE,YAAA;AnEy5MF;;AmEt5MA;EACE,YAAA;AnEy5MF;;AmEt5MA;EACE,4B7D2BY;AN83Md;;AmEt5MA;EACC,kBAAA;AnEy5MD;;AmEt5MA;EACE,cAAA;AnEy5MF;;AmEt5MA;EACE,eAAA;AnEy5MF;;AmEt5MA;EACE,cAAA;AnEy5MF;;AmEt5MA;EACE,cAAA;AnEy5MF;;AmEt5MA;EACE,cAAA;AnEy5MF;;AmEt5MA;EACE,ctC+BkB;A7B03MpB;;AmEt5MA;EACE,gBAAA;AnEy5MF;;AmEt5MA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AnEy5MF;;AmEt5MA;EACE,kBAAA;AnEy5MF;;AmEt5MA;EACE,0BAAA;AnEy5MF;;AmEt5MA;EACE,kBAAA;AnEy5MF;;AmEt5MA;EACE,gBAAA;AnEy5MF;;AmEr5MA;EACE,qBAAA;AnEw5MF;;AmEr5MA;EACE,mBAAA;AnEw5MF;;AmEr5MA;EACE,mBAAA;AnEw5MF;;AmEr5MA;EACE,kBAAA;AnEw5MF;;AmEr5MA;EACE,cAAA;AnEw5MF;;AoE1hNA;EACC;IACC,2BAAA;EpE6hNA;EoE3hND;IACC,6BAAA;EpE6hNA;EoE3hND;IACC,2BAAA;EpE6hNA;AACF;AoE1hNA;EACE,yFAAA;EACA,yFAAA;EACA,yFAAA;EACA,0BAAA;EACA,qCAAA;ApE4hNF;;AoExhNA;EACC,yFAAA;EACA,wFAAA;EACA,wFAAA;EAEC,0BAAA;EACA,qCAAA;ApE0hNF;;AoEthNA;EACC,6BAAA;EACA,8HAAA;ApEyhND;;AoEthNA;EACC,8GAAA;EACA,8GAAA;EACA,8GAAA;EACA,0BAAA;EACA,qCAAA;ApEyhND;;AoEthNA;EACC,8BAAA;EAGA,2JAAA;EACA,0BAAA;ApEyhND;;AoEthNA;EACC,qDAAA;ApEyhND;;AoEthNA;EACC,uEAAA;ApEyhND;;AoEthNA;EACC,wEAAA;ApEyhND;;AoEthNA;EACC,yEAAA;ApEyhND;;AoEthNA;EACC,0CAAA;EACA,aAAA;EACA,kBAAA;ApEyhND;;AqE7lNA;EACE,oBAAA;ArEgmNF;;AqE7lNA;EACE,eAAA;EACA,kBAAA;ArEgmNF;;AsEzmNA;EACE,kBAAA;AtE4mNF;;AsEzmNA;EACE,aAAA;AtE4mNF;;AsEzmNA;EACE,aAAA;AtE4mNF;;AsEzmNA;EACE,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;AtE4mNF;;AsEzmNA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AtE4mNF;AsE1mNE;EACE,2BAAA;AtE4mNJ;AsEzmNE;EACE,8BAAA;AtE2mNJ;;AsEvmNA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AtE0mNF;AsExmNE;EACA,sBAAA;AtE0mNF;AEn+MQ;EoExIN;IAII,mBAAA;IACA,uBAAA;EtE2mNJ;AACF;AsExmNE;EACE,uBAAA;EACA,2BAAA;AtE0mNJ;;AsEtmNA;EACE,WAAA;AtEymNF;;AsEtmNA;EACE,gBAAA;AtEymNF;;AsEtmNA;EACE,gBAAA;AtEymNF;AEp/MQ;EoEtHR;IAGI,iBAAA;EtE2mNF;AACF;;AuE5qNA;EACE,oBAAA;AvE+qNF;;AuE5qNA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AvE+qNF;;AwEhrNA;EAPE,yCAAA;EACA,cAOkB;EANlB,aAAA;EACA,gBAJ+B;EAK/B,WAAA;AxE2rNF;;AwEprNA;EAXE,uCAAA;EACA,WlEkFM;EkEjFN,aAAA;EACA,kBAS0B;EAR1B,WAAA;AxEmsNF;;AwExrNA;EAfE,yCAAA;EACA,cAekB;EAdlB,aAAA;EACA,kBAasC;EAZtC,WAAA;EAaA,mBAAA;AxE+rNF;;AyEjtNA;EACE,kBAAA;EACA,UAAA;AzEotNF;;AyEjtNA;EACE,aAAA;EACA,sBAAA;AzEotNF;AE3iNQ;EuEvKN;IAEI,mBAAA;IACA,mBAAA;EzEotNJ;AACF;;A0E/tNE;;;;EACE,cRFI;EQGJ,8CAAA;A1EquNJ;;A0EjuNA;EACE,cAAA;EACA,mBAAA;A1EouNF;A0EluNE;EACE,WAAA;A1EouNJ;;A0EhuNA;EACE,c7CgGkB;E6C/FlB,yBRlBM;EQmBN,0BAAA;A1EmuNF;A0EjuNE;EACE,yB7C2FgB;E6C1FhB,cRvBI;EQwBJ,yBAAA;A1EmuNJ;A0E/tNE;EACE,yBAAA;A1EiuNJ;;A0E5tNE;EACE,WAAA;EACA,mBAAA;A1E+tNJ;AE/kNQ;EwE5IJ;IACE,WAAA;IACA,gBAAA;E1E8tNJ;E0E5tNE;IACE,iBAAA;E1E8tNJ;AACF;;A2E7wNA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;A3EgxNF;AEnmNQ;EyEhLR;IAMI,YAAA;E3EixNF;AACF;A2E/wNE;EACE,mBAAA;EACA,qBAAA;A3EixNJ;A2E9wNE;EACE,mBAAA;A3EgxNJ;A2E/wNI;EACE,kBAAA;A3EixNN;A2E7wNE;EACE,yCAAA;A3E+wNJ;A2E5wNE;EACE,wCAAA;A3E8wNJ;;A2E1wNA;EACE,4BAAA;EACA,aAAA;EACA,WAAA;A3E6wNF;;A2E1wNA;EACE,aAAA;EACA,YAAA;A3E6wNF;;A2E1wNA;EACE,WAAA;EACA,eAAA;A3E6wNF;;A2E1wNA;EACE,wCAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;A3E6wNF;A2E3wNE;EACE,4BAAA;EACA,iBAAA;A3E6wNJ;;A2EzwNA;EACE,0BAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;A3E4wNF;;A2EzwNA;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;A3E4wNF;A2E1wNE;EACE,SAAA;A3E4wNJ;;A2ExwNA;EACE,eAAA;EACA,yBAAA;EACA,UAAA;A3E2wNF;;A2ExwNA;EACE,eAAA;EACA,yBAAA;EACA,UAAA;A3E2wNF;;A4En2NA;EACE,UAAA;EACA,eAAA;EACA,cAAA;A5Es2NF;A4Er2NE;EACE,aAAA;A5Eu2NJ;;A4En2NA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;A5Es2NF;;A4En2NA;EACE,oBAAA;EACA,0BAAA;A5Es2NF;A4Ep2NE;EACE,2CAAA;EACA,gBAAA;A5Es2NJ;A4Ep2NI;EAEG,sBAAA;A5Eq2NP;;A4Eh2NA;EAEE,gBVjCO;EUkCP,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;A5Ek2NF;A4E51NA;EACE,YAAA;A5E81NF;;A4E31NA;EACE,0BAAA;A5E81NF;;A6E94NA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;A7Ei5NF;A6Eh5NE;EACE,0BAAA;A7Ek5NJ;;A6E94NA;EACE,aAAA;A7Ei5NF;;A6E94NA;EACE,cAAA;A7Ei5NF;;A6E94NA;EACE,eAAA;EACA,WAAA;EACA,WAAA;A7Ei5NF;;A6E74NI;EACE,chDwFc;A7BwzNpB;A6E74NI;EACE,chDoFc;A7B2zNpB;A6E34NM;EACE,UAAA;A7E64NR;;A6Et4NI;EACE,cX1CE;AlEm7NR;A6Ev4NM;EACE,cX7CA;EW8CA,0CAAA;EACA,kBAAA;A7Ey4NR;A6Er4NI;EACE,cXpDE;EWqDF,0CAAA;EACA,YAAA;A7Eu4NN;A6Er4NM;EACE,chDwDY;EgDvDZ,uBAAA;A7Eu4NR;A6En4NI;EACE,cX/DE;EWgEF,0CAAA;A7Eq4NN;A6Ej4NM;EACE,UAAA;A7Em4NR;A6Eh4NM;EACE,6BAAA;A7Ek4NR;;A6E73NA;EACE,iBAAA;EACA,oBAAA;A7Eg4NF;;A6E73NA;EACE,yBAAA;A7Eg4NF;;A6E73NA;EACE,6BAAA;EACA,yBXzFM;EW0FN,2CAAA;EACA,iCAAA;A7Eg4NF;A6E73NI;EACI,UAAA;A7E+3NR;A6E53NI;EACA,WvEhBI;AN84NR;A6E53NM;EACE,chDWY;A7Bm3NpB;A6E13NI;EACE,yBhDMc;EgDLd,cX5GE;AlEw+NR;A6E33NM;EACE,8CAAA;EACA,cX/GA;AlE4+NR;A6Ez3NM;EACE,yBXpHA;EWqHA,chDJY;EgDKZ,yBAAA;A7E23NR;A6E13NM;EACE,yBhDPY;EgDQZ,cXzHA;AlEq/NR;;A6Er3NA;EACE,sBvE9CM;EuE+CN,cXlIM;EWmIN,aAAA;A7Ew3NF;;A6Er3NA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;A7Ew3NF;;A6Er3NA;EACE,cX7IM;AlEqgOR;A6Et3NE;EACE,aXhJI;AlEwgOR;;A6Ep3NA;EACE,cXrJM;EWsJN,0BAAA;EACA,kBAAA;A7Eu3NF;A6Er3NE;EACE,cX1JI;EW2JJ,0CAAA;A7Eu3NJ;;A6En3NA;EACE,YAAA;EACA,0BAAA;EACA,cAAA;EACA,qBAAA;A7Es3NF;A6Ep3NE;EACE,UAAA;A7Es3NJ;;A6El3NA;EACE,oBvE5EoB;ANi8NtB;;A8E/hOA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;A9EkiOF;;A8E/hOA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;A9EkiOF;;A8E9hOA;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;A9EiiOF;AEz4NQ;E4E5JR;IAOI,6BAAA;IACA,UAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;IACA,cZhCI;IYiCJ,gBAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;E9EkiOF;AACF;;A+ExkOA;EACE,YAAA;EACA,gBAAA;A/E2kOF;;A+ExkOA;EACE,qBAAA;EACA,sBAAA;A/E2kOF;;A+ExkOA;EACE,abVM;AlEqlOR;;A+ExkOA;EACE,WAAA;EACA,YAAA;A/E2kOF;;A+ExkOA;EACE,aAAA;EACA,cAAA;A/E2kOF;;A+EvkOA;EACE,WAAA;EACA,YAAA;A/E0kOF;;A+EvkOA;EACE,aAAA;EACA,cAAA;A/E0kOF;;A+EvkOA;EACE,WAAA;EACA,YAAA;A/E0kOF;;A+EvkOA;EACE,WAAA;EACA,YAAA;A/E0kOF;;A+EvkOA;EACE,oBAAA;A/E0kOF;;A+EvkOA;EACE,mBAAA;EACA,cAAA;A/E0kOF;;A+EvkOA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;A/E0kOF;;AgFnoOA;EACE,WAAA;AhFsoOF;;AgFnoOA;EACE,gBAAA;EACA,iBAAA;AhFsoOF;;AgFloOA;EACE,mBAAA;AhFqoOF;;AgFjoOA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;AhFooOF;;AgFjoOA;EACE,gBAAA;EACA,iBAAA;AhFooOF;;AgFjoOA;EACE,gBAAA;EACA,iBAAA;AhFooOF;;AgFjoOA;EACE,gBAAA;EACA,iBAAA;AhFooOF;;AgFjoOA;EACE,gBAAA;EACA,iBAAA;AhFooOF;;AgFhoOA;EACE,mBAAA;AhFmoOF;;AgFhoOA;EACE,yDAAA;EACA,iBAAA;AhFmoOF;;AgFhoOA;EACE,yDAAA;AhFmoOF;AEvgOQ;E8E7HR;IAGI,iBAAA;EhFqoOF;AACF;;AgFloOA;EACE,yDAAA;EACA,iBAAA;EACA,kCAAA;EACA,iBAAA;EACA,iCAAA;AhFqoOF;AE/gOQ;E8E3HR;IAOI,sBAAA;IACA,gBAAA;IACA,4BAAA;IACA,kCAAA;IACA,iBAAA;IACA,iBAAA;EhFuoOF;AACF;;AiF7sOA;EACE,eAAA;EACA,UAAA;AjFgtOF;;AiF7sOA;EACE,iBAAA;AjFgtOF;;AiF7sOA;EACE,uBAAA;AjFgtOF;;AiF7sOA;EACE,oB3EiFoB;AN+nOtB;;AiF7sOA;EACE,yBflBM;EemBN,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,qCAAA;EACA,+CAAA;AjFgtOF;;AkF1uOA;EACC,eAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AlF6uOD;;AkF1uOA;EACC,yBhBdO;EgBeP,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AlF6uOD;;AkF1uOA;EACC,kBAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,W5EuDO;E4EtDP,gBAAA;EACA,YAAA;EACA,0BAAA;AlF6uOD;AkF3uOC;EACC,UAAA;AlF6uOF;;AmFhxOA;EACE,gBAAA;AnFmxOF;;AmFhxOA;EACE,aAAA;EACA,cAAA;AnFmxOF;AmFlxOE;EACE,0BAAA;EACA,wCAAA;AnFoxOJ;AmFjxOE;EACE,0BAAA;AnFmxOJ;;AoFhyOA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;ApFmyOF;AElnOQ;EkFrLR;IAOI,mBAAA;EpFoyOF;AACF;AoFlyOE;EACE,cAAA;ApFoyOJ;;AoFhyOA;EACE,iBAAA;EACA,aAAA;EACA,yBlBjBM;EkBkBN,gBAAA;EACA,UAAA;ApFmyOF;;AoFhyOA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;ApFmyOF;;AoFhyOA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;ApFmyOF","sourcesContent":["@charset 'utf-8';\n@import url(\"https://use.typekit.net/wob2bge.css\");\n\n@import \"../../node_modules/foundation-sites/scss/foundation\";\n@import './settings';\n@include foundation-everything;\n\n\n@import './tools/tools';\n@import './elements/elements';\n@import './utilities/utilities';\n@import './objects/objects';\n@import './components/components';\n","/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n\n// --- Dependencies ---\n@import 'vendor/normalize';\n@import '../_vendor/sassy-lists/stylesheets/helpers/missing-dependencies';\n@import '../_vendor/sassy-lists/stylesheets/helpers/true';\n@import '../_vendor/sassy-lists/stylesheets/functions/contain';\n@import '../_vendor/sassy-lists/stylesheets/functions/purge';\n@import '../_vendor/sassy-lists/stylesheets/functions/remove';\n@import '../_vendor/sassy-lists/stylesheets/functions/replace';\n@import '../_vendor/sassy-lists/stylesheets/functions/to-list';\n\n// --- Settings ---\n// import your own `settings` here or\n// import and modify the default settings through\n// @import 'settings/settings';\n\n// --- Components ---\n// Utilities\n@import 'util/util';\n// Global styles\n@import 'global';\n@import 'forms/forms';\n@import 'typography/typography';\n\n// Grids\n@import 'grid/grid';\n@import 'xy-grid/xy-grid';\n// Generic components\n@import 'components/button';\n@import 'components/button-group';\n@import 'components/close-button';\n@import 'components/label';\n@import 'components/progress-bar';\n@import 'components/slider';\n@import 'components/switch';\n@import 'components/table';\n// Basic components\n@import 'components/badge';\n@import 'components/breadcrumbs';\n@import 'components/callout';\n@import 'components/card';\n@import 'components/dropdown';\n@import 'components/pagination';\n@import 'components/tooltip';\n\n// Containers\n@import 'components/accordion';\n@import 'components/media-object';\n@import 'components/orbit';\n@import 'components/responsive-embed';\n@import 'components/tabs';\n@import 'components/thumbnail';\n// Menu-based containers\n@import 'components/menu';\n@import 'components/menu-icon';\n@import 'components/accordion-menu';\n@import 'components/drilldown';\n@import 'components/dropdown-menu';\n\n// Layout components\n@import 'components/off-canvas';\n@import 'components/reveal';\n@import 'components/sticky';\n@import 'components/title-bar';\n@import 'components/top-bar';\n\n// Helpers\n@import 'components/float';\n@import 'components/flex';\n@import 'components/visibility';\n@import 'prototype/prototype';\n\n\n@mixin foundation-everything(\n  $flex: true,\n  $prototype: false,\n  $xy-grid: $xy-grid\n) {\n  @if $flex {\n    $global-flexbox: true !global;\n  }\n\n  @if $xy-grid {\n    $xy-grid: true !global;\n  }\n\n  // Global styles\n  @include foundation-global-styles;\n  @include foundation-forms;\n  @include foundation-typography;\n\n  // Grids\n  @if not $flex {\n    @include foundation-grid;\n  }\n  @else {\n    @if $xy-grid {\n      @include foundation-xy-grid-classes;\n    }\n    @else {\n      @include foundation-flex-grid;\n    }\n  }\n\n  // Generic components\n  @include foundation-button;\n  @include foundation-button-group;\n  @include foundation-close-button;\n  @include foundation-label;\n  @include foundation-progress-bar;\n  @include foundation-slider;\n  @include foundation-switch;\n  @include foundation-table;\n  // Basic components\n  @include foundation-badge;\n  @include foundation-breadcrumbs;\n  @include foundation-callout;\n  @include foundation-card;\n  @include foundation-dropdown;\n  @include foundation-pagination;\n  @include foundation-tooltip;\n\n  // Containers\n  @include foundation-accordion;\n  @include foundation-media-object;\n  @include foundation-orbit;\n  @include foundation-responsive-embed;\n  @include foundation-tabs;\n  @include foundation-thumbnail;\n  // Menu-based containers\n  @include foundation-menu;\n  @include foundation-menu-icon;\n  @include foundation-accordion-menu;\n  @include foundation-drilldown-menu;\n  @include foundation-dropdown-menu;\n\n  // Layout components\n  @include foundation-off-canvas;\n  @include foundation-reveal;\n  @include foundation-sticky;\n  @include foundation-title-bar;\n  @include foundation-top-bar;\n\n  // Helpers\n  @include foundation-float-classes;\n  @if $flex { @include foundation-flex-classes; }\n  @include foundation-visibility-classes;\n  @if $prototype { @include foundation-prototype-classes; }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group breakpoints\n////\n\n/// A list of named breakpoints. You can use these with the `breakpoint()` mixin to quickly create media queries.\n/// @type Map\n$breakpoints: (\n  small: 0,\n  medium: 640px,\n  large: 1024px,\n  xlarge: 1200px,\n  xxlarge: 1440px,\n) !default;\n\n/// A list of named HiDPI breakpoints. You can use these with the `breakpoint()` mixin to quickly create media queries for resolutions.\n/// Values must represent the device pixels / web pixels ration and be unitless or in DPPX.\n/// @type Map\n$breakpoints-hidpi: (\n  hidpi-1: 1,\n  hidpi-1-5: 1.5,\n  hidpi-2: 2,\n  retina: 2,\n  hidpi-3: 3\n) !default;\n\n/// The largest named breakpoint in which to include print as a media type\n/// @type Keyword\n$print-breakpoint: large !default;\n\n$-zf-zero-breakpoint: small !default;\n\n$-zf-breakpoints-keys: map-to-list($breakpoints, 'keys');\n\n@if nth(map-values($breakpoints), 1) != 0 {\n  @error 'The first key in the $breakpoints map must have a value of \"0\".';\n}\n@else {\n  $-zf-zero-breakpoint: nth(map-keys($breakpoints), 1);\n}\n\n/// All of the names in this list will be output as classes in your CSS, like `.small-12`, `.medium-6`, and so on. Each value in this list must also be in the `$breakpoints` map.\n/// @type List\n$breakpoint-classes: (small medium large) !default;\n\n/// Generates a media query string matching the input value. Refer to the documentation for the `breakpoint()` mixin to see what the possible inputs are.\n///\n/// @param {Keyword|Number} $val [small] - Breakpoint name, or px, rem, or em value to process.\n@function breakpoint($val: $-zf-zero-breakpoint) {\n  // Web standard Pixels per inch. (1ddpx / $std-web-dpi) = 1dpi\n  // See https://www.w3.org/TR/css-values-3/#absolute-lengths\n  $std-web-dpi: 96;\n\n  // Size or keyword\n  $bp: nth($val, 1);\n  // Value of the following breakpoint\n  $bp-next: null;\n  // Value for max-width media queries\n  $bp-min: null;\n  // Value for min-width media queries\n  $bp-max: null;\n  // Direction of media query (up, down, or only)\n  $dir: if(length($val) > 1, nth($val, 2), up);\n  // If named, name of the breakpoint\n  $name: null;\n  // If the breakpoint is a HiDPI breakpoint\n  $hidpi: false;\n\n  // Orientation media queries have a unique syntax\n  @if $bp == 'landscape' or $bp == 'portrait' {\n    @return '(orientation: #{$bp})';\n  }\n\n  // If a breakpoint name is given, get its value from the $breakpoints/$breakpoints-hidpi map.\n  @if type-of($bp) == 'string' {\n    @if map-has-key($breakpoints, $bp) {\n      $name: $bp;\n      $bp: map-get($breakpoints, $name);\n      $bp-next: -zf-map-next($breakpoints, $name);\n    }\n    @else if map-has-key($breakpoints-hidpi, $bp) {\n      $name: $bp;\n      $bp: map-get($breakpoints-hidpi, $name);\n      $bp-next: -zf-map-next-number($breakpoints-hidpi, $bp);\n      $hidpi: true;\n    }\n    @else {\n      $bp: 0;\n      @warn 'breakpoint(): \"#{$val}\" is not defined in your `$breakpoints` or `$breakpoints-hidpi` setting.';\n    }\n  }\n\n  @if not $name and $dir == 'only' {\n    @warn 'breakpoint(): Only named media queries can have an `only` range.';\n    @return null;\n  }\n\n  // Only 'only' and 'up' have a min limit.\n  @if $dir == 'only' or $dir == 'up' {\n    $bp-min: if($hidpi, strip-unit($bp), -zf-bp-to-em($bp));\n  }\n  // Only 'only' and 'down' have a max limit.\n  @if $dir == 'only' or $dir == 'down' {\n    // If the breakpoint is a value, use it as max limit.\n    @if not $name {\n      $bp-max: if($hidpi, strip-unit($bp), -zf-bp-to-em($bp));\n    }\n    // If the breakpoint is named, the max limit is the following breakpoint - 1px.\n    @else if $bp-next {\n      // Max value is 0.2px under the next breakpoint (0.02 / 16 = 0.00125).\n      // Use a precision under 1px to support browser zoom, but not to low to avoid rounding.\n      // See https://github.com/foundation/foundation-sites/issues/11313\n      $bp-max: if($hidpi, $bp-next - (1/$std-web-dpi), -zf-bp-to-em($bp-next) - 0.00125);\n    }\n  }\n\n  // Generate the media query string from min and max limits.\n  @if $hidpi {\n    // Generate values in DPI instead of DPPX for an IE9-11/Opera mini compatibility.\n    // See https://caniuse.com/#feat=css-media-resolution\n    $bp-min-dpi: if($bp-min, $bp-min * $std-web-dpi * 1dpi, $bp-min);\n    $bp-max-dpi: if($bp-max, $bp-max * $std-web-dpi * 1dpi, $bp-max);\n    @return zf-str-join(\n      -zf-bp-join($bp-min, $bp-max, '-webkit-min-device-pixel-ratio', '-webkit-max-device-pixel-ratio'),\n      -zf-bp-join($bp-min-dpi, $bp-max-dpi, 'min-resolution', 'max-resolution'),\n      ', ');\n  }\n  @else {\n    @return -zf-bp-join($bp-min, $bp-max);\n  }\n}\n\n/// Wraps a media query around the content you put inside the mixin. This mixin accepts a number of values:\n///  - If a string is passed, the mixin will look for it in the `$breakpoints` and `$breakpoints-hidpi` maps, and use a media query there.\n///  - If a pixel value is passed, it will be converted to an em value using `$global-font-size` as the base.\n///  - If a rem value is passed, the unit will be changed to em.\n///  - If an em value is passed, the value will be used as-is.\n///\n/// If multiple values are passed, the mixin will generate a media query for each of them as described above.\n/// Since the content is duplicated for each breakpoint, this mixin should only be used with properties that\n/// change across breakpoints.\n///\n/// @param {Keyword|Number} $values... - Breakpoint name or px/rem/em value to process.\n///\n/// @output If the breakpoint is \"0px and larger\", outputs the content as-is. Otherwise, outputs the content wrapped in a media query.\n@mixin breakpoint($values...) {\n  @for $i from 1 through length($values) {\n    $value: nth($values, $i);\n    $str: breakpoint($value);\n    $bp: index($-zf-breakpoints-keys, nth($value, 1));\n    $pbp: index($-zf-breakpoints-keys, $print-breakpoint);\n    // Direction of media query (up, down, or only)\n    $dir: if(length($value) > 1, nth($value, 2), up);\n\n    $old-zf-size: null;\n\n    // Make breakpoint size available as a variable\n    @if global-variable-exists(-zf-size) {\n      $old-zf-size: $-zf-size;\n    }\n    $-zf-size: nth($value, 1) !global; // get the first value to account for `only` and `down` keywords\n\n    // If $str is still an empty string, no media query is needed\n    @if $str == '' {\n      @content;\n    }\n\n    // Otherwise, wrap the content in a media query\n    @else {\n      // For named breakpoints less than or equal to $print-breakpoint, add print to the media types\n      // generate print if the breakpoint affects the print-breakpoint (or smaller).\n      // This means the current condition only needs to be extended so 'down' always generates print.\n      @if $bp != null and ($bp <= $pbp or $dir == down) {\n        @media print, screen and #{$str} {\n          @content;\n        }\n      }\n      @else {\n        @media screen and #{$str} {\n          @content;\n        }\n      }\n    }\n\n    $-zf-size: $old-zf-size !global;\n  }\n}\n\n/// Converts the breakpoints map to a URL-encoded string, like this: `key1=value1&key2=value2`. The value is then dropped into the CSS for a special `<meta>` tag, which is read by the Foundation JavaScript. This is how we transfer values from Sass to JavaScript, so they can be defined in one place.\n/// @access private\n///\n/// @param {Map} $map - Map to convert.\n///\n/// @returns {String} A string containing the map's contents.\n@function -zf-bp-serialize($map) {\n  $str: '';\n  @each $key, $value in $map {\n    $str: $str + $key + '=' + -zf-bp-to-em($value) + '&';\n  }\n  $str: str-slice($str, 1, -2);\n\n  @return $str;\n}\n\n/// Find the next key in a map.\n/// @access private\n///\n/// @param {Map} $map - Map to traverse.\n/// @param {Mixed} $key - Key to use as a starting point.\n///\n/// @returns {Mixed} The value for the key after `$key`, if `$key` was found. If `$key` was not found, or `$key` was the last value in the map, returns `null`.\n@function -zf-map-next($map, $key) {\n\n  // Store the keys of the map as a list\n  $values: map-keys($map);\n\n  $i: 0;\n\n  // If the Key Exists, Get the index of the key within the map and add 1 to it for the next breakpoint in the map\n  @if (map-has-key($map, $key)) {\n    $i: index($values, $key) + 1;\n  }\n\n  // If the key doesn't exist, or it's the last key in the map, return null\n  @if ($i > length($map) or $i == 0) {\n    @return null;\n  }\n  // Otherwise, return the value\n  @else {\n    @return map-get($map, nth($values, $i));\n  }\n\n}\n\n/// Find the next number in a map.\n/// @access private\n///\n/// @param {Map} $map - Map to traverse.\n/// @param {Mixed} $number - Number to use as a starting point.\n///\n/// @returns {Mixed} The number following `$number`, if `$number` was found. If `$number` was not found, or `$number` was the biggest number in the map, returns `null`.\n@function -zf-map-next-number($map, $number) {\n\n  $next_number: null;\n\n  @each $k, $v in $map {\n    @if type-of($v) == 'number' and $v > $number and ($next_number == null or $v < $next_number) {\n      $next_number: $v;\n    }\n  }\n\n  @return $next_number;\n}\n\n/// Return a list of our named breakpoints less than $key. Useful for dealing with\n/// responsive gutters for the grid.\n/// @access private\n///\n/// @param {String} $key - Key to use as last breakpoint.\n///\n/// @returns {Array} The list of breakpoints up to and. If $key is auto, returns breakpoints above the zero\n@function -zf-breakpoints-less-than($key) {\n  $list: ();\n  $found_key: false;\n\n  @each $name in $-zf-breakpoints-keys {\n    @if ($name == $key) {\n      $found_key: true;\n    }\n    @if not $found_key {\n      $list: append($list, $name);\n    }\n  }\n  @return $list;\n}\n\n/// Return a list of our named breakpoints less than $key. Useful for dealing with\n/// responsive gutters for the grid.\n/// @access private\n///\n/// @param {String} $breakpoint - a named or non-named breakpoint.\n///\n/// @returns {Array} The list of breakpoints up to and. If $key is auto, returns breakpoints above the zero\n@function -zf-closest-named-breakpoint($breakpoint) {\n  $last: $-zf-zero-breakpoint;\n  $found: false;\n\n  $value: unitless-calc($breakpoint, 1px);\n  @each $key, $val in $breakpoints {\n    @if not $found {\n      @if unitless-calc($val) > $value {\n        $found: true;\n      } @else {\n        $last: $key;\n      }\n    }\n  }\n\n  @return $last;\n}\n\n/// Get a value for a breakpoint from a responsive config map or single value.\n/// - If the config is a single value, return it regardless of `$value`.\n/// - If the config is a map and has the key `$value`, the exact breakpoint value is returned.\n/// - If the config is a map and does *not* have the breakpoint, the value matching the next lowest breakpoint in the config map is returned.\n/// @access private\n///\n/// @param {Number|Map} $map - Responsive config map or single value.\n/// @param {Keyword} $value - Breakpoint name to use.\n///\n/// @return {Mixed} The corresponding breakpoint value.\n@function -zf-get-bp-val($map, $value) {\n  // If the given map is a single value, return it\n  @if type-of($map) == 'number' {\n    @return $map;\n  }\n\n\n  // Check if the breakpoint name exists globally\n  @if not map-has-key($breakpoints, $value) {\n    @if type-of($value) == 'number' {\n      $value: -zf-closest-named-breakpoint($value);\n    } @else {\n      @return null;\n    }\n  }\n  // Check if the breakpoint name exists in the local config map\n  @else if map-has-key($map, $value) {\n    // If it does, just return the value\n    @return map-get($map, $value);\n  }\n  // Otherwise, find the next lowest breakpoint and return that value\n  @else {\n    $anchor: null;\n    $found: false;\n\n    @each $key, $val in $breakpoints {\n      @if not $found {\n        @if map-has-key($map, $key) {\n          $anchor: $key;\n        }\n        @if $key == $value {\n          $found: true;\n        }\n      }\n    }\n\n    @return map-get($map, $anchor);\n  }\n}\n\n/// Return the best breakpoint to use according to the calling context. It returns in order:\n/// 1. the given `$value` argument if it is not null.\n/// 2. the global breakpoint context `$-zf-size` if it is not null (like if called inside then `breakpoint()` mixin)\n/// 3. the given `$default` argument.\n/// @access private\n///\n/// @param {Keyword} $value [null] - Breakpoint to use in priority if non-null.\n/// @param {Keyword} $default [null] - Breakpoint to use by default if no other value can be used.\n///\n/// @return {Keyword} The resolved breakpoint.\n@function -zf-current-breakpoint($value: null, $default: null) {\n  @if ($value != null) {\n    @return $value;\n  }\n  @else if (variable-exists(-zf-size) and type-of($-zf-size) != 'number') and $-zf-size != null {\n    @return $-zf-size;\n  }\n  @else {\n    @return $default;\n  }\n}\n\n/// Return media query string from the given min and/or max limits.\n/// If a limit is equal to `null` or `0`, it is ignored.\n/// @access private\n///\n/// @param {Number} $min [0] - Min media query limit.\n/// @param {Number} $max [0] - Max media query limit.\n/// @param {String} $min-name ['min-width'] - Name of the min media query limit.\n/// @param {String} $delimiter ['max-width'] - Name of the max media query limit.\n///\n/// @returns {String} Media Query string.\n@function -zf-bp-join(\n  $min: 0,\n  $max: 0,\n  $min-name: 'min-width',\n  $max-name: 'max-width'\n) {\n  @return zf-str-join(\n    if($min and $min > 0, '(#{$min-name}: #{$min})', null),\n    if($max and $max > 0, '(#{$max-name}: #{$max})', null),\n    ' and ');\n}\n\n$small-up: '';\n$small-only: '';\n\n@if map-has-key($breakpoints, small) {\n  $small-up: screen;\n  $small-only: unquote('screen and #{breakpoint(small only)}');\n}\n\n$medium-up: '';\n$medium-only: '';\n\n@if map-has-key($breakpoints, medium) {\n  $medium-up: unquote('screen and #{breakpoint(medium)}');\n  $medium-only: unquote('screen and #{breakpoint(medium only)}');\n}\n\n$large-up: '';\n$large-only: '';\n\n@if map-has-key($breakpoints, large) {\n  $large-up: unquote('screen and #{breakpoint(large)}');\n  $large-only: unquote('screen and #{breakpoint(large only)}');\n}\n\n$xlarge-up: '';\n$xlarge-only: '';\n\n@if map-has-key($breakpoints, xlarge) {\n  $xlarge-up: unquote('screen and #{breakpoint(xlarge)}');\n  $xlarge-only: unquote('screen and #{breakpoint(xlarge only)}');\n}\n\n$xxlarge-up: '';\n\n@if map-has-key($breakpoints, xxlarge) {\n  $xxlarge-up: unquote('screen and #{breakpoint(xxlarge)}');\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group reveal\n////\n\n/// Default background color of a modal.\n/// @type Color\n$reveal-background: $white !default;\n\n/// Default width of a modal, with no class applied.\n/// @type Number\n$reveal-width: 600px !default;\n\n/// Default maximum width of a modal.\n/// @type Number\n$reveal-max-width: $global-width !default;\n\n/// Default padding inside a modal.\n/// @type Number\n$reveal-padding: $global-padding !default;\n\n/// Default border around a modal.\n/// @type Number\n$reveal-border: 1px solid $medium-gray !default;\n\n/// Default radius for modal.\n/// @type Number\n$reveal-radius: $global-radius !default;\n\n/// z-index for modals. The overlay uses this value, while the modal itself uses this value plus one.\n/// @type Number\n$reveal-zindex: 1005 !default;\n\n/// Background color of modal overlays.\n/// @type Color\n$reveal-overlay-background: rgba($black, 0.45) !default;\n\n\n// Placeholder selector for medium-and-up modals\n// Prevents duplicate CSS when defining multiple Reveal sizes\n// This should be in the same breakpoint then `@mixin reveal-modal-width`\n@include breakpoint(medium) {\n  %reveal-centered {\n    right: auto;\n    left: auto;\n    margin: 0 auto;\n  }\n}\n\n\n/// Adds styles for a modal overlay.\n/// @param {Color} $background [$reveal-overlay-background] - Background color of the overlay.\n@mixin reveal-overlay($background: $reveal-overlay-background) {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $reveal-zindex;\n\n  display: none;\n  background-color: $background;\n  overflow-y: auto;\n}\n\n/// Adds base styles for a modal.\n@mixin reveal-modal-base {\n  @include disable-mouse-outline;\n  z-index: $reveal-zindex + 1;\n  // Workaround android browser z-index bug\n  backface-visibility: hidden;\n\n  display: none;\n  padding: $reveal-padding;\n\n  border: $reveal-border;\n  border-radius: $reveal-radius;\n  background-color: $reveal-background;\n\n  @include breakpoint(medium) {\n    min-height: 0;\n  }\n\n  // Make sure rows don't have a min-width on them\n  .column {\n    min-width: 0;\n  }\n\n  // Strip margins from the last item in the modal\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n/// Adjusts the width of a modal.\n/// @param {Number} $width - Width of the modal. Generally a percentage.\n/// @param {Number} $max-width [$reveal-max-width] - Maximum width of the modal.\n@mixin reveal-modal-width(\n  $width: $reveal-width,\n  $max-width: $reveal-max-width\n) {\n  // Extends must be made outside of breakpoints for compatibility with newer Sass versions (libsass v3.5)\n  @extend %reveal-centered;\n  @include breakpoint(medium) {\n    width: $width;\n    max-width: $max-width;\n  }\n}\n\n/// Creates a full-screen modal, which stretches the full width and height of the window.\n@mixin reveal-modal-fullscreen {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n\n  width: 100%;\n  max-width: none;\n  height: 100%;\n  min-height: 100%;\n  margin-left: 0;\n\n  border: 0;\n  border-radius: 0;\n}\n\n@mixin foundation-reveal {\n\n  /// Disables the scroll when Reveal is shown to prevent the background from shifting\n  html.is-reveal-open {\n    position: fixed;\n    width: 100%;\n    overflow-y: hidden;\n\n    &.zf-has-scroll {\n      overflow-y: scroll;\n    }\n\n    body { // sass-lint:disable-line no-qualifying-elements\n      overflow-y: hidden;\n    }\n  }\n\n  // Overlay\n  .reveal-overlay {\n    @include reveal-overlay;\n  }\n\n  // Modal container\n  .reveal {\n    @include reveal-modal-base;\n    @include reveal-modal-width($reveal-width);\n    position: relative;\n    top: 100px;\n    margin-right: auto;\n    margin-left: auto;\n    overflow-y: auto;\n\n    // Remove padding\n    &.collapse {\n      padding: 0;\n    }\n\n    // Sizing classes\n    &.tiny  { @include reveal-modal-width(30%); }\n    &.small { @include reveal-modal-width(50%); }\n    &.large { @include reveal-modal-width(90%); }\n\n    // Full-screen mode\n    &.full {\n      @include reveal-modal-fullscreen;\n    }\n\n    @include breakpoint($-zf-zero-breakpoint only) {\n      @include reveal-modal-fullscreen;\n    }\n\n    &.without-overlay {\n      position: fixed;\n    }\n  }\n}\n","@mixin foundation-normalize() {\n  /*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */\n\n  // Document\n  // ==========================================================================\n\n  // 1. Correct the line height in all browsers.\n  // 2. Prevent adjustments of font size after orientation changes in iOS.\n\n  html {\n    line-height: 1.15; // 1\n    -webkit-text-size-adjust: 100%; // 2\n  }\n\n  // Sections\n  // ==========================================================================\n\n  // Remove the margin in all browsers.\n\n  body {\n    margin: 0;\n  }\n\n  // Correct the font size and margin on `h1` elements within `section` and\n  // `article` contexts in Chrome, Firefox, and Safari.\n\n  h1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n  }\n\n  // Grouping content\n  // ==========================================================================\n\n  // 1. Add the correct box sizing in Firefox.\n  // 2. Show the overflow in Edge and IE.\n\n  hr {\n    box-sizing: content-box; // 1\n    height: 0; // 1\n    overflow: visible; // 2\n  }\n\n  // 1. Correct the inheritance and scaling of font size in all browsers.\n  // 2. Correct the odd `em` font sizing in all browsers.\n\n  pre {\n    font-family: monospace, monospace; // 1\n    font-size: 1em; // 2\n  }\n\n  // Text-level semantics\n  // ==========================================================================\n\n  // Remove the gray background on active links in IE 10.\n\n  a {\n    background-color: transparent;\n  }\n\n  // 1. Remove the bottom border in Chrome 57-\n  // 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n\n  abbr[title] {\n    border-bottom: none; // 1\n    text-decoration: underline; // 2\n    text-decoration: underline dotted; // 2\n  }\n\n  // Add the correct font weight in Chrome, Edge, and Safari.\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  // 1. Correct the inheritance and scaling of font size in all browsers.\n  // 2. Correct the odd `em` font sizing in all browsers.\n\n  code,\n  kbd,\n  samp {\n    font-family: monospace, monospace; // 1\n    font-size: 1em; // 2\n  }\n\n  // Add the correct font size in all browsers.\n\n  small {\n    font-size: 80%;\n  }\n\n  // Prevent `sub` and `sup` elements from affecting the line height in\n  // all browsers.\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  // Embedded content\n  // ==========================================================================\n\n  // Remove the border on images inside links in IE 10.\n\n  img {\n    border-style: none;\n  }\n\n  // Forms\n  // ==========================================================================\n\n  // 1. Change the font styles in all browsers.\n  // 2. Remove the margin in Firefox and Safari.\n\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit; // 1\n    font-size: 100%; // 1\n    line-height: 1.15; // 1\n    margin: 0; // 2\n  }\n\n  // Show the overflow in IE.\n  // 1. Show the overflow in Edge.\n\n  button,\n  input { // 1\n    overflow: visible;\n  }\n\n  // Remove the inheritance of text transform in Edge, Firefox, and IE.\n  // 1. Remove the inheritance of text transform in Firefox.\n\n  button,\n  select { // 1\n    text-transform: none;\n  }\n\n  // Correct the inability to style clickable types in iOS and Safari.\n\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    -webkit-appearance: button;\n  }\n\n  // Remove the inner border and padding in Firefox.\n\n  button::-moz-focus-inner,\n  [type=\"button\"]::-moz-focus-inner,\n  [type=\"reset\"]::-moz-focus-inner,\n  [type=\"submit\"]::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n\n  // Restore the focus styles unset by the previous rule.\n\n  button:-moz-focusring,\n  [type=\"button\"]:-moz-focusring,\n  [type=\"reset\"]:-moz-focusring,\n  [type=\"submit\"]:-moz-focusring {\n    outline: 1px dotted ButtonText;\n  }\n\n  // Correct the padding in Firefox.\n\n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n\n  // 1. Correct the text wrapping in Edge and IE.\n  // 2. Correct the color inheritance from `fieldset` elements in IE.\n  // 3. Remove the padding so developers are not caught out when they zero out\n  //    `fieldset` elements in all browsers.\n\n  legend {\n    box-sizing: border-box; // 1\n    color: inherit; // 2\n    display: table; // 1\n    max-width: 100%; // 1\n    padding: 0; // 3\n    white-space: normal; // 1\n  }\n\n  // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  // Remove the default vertical scrollbar in IE 10+.\n\n  textarea {\n    overflow: auto;\n  }\n\n  // 1. Add the correct box sizing in IE 10.\n  // 2. Remove the padding in IE 10.\n\n  [type=\"checkbox\"],\n  [type=\"radio\"] {\n    box-sizing: border-box; // 1\n    padding: 0; // 2\n  }\n\n  // Correct the cursor style of increment and decrement buttons in Chrome.\n\n  [type=\"number\"]::-webkit-inner-spin-button,\n  [type=\"number\"]::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  // 1. Correct the odd appearance in Chrome and Safari.\n  // 2. Correct the outline style in Safari.\n\n  [type=\"search\"] {\n    -webkit-appearance: textfield; // 1\n    outline-offset: -2px; // 2\n  }\n\n  // Remove the inner padding in Chrome and Safari on macOS.\n\n  [type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  // 1. Correct the inability to style clickable types in iOS and Safari.\n  // 2. Change font properties to `inherit` in Safari.\n\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button; // 1\n    font: inherit; // 2\n  }\n\n  // Interactive\n  // ==========================================================================\n\n  // Add the correct display in Edge, IE 10+, and Firefox.\n\n  details {\n    display: block;\n  }\n\n  // Add the correct display in all browsers.\n\n  summary {\n    display: list-item;\n  }\n\n  // Misc\n  // ==========================================================================\n\n  // Add the correct display in IE 10+.\n\n  template {\n    display: none;\n  }\n\n  // Add the correct display in IE 10.\n\n  [hidden] {\n    display: none;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n// sass-lint:disable no-color-literals, no-qualifying-elements\n\n////\n/// @group global\n////\n\n@import 'util/util';\n\n/// Font size attribute applied to `<html>` and `<body>`. We use 100% by default so the value is inherited from the user's browser settings.\n/// @type Number\n$global-font-size: 100% !default;\n\n/// Global width of your site. Used by the grid to determine row width.\n/// @type Number\n$global-width: rem-calc(1200) !default;\n\n/// Default line height for all type. `$global-lineheight` is 24px while `$global-font-size` is 16px\n/// @type Number\n$global-lineheight: 1.5 !default;\n\n/// Colors used for buttons, callouts, links, etc. There must always be a color called `primary`.\n/// @type Map\n$foundation-palette: (\n  primary: #1779ba,\n  secondary: #767676,\n  success: #3adb76,\n  warning: #ffae00,\n  alert: #cc4b37,\n) !default;\n\n/// Color used for light gray UI items.\n/// @type Color\n$light-gray: #e6e6e6 !default;\n\n/// Color used for medium gray UI items.\n/// @type Color\n$medium-gray: #cacaca !default;\n\n/// Color used for dark gray UI items.\n/// @type Color\n$dark-gray: #8a8a8a !default;\n\n/// Color used for black ui items.\n/// @type Color\n$black: #0a0a0a !default;\n\n/// Color used for white ui items.\n/// @type Color\n$white: #fefefe !default;\n\n/// Background color of the body.\n/// @type Color\n$body-background: $white !default;\n\n/// Text color of the body.\n/// @type Color\n$body-font-color: $black !default;\n\n/// Font stack of the body.\n/// @type List\n$body-font-family: 'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif !default;\n\n/// Set to `true` to enable antialiased type, using the `-webkit-font-smoothing` and `-moz-osx-font-smoothing` CSS properties.\n/// @type Boolean\n$body-antialiased: true !default;\n\n/// Global value used for margin on components.\n/// @type Number\n$global-margin: 1rem !default;\n\n/// Global value used for padding on components.\n/// @type Number\n$global-padding: 1rem !default;\n\n/// Global value used for positioning on components.\n/// @type Number\n$global-position: 1rem !default;\n\n/// Global font weight used for normal type.\n/// @type Keyword | Number\n$global-weight-normal: normal !default;\n\n/// Global font weight used for bold type.\n/// @type Keyword | Number\n$global-weight-bold: bold !default;\n\n/// Global value used for all elements that have a border radius.\n/// @type Number\n$global-radius: 0 !default;\n\n/// Global value used for all menu styles. Can be overwritten at individual menu component level.\n/// @type Number\n$global-menu-padding: 0.7rem 1rem !default;\n\n/// Global value used for all menu styles. Nested margin for submenu.\n$global-menu-nested-margin: 1rem !default;\n\n/// Sets the text direction of the CSS. Can be either `ltr` or `rtl`.\n/// @type Keyword\n$global-text-direction: ltr !default;\n\n/// Enables flexbox for components that support it.\n/// @type Boolean\n$global-flexbox: true !default;\n\n/// Enabled responsive breakpoints for prototypes if applicable\n/// @type Boolean\n$global-prototype-breakpoints: false !default;\n\n/// Button cursor's value, `auto` by default\n/// @type Keyword\n$global-button-cursor: auto !default;\n\n@if not map-has-key($foundation-palette, primary) {\n  @error 'In $foundation-palette, you must have a color named \"primary\".';\n}\n\n// Internal variables used for text direction\n$global-left: if($global-text-direction == rtl, right, left);\n$global-right: if($global-text-direction == rtl, left, right);\n\n// Internal variable that contains the flex justifying options\n$-zf-flex-justify: -zf-flex-justify($global-text-direction);\n\n/// Global tolerance for color pick contrast.\n/// @type Number\n$global-color-pick-contrast-tolerance: 0 !default;\n\n// Internal variables used for colors\n@include add-foundation-colors;\n\n@mixin foundation-global-styles {\n  @include foundation-normalize;\n\n  // These styles are applied to a <meta> tag, which is read by the Foundation JavaScript\n  .foundation-mq {\n    font-family: '#{-zf-bp-serialize($breakpoints)}';\n  }\n\n  html {\n    box-sizing: border-box;\n    font-size: $global-font-size;\n  }\n\n  // Set box-sizing globally to handle padding and border widths\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n\n  // Default body styles\n  body {\n    margin: 0;\n    padding: 0;\n\n    background: $body-background;\n\n    font-family: $body-font-family;\n    font-weight: $global-weight-normal;\n    line-height: $global-lineheight;\n    color: $body-font-color;\n\n    @if ($body-antialiased) {\n      -webkit-font-smoothing: antialiased; // sass-lint:disable-line no-vendor-prefixes\n      -moz-osx-font-smoothing: grayscale; // sass-lint:disable-line no-vendor-prefixes\n    }\n  }\n\n  img {\n    // Get rid of gap under images by making them display: inline-block; by default\n    display: inline-block;\n    vertical-align: middle;\n\n    // Grid defaults to get images and embeds to work properly\n    max-width: 100%;\n    height: auto;\n    -ms-interpolation-mode: bicubic;\n  }\n\n  // Make sure textarea takes on height automatically\n  textarea {\n    height: auto;\n    min-height: 50px;\n    border-radius: $global-radius;\n  }\n\n  // Make select elements are 100% width by default\n  select {\n    box-sizing: border-box;\n    width: 100%;\n    border-radius: $global-radius;\n  }\n\n  // Styles Google Maps and MapQuest embeds properly\n  // sass-lint:disable-line no-ids\n  .map_canvas,\n  .mqa-display {\n    img,\n    embed,\n    object {\n      max-width: none !important;\n    }\n  }\n\n  // Reset <button> styles created by most browsers\n  button {\n    @include disable-mouse-outline;\n    padding: 0;\n    appearance: none;\n    border: 0;\n    border-radius: $global-radius;\n    background: transparent;\n    line-height: 1;\n    cursor: $global-button-cursor;\n  }\n\n  // Prevent text overflow on pre\n  pre {\n    overflow: auto;\n  }\n\n  // Make reset inherit font-family instead of settings sans-serif\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit;\n  }\n\n  // Internal classes to show/hide elements in JavaScript\n  .is-visible {\n    display: block !important;\n  }\n\n  .is-hidden {\n    display: none !important;\n  }\n}\n","//  Foundation for Sites Settings\n//  -----------------------------\n//\n//  Table of Contents:\n//\n//   1. Global\n//   2. Breakpoints\n//   3. The Grid\n//   4. Base Typography\n//   5. Typography Helpers\n//   6. Abide\n//   7. Accordion\n//   8. Accordion Menu\n//   9. Badge\n//  10. Breadcrumbs\n//  11. Button\n//  12. Button Group\n//  13. Callout\n//  14. Card\n//  15. Close Button\n//  16. Drilldown\n//  17. Dropdown\n//  18. Dropdown Menu\n//  19. Flexbox Utilities\n//  20. Forms\n//  21. Label\n//  22. Media Object\n//  23. Menu\n//  24. Meter\n//  25. Off-canvas\n//  26. Orbit\n//  27. Pagination\n//  28. Progress Bar\n//  29. Prototype Arrow\n//  30. Prototype Border-Box\n//  31. Prototype Border-None\n//  32. Prototype Bordered\n//  33. Prototype Display\n//  34. Prototype Font-Styling\n//  35. Prototype List-Style-Type\n//  36. Prototype Overflow\n//  37. Prototype Position\n//  38. Prototype Rounded\n//  39. Prototype Separator\n//  40. Prototype Shadow\n//  41. Prototype Sizing\n//  42. Prototype Spacing\n//  43. Prototype Text-Decoration\n//  44. Prototype Text-Transformation\n//  45. Prototype Text-Utilities\n//  46. Responsive Embed\n//  47. Reveal\n//  48. Slider\n//  49. Switch\n//  50. Table\n//  51. Tabs\n//  52. Thumbnail\n//  53. Title Bar\n//  54. Tooltip\n//  55. Top Bar\n//  56. Xy Grid\n\n@import 'node_modules/foundation-sites/scss/util/util';\n\n// 1. Global\n// ---------\n\n$global-font-size: 100%;\n$global-width: rem-calc(1200);\n$global-lineheight: 1.4;\n$foundation-palette: (\nprimary: #FF2476,\nsecondary: #00BAEF,\ndefault: #F2F3F4,\nsuccess: #0AC775,\nwarning: #FFA501,\nalert: #E31926,\nwhite: #FFFFFF,\ninfo: #1F7CC1,\nblack: #333333\n);\n$light-gray: rgba(#333, .15);\n$medium-gray: rgba(#333,.5);\n$dark-gray: rgba(#333,.75);\n$black: #333;\n$white: #fff;\n$body-background: $white;\n$body-font-color: $black;\n$body-font-family: 'Europa', 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n$body-antialiased: true;\n$global-margin: 1rem;\n$global-padding: 1rem;\n$global-position: 1rem;\n$global-weight-normal: normal;\n$global-weight-bold: bold;\n$global-radius: 3px;\n$global-menu-padding: 0.7rem 1rem;\n$global-menu-nested-margin: 1rem;\n$global-text-direction: ltr;\n$global-flexbox: true;\n$global-prototype-breakpoints: false;\n$global-button-cursor: auto;\n$global-color-pick-contrast-tolerance: 0;\n$print-transparent-backgrounds: true;\n$print-hrefs: true;\n\n@include add-foundation-colors;\n\n// 2. Breakpoints\n// --------------\n\n$breakpoints: (\n  small: 0,\n  medium: 640px,\n  xmedium: 832px,\n  large: 1024px,\n  xlarge: 1200px,\n  xxlarge: 1440px,\n);\n$breakpoints-hidpi: (\n  hidpi-1: 1,\n  hidpi-1-5: 1.5,\n  hidpi-2: 2,\n  retina: 2,\n  hidpi-3: 3\n);\n$print-breakpoint: large;\n$breakpoint-classes: (small medium large);\n\n// 3. The Grid\n// -----------\n\n$grid-row-width: $global-width;\n$grid-column-count: 12;\n$grid-column-gutter: (\n  small: 20px,\n  medium: 30px,\n);\n$grid-column-align-edge: true;\n$grid-column-alias: 'columns';\n$block-grid-max: 8;\n\n// 4. Base Typography\n// ------------------\n\n$header-font-family: $body-font-family;\n$header-font-weight: $global-weight-normal;\n$header-font-style: normal;\n$font-family-monospace: Consolas, 'Liberation Mono', Courier, monospace;\n$header-color: inherit;\n$header-lineheight: 1.2;\n$header-margin-bottom: 0.5rem;\n$header-styles: (\n  small: (\n    'h1': ('font-size': 26),\n    'h2': ('font-size': 24),\n    'h3': ('font-size': 20),\n    'h4': ('font-size': 16),\n    'h5': ('font-size': 14),\n    'h6': ('font-size': 16)\n  ),\n  medium: (\n    'h1': ('font-size': 36),\n    'h2': ('font-size': 32),\n    'h3': ('font-size': 24),\n    'h4': ('font-size': 20),\n    'h5': ('font-size': 18),\n    'h6': ('font-size': 16)\n  ),\n\n  large: (\n    'h1': ('font-size': 48),\n    'h2': ('font-size': 36),\n    'h3': ('font-size': 32),\n    'h4': ('font-size': 24),\n    'h5': ('font-size': 20),\n    'h6': ('font-size': 16),\n  ),\n  xlarge: (\n    'h1': ('font-size': 57),\n    'h2': ('font-size': 46),\n    'h3': ('font-size': 36),\n    'h4': ('font-size': 24),\n    'h5': ('font-size': 20),\n    'h6': ('font-size': 16),\n  ),\n);\n$header-text-rendering: optimizeLegibility;\n$small-font-size: 80%;\n$header-small-font-color: $medium-gray;\n$paragraph-lineheight: 1.4;\n$paragraph-margin-bottom: 1rem;\n$paragraph-text-rendering: optimizeLegibility;\n$enable-code-inline: true;\n$anchor-color: $black;\n$anchor-color-hover: scale-color($primary-color, $lightness: -14%);\n$anchor-text-decoration: none;\n$anchor-text-decoration-hover: none;\n$hr-width: $global-width;\n$hr-border: 1px solid $medium-gray;\n$hr-margin: rem-calc(20) auto;\n$list-lineheight: $paragraph-lineheight;\n$list-margin-bottom: $paragraph-margin-bottom;\n$list-style-type: disc;\n$list-style-position: outside;\n$list-side-margin: 1.25rem;\n$list-nested-side-margin: 1.25rem;\n$defnlist-margin-bottom: 1rem;\n$defnlist-term-weight: $global-weight-bold;\n$defnlist-term-margin-bottom: 0.3rem;\n$blockquote-color: $dark-gray;\n$blockquote-padding: rem-calc(9 20 0 19);\n$blockquote-border: 1px solid $medium-gray;\n$enable-cite-block: true;\n$keystroke-font: $font-family-monospace;\n$keystroke-color: $black;\n$keystroke-background: $light-gray;\n$keystroke-padding: rem-calc(2 4 0);\n$keystroke-radius: $global-radius;\n$abbr-underline: 1px dotted $black;\n\n// 5. Typography Helpers\n// ---------------------\n\n$lead-font-size: $global-font-size * 1.25;\n$lead-lineheight: 1.6;\n$subheader-lineheight: 1.4;\n$subheader-color: $dark-gray;\n$subheader-font-weight: $global-weight-normal;\n$subheader-margin-top: 0.2rem;\n$subheader-margin-bottom: 0.5rem;\n$stat-font-size: 2.5rem;\n$cite-color: $dark-gray;\n$cite-font-size: rem-calc(13);\n$cite-pseudo-content: '\\2014 \\0020';\n$code-color: $black;\n$code-font-family: $font-family-monospace;\n$code-font-weight: $global-weight-normal;\n$code-background: $light-gray;\n$code-border: 1px solid $medium-gray;\n$code-padding: rem-calc(2 5 1);\n$code-block-padding: 1rem;\n$code-block-margin-bottom: 1.5rem;\n\n// 6. Abide\n// --------\n\n$abide-inputs: true;\n$abide-labels: true;\n$input-background-invalid: get-color(alert);\n$form-label-color-invalid: get-color(alert);\n$input-error-color: get-color(alert);\n$input-error-font-size: rem-calc(12);\n$input-error-font-weight: $global-weight-bold;\n\n// 7. Accordion\n// ------------\n\n$accordion-background: $white;\n$accordion-plusminus: true;\n$accordion-plus-content: '\\002B';\n$accordion-minus-content: '\\2013';\n$accordion-title-font-size: rem-calc(12);\n$accordion-item-color: $primary-color;\n$accordion-item-background-hover: $light-gray;\n$accordion-item-padding: 1.25rem 1rem;\n$accordion-content-background: $white;\n$accordion-content-border: 1px solid $light-gray;\n$accordion-content-color: $body-font-color;\n$accordion-content-padding: 1rem;\n\n// 8. Accordion Menu\n// -----------------\n\n$accordionmenu-padding: $global-menu-padding;\n$accordionmenu-nested-margin: $global-menu-nested-margin;\n$accordionmenu-submenu-padding: $accordionmenu-padding;\n$accordionmenu-arrows: true;\n$accordionmenu-arrow-color: $primary-color;\n$accordionmenu-item-background: null;\n$accordionmenu-border: null;\n$accordionmenu-submenu-toggle-background: null;\n$accordion-submenu-toggle-border: $accordionmenu-border;\n$accordionmenu-submenu-toggle-width: 40px;\n$accordionmenu-submenu-toggle-height: $accordionmenu-submenu-toggle-width;\n$accordionmenu-arrow-size: 6px;\n\n// 9. Badge\n// --------\n\n$badge-background: $primary-color;\n$badge-color: $white;\n$badge-color-alt: $black;\n$badge-palette: $foundation-palette;\n$badge-padding: 0.3em;\n$badge-minwidth: 2.1em;\n$badge-font-size: 0.6rem;\n\n// 10. Breadcrumbs\n// ---------------\n\n$breadcrumbs-margin: 0 0 $global-margin 0;\n$breadcrumbs-item-font-size: rem-calc(11);\n$breadcrumbs-item-color: $primary-color;\n$breadcrumbs-item-color-current: $black;\n$breadcrumbs-item-color-disabled: $medium-gray;\n$breadcrumbs-item-margin: 0.75rem;\n$breadcrumbs-item-uppercase: true;\n$breadcrumbs-item-separator: true;\n$breadcrumbs-item-separator-item: '/';\n$breadcrumbs-item-separator-item-rtl: '\\\\';\n$breadcrumbs-item-separator-color: $medium-gray;\n\n// 11. Button\n// ----------\n\n$button-font-family: inherit;\n$button-font-weight: 600;\n$button-padding: 0.85em 1em;\n$button-margin: 0 0 $global-margin 0;\n$button-fill: solid;\n$button-background: $primary-color;\n$button-background-hover: scale-color($button-background, $lightness: -15%);\n$button-color: $white;\n$button-color-alt: $black;\n$button-radius: $global-radius;\n$button-border: 1px solid transparent;\n$button-hollow-border-width: 1px;\n$button-sizes: (\n  tiny: 0.6rem,\n  small: 0.75rem,\n  default: 0.9rem,\n  large: 1.25rem,\n);\n$button-palette: $foundation-palette;\n$button-opacity-disabled: 0.25;\n$button-background-hover-lightness: -20%;\n$button-hollow-hover-lightness: -50%;\n$button-transition: background-color 0.25s ease-out, color 0.25s ease-out;\n$button-responsive-expanded: false;\n\n// 12. Button Group\n// ----------------\n\n$buttongroup-margin: 1rem;\n$buttongroup-spacing: 1px;\n$buttongroup-child-selector: '.button';\n$buttongroup-expand-max: 6;\n$buttongroup-radius-on-each: true;\n\n// 13. Callout\n// -----------\n\n$callout-background: $white;\n$callout-background-fade: 85%;\n$callout-border: 1px solid rgba($black, 0.25);\n$callout-margin: 0 0 1rem 0;\n$callout-sizes: (\n  small: 0.5rem,\n  default: 1rem,\n  large: 3rem,\n);\n$callout-font-color: $body-font-color;\n$callout-font-color-alt: $body-background;\n$callout-radius: $global-radius;\n$callout-link-tint: 30%;\n\n// 14. Card\n// --------\n\n$card-background: $white;\n$card-font-color: $body-font-color;\n$card-divider-background: $light-gray;\n$card-border: 1px solid $light-gray;\n$card-shadow: none;\n$card-border-radius: $global-radius;\n$card-padding: $global-padding;\n$card-margin-bottom: $global-margin;\n\n// 15. Close Button\n// ----------------\n\n$closebutton-position: right top;\n$closebutton-z-index: 10;\n$closebutton-default-size: medium;\n$closebutton-offset-horizontal: (\n  small: 0.66rem,\n  medium: 1rem,\n);\n$closebutton-offset-vertical: (\n  small: 0.33em,\n  medium: 0.5rem,\n);\n$closebutton-size: (\n  small: 1.5em,\n  medium: 2em,\n);\n$closebutton-lineheight: 1;\n$closebutton-color: $dark-gray;\n$closebutton-color-hover: $black;\n\n// 16. Drilldown\n// -------------\n\n$drilldown-transition: transform 0.15s linear;\n$drilldown-arrows: true;\n$drilldown-padding: $global-menu-padding;\n$drilldown-nested-margin: 0;\n$drilldown-background: $white;\n$drilldown-submenu-padding: $drilldown-padding;\n$drilldown-submenu-background: $white;\n$drilldown-arrow-color: $primary-color;\n$drilldown-arrow-size: 6px;\n\n// 17. Dropdown\n// ------------\n\n$dropdown-padding: 1rem;\n$dropdown-background: $body-background;\n$dropdown-border: 1px solid $medium-gray;\n$dropdown-font-size: 1rem;\n$dropdown-width: 300px;\n$dropdown-radius: $global-radius;\n$dropdown-sizes: (\n  tiny: 100px,\n  small: 200px,\n  large: 400px,\n);\n\n// 18. Dropdown Menu\n// -----------------\n\n$dropdownmenu-arrows: true;\n$dropdownmenu-arrow-color: $anchor-color;\n$dropdownmenu-arrow-size: 6px;\n$dropdownmenu-arrow-padding: 1.5rem;\n$dropdownmenu-min-width: 200px;\n$dropdownmenu-background: null;\n$dropdownmenu-submenu-background: $white;\n$dropdownmenu-padding: $global-menu-padding;\n$dropdownmenu-nested-margin: 0;\n$dropdownmenu-submenu-padding: $dropdownmenu-padding;\n$dropdownmenu-border: 1px solid $medium-gray;\n$dropdown-menu-item-color-active: get-color(primary);\n$dropdown-menu-item-background-active: transparent;\n\n// 19. Flexbox Utilities\n// ---------------------\n\n$flex-source-ordering-count: 6;\n$flexbox-responsive-breakpoints: true;\n\n// 20. Forms\n// ---------\n\n$fieldset-border: 1px solid $medium-gray;\n$fieldset-padding: rem-calc(20);\n$fieldset-margin: rem-calc(18 0);\n$legend-padding: rem-calc(0 3);\n$form-spacing: rem-calc(16);\n$helptext-color: $black;\n$helptext-font-size: rem-calc(13);\n$helptext-font-style: italic;\n$input-prefix-color: $black;\n$input-prefix-background: $light-gray;\n$input-prefix-border: 1px solid $medium-gray;\n$input-prefix-padding: 1rem;\n$form-label-color: $black;\n$form-label-font-size: rem-calc(14);\n$form-label-font-weight: $global-weight-normal;\n$form-label-line-height: 1.8;\n$select-background: $white;\n$select-triangle-color: $dark-gray;\n$select-radius: $global-radius;\n$input-color: $black;\n$input-placeholder-color: $medium-gray;\n$input-font-family: inherit;\n$input-font-size: rem-calc(16);\n$input-font-weight: $global-weight-normal;\n$input-line-height: $global-lineheight;\n$input-background: $white;\n$input-background-focus: $white;\n$input-background-disabled: $light-gray;\n$input-border: 1px solid $medium-gray;\n$input-border-focus: 1px solid $dark-gray;\n$input-padding: $form-spacing / 2;\n$input-shadow: inset 0 1px 2px rgba($black, 0.1);\n$input-shadow-focus: 0 0 5px $medium-gray;\n$input-cursor-disabled: not-allowed;\n$input-transition: box-shadow 0.5s, border-color 0.25s ease-in-out;\n$input-number-spinners: true;\n$input-radius: $global-radius;\n$form-button-radius: $global-radius;\n\n// 21. Label\n// ---------\n\n$label-background: $primary-color;\n$label-color: $white;\n$label-color-alt: $black;\n$label-palette: $foundation-palette;\n$label-font-size: 0.8rem;\n$label-padding: 0.33333rem 0.5rem;\n$label-radius: $global-radius;\n\n// 22. Media Object\n// ----------------\n\n$mediaobject-margin-bottom: $global-margin;\n$mediaobject-section-padding: $global-padding;\n$mediaobject-image-width-stacked: 100%;\n\n// 23. Menu\n// --------\n\n$menu-margin: 0;\n$menu-nested-margin: $global-menu-nested-margin;\n$menu-items-padding: $global-menu-padding;\n$menu-simple-margin: 1rem;\n$menu-item-color-active: $white;\n$menu-item-color-alt-active: $black;\n$menu-item-background-active: get-color(primary);\n$menu-icon-spacing: 0.25rem;\n$menu-state-back-compat: true;\n$menu-centered-back-compat: true;\n$menu-icons-back-compat: true;\n\n// 24. Meter\n// ---------\n\n$meter-height: 1rem;\n$meter-radius: $global-radius;\n$meter-background: $medium-gray;\n$meter-fill-good: $success-color;\n$meter-fill-medium: $warning-color;\n$meter-fill-bad: $alert-color;\n\n// 25. Off-canvas\n// --------------\n\n$offcanvas-sizes: (\n  small: 250px,\n);\n$offcanvas-vertical-sizes: (\n  small: 250px,\n);\n$offcanvas-background: $light-gray;\n$offcanvas-shadow: 0 0 10px rgba($black, 0.7);\n$offcanvas-inner-shadow-size: 20px;\n$offcanvas-inner-shadow-color: rgba($black, 0.25);\n$offcanvas-overlay-zindex: 11;\n$offcanvas-push-zindex: 12;\n$offcanvas-overlap-zindex: 13;\n$offcanvas-reveal-zindex: 12;\n$offcanvas-transition-length: 0.5s;\n$offcanvas-transition-timing: ease;\n$offcanvas-fixed-reveal: true;\n$offcanvas-exit-background: rgba($white, 0.25);\n$maincontent-class: 'off-canvas-content';\n\n// 26. Orbit\n// ---------\n\n$orbit-bullet-background: $medium-gray;\n$orbit-bullet-background-active: $dark-gray;\n$orbit-bullet-diameter: 1.2rem;\n$orbit-bullet-margin: 0.1rem;\n$orbit-bullet-margin-top: 0.8rem;\n$orbit-bullet-margin-bottom: 0.8rem;\n$orbit-caption-background: rgba($black, 0.5);\n$orbit-caption-padding: 1rem;\n$orbit-control-background-hover: rgba($black, 0.5);\n$orbit-control-padding: 1rem;\n$orbit-control-zindex: 10;\n\n// 27. Pagination\n// --------------\n\n$pagination-font-size: rem-calc(14);\n$pagination-margin-bottom: $global-margin;\n$pagination-item-color: $black;\n$pagination-item-padding: rem-calc(3 10);\n$pagination-item-spacing: rem-calc(1);\n$pagination-radius: $global-radius;\n$pagination-item-background-hover: $light-gray;\n$pagination-item-background-current: $primary-color;\n$pagination-item-color-current: $white;\n$pagination-item-color-disabled: $medium-gray;\n$pagination-ellipsis-color: $black;\n$pagination-mobile-items: false;\n$pagination-mobile-current-item: false;\n$pagination-arrows: true;\n$pagination-arrow-previous: '\\00AB';\n$pagination-arrow-next: '\\00BB';\n\n// 28. Progress Bar\n// ----------------\n\n$progress-height: 1rem;\n$progress-background: $medium-gray;\n$progress-margin-bottom: $global-margin;\n$progress-meter-background: $primary-color;\n$progress-radius: $global-radius;\n\n// 29. Prototype Arrow\n// -------------------\n\n$prototype-arrow-directions: (\n  down,\n  up,\n  right,\n  left\n);\n$prototype-arrow-size: 0.4375rem;\n$prototype-arrow-color: $black;\n\n// 30. Prototype Border-Box\n// ------------------------\n\n$prototype-border-box-breakpoints: $global-prototype-breakpoints;\n\n// 31. Prototype Border-None\n// -------------------------\n\n$prototype-border-none-breakpoints: $global-prototype-breakpoints;\n\n// 32. Prototype Bordered\n// ----------------------\n\n$prototype-bordered-breakpoints: $global-prototype-breakpoints;\n$prototype-border-width: rem-calc(1);\n$prototype-border-type: solid;\n$prototype-border-color: $medium-gray;\n\n// 33. Prototype Display\n// ---------------------\n\n$prototype-display-breakpoints: $global-prototype-breakpoints;\n$prototype-display: (\n  inline,\n  inline-block,\n  block,\n  table,\n  table-cell\n);\n\n// 34. Prototype Font-Styling\n// --------------------------\n\n$prototype-font-breakpoints: $global-prototype-breakpoints;\n$prototype-wide-letter-spacing: rem-calc(4);\n$prototype-font-normal: $global-weight-normal;\n$prototype-font-bold: $global-weight-bold;\n\n// 35. Prototype List-Style-Type\n// -----------------------------\n\n$prototype-list-breakpoints: $global-prototype-breakpoints;\n$prototype-style-type-unordered: (\n  disc,\n  circle,\n  square\n);\n$prototype-style-type-ordered: (\n  decimal,\n  lower-alpha,\n  lower-latin,\n  lower-roman,\n  upper-alpha,\n  upper-latin,\n  upper-roman\n);\n\n// 36. Prototype Overflow\n// ----------------------\n\n$prototype-overflow-breakpoints: $global-prototype-breakpoints;\n$prototype-overflow: (\n  visible,\n  hidden,\n  scroll\n);\n\n// 37. Prototype Position\n// ----------------------\n\n$prototype-position-breakpoints: $global-prototype-breakpoints;\n$prototype-position: (\n  static,\n  relative,\n  absolute,\n  fixed\n);\n$prototype-position-z-index: 975;\n\n// 38. Prototype Rounded\n// ---------------------\n\n$prototype-rounded-breakpoints: $global-prototype-breakpoints;\n$prototype-border-radius: rem-calc(3);\n\n// 39. Prototype Separator\n// -----------------------\n\n$prototype-separator-breakpoints: $global-prototype-breakpoints;\n$prototype-separator-align: center;\n$prototype-separator-height: rem-calc(2);\n$prototype-separator-width: 3rem;\n$prototype-separator-background: $primary-color;\n$prototype-separator-margin-top: $global-margin;\n\n// 40. Prototype Shadow\n// --------------------\n\n$prototype-shadow-breakpoints: $global-prototype-breakpoints;\n$prototype-box-shadow: 0 2px 5px 0 rgba(0,0,0,.16),\n                       0 2px 10px 0 rgba(0,0,0,.12);\n\n// 41. Prototype Sizing\n// --------------------\n\n$prototype-sizing-breakpoints: $global-prototype-breakpoints;\n$prototype-sizing: (\n  width,\n  height\n);\n$prototype-sizes: (\n  25: 25%,\n  50: 50%,\n  75: 75%,\n  100: 100%\n);\n\n// 42. Prototype Spacing\n// ---------------------\n\n$prototype-spacing-breakpoints: $global-prototype-breakpoints;\n$prototype-spacers-count: 3;\n\n// 43. Prototype Text-Decoration\n// -----------------------------\n\n$prototype-decoration-breakpoints: $global-prototype-breakpoints;\n$prototype-text-decoration: (\n  overline,\n  underline,\n  line-through,\n);\n\n// 44. Prototype Text-Transformation\n// ---------------------------------\n\n$prototype-transformation-breakpoints: $global-prototype-breakpoints;\n$prototype-text-transformation: (\n  lowercase,\n  uppercase,\n  capitalize\n);\n\n// 45. Prototype Text-Utilities\n// ----------------------------\n\n$prototype-utilities-breakpoints: $global-prototype-breakpoints;\n$prototype-text-overflow: ellipsis;\n\n// 46. Responsive Embed\n// --------------------\n\n$responsive-embed-margin-bottom: rem-calc(16);\n$responsive-embed-ratios: (\n  default: 4 by 3,\n  widescreen: 16 by 9,\n);\n\n// 47. Reveal\n// ----------\n\n$reveal-background: $white;\n$reveal-width: 600px;\n$reveal-max-width: $global-width;\n$reveal-padding: $global-padding;\n$reveal-border: 1px solid $medium-gray;\n$reveal-radius: $global-radius;\n$reveal-zindex: 1005;\n$reveal-overlay-background: rgba($black, 0.45);\n\n// 48. Slider\n// ----------\n\n$slider-width-vertical: 0.5rem;\n$slider-transition: all 0.2s ease-in-out;\n$slider-height: 0.5rem;\n$slider-background: $light-gray;\n$slider-fill-background: $medium-gray;\n$slider-handle-height: 1.4rem;\n$slider-handle-width: 1.4rem;\n$slider-handle-background: $primary-color;\n$slider-opacity-disabled: 0.25;\n$slider-radius: $global-radius;\n\n// 49. Switch\n// ----------\n\n$switch-background: $medium-gray;\n$switch-background-active: $primary-color;\n$switch-height: 2rem;\n$switch-height-tiny: 1.5rem;\n$switch-height-small: 1.75rem;\n$switch-height-large: 2.5rem;\n$switch-radius: $global-radius;\n$switch-margin: $global-margin;\n$switch-paddle-background: $white;\n$switch-paddle-offset: 0.25rem;\n$switch-paddle-radius: $global-radius;\n$switch-paddle-transition: all 0.25s ease-out;\n$switch-opacity-disabled: .5;\n$switch-cursor-disabled: not-allowed;\n\n// 50. Table\n// ---------\n\n$table-background: $white;\n$table-color-scale: 5%;\n$table-border: 1px solid smart-scale($table-background, $table-color-scale);\n$table-padding: rem-calc(8 10 10);\n$table-hover-scale: 2%;\n$table-row-hover: darken($table-background, $table-hover-scale);\n$table-row-stripe-hover: darken($table-background, $table-color-scale + $table-hover-scale);\n$table-is-striped: true;\n$table-striped-background: smart-scale($table-background, $table-color-scale);\n$table-stripe: even;\n$table-head-background: smart-scale($table-background, $table-color-scale / 2);\n$table-head-row-hover: darken($table-head-background, $table-hover-scale);\n$table-foot-background: smart-scale($table-background, $table-color-scale);\n$table-foot-row-hover: darken($table-foot-background, $table-hover-scale);\n$table-head-font-color: $body-font-color;\n$table-foot-font-color: $body-font-color;\n$show-header-for-stacked: false;\n$table-stack-breakpoint: medium;\n\n// 51. Tabs\n// --------\n\n$tab-margin: 0;\n$tab-background: $white;\n$tab-color: $primary-color;\n$tab-background-active: $light-gray;\n$tab-active-color: $primary-color;\n$tab-item-font-size: rem-calc(12);\n$tab-item-background-hover: $white;\n$tab-item-padding: 1.25rem 1.5rem;\n$tab-content-background: $white;\n$tab-content-border: $light-gray;\n$tab-content-color: $body-font-color;\n$tab-content-padding: 1rem;\n\n// 52. Thumbnail\n// -------------\n\n$thumbnail-border: 4px solid $white;\n$thumbnail-margin-bottom: $global-margin;\n$thumbnail-shadow: 0 0 0 1px rgba($black, 0.2);\n$thumbnail-shadow-hover: 0 0 6px 1px rgba($primary-color, 0.5);\n$thumbnail-transition: box-shadow 200ms ease-out;\n$thumbnail-radius: $global-radius;\n\n// 53. Title Bar\n// -------------\n\n$titlebar-background: $black;\n$titlebar-color: $white;\n$titlebar-padding: 0.5rem;\n$titlebar-text-font-weight: bold;\n$titlebar-icon-color: $white;\n$titlebar-icon-color-hover: $medium-gray;\n$titlebar-icon-spacing: 0.25rem;\n\n// 54. Tooltip\n// -----------\n\n$has-tip-cursor: help;\n$has-tip-font-weight: $global-weight-bold;\n$has-tip-border-bottom: dotted 1px $dark-gray;\n$tooltip-background-color: $black;\n$tooltip-color: $white;\n$tooltip-padding: 0.75rem;\n$tooltip-max-width: 10rem;\n$tooltip-font-size: $small-font-size;\n$tooltip-pip-width: 0.75rem;\n$tooltip-pip-height: $tooltip-pip-width * 0.866;\n$tooltip-radius: $global-radius;\n\n// 55. Top Bar\n// -----------\n\n$topbar-padding: 0.5rem;\n$topbar-background: $light-gray;\n$topbar-submenu-background: $topbar-background;\n$topbar-title-spacing: 0.5rem 1rem 0.5rem 0;\n$topbar-input-width: 200px;\n$topbar-unstack-breakpoint: medium;\n\n// 56. Xy Grid\n// -----------\n\n$xy-grid: true;\n$grid-container: $global-width;\n$grid-columns: 12;\n$grid-margin-gutters: (\n  small: 20px,\n  medium: 30px\n);\n$grid-padding-gutters: $grid-margin-gutters;\n$grid-container-padding: $grid-padding-gutters;\n$grid-container-max: $global-width;\n$xy-block-grid-max: 8;\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group functions\n////\n\n/// Creates an inner box-shadow for only one side\n///\n/// @param {Keyword} $side - Side the shadow is supposed to appear. Can be `top`, `left`, `right` or `bottom`.\n/// @param {Number} $size - Width for the target side.\n/// @param {Color} $color - Color of the shadow.\n@mixin inner-side-shadow(\n  $side: bottom,\n  $size: 20px,\n  $color: rgba($black, 0.25)\n) {\n\n  $helper: round($size * 0.65);\n\n  @if ($side == top) {\n    box-shadow: inset 0 $helper $size (-1)*$helper $color;\n  } @else if ($side == left) {\n    box-shadow: inset $helper 0 $size (-1)*$helper $color;\n  } @else if ($side == right) {\n    box-shadow: inset (-1)*$helper 0 $size (-1)*$helper $color;\n  } @else if ($side == bottom) {\n    box-shadow: inset 0 (-1)*$helper $size (-1)*$helper $color;\n  }\n}\n\n/// Creates a CSS triangle, which can be used for dropdown arrows, dropdown pips, and more. Use this mixin inside a `&::before` or `&::after` selector, to attach the triangle to an existing element.\n///\n/// @param {Number} $triangle-size - Width of the triangle.\n/// @param {Color} $triangle-color - Color of the triangle.\n/// @param {Keyword} $triangle-direction - Direction the triangle points. Can be `up`, `right`, `down`, or `left`.\n@mixin css-triangle(\n  $triangle-size,\n  $triangle-color,\n  $triangle-direction\n) {\n  display: block;\n  width: 0;\n  height: 0;\n\n  border: inset $triangle-size;\n\n  content: '';\n\n  @if ($triangle-direction == down) {\n    border-bottom-width: 0;\n    border-top-style: solid;\n    border-color: $triangle-color transparent transparent;\n  }\n  @if ($triangle-direction == up) {\n    border-top-width: 0;\n    border-bottom-style: solid;\n    border-color: transparent transparent $triangle-color;\n  }\n  @if ($triangle-direction == right) {\n    border-right-width: 0;\n    border-left-style: solid;\n    border-color: transparent transparent transparent $triangle-color;\n  }\n  @if ($triangle-direction == left) {\n    border-left-width: 0;\n    border-right-style: solid;\n    border-color: transparent $triangle-color transparent transparent;\n  }\n}\n\n/// Creates a menu icon with a set width, height, number of bars, and colors. The mixin uses the height of the icon and the weight of the bars to determine spacing. <div class=\"docs-example-burger\"></div>\n///\n/// @param {Color} $color [$black] - Color to use for the icon.\n/// @param {Color} $color-hover [$dark-gray] - Color to use when the icon is hovered over.\n/// @param {Number} $width [20px] - Width of the icon.\n/// @param {Number} $height [16px] - Height of the icon.\n/// @param {Number} $weight [2px] - Height of individual bars in the icon.\n/// @param {Number} $bars [3] - Number of bars in the icon.\n@mixin hamburger(\n  $color: $black,\n  $color-hover: $dark-gray,\n  $width: 20px,\n  $height: 16px,\n  $weight: 2px,\n  $bars: 3\n) {\n  // box-shadow CSS output\n  $shadow: ();\n  $hover-shadow: ();\n\n  // Spacing between bars is calculated based on the total height of the icon and the weight of each bar\n  $spacing: ($height - ($weight * $bars)) / ($bars - 1);\n\n  @if unit($spacing) == 'px' {\n    $spacing: floor($spacing);\n  }\n\n  @for $i from 2 through $bars {\n    $offset: ($weight + $spacing) * ($i - 1);\n    $shadow: append($shadow, 0 $offset 0 $color, comma);\n  }\n\n  // Icon container\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: $width;\n  height: $height;\n  cursor: pointer;\n\n  // Icon bars\n  &::after {\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    display: block;\n    width: 100%;\n    height: $weight;\n\n    background: $color;\n    box-shadow: $shadow;\n\n    content: '';\n  }\n\n  // Hover state\n  @if $color-hover {\n    // Generate CSS\n    @for $i from 2 through $bars {\n      $offset: ($weight + $spacing) * ($i - 1);\n      $hover-shadow: append($hover-shadow, 0 $offset 0 $color-hover, comma);\n    }\n\n    &:hover::after {\n      background: $color-hover;\n      box-shadow: $hover-shadow;\n    }\n  }\n}\n\n/// Adds a downward-facing triangle as a background image to an element. The image is formatted as an SVG, making it easy to change the color. Because Internet Explorer doesn't support encoded SVGs as background images, a PNG fallback is also included.\n/// There are two PNG fallbacks: a black triangle and a white triangle. The one used depends on the lightness of the input color.\n///\n/// @param {Color} $color [$black] - Color to use for the triangle.\n@mixin background-triangle($color: $black) {\n  $rgb: 'rgb%28#{round(red($color))}, #{round(green($color))}, #{round(blue($color))}%29';\n\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: #{$rgb}'></polygon></svg>\");\n\n  @media screen and (min-width:0\\0) {\n    @if lightness($color) < 60% {\n      // White triangle\n      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIpJREFUeNrEkckNgDAMBBfRkEt0ObRBBdsGXUDgmQfK4XhH2m8czQAAy27R3tsw4Qfe2x8uOO6oYLb6GlOor3GF+swURAOmUJ+RwtEJs9WvTGEYxBXqI1MQAZhCfUQKRzDMVj+TwrAIV6jvSUEkYAr1LSkcyTBb/V+KYfX7xAeusq3sLDtGH3kEGACPWIflNZfhRQAAAABJRU5ErkJggg==');\n    }\n    @else {\n      // Black triangle\n      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMBJREFUeNrEllsOhCAMRVszC9IlzU7KCmVHTJsoMWYMUtpyv9BgbuXQB5ZSdgBYYY4ycgBivk8KYFsQMfMiTTBP4o3nUzCKzOabLJbLy2/g31evGkAginR4/ZegKH5qX3bJCscA3t0x3kgO5tQFyhhFf50xRqFLbyMUNJQzgyjGS/wgCpvKqkRBpuWrE4V9d+1E4dPUXqIg107SQOE/2DRQxMwTDygIInVDET9T3lCoj/6j/VCmGjZOl2lKpZ8AAwDQP7zIimDGFQAAAABJRU5ErkJggg==');\n    }\n  }\n}\n\n/// Applies the micro clearfix hack popularized by Nicolas Gallagher. Include this mixin on a container if its children are all floated, to give the container a proper height.\n/// The clearfix is augmented with specific styles to prevent borders in flexbox environments\n/// @link http://nicolasgallagher.com/micro-clearfix-hack/ Micro Clearfix Hack\n/// @link http://danisadesigner.com/blog/flexbox-clear-fix-pseudo-elements/ Flexbox fix\n@mixin clearfix {\n  &::before,\n  &::after {\n    display: table;\n    content: ' ';\n\n    @if $global-flexbox {\n      flex-basis: 0;\n      order: 1;\n    }\n  }\n\n  &::after {\n    clear: both;\n  }\n}\n\n/// Adds CSS for a \"quantity query\" selector that automatically sizes elements based on how many there are inside a container.\n/// @link http://alistapart.com/article/quantity-queries-for-css Quantity Queries for CSS\n///\n/// @param {Number} $max - Maximum number of items to detect. The higher this number is, the more CSS that's required to cover each number of items.\n/// @param {Keyword} $elem [li] - Tag to use for sibling selectors.\n@mixin auto-width($max, $elem: li) {\n  @for $i from 2 through $max {\n    &:nth-last-child(#{$i}):first-child,\n    &:nth-last-child(#{$i}):first-child ~ #{$elem} {\n      width: percentage(1 / $i);\n    }\n  }\n}\n\n/// Removes the focus ring around an element when a mouse input is detected.\n@mixin disable-mouse-outline {\n  [data-whatinput='mouse'] & {\n    outline: 0;\n  }\n}\n\n/// Makes an element visually hidden, but still accessible to keyboards and assistive devices.\n/// @link http://snook.ca/archives/html_and_css/hiding-content-for-accessibility Hiding Content for Accessibility\n/// @link http://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n///\n/// @param {Boolean} $enforce - If `true`, use `!important` on applied properties\n@mixin element-invisible(\n  $enforce: true\n) {\n  $important: if($enforce, '!important', null);\n\n  position: absolute #{$important};\n  width: 1px #{$important};\n  height: 1px #{$important};\n  padding: 0 #{$important};\n  overflow: hidden #{$important};\n  clip: rect(0,0,0,0) #{$important};\n  white-space: nowrap #{$important};\n  border: 0 #{$important};\n}\n\n/// Reverses the CSS output created by the `element-invisible()` mixin.\n/// @param {Boolean} $enforce - If `true`, use `!important` on applied properties\n@mixin element-invisible-off(\n  $enforce: true\n) {\n  $important: if($enforce, '!important', null);\n\n  position: static #{$important};\n  width: auto #{$important};\n  height: auto #{$important};\n  overflow: visible #{$important};\n  clip: auto #{$important};\n  white-space: normal #{$important};\n}\n\n/// Vertically centers the element inside of its first non-static parent,\n/// @link http://www.sitepoint.com/centering-with-sass/ Centering With Sass\n@mixin vertical-center {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n/// Horizontally centers the element inside of its first non-static parent,\n/// @link http://www.sitepoint.com/centering-with-sass/ Centering With Sass\n@mixin horizontal-center {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n/// Absolutely centers the element inside of its first non-static parent,\n/// @link http://www.sitepoint.com/centering-with-sass/ Centering With Sass\n@mixin absolute-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/// Iterates through breakpoints defined in `$breakpoint-classes` and prints the CSS inside the mixin at each breakpoint's media query. Use this with the grid, or any other component that has responsive classes.\n///\n/// @param {Boolean} $small [true] - If `false`, the mixin will skip the `small` breakpoint. Use this with components that don't prefix classes with `small-`, only `medium-` and up.\n/// @param {Boolean} $auto-insert-breakpoints [true] - If `false`, the mixin will iterate over breakpoints without doing the media query itself. Useful for more complex media query generation as in the margin grid.\n@mixin -zf-each-breakpoint(\n  $small: true,\n  $auto-insert-breakpoints: true\n) {\n  @include -zf-each-breakpoint-in(auto, -zf-bool($small), -zf-bool($auto-insert-breakpoints)) {\n    @content\n  };\n}\n\n/// Iterates with `@content` through the given list of breakpoints `$breakpoints`.\n///\n/// @access private\n///\n/// @param {Keyword|List} $breakpoints [auto] - Breakpoints to iterates on. It can be a breakpoint name, list of breakpoints or `auto` for all breakpoints.\n/// @param {Boolean|Null} $zero-breakpoint [null] - Whether the zero-breakpoint (often `small`) must be included. If `true`, it will always be added to the list if not already there. If `false`, it will always be removed. Does nothing by default.\n/// @param {Boolean|Keyword} $media-queries [true] - Whether media-queries must be generated. If `for-lists`, only generate media-queries when `$breakpoints` is a list.\n@mixin -zf-each-breakpoint-in(\n  $breakpoints: auto,\n  $zero-breakpoint: null,\n  $media-queries: true\n) {\n  $-list: ();\n  $-breakpoints-is-a-list: true;\n\n  // Retrieve the list of breakpoint(s) to iterate on.\n  @if $breakpoints == auto {\n    $-list: $breakpoint-classes;\n  }\n  @else if type-of($breakpoints) == 'list' {\n    $-list: $breakpoints;\n  }\n  @else if type-of($breakpoints) == 'string' {\n    $-list: ($breakpoints);\n    $-breakpoints-is-a-list: false;\n  }\n  @else {\n    @error 'Wrong syntax for \"$breakpoints\" in \"-zf-each-breakpoint-in()\". Got \"#{$breakpoints}\" (#{type-of($breakpoints)}). Expected a breakpoint name, a list of breakpoints or \"auto\"';\n  }\n\n  // Add or remove the zero breakpoint according to `$zero-breakpoint`\n  @if $zero-breakpoint == true {\n    $-list: join(($-zf-zero-breakpoint), sl-remove($-list, $-zf-zero-breakpoint));\n  }\n  @else if $zero-breakpoint == false {\n    $-list: sl-remove($-list, $-zf-zero-breakpoint);\n  }\n\n  // Iterate on breakpoint(s)\n  @each $bp in $-list {\n    $old-zf-size: null;\n    @if global-variable-exists(-zf-size) {\n      $old-zf-size: $-zf-size;\n    }\n    $-zf-size: $bp !global;\n\n    @if ($media-queries == true\n      or ($media-queries == 'for-lists' and $-breakpoints-is-a-list)) {\n      @include breakpoint($bp) {\n        @content;\n      }\n    }\n    @else {\n      @content;\n    }\n\n    $-zf-size: $old-zf-size !global;\n  }\n}\n\n/// Generate the `@content` passed to the mixin with a value `$-zf-bp-value` related to a breakpoint, depending on the `$name` parameter:\n/// - For a single value, `$-zf-bp-value` is this value.\n/// - For a breakpoint name, `$-zf-bp-value` is the corresponding breakpoint value in `$map`.\n/// - For \"auto\", `$-zf-bp-value` is the corresponding breakpoint value in `$map` and is passed to `@content`, which is made responsive for each breakpoint of `$map`.\n/// @param {Number|Array|Keyword} $name [auto] - Single value, breakpoint name, or list of breakpoint names to use. \"auto\" by default.\n/// @param {Number|Map} $map - Map of breakpoints and values or single value to use.\n@mixin -zf-breakpoint-value(\n  $name: auto,\n  $map: null\n) {\n  @if $name == auto and type-of($map) == 'map' {\n    // \"auto\"\n    @each $k, $v in $map {\n      @include breakpoint($k) {\n        @include -zf-breakpoint-value($v, $map) {\n          @content;\n        }\n      }\n    }\n  }\n  @else {\n    // breakpoint name\n    @if type-of($name) == 'string' {\n      $bp-value: -zf-get-bp-val($map, $name);\n      @if $bp-value != null {\n        $name: $bp-value;\n      }\n    }\n\n    // breakpoint value\n    $-zf-bp-value: $name !global;\n    @content;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group forms\n////\n\n/// Font color of text inputs.\n/// @type Color\n$input-color: $black !default;\n\n/// Font color of placeholder text within text inputs.\n/// @type Color\n$input-placeholder-color: $medium-gray !default;\n\n/// Font family of text inputs.\n/// @type Font\n$input-font-family: inherit !default;\n\n/// Font size of text inputs.\n/// @type Number\n$input-font-size: rem-calc(16) !default;\n\n/// Font weight of text inputs.\n/// @type Keyword\n$input-font-weight: $global-weight-normal !default;\n\n/// Line height of text inputs.\n/// @type Keyword\n$input-line-height: $global-lineheight !default;\n\n/// Background color of text inputs.\n/// @type Color\n$input-background: $white !default;\n\n/// Background color of focused of text inputs.\n/// @type Color\n$input-background-focus: $white !default;\n\n/// Background color of disabled text inputs.\n/// @type Color\n$input-background-disabled: $light-gray !default;\n\n/// Border around text inputs.\n/// @type Border\n$input-border: 1px solid $medium-gray !default;\n\n/// Border around focused text inputs.\n/// @type Color\n$input-border-focus: 1px solid $dark-gray !default;\n\n/// Padding of text inputs.\n/// @type Color\n$input-padding: $form-spacing / 2 !default;\n\n/// Box shadow inside text inputs when not focused.\n/// @type Shadow\n$input-shadow: inset 0 1px 2px rgba($black, 0.1) !default;\n\n/// Box shadow outside text inputs when focused.\n/// @type Shadow\n$input-shadow-focus: 0 0 5px $medium-gray !default;\n\n/// Cursor to use when hovering over a disabled text input.\n/// @type Cursor\n$input-cursor-disabled: not-allowed !default;\n\n/// Properties to transition on text inputs.\n/// @type Transition\n$input-transition: box-shadow 0.5s, border-color 0.25s ease-in-out !default;\n\n/// Enables the up/down buttons that Chrome and Firefox add to `<input type='number'>` elements.\n/// @type Boolean\n$input-number-spinners: true !default;\n\n/// Radius for text inputs.\n/// @type Border\n$input-radius: $global-radius !default;\n\n/// Border radius for form buttons, defaulted to global-radius.\n/// @type Number\n$form-button-radius: $global-radius !default;\n\n@mixin form-element {\n  $height: ($input-font-size * unitless-calc($input-line-height)) + (get-side($input-padding, 'top') + get-side($input-padding, 'bottom')) - rem-calc(1);\n\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  height: $height;\n  margin: 0 0 $form-spacing;\n  padding: $input-padding;\n\n  border: $input-border;\n  border-radius: $input-radius;\n  background-color: $input-background;\n  box-shadow: $input-shadow;\n\n  font-family: $input-font-family;\n  font-size: $input-font-size;\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n\n  @if has-value($input-transition) {\n    transition: $input-transition;\n  }\n\n  // Focus state\n  &:focus {\n    outline: none;\n    border: $input-border-focus;\n    background-color: $input-background-focus;\n    box-shadow: $input-shadow-focus;\n\n    @if has-value($input-transition) {\n      transition: $input-transition;\n    }\n  }\n}\n\n@mixin foundation-form-text {\n  // Text inputs\n  #{text-inputs()},\n  textarea {\n    @include form-element;\n    appearance: none;\n  }\n\n  // Text areas\n  textarea {\n    max-width: 100%;\n\n    &[rows] {\n      height: auto;\n    }\n  }\n\n  input,\n  textarea {\n    // Disabled/readonly state\n    &:disabled,\n    &[readonly] {\n      background-color: $input-background-disabled;\n      cursor: $input-cursor-disabled;\n    }\n  }\n\n  // Reset styles on button-like inputs\n  [type='submit'],\n  [type='button'] {\n    appearance: none;\n    border-radius: $form-button-radius;\n  }\n\n  // Reset Normalize setting content-box to search elements\n  input[type='search'] { // sass-lint:disable-line no-qualifying-elements\n    box-sizing: border-box;\n  }\n\n  // Number input styles\n  [type='number'] {\n    @if not $input-number-spinners {\n      -moz-appearance: textfield; // sass-lint:disable-line no-vendor-prefixes\n\n      &::-webkit-inner-spin-button,\n      &::-webkit-outer-spin-button {\n        -webkit-appearance: none; // sass-lint:disable-line no-vendor-prefixes\n        margin: 0;\n      }\n    }\n  }\n\n  // Placeholder text\n  ::placeholder {\n    color: $input-placeholder-color;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group forms\n////\n\n@mixin foundation-form-checkbox {\n  [type='file'],\n  [type='checkbox'],\n  [type='radio'] {\n    margin: 0 0 $form-spacing;\n  }\n\n  // Styles for input/label siblings\n  [type='checkbox'] + label,\n  [type='radio'] + label {\n    display: inline-block;\n    vertical-align: baseline;\n\n    margin-#{$global-left}: $form-spacing * 0.5;\n    margin-#{$global-right}: $form-spacing;\n    margin-bottom: 0;\n\n    &[for] {\n      cursor: pointer;\n    }\n  }\n\n  // Styles for inputs inside labels\n  label > [type='checkbox'],\n  label > [type='radio'] {\n    margin-#{$global-right}: $form-spacing * 0.5;\n  }\n\n  // Normalize file input width\n  [type='file'] {\n    width: 100%;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group forms\n////\n\n/// Color for form labels.\n/// @type Color\n$form-label-color: $black !default;\n\n/// Font size for form labels.\n/// @type Number\n$form-label-font-size: rem-calc(14) !default;\n\n/// Font weight for form labels.\n/// @type Keyword\n$form-label-font-weight: $global-weight-normal !default;\n\n/// Line height for form labels. The higher the number, the more space between the label and its input field.\n/// @type Number\n$form-label-line-height: 1.8 !default;\n\n@mixin form-label {\n  display: block;\n  margin: 0;\n\n  font-size: $form-label-font-size;\n  font-weight: $form-label-font-weight;\n  line-height: $form-label-line-height;\n  color: $form-label-color;\n}\n\n@mixin form-label-middle {\n  $input-border-width: get-border-value($input-border, width);\n\n  margin: 0 0 $form-spacing;\n  padding: ($form-spacing / 2 + rem-calc($input-border-width)) 0;\n}\n\n@mixin foundation-form-label {\n  label {\n    @include form-label;\n\n    &.middle {\n      @include form-label-middle;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group forms\n////\n\n/// Default color for help text.\n/// @type Color\n$helptext-color: $black !default;\n\n/// Default font size for help text.\n/// @type Number\n$helptext-font-size: rem-calc(13) !default;\n\n/// Default font style for help text.\n/// @type Keyword\n$helptext-font-style: italic !default;\n\n@mixin foundation-form-helptext {\n  .help-text {\n    $margin-top: ($form-spacing * 0.5) * -1;\n\n    margin-top: $margin-top;\n    font-size: $helptext-font-size;\n    font-style: $helptext-font-style;\n    color: $helptext-color;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group forms\n////\n\n/// Color of labels prefixed to an input.\n/// @type Color\n$input-prefix-color: $black !default;\n\n/// Background color of labels prefixed to an input.\n/// @type Color\n$input-prefix-background: $light-gray !default;\n\n/// Border around labels prefixed to an input.\n/// @type Border\n$input-prefix-border: 1px solid $medium-gray !default;\n\n/// Left/right padding of an pre/postfixed input label\n$input-prefix-padding: 1rem !default;\n\n@mixin foundation-form-prepostfix {\n  $height: ($input-font-size * $input-line-height) + (get-side($input-padding, 'top') + get-side($input-padding, 'bottom')) - rem-calc(1);\n\n  .input-group {\n    display: if($global-flexbox, flex, table);\n    width: 100%;\n    margin-bottom: $form-spacing;\n\n    @if $global-flexbox {\n      align-items: stretch;\n    }\n\n    > :first-child {\n      &, &.input-group-button > * {\n        border-radius: if($global-text-direction == rtl, 0 $input-radius $input-radius 0, $input-radius 0 0 $input-radius);\n      }\n    }\n\n    > :last-child {\n      &, &.input-group-button > * {\n        border-radius: if($global-text-direction == rtl, $input-radius 0 0 $input-radius, 0 $input-radius $input-radius 0);\n      }\n    }\n  }\n\n  %input-group-child {\n    margin: 0;\n    white-space: nowrap;\n\n    @if not $global-flexbox {\n      display: table-cell;\n      vertical-align: middle;\n    }\n  }\n\n  .input-group-label {\n    @extend %input-group-child;\n    padding: 0 $input-prefix-padding;\n    border: $input-prefix-border;\n    background: $input-prefix-background;\n\n    color: $input-prefix-color;\n    text-align: center;\n    white-space: nowrap;\n\n    @if $global-flexbox {\n      display: flex;\n      flex: 0 0 auto;\n      align-items: center;\n    }\n    @else {\n      width: 1%;\n      height: 100%;\n    }\n\n    @if has-value($input-prefix-border) {\n      &:first-child {\n        border-#{$global-right}: 0;\n      }\n\n      &:last-child {\n        border-#{$global-left}: 0;\n      }\n    }\n  }\n\n  .input-group-field {\n    @extend %input-group-child;\n    border-radius: 0;\n\n    @if $global-flexbox {\n      flex: 1 1 0px; // sass-lint:disable-line zero-unit\n      min-width: 0;\n    }\n  }\n\n  .input-group-button {\n    @extend %input-group-child;\n    padding-top: 0;\n    padding-bottom: 0;\n    text-align: center;\n\n    @if $global-flexbox {\n      display: flex;\n      flex: 0 0 auto;\n    }\n    @else {\n      width: 1%;\n      height: 100%;\n    }\n\n    a,\n    input,\n    button,\n    label {\n      @extend %input-group-child;\n\n      @if $global-flexbox {\n        align-self: stretch;\n        height: auto;\n      }\n      @else {\n        height: $height;\n      }\n      padding-top: 0;\n      padding-bottom: 0;\n      font-size: $input-font-size;\n    }\n  }\n\n  // Specificity bump needed to prevent override by buttons\n  @if not $global-flexbox {\n    .input-group {\n      .input-group-button {\n        display: table-cell;\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group forms\n////\n\n/// Default border around custom fieldsets.\n/// @type Border\n$fieldset-border: 1px solid $medium-gray !default;\n\n/// Default padding inside custom fieldsets.\n/// @type Number\n$fieldset-padding: rem-calc(20) !default;\n\n/// Default margin around custom fieldsets.\n/// @type Number\n$fieldset-margin: rem-calc(18 0) !default;\n\n/// Default padding between the legend text and fieldset border.\n/// @type Number\n$legend-padding: rem-calc(0 3) !default;\n\n@mixin fieldset {\n  margin: $fieldset-margin;\n  padding: $fieldset-padding;\n  border: $fieldset-border;\n\n  legend {\n    // Covers up the fieldset's border to create artificial padding\n    margin: 0;\n    margin-#{$global-left}: rem-calc(-3);\n    padding: $legend-padding;\n  }\n}\n\n@mixin foundation-form-fieldset {\n  fieldset {\n    margin: 0;\n    padding: 0;\n    border: 0;\n  }\n\n  legend {\n    max-width: 100%;\n    margin-bottom: $form-spacing * 0.5;\n  }\n\n  .fieldset {\n    @include fieldset;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group forms\n////\n\n/// Background color for select menus.\n/// @type Color\n$select-background: $white !default;\n\n/// Color of the dropdown triangle inside select menus. Set to `transparent` to remove it entirely.\n/// @type Color\n$select-triangle-color: $dark-gray !default;\n\n/// Default radius for select menus.\n/// @type Color\n$select-radius: $global-radius !default;\n\n@mixin form-select {\n  $height: ($input-font-size * unitless-calc($input-line-height)) + (get-side($input-padding, 'top') + get-side($input-padding, 'bottom')) - rem-calc(1);\n\n  height: $height;\n  margin: 0 0 $form-spacing;\n  padding: $input-padding;\n\n  appearance: none;\n  border: $input-border;\n  border-radius: $select-radius;\n  background-color: $select-background;\n\n  font-family: $input-font-family;\n  font-size: $input-font-size;\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n\n  @if $select-triangle-color != transparent {\n    @include background-triangle($select-triangle-color);\n    background-origin: content-box;\n    background-position: $global-right (-$form-spacing) center;\n    background-repeat: no-repeat;\n    background-size: 9px 6px;\n\n    padding-#{$global-right}: ($form-spacing * 1.5);\n  }\n\n  @if has-value($input-transition) {\n    transition: $input-transition;\n  }\n\n  // Focus state\n  &:focus {\n    outline: none;\n    border: $input-border-focus;\n    background-color: $input-background-focus;\n    box-shadow: $input-shadow-focus;\n\n    @if has-value($input-transition) {\n      transition: $input-transition;\n    }\n  }\n\n  // Disabled state\n  &:disabled {\n    background-color: $input-background-disabled;\n    cursor: $input-cursor-disabled;\n  }\n\n  // Hide the dropdown arrow shown in newer IE versions\n  &::-ms-expand {\n    display: none;\n  }\n\n  &[multiple] {\n    height: auto;\n    background-image: none;\n  }\n  &:not([multiple]) {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n}\n\n@mixin foundation-form-select {\n  select {\n    @include form-select;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group abide\n////\n\n/// Sets if error styles should be added to inputs.\n/// @type Boolean\n$abide-inputs: true !default;\n\n/// Sets if error styles should be added to labels.\n/// @type Boolean\n$abide-labels: true !default;\n\n/// Background color to use for invalid text inputs.\n/// @type Color\n$input-background-invalid: get-color(alert) !default;\n\n/// Color to use for labels of invalid inputs.\n/// @type Color\n$form-label-color-invalid: get-color(alert) !default;\n\n/// Default font color for form error text.\n/// @type Color\n$input-error-color: get-color(alert) !default;\n\n/// Default font size for form error text.\n/// @type Number\n$input-error-font-size: rem-calc(12) !default;\n\n/// Default font weight for form error text.\n/// @type Keyword\n$input-error-font-weight: $global-weight-bold !default;\n\n/// Styles the background and border of an input field to have an error state.\n///\n/// @param {Color} $background [$alert-color] - Color to use for the background and border.\n/// @param {Number} $background-lighten [10%] - Lightness level of the background color.\n@mixin form-input-error(\n  $background: $input-background-invalid,\n  $background-lighten: 10%\n) {\n  &:not(:focus) {\n    border-color: $background;\n    background-color: mix($background, $white, $background-lighten);\n\n    &::placeholder {\n      color: $background;\n    }\n  }\n}\n\n/// Adds error styles to a form element, using the values in the settings file.\n@mixin form-error {\n  display: none;\n  margin-top: $form-spacing * -0.5;\n  margin-bottom: $form-spacing;\n\n  font-size: $input-error-font-size;\n  font-weight: $input-error-font-weight;\n  color: $input-error-color;\n}\n\n@mixin foundation-form-error {\n  @if $abide-inputs {\n    // Error class for invalid inputs\n    .is-invalid-input {\n      @include form-input-error;\n    }\n  }\n\n  @if $abide-labels {\n    // Error class for labels of invalid outputs\n    .is-invalid-label {\n      color: $form-label-color-invalid;\n    }\n  }\n\n  // Form error element\n  .form-error {\n    @include form-error;\n\n    &.is-visible {\n      display: block;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group typography-base\n////\n\n// Base Typography\n// - - - - - - - - - - - - - - -\n// These are styles applied to basic HTML tags, including:\n//   - Paragraphs <p>\n//   - Bold/italics <b> <strong> <i> <em>\n//   - Small text <small>\n//   - Headings <h1>-<h6>\n//   - Anchors <a>\n//   - Dividers <hr>\n//   - Lists <ul> <ol> <dl>\n//   - Blockquotes <blockquote>\n//   - Code blocks <code>\n//   - Abbreviations <abbr>\n//   - Citations <cite>\n//   - Keystrokes <kbd>\n\n/// Font family for header elements.\n/// @type String | List\n$header-font-family: $body-font-family !default;\n\n/// Font weight of headers.\n/// @type String\n$header-font-weight: $global-weight-normal !default;\n\n/// Font style (e.g. italicized) of headers.\n/// @type String\n$header-font-style: normal !default;\n\n/// Font stack used for elements that use monospaced type, such as code samples\n/// @type String | List\n$font-family-monospace: Consolas, 'Liberation Mono', Courier, monospace !default;\n\n/// Color of headers.\n/// @type Color\n$header-color: inherit !default;\n\n/// Line height of headers.\n/// @type Number\n$header-lineheight: 1.4 !default;\n\n/// Bottom margin of headers.\n/// @type Number\n$header-margin-bottom: 0.5rem !default;\n\n/// Styles for headings at various screen sizes. Each key is a breakpoint, and each value is a map of heading styles.\n/// @type Map\n$header-styles: (\n  small: (\n    'h1': ('font-size': 24),\n    'h2': ('font-size': 20),\n    'h3': ('font-size': 19),\n    'h4': ('font-size': 18),\n    'h5': ('font-size': 17),\n    'h6': ('font-size': 16),\n  ),\n  medium: (\n    'h1': ('font-size': 48),\n    'h2': ('font-size': 40),\n    'h3': ('font-size': 31),\n    'h4': ('font-size': 25),\n    'h5': ('font-size': 20),\n    'h6': ('font-size': 16),\n  ),\n) !default;\n\n// $header-styles map is built from $header-sizes in order to ensure downward compatibility\n// when $header-sizes is depreciated, $header-styles needs to get !default values like settings.scss\n@function build_from_header-sizes($header-sizes) {\n  @warn 'Note, that $header-sizes has been replaced with $header-styles. $header-sizes still works, but it is going to be depreciated.';\n  $header-styles: ();\n  @each $size, $headers in $header-sizes {\n    $header-map: ();\n    @each $header, $font-size in $headers {\n      $header-map: map-merge($header-map, ($header: ('font-size': $font-size)));\n    }\n    $header-styles: map-merge($header-styles, ($size: $header-map));\n  }\n  @return $header-styles;\n}\n\n// If it exists $headers-sizes is used to build $header-styles. See the documentation.\n@if variable-exists(header-sizes) {\n  $header-styles: build_from_header-sizes($header-sizes);\n}\n\n/// Text rendering method of headers.\n/// @type String\n$header-text-rendering: optimizeLegibility !default;\n\n/// Font size of `<small>` elements.\n/// @type Number\n$small-font-size: 80% !default;\n\n/// Color of `<small>` elements when placed inside headers.\n/// @type Color\n$header-small-font-color: $medium-gray !default;\n\n/// Line height of text inside `<p>` elements.\n/// @type Number\n$paragraph-lineheight: 1.6 !default;\n\n/// Bottom margin of paragraphs.\n/// @type Number\n$paragraph-margin-bottom: 1rem !default;\n\n/// Text rendering method for paragraph text.\n/// @type String\n$paragraph-text-rendering: optimizeLegibility !default;\n\n/// Use the `.code-inline` component as default for `<code>` elements.\n/// @type Boolean\n$enable-code-inline: true;\n\n/// Default color for links.\n/// @type Color\n$anchor-color: $primary-color !default;\n\n/// Default color for links on hover.\n/// @type Color\n$anchor-color-hover: scale-color($anchor-color, $lightness: -14%) !default;\n\n/// Default text decoration for links.\n/// @type String\n$anchor-text-decoration: none !default;\n\n/// Default text decoration for links on hover.\n/// @type String\n$anchor-text-decoration-hover: none !default;\n\n/// Maximum width of a divider.\n/// @type Number\n$hr-width: $global-width !default;\n\n/// Default border for a divider.\n/// @type List\n$hr-border: 1px solid $medium-gray !default;\n\n/// Default margin for a divider.\n/// @type Number | List\n$hr-margin: rem-calc(20) auto !default;\n\n/// Line height for items in a list.\n/// @type Number\n$list-lineheight: $paragraph-lineheight !default;\n\n/// Bottom margin for items in a list.\n/// @type Number\n$list-margin-bottom: $paragraph-margin-bottom !default;\n\n/// Bullet type to use for unordered lists (e.g., `square`, `circle`, `disc`).\n/// @type String\n$list-style-type: disc !default;\n\n/// Positioning for bullets on unordered list items.\n/// @type String\n$list-style-position: outside !default;\n\n/// Left (or right) margin for lists.\n/// @type Number\n$list-side-margin: 1.25rem !default;\n\n/// Left (or right) margin for a list inside a list.\n/// @type Number\n$list-nested-side-margin: 1.25rem !default;\n\n/// Bottom margin for `<dl>` elements.\n/// @type Number\n$defnlist-margin-bottom: 1rem !default;\n\n/// Font weight for `<dt>` elements.\n/// @type String\n$defnlist-term-weight: $global-weight-bold !default;\n\n/// Spacing between `<dt>` and `<dd>` elements.\n/// @type Number\n$defnlist-term-margin-bottom: 0.3rem !default;\n\n/// Text color of `<blockquote>` elements.\n/// @type Color\n$blockquote-color: $dark-gray !default;\n\n/// Padding inside a `<blockquote>` element.\n/// @type Number | List\n$blockquote-padding: rem-calc(9 20 0 19) !default;\n\n/// Side border for `<blockquote>` elements.\n/// @type List\n$blockquote-border: 1px solid $medium-gray !default;\n\n/// Use the `.cite-block` component as default for `<cite>` elements.\n/// @type Boolean\n$enable-cite-block: true;\n\n/// Font family for `<kbd>` elements.\n/// @type String | List\n$keystroke-font: $font-family-monospace !default;\n\n/// Text color for `<kbd>` elements.\n/// @type Color\n$keystroke-color: $black !default;\n\n/// Background color for `<kbd>` elements.\n/// @type Color\n$keystroke-background: $light-gray !default;\n\n/// Padding for `<kbd>` elements.\n/// @type Number | List\n$keystroke-padding: rem-calc(2 4 0) !default;\n\n/// Border radius for `<kbd>` elements.\n/// @type Number | List\n$keystroke-radius: $global-radius !default;\n\n/// Bottom border style for `<abbr>` elements.\n/// @type List\n$abbr-underline: 1px dotted $black !default;\n\n@mixin foundation-typography-base {\n  // Typography resets\n  div,\n  dl,\n  dt,\n  dd,\n  ul,\n  ol,\n  li,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  pre,\n  form,\n  p,\n  blockquote,\n  th,\n  td {\n    margin: 0;\n    padding: 0;\n  }\n\n  // Paragraphs\n  p {\n    margin-bottom: $paragraph-margin-bottom;\n\n    font-size: inherit;\n    line-height: $paragraph-lineheight;\n    text-rendering: $paragraph-text-rendering;\n  }\n\n  // Emphasized text\n  em,\n  i {\n    font-style: italic;\n    line-height: inherit;\n  }\n\n  // Strong text\n  strong,\n  b {\n    font-weight: $global-weight-bold;\n    line-height: inherit;\n  }\n\n  // Small text\n  small {\n    font-size: $small-font-size;\n    line-height: inherit;\n  }\n\n  // Headings\n  h1, .h1,\n  h2, .h2,\n  h3, .h3,\n  h4, .h4,\n  h5, .h5,\n  h6, .h6 {\n    font-family: $header-font-family;\n    font-style: $header-font-style;\n    font-weight: $header-font-weight;\n    color: $header-color;\n    text-rendering: $header-text-rendering;\n\n    small {\n      line-height: 0;\n      color: $header-small-font-color;\n    }\n  }\n\n  // Heading styles\n  @each $size, $headers in $header-styles {\n    @include breakpoint($size) {\n      @each $header, $header-defs in $headers {\n        $font-size-temp: 1rem;\n        #{$header}, .#{$header} {\n\n          @if map-has-key($header-defs, font-size) {\n            $font-size-temp: rem-calc(map-get($header-defs, font-size));\n            font-size: $font-size-temp;\n          } @else if map-has-key($header-defs, fs) {\n            $font-size-temp: rem-calc(map-get($header-defs, fs));\n            font-size: $font-size-temp;\n          } @else if $size == $-zf-zero-breakpoint {\n            font-size: $font-size-temp;\n          }\n          @if map-has-key($header-defs, line-height) {\n            line-height: unitless-calc(map-get($header-defs, line-height), $font-size-temp);\n          } @else if map-has-key($header-defs, lh) {\n            line-height: unitless-calc(map-get($header-defs, lh), $font-size-temp);\n          } @else if $size == $-zf-zero-breakpoint {\n            line-height: unitless-calc($header-lineheight, $font-size-temp);\n          }\n\n          @if map-has-key($header-defs, margin-top) {\n            margin-top: rem-calc(map-get($header-defs, margin-top));\n          } @else if map-has-key($header-defs, mt) {\n            margin-top: rem-calc(map-get($header-defs, mt));\n          } @else if $size == $-zf-zero-breakpoint {\n            margin-top: 0;\n          }\n          @if map-has-key($header-defs, margin-bottom) {\n            margin-bottom: rem-calc(map-get($header-defs, margin-bottom));\n          } @else if map-has-key($header-defs, mb) {\n            margin-bottom: rem-calc(map-get($header-defs, mb));\n          } @else if $size == $-zf-zero-breakpoint {\n            margin-bottom: rem-calc($header-margin-bottom);\n          }\n        }\n      }\n    }\n  }\n\n  // Links\n  a {\n    line-height: inherit;\n    color: $anchor-color;\n    text-decoration: $anchor-text-decoration;\n\n    cursor: pointer;\n\n    &:hover,\n    &:focus {\n      color: $anchor-color-hover;\n      @if $anchor-text-decoration-hover != $anchor-text-decoration {\n        text-decoration: $anchor-text-decoration-hover;\n      }\n    }\n\n    img {\n      border: 0;\n    }\n  }\n\n  // Horizontal rule\n  hr {\n    clear: both;\n\n    max-width: $hr-width;\n    height: 0;\n    margin: $hr-margin;\n\n    border-top: 0;\n    border-right: 0;\n    border-bottom: $hr-border;\n    border-left: 0;\n  }\n\n  // Lists\n  ul,\n  ol,\n  dl {\n    margin-bottom: $list-margin-bottom;\n    list-style-position: $list-style-position;\n    line-height: $list-lineheight;\n  }\n\n  // List items\n  li {\n    font-size: inherit;\n  }\n\n  // Unordered lists\n  ul {\n    margin-#{$global-left}: $list-side-margin;\n    list-style-type: $list-style-type;\n  }\n\n  // Ordered lists\n  ol {\n    margin-#{$global-left}: $list-side-margin;\n  }\n\n  // Nested unordered/ordered lists\n  ul, ol {\n    & & {\n      margin-#{$global-left}: $list-nested-side-margin;\n      margin-bottom: 0;\n    }\n  }\n\n  // Definition lists\n  dl {\n    margin-bottom: $defnlist-margin-bottom;\n\n    dt {\n      margin-bottom: $defnlist-term-margin-bottom;\n      font-weight: $defnlist-term-weight;\n    }\n  }\n\n  // Blockquotes\n  blockquote {\n    margin: 0 0 $paragraph-margin-bottom;\n    padding: $blockquote-padding;\n    border-#{$global-left}: $blockquote-border;\n\n    &, p {\n      line-height: $paragraph-lineheight;\n      color: $blockquote-color;\n    }\n  }\n\n  // Inline Citations\n  @if ($enable-cite-block == true) {\n    cite {\n      // Extending a class is not recommended.\n      // TODO: Break the typography-base/typography-helpers separation\n      @extend .cite-block;\n    }\n  }\n\n  // Abbreviations\n  abbr, abbr[title] {\n    border-bottom: $abbr-underline;\n    cursor: help;\n    text-decoration: none;\n  }\n\n  // Figures\n  figure {\n    margin: 0;\n  }\n\n  // Code\n  @if ($enable-code-inline == true) {\n    code {\n      @extend .code-inline;\n    }\n  }\n\n  // Keystrokes\n  kbd {\n    margin: 0;\n    padding: $keystroke-padding;\n\n    background-color: $keystroke-background;\n\n    font-family: $keystroke-font;\n    color: $keystroke-color;\n\n    @if has-value($keystroke-radius) {\n      border-radius: $keystroke-radius;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group typography-helpers\n////\n\n/// Default font size for lead paragraphs.\n/// @type Number\n$lead-font-size: $global-font-size * 1.25 !default;\n\n/// Default line height for lead paragraphs.\n/// @type String\n$lead-lineheight: 1.6 !default;\n\n/// Default line height for subheaders.\n/// @type Number\n$subheader-lineheight: 1.4 !default;\n\n/// Default font color for subheaders.\n/// @type Color\n$subheader-color: $dark-gray !default;\n\n/// Default font weight for subheaders.\n/// @type String\n$subheader-font-weight: $global-weight-normal !default;\n\n/// Default top margin for subheaders.\n/// @type Number\n$subheader-margin-top: 0.2rem !default;\n\n/// Default bottom margin for subheaders.\n/// @type Number\n$subheader-margin-bottom: 0.5rem !default;\n\n/// Default font size for statistic numbers.\n/// @type Number\n$stat-font-size: 2.5rem !default;\n\n/// Text color for `.cite-block` component.\n/// @type Color\n$cite-color: $dark-gray !default;\n\n/// Font size for `.cite-block` component.\n/// @type Number\n$cite-font-size: rem-calc(13) !default;\n\n/// Pseudo content for `.cite-block` component.\n/// @type String\n$cite-pseudo-content: '\\2014 \\0020' !default;\n\n/// Text color of `.code-inline` and `.code-block` components.\n/// @type Color\n$code-color: $black !default;\n\n/// Font family of `.code-inline` and `.code-block` components.\n/// @type String | List\n$code-font-family: $font-family-monospace !default;\n\n/// Font weight of text in `.code-inline` and `.code-block` components.\n/// @type String\n$code-font-weight: $global-weight-normal !default;\n\n/// Background color of `.code-inline` and `.code-block` components.\n/// @type Color\n$code-background: $light-gray !default;\n\n/// Border around `.code-inline` and `.code-block` components.\n/// @type List\n$code-border: 1px solid $medium-gray !default;\n\n/// Padding around text of the `.code-inline` component.\n/// @type Number | List\n$code-padding: rem-calc(2 5 1) !default;\n\n/// Padding around text of the `.code-block` component.\n/// @type Number | List\n$code-block-padding: 1rem !default;\n\n/// Margin under the `.code-block` component.\n/// @type Number\n$code-block-margin-bottom: 1.5rem !default;\n\n@mixin cite-block {\n  display: block;\n  color: $cite-color;\n  font-size: $cite-font-size;\n\n  &:before {\n    content: $cite-pseudo-content;\n  }\n}\n\n/// Add basic styles for a code helper.\n/// See `code-inline` and `code-block` mixins.\n@mixin code-style {\n  border: $code-border;\n  background-color: $code-background;\n\n  font-family: $code-font-family;\n  font-weight: $code-font-weight;\n  color: $code-color;\n}\n\n/// Make code helper from the `code-style` mixin inline.\n/// Used to generate `.code-inline`\n@mixin code-inline {\n  display: inline;\n  max-width: 100%;\n  word-wrap: break-word;\n\n  padding: $code-padding;\n}\n\n/// Make code helper from the `code-style` mixin a block.\n/// Used to generate `.code-block`\n@mixin code-block {\n  display: block;\n  overflow: auto;\n  white-space: pre;\n\n  padding: $code-block-padding;\n  margin-bottom: $code-block-margin-bottom;\n}\n\n@mixin foundation-typography-helpers {\n  // Use to create a subheading under a main header\n  // Make sure you pair the two elements in a <header> element, like this:\n  // <header>\n  //   <h1>Heading</h1>\n  //   <h2>Subheading</h2>\n  // </header>\n  .subheader {\n    margin-top: $subheader-margin-top;\n    margin-bottom: $subheader-margin-bottom;\n\n    font-weight: $subheader-font-weight;\n    line-height: $subheader-lineheight;\n    color: $subheader-color;\n  }\n\n  // Use to style an introductory lead, deck, blurb, etc.\n  .lead {\n    font-size: $lead-font-size;\n    line-height: $lead-lineheight;\n  }\n\n  // Use to style a large number to display a statistic\n  .stat {\n    font-size: $stat-font-size;\n    line-height: 1;\n\n    p + & {\n      margin-top: -1rem;\n    }\n  }\n\n  ul, ol {\n    // Use to remove numbers from ordered list & bullets from unordered list\n    &.no-bullet {\n      margin-#{$global-left}: 0;\n      list-style: none;\n    }\n  }\n\n  .cite-block {\n    @include cite-block;\n  }\n\n  .code-inline {\n    @include code-style;\n    @include code-inline;\n  }\n\n  .code-block {\n    @include code-style;\n    @include code-block;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n@mixin foundation-text-alignment {\n  @each $size in $breakpoint-classes {\n    @include breakpoint($size) {\n      @each $align in (left, right, center, justify) {\n        @if $size != $-zf-zero-breakpoint {\n          .#{$size}-text-#{$align} {\n            text-align: $align;\n          }\n        }\n        @else {\n          .text-#{$align} {\n            text-align: $align;\n          }\n        }\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n/// If `true`, all elements will have transparent backgrounds when printed, to save on ink.\n/// @type Boolean\n/// @group global\n$print-transparent-backgrounds: true !default;\n\n/// If `true`, displays next to all links their \"href\" when printed.\n/// @type Boolean\n/// @group global\n$print-hrefs: true !default;\n\n// sass-lint:disable-all\n\n@mixin foundation-print-styles {\n  .show-for-print { display: none !important; }\n\n  @media print {\n    * {\n      // Ensure a \"black-on-white\" print by removing backgrounds,\n      // using black text everywhere and forcing the browser to economize ink.\n      @if $print-transparent-backgrounds {\n        background: transparent !important;\n        color: black !important; // Black prints faster: h5bp.com/s\n        color-adjust: economy;\n      }\n      // Otherwise, prevent any economy by the browser.\n      @else {\n        color-adjust: exact;\n      }\n\n      box-shadow: none !important;\n      text-shadow: none !important;\n    }\n\n    .show-for-print { display: block !important; }\n    .hide-for-print { display: none !important; }\n\n    table.show-for-print { display: table !important; }\n    thead.show-for-print { display: table-header-group !important; }\n    tbody.show-for-print { display: table-row-group !important; }\n    tr.show-for-print { display: table-row !important; }\n    td.show-for-print { display: table-cell !important; }\n    th.show-for-print { display: table-cell !important; }\n\n    // Display the URL of a link after the text\n    a,\n    a:visited { text-decoration: underline;}\n    @if $print-hrefs {\n      a[href]:after { content: ' (' attr(href) ')'; }\n    }\n\n    // Don't display the URL for images or JavaScript/internal links\n    .ir a:after,\n    a[href^='javascript:']:after,\n    a[href^='#']:after { content: ''; }\n\n    // Display what an abbreviation stands for after the text\n    abbr[title]:after { content: ' (' attr(title) ')'; }\n\n    // Prevent page breaks in the middle of a blockquote or preformatted text block\n    pre,\n    blockquote {\n      border: 1px solid $dark-gray;\n      page-break-inside: avoid;\n    }\n\n    // h5bp.com/t\n    thead { display: table-header-group; }\n\n    tr,\n    img { page-break-inside: avoid; }\n\n    img { max-width: 100% !important; }\n\n    @page { margin: 0.5cm; }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    // Avoid page breaks after a heading\n    h2,\n    h3 { page-break-after: avoid; }\n\n    // Helper to re-allow page breaks in the middle of certain elements (e.g. pre, blockquote, tr)\n    .print-break-inside {\n      page-break-inside: auto;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n// Margin Grid classes\n@mixin xy-base-grid-classes {\n\n  // Grid Container\n  .grid-container {\n    @include xy-grid-container;\n\n    &.fluid {\n      @include xy-grid-container(100%);\n    }\n\n    &.full {\n      @include xy-grid-container(100%, 0);\n    }\n  }\n\n  // Base grid styles\n  .grid-x {\n    @include xy-grid;\n  }\n\n  .cell {\n    @include xy-cell(full, $gutter-type: none);\n\n    &.auto {\n      @include xy-cell-base(auto);\n    }\n\n    &.shrink {\n      @include xy-cell-base(shrink);\n    }\n\n  }\n  .grid-x {\n    > .auto {\n      @include xy-cell-size(auto, $gutter-type: none);\n    }\n\n    > .shrink {\n      @include xy-cell-size(shrink, $gutter-type: none);\n    }\n  }\n\n  // Auto width\n  @include -zf-each-breakpoint() {\n    // This is a bit of a hack/workaround, see these issues & PRs for the backstory:\n    // https://github.com/foundation/foundation-sites/issues/10244\n    // https://github.com/foundation/foundation-sites/pull/10222 and\n    // https://github.com/foundation/foundation-sites/pull/10164\n    .grid-x {\n      $str: \"> .#{$-zf-size}-shrink, > .#{$-zf-size}-full\";\n      @for $i from 1 through $grid-columns {\n        $str: $str + \", > .#{$-zf-size}-#{$i}\"\n      }\n      #{$str} {\n        flex-basis: auto;\n      }\n    }\n  }\n\n  @include -zf-each-breakpoint() {\n    // Responsive \"auto\" modifier\n    @if not($-zf-size == $-zf-zero-breakpoint) {\n      .grid-x > .#{$-zf-size}-auto {\n        @include xy-cell(auto, $gutter-type: none);\n      }\n    }\n\n    %-xy-cell-base-shrink-horizontal-#{$-zf-size} {\n      @include xy-cell-base(shrink);\n    }\n\n    // Responsive \"shrink\" modifier\n    @if not($-zf-size == $-zf-zero-breakpoint) {\n      .grid-x > .#{$-zf-size}-shrink {\n        @extend %-xy-cell-base-shrink-horizontal-#{$-zf-size};\n        @include xy-cell-size(shrink, $gutter-type: none);\n      }\n    }\n\n    // Responsive width modifiers\n    @for $i from 1 through $grid-columns {\n      // Sizing (percentage)\n      .grid-x > .#{$-zf-size}-#{$i} {\n        @extend %-xy-cell-base-shrink-horizontal-#{$-zf-size};\n        @include xy-cell-size($i, $gutter-type: none);\n      }\n    }\n  }\n\n  // Reset width when using `.grid-margin-x` not on `.grid-x`\n  .grid-margin-x:not(.grid-x) > .cell {\n    width: auto;\n  }\n\n  // Reset height when using `.grid-margin-y` not on `.grid-y`\n  .grid-margin-y:not(.grid-y) > .cell {\n    height: auto;\n  }\n}\n\n@mixin -xy-breakpoint-cell-classes($class-breakpoint, $gutter-breakpoint, $vertical) {\n  $prefix: if($class-breakpoint == $-zf-zero-breakpoint, '', '#{$class-breakpoint}-');\n  > .#{$prefix}auto {\n    @include xy-cell-size(auto, $vertical: $vertical);\n  }\n\n  > .#{$prefix}shrink {\n    @include xy-cell-size(shrink, $vertical: $vertical);\n  }\n\n  @for $i from 1 through $grid-columns {\n    // Sizing (percentage)\n    $classname: if($vertical, '.#{$class-breakpoint}-#{$i}', '.#{$class-breakpoint}-#{$i}');\n\n    > #{$classname} {\n      @include xy-cell-size($i, $vertical: $vertical);\n    }\n  }\n}\n\n// Margin Grid classes\n@mixin xy-margin-grid-classes(\n  $gutter-position: left right,\n  $vertical: false,\n  $wrapping-selector: '.grid-margin-x'\n){\n  #{$wrapping-selector} {\n    @include xy-gutters($negative: true, $gutter-position: $gutter-position);\n\n    // Base cell styles\n    > .cell {\n      @include xy-cell($vertical: $vertical, $output: (size gutters));\n    }\n\n    // base styles need to all be before the auto and shrink styles\n    @include -zf-each-breakpoint() {\n      @if(type-of($grid-margin-gutters) == 'map' and map-has-key($grid-margin-gutters, $-zf-size) and $-zf-size != $-zf-zero-breakpoint) {\n        > .cell {\n          @include xy-cell($vertical: $vertical, $output: (size gutters));\n        }\n      }\n    }\n\n    @include -zf-each-breakpoint() {\n\n      // This is purely for responsive gutters - the margin grid has to go back and adjust widths (or heights)\n      // for all prior breakpoints.\n      // As their gutter is defined with their width/height, even breakpoint without a new margin must be\n      // generated to not having their width/height overrided by re-adjusted smaller breakpoints.\n      @if(type-of($grid-margin-gutters) == 'map' and map-has-key($grid-margin-gutters, $-zf-size)) {\n        @each $bp in -zf-breakpoints-less-than($-zf-size) {\n          @include -xy-breakpoint-cell-classes($bp, $-zf-size, $vertical);\n        }\n      }\n\n      @include -xy-breakpoint-cell-classes($-zf-size, $-zf-size, $vertical);\n    }\n  }\n}\n\n// Padding Grid classes\n@mixin xy-padding-grid-classes {\n  .grid-padding-x {\n\n    // Negative margin for nested grids\n    .grid-padding-x {\n      @include xy-gutters($negative: true);\n    }\n\n    // Negative margin for grids within `grid-container/grid-container.fluid`\n    // This allows margin and padding grids to line up with eachother\n    .grid-container:not(.full) > & {\n      @include xy-gutters($negative: true);\n    }\n\n    // Base cell styles\n    > .cell {\n      @include xy-gutters($gutters: $grid-padding-gutters, $gutter-type: padding);\n    }\n  }\n}\n\n// Block Grid classes\n@mixin xy-block-grid-classes($margin-grid: true, $padding-grid: true) {\n  @if $padding-grid {\n    @include -zf-each-breakpoint {\n      @for $i from 1 through $xy-block-grid-max {\n        .#{$-zf-size}-up-#{$i} {\n          @include xy-grid-layout($n: $i, $selector: '.cell', $gutter-type: padding, $output: (size));\n        }\n      }\n    }\n  }\n\n  @if $margin-grid {\n    @include -zf-each-breakpoint {\n      @for $i from 1 through $xy-block-grid-max {\n        // This is purely for responsive gutters - the margin grid has to go back and adjust widths (or heights)\n        // for prior breakpoints based on the responsive gutter.\n        @if(type-of($grid-margin-gutters) == 'map' and map-has-key($grid-margin-gutters, $-zf-size)) {\n          @each $bp in -zf-breakpoints-less-than($-zf-size) {\n            @if(map-has-key($grid-margin-gutters, $bp)) {\n              .grid-margin-x.#{$bp}-up-#{$i} {\n                @include xy-grid-layout($n: $i, $selector: '.cell', $gutter-type: margin, $output: (size));\n              }\n            }\n          }\n        }\n      }\n      @for $i from 1 through $xy-block-grid-max {\n        .grid-margin-x.#{$-zf-size}-up-#{$i} {\n          @include xy-grid-layout($n: $i, $selector: '.cell', $gutter-type: margin, $output: (size));\n        }\n      }\n    }\n  }\n}\n\n// Collapse classes\n@mixin xy-collapse-grid-classes($margin-grid: true, $padding-grid: true) {\n  @each $bp in $breakpoint-classes {\n    @if $margin-grid {\n      .#{$bp}-margin-collapse {\n        @include xy-grid-collapse($gutter-type: margin, $min-breakpoint: $bp);\n      }\n    }\n\n    @if $padding-grid {\n      .#{$bp}-padding-collapse {\n        @include xy-grid-collapse($gutter-type: padding, $min-breakpoint: $bp);\n      }\n    }\n  }\n}\n\n// Offset classes\n@mixin xy-offset-cell-classes {\n  @include -zf-each-breakpoint {\n    @for $i from 1 through $grid-columns {\n      // Offsets\n      $o: $i - 1;\n\n      .#{$-zf-size}-offset-#{$o} {\n        @include xy-cell-offset($o, $gutters: $grid-padding-gutters, $gutter-type: padding);\n      }\n\n      .grid-margin-x > .#{$-zf-size}-offset-#{$o} {\n        @include xy-cell-offset($o);\n      }\n    }\n  }\n}\n\n// Vertical Grid classes\n@mixin xy-vertical-grid-classes(\n  $margin-grid: true,\n  $padding-grid: true\n) {\n\n  @include -zf-each-breakpoint() {\n    @if not($-zf-size == $-zf-zero-breakpoint) {\n    }\n  }\n\n  .grid-y {\n    @include xy-grid(vertical, false);\n\n\n    > .cell {\n      @include xy-cell-reset();\n    }\n\n    > .auto {\n      @include xy-cell-size(auto, $gutter-type: none, $vertical: true);\n    }\n\n    > .shrink {\n      @include xy-cell-size(shrink, $gutter-type: none, $vertical: true);\n    }\n\n\n    @include -zf-each-breakpoint() {\n      // This is a bit of a hack/workaround, see these issues and PRs for the backstory:\n      // https://github.com/foundation/foundation-sites/issues/10244\n      // https://github.com/foundation/foundation-sites/pull/10222 and\n      // https://github.com/foundation/foundation-sites/pull/10164\n      $str: \"> .#{$-zf-size}-shrink, > .#{$-zf-size}-full\";\n      @for $i from 1 through $grid-columns {\n        $str: $str + \", > .#{$-zf-size}-#{$i}\"\n      }\n      #{$str} {\n        flex-basis: auto;\n      }\n    }\n\n    @include -zf-each-breakpoint() {\n      // Responsive \"auto\" modifier\n      @if not($-zf-size == $-zf-zero-breakpoint) {\n        > .#{$-zf-size}-auto {\n          @include xy-cell(auto, $gutter-type: none, $vertical: true);\n        }\n      }\n\n      %-xy-cell-base-shrink-vertical-#{$-zf-size} {\n        @include xy-cell-base(shrink);\n      }\n\n      // Responsive \"shrink\" modifier\n      @if not($-zf-size == $-zf-zero-breakpoint) {\n        > .#{$-zf-size}-shrink {\n          @extend %-xy-cell-base-shrink-vertical-#{$-zf-size};\n          @include xy-cell-size(shrink, $gutter-type: none, $vertical: true);\n        }\n      }\n\n      // Responsive width modifiers\n      @for $i from 1 through $grid-columns {\n        // Sizing (percentage)\n        > .#{$-zf-size}-#{$i} {\n          @extend %-xy-cell-base-shrink-vertical-#{$-zf-size};\n          @include xy-cell-size($i, $gutter-type: none, $vertical: true);\n        }\n      }\n\n    }\n  }\n\n  @if $padding-grid {\n    .grid-padding-y {\n      // Negative margin for nested grids\n      .grid-padding-y {\n        @include xy-gutters($negative: true, $gutter-position: top bottom);\n      }\n\n      // Base cell styles\n      > .cell {\n        @include xy-gutters($gutters: $grid-padding-gutters, $gutter-type: padding, $gutter-position: top bottom);\n      }\n    }\n  }\n\n  @if $margin-grid {\n    @include xy-margin-grid-classes(top bottom, true, '.grid-margin-y');\n  }\n\n}\n\n@mixin xy-frame-grid-classes($vertical-grid: true, $margin-grid: true) {\n  // Framed grid styles\n  .grid-frame {\n    @include xy-grid-frame;\n  }\n\n  .cell .grid-frame {\n    width: 100%; // Same as include with $nested, but with less css\n  }\n\n  .cell-block {\n    @include xy-cell-block();\n  }\n\n  .cell-block-y {\n    @include xy-cell-block(true);\n  }\n\n\n  .cell-block-container {\n    @include xy-cell-block-container();\n  }\n\n\n  @include -zf-each-breakpoint(false) {\n\n    .#{$-zf-size}-grid-frame {\n      @include xy-grid-frame;\n    }\n\n    .cell .#{$-zf-size}-grid-frame {\n      width: 100%; // Same as include with $nested, but with less css\n    }\n\n    .#{$-zf-size}-cell-block {\n      @include xy-cell-block();\n    }\n\n    .#{$-zf-size}-cell-block-container {\n      @include xy-cell-block-container();\n    }\n\n    .#{$-zf-size}-cell-block-y {\n      @include xy-cell-block(true);\n    }\n  }\n\n  @if $vertical-grid {\n    .grid-y {\n      &.grid-frame {\n        width: auto;\n        @include xy-grid-frame(true);\n      }\n\n      @include -zf-each-breakpoint(false) {\n        &.#{$-zf-size}-grid-frame {\n          width: auto;\n          @include xy-grid-frame(true);\n        }\n\n      }\n    }\n    .cell {\n      .grid-y.grid-frame {\n        height: 100%; // Same as include with $nested, but with less css\n      }\n      @include -zf-each-breakpoint(false) {\n        .grid-y.#{$-zf-size}-grid-frame {\n          height: 100%; // Same as include with $nested, but with less css\n        }\n      }\n    }\n  }\n  @if $margin-grid {\n    @include xy-margin-grid-classes(top bottom, true, '.grid-margin-y');\n    .grid-frame.grid-margin-y {\n      @include xy-grid-frame(true, false, $grid-margin-gutters, $include-base: false);\n    }\n    @include -zf-each-breakpoint(false) {\n      .grid-margin-y.#{$-zf-size}-grid-frame {\n        @include xy-grid-frame(true, false, $grid-margin-gutters, $-zf-size, false);\n      }\n    }\n  }\n}\n\n// Final classes\n@mixin foundation-xy-grid-classes(\n  $base-grid: true,\n  $margin-grid: true,\n  $padding-grid: true,\n  $block-grid: true,\n  $collapse: true,\n  $offset: true,\n  $vertical-grid: true,\n  $frame-grid: true\n) {\n\n  // Base grid styles\n  @if($base-grid) {\n    @include xy-base-grid-classes();\n  }\n\n  // Margin grid\n  @if($margin-grid) {\n    @include xy-margin-grid-classes();\n  }\n\n  // Padding grid\n  @if($padding-grid) {\n    @include xy-padding-grid-classes();\n  }\n\n  // Block grid\n  @if($block-grid) {\n    @include xy-block-grid-classes($margin-grid, $padding-grid);\n  }\n\n  // Collapse gutters\n  @if($collapse) {\n    @include xy-collapse-grid-classes($margin-grid, $padding-grid);\n  }\n\n  // Offset gutters\n  @if($offset) {\n    @include xy-offset-cell-classes();\n  }\n\n  // Vertical grid\n  @if($vertical-grid) {\n    @include xy-vertical-grid-classes($margin-grid, $padding-grid);\n  }\n\n  @if ($frame-grid) {\n    @include xy-frame-grid-classes($vertical-grid, $margin-grid)\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Create gutters for a cell/container.\n///\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts either margin or padding.\n/// @param {List} $gutter-position [right left] - The position to apply gutters to. Accepts `top`, `bottom`, `left`, `right` in any combination.\n/// @param {Boolean} $negative [false] - Whether to apply the gutter as a negative value. Commonly used for nested grids.\n@mixin xy-gutters(\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $gutter-position: right left,\n  $negative: false\n) {\n  $operator: if($negative, '-', '');\n\n  // If we have declared negative gutters, force type to `margin.\n  $gutter-type: if($negative, 'margin', $gutter-type);\n\n  // Output our margin gutters.\n  @if (type-of($gutters) == 'map') {\n    @include -zf-breakpoint-value(auto, $gutters) {\n      $gutter: rem-calc($-zf-bp-value) / 2;\n\n      // Loop through each gutter position\n      @each $value in $gutter-position {\n        #{$gutter-type}-#{$value}: unquote(\"#{$operator}#{$gutter}\");\n      }\n    }\n  }\n  @else if (type-of($gutters) == 'number') {\n    $gutter: rem-calc($gutters) / 2;\n\n    // Loop through each gutter position\n    @each $value in $gutter-position {\n      #{$gutter-type}-#{$value}: unquote(\"#{$operator}#{$gutter}\");\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Creates a max width container, designed to house your grid content.\n///\n/// @param {Number} $width [$grid-container] - a width to limit the container to.\n/// @param {Number} $padding [$grid-container-padding] - paddings of the container.\n@mixin xy-grid-container(\n  $width: $grid-container,\n  $padding: $grid-container-padding\n) {\n  @include xy-gutters($gutters: $padding, $gutter-type: padding);\n\n  max-width: $width;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/// Creates a container for your flex cells.\n///\n/// @param {Keyword} $direction [horizontal] - Either horizontal or vertical direction of cells within.\n/// @param {Boolean} $wrap [true] - If the cells within should wrap or not.\n@mixin xy-grid(\n  $direction: horizontal,\n  $wrap: true\n) {\n  $direction: if($direction == 'horizontal', row, column);\n  $wrap: if($wrap, wrap, nowrap);\n\n  display: flex;\n  flex-flow: $direction $wrap;\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Returns the appropriate CSS flex value for a cell base.\n///\n/// @param {Keyword} $size [full] - The size of your cell. Accepts `full`, `auto`, `shrink`, `grow`, or any other value representing a cell size (it will be treated as `shrink`).\n///\n/// @returns {List} The cell flex property value.\n@function xy-cell-base($size: full) {\n  @if ($size == 'auto') {\n    @return 1 1 0px;\n  }\n  @else if ($size == 'grow') {\n    @return 1 0 auto;\n  }\n  @else if ($size == 'shrink' or $size == 'full' or zf-is-fraction($size, $allow-no-denominator: true)) {\n    @return 0 0 auto;\n  }\n  @return null;\n}\n\n/// Calculate the size of a cell gutters.\n///\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, returns the responsive gutters map `$gutters`. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n///\n/// @returns {Number|Map} The cell gutter size or the responsive gutters map.\n@function xy-cell-gutters(\n  $gutters: $grid-margin-gutters,\n  $breakpoint: null\n) {\n  // For `auto`, returns the responsive map `$gutters`.\n  @if ($breakpoint == 'auto') {\n    @return $gutters;\n  }\n\n  // Use the contextual breakpoint by default.\n  $breakpoint: -zf-current-breakpoint($breakpoint);\n\n  @if ($breakpoint) {\n    @return -zf-get-bp-val($gutters, $breakpoint);\n  }\n  @else {\n    @return -zf-get-bp-val($gutters, $-zf-zero-breakpoint) or 0;\n  }\n}\n\n/// Returns the percentage size of a cell.\n///\n/// @param {Number|List} $size [$grid-columns] - Size to make the cell. You can pass a value in multiple formats, such as `6`, `50%`, `1 of 2` or `1/3`.\n///\n/// @returns {Number} Size of the cell (in percent).\n@function xy-cell-size(\n  $size: $grid-columns\n) {\n  @return fraction-to-percentage($size, $denominator: $grid-columns);\n}\n\n/// Returns the appropriate CSS value for a cell size.\n///\n/// Gutters-related arguments are required for cells with margin gutters (by default) as the gutter is included in the width.\n///\n/// @param {Keyword|Number} $size [full] - The size of your cell. Can be `full`, `auto`, `shrink` or any fraction like `6`, `50%`, `1 of 2` or `1/2`.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, returns a map of sizes adapted to responsive gutters. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n///\n/// @returns {Number|String|Map} The cell sizing property value, or a responsive map of them.\n@function xy-cell-size-css(\n  $size: full,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $breakpoint: null\n) {\n  $margin-gutter: 0;\n\n  @if ($size == 'auto' or $size == 'shrink') {\n    @return auto;\n  }\n\n  // For cells with margin gutters, the gutter is included in the width.\n  @if ($gutter-type == 'margin') {\n    $margin-gutter: xy-cell-gutters($gutters, $breakpoint);\n    @if ($margin-gutter == null) {\n      @error 'xy-cell-size: no gutters were found in `$gutters` for \"$breakpoint: #{$breakpoint}\"';\n    }\n  }\n\n  // Calculate the cell size (number)\n  $size-raw: if($size == 'full', 100%, xy-cell-size($size));\n\n  // Calculate the cell CSS size including gutters (string)\n  // If the cell has responsive margin gutters, return a responsive map of sizes.\n  @if type-of($margin-gutter) == 'map' {\n    $responsive-css-sizes: ();\n\n    @each $bp, $mg in $margin-gutter {\n      $size-css: if($mg == 0, $size-raw, calc(#{$size-raw} - #{rem-calc($mg)}));\n      $responsive-css-sizes: map-merge($responsive-css-sizes, ($bp: $size-css));\n    }\n\n    @return $responsive-css-sizes;\n  }\n  // Otherwise, return a single CSS size.\n  @else {\n    $css-size: if($margin-gutter == 0, $size-raw, calc(#{$size-raw} - #{rem-calc($margin-gutter)}));\n    @return $css-size;\n  }\n}\n\n/// Sets base flex properties for cells.\n///\n/// @param {Keyword} $size [full] - The size of your cell. Accepts `full`, `auto`, `shrink`, `grow`, or any other value representing a cell size (it will be treated as `shrink`).\n@mixin xy-cell-base($size: full) {\n  $base: xy-cell-base($size);\n\n  flex: #{$base};\n\n  // Set base styles for \"full\" only\n  @if($size == 'full') {\n    min-height: 0px;\n    min-width: 0px;\n  }\n}\n\n/// Resets a cells width (or height if vertical is true) as well as strips its gutters.\n///\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n@mixin xy-cell-reset($vertical: true) {\n  $direction: if($vertical == true, height, width);\n  #{$direction}: auto;\n  max-#{$direction}: none;\n}\n\n/// Sets sizing properties for cells.\n///\n/// Gutters-related arguments are required for cells with margin gutters (by default) as the gutter is included in the width.\n///\n/// @param {Keyword|Number} $size [full] - The size of your cell. Can be `full` (100% width), `auto` (use all available space), `shrink` (use only the required space) or any fraction (`6`, `50%`, `1 of 2` or `1/2`...).\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, generates sizes adapted for responsive gutters. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n@mixin xy-cell-size(\n  $size: full,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $breakpoint: null,\n  $vertical: false\n) {\n  $sizes: xy-cell-size-css($size, $gutters, $gutter-type, $breakpoint);\n  $direction: if($vertical == true, height, width);\n\n  @if (type-of($sizes) == 'map') {\n    @include -zf-breakpoint-value(auto, $sizes) {\n      #{$direction}: $-zf-bp-value;\n    }\n  }\n  @else {\n    #{$direction}: $sizes;\n  }\n}\n\n/// Sets gutters properties for cells.\n///\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {List} $gutter-position [null] - The position to apply gutters to. Accepts `top`, `bottom`, `left`, `right` in any combination. By default `right left` for horizontal cells and `top bottom` for vertical cells.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, generates responsive gutters. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Direction of the gutters to output. See `$gutter-position`.\n@mixin xy-cell-gutters(\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $gutter-position: null,\n  $breakpoint: null,\n  $vertical: false\n) {\n  // Get the default gutter position according to cell direction\n  @if($gutter-position == null) {\n    $gutter-position: if($vertical == true, top bottom, left right);\n  }\n\n  // Get the gutter width for this breakpoint\n  $gutter-width: xy-cell-gutters($gutters, $breakpoint);\n  @if ($gutter-width == null) {\n    @error 'xy-cell-gutters: no gutters were found in `$gutters` for \"$breakpoint: #{$breakpoint}\"';\n  }\n\n  @if ($gutter-type and $gutter-type != none) {\n    @include xy-gutters($gutter-width, $gutter-type, $gutter-position);\n  }\n}\n\n/// Creates a cell for your grid.\n///\n/// @param {Keyword|Number} $size [full] - The size of your cell. Can be `full` (100% width), `auto` (use all available space), `shrink` (use only the required space) or any fraction (`6`, `50%`, `1 of 2` or `1/2`...).\n/// @param {Boolean} $gutter-output [null] - [DEPRECATED] Whether or not to output gutters.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {List} $gutter-position [null] - The position to apply gutters to. Accepts `top`, `bottom`, `left`, `right` in any combination. By default `right left` for horizontal cells and `top bottom` for vertical cells.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, generates responsive gutters. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n/// @param {List} $output [(base size gutters)] - Cell parts to output. You will need to generate others parts of the cell seperately, it may not work properly otherwise.\n@mixin xy-cell(\n  $size: full,\n  $gutter-output: null,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $gutter-position: null,\n  $breakpoint: null,\n  $vertical: false,\n  $output: (base size gutters)\n) {\n  // Default for $gutter-output\n  @if ($gutter-output != null) {\n    @warn 'xy-cell: $gutter-output is deprecated and will be removed. See migration notes at https://git.io/foundation-6-6-0';\n    @if ($gutter-output == false) {\n      $output: sl-remove($output, gutters);\n    }\n  }\n\n  @if (index($output, base)) {\n    @include xy-cell-base($size);\n  }\n  @if (index($output, size)) {\n    @include xy-cell-size($size, $gutters, $gutter-type, $breakpoint, $vertical);\n  }\n  @if (index($output, gutters)) {\n    @include xy-cell-gutters($gutters, $gutter-type, $gutter-position, $breakpoint, $vertical);\n  }\n}\n\n/// Creates a single breakpoint sized grid. Used to generate our grid classes.\n///\n/// `xy-cell-static()` is deprecated and will be removed.\n/// Use `xy-cell()` instead with `$output: (size gutters)` to not generate the cell base.\n/// See migration notes at https://git.io/foundation-6-6-0\n///\n/// @deprecated v6.6.0\n///\n/// @param {Keyword|Number} $size [full] - The size of your cell. Can be `full` (100% width), `auto` (use all available space), `shrink` (use only the required space) or any fraction (`6`, `50%`, `1 of 2` or `1/2`...).\n/// @param {Boolean} $gutter-output [true] - Whether or not to output gutters. Always `true` for margin gutters.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Map or single value for gutters.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n@mixin xy-cell-static(\n  $size: full,\n  $gutter-output: true,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $breakpoint: $-zf-zero-breakpoint,\n  $vertical: false\n) {\n  @warn 'xy-cell-static() mixin is deprecated and will be removed. Use \"xy-cell()\" instead. See migration notes at https://git.io/foundation-6-6-0';\n\n  $gutter: -zf-get-bp-val($gutters, $breakpoint);\n  $gutter-position: if($vertical == true, top bottom, left right);\n\n  $-gutter-output: if($gutter-type == 'margin', true, $gutter-output);\n  $-gutter-margin: if($gutter-type == 'margin', $gutter, 0);\n\n  @include -xy-cell-properties($size, $-gutter-margin, $vertical);\n  @if ($-gutter-output) {\n    @include xy-gutters($gutter, $gutter-type, $gutter-position);\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Sizes child elements so that `$n` number of items appear on each row.\n///\n/// @param {Number} $n - Number of elements to display per row.\n/// @param {String} $selector ['.cell'] - Selector(s) to use for child elements.\n/// @param {Boolean} $gutter-output [null] - [DEPRECATED] Whether or not to output gutters.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {List} $gutter-position [null] - The position to apply gutters to. Accepts `top`, `bottom`, `left`, `right` in any combination. By default `right left` for horizontal cells and `top bottom` for vertical cells.\n/// @param {String} $breakpoint [null] - The breakpoint to use for the cell generation. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n/// @param {List} $output [(base size gutters)] - Cell parts to output. You will need to generate others parts of the cell seperately, it may not work correctly otherwise.\n@mixin xy-grid-layout(\n  $n,\n  $selector: '.cell',\n  $gutter-output: null,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $gutter-position: null,\n  $breakpoint: null,\n  $vertical: false,\n  $output: (base size gutters)\n) {\n  $size: percentage(1/$n);\n\n  & > #{$selector} {\n    @include xy-cell($size, $gutter-output, $gutters, $gutter-type, $gutter-position, $breakpoint, $vertical, $output);\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Collapses the grid a cells within it.\n///\n/// @param {String} $selector [.cell] - The child element to remove the gutter from.\n/// @param {Keyword} $gutter-type [margin] - The type of gutter to remove.\n/// @param {List} $gutter-position [right left] - The positions to remove gutters from. Accepts `top`, `bottom`, `left`, `right` in any combination.\n/// @param {Keyword} $min-breakpoint [$-zf-zero-breakpoint] - Minimum breakpoint in `$breakpoint-classes` for which to collapse the gutter.\n@mixin xy-grid-collapse(\n  $selector: '.cell',\n  $gutter-type: margin,\n  $gutter-position: right left,\n  $min-breakpoint: $-zf-zero-breakpoint\n) {\n  // First, lets negate any margins on the top level\n  @if ($gutter-type == 'margin') {\n\n    @include breakpoint($min-breakpoint) {\n      @each $value in $gutter-position {\n        margin-#{$value}: 0;\n      }\n\n      > #{$selector} {\n        @each $value in $gutter-position {\n          margin-#{$value}: 0;\n        }\n      }\n    }\n\n    $excluded-bps: -zf-breakpoints-less-than($min-breakpoint);\n\n    // Output new widths to not include gutters\n    @each $bp in $breakpoint-classes {\n      @if(sl-contain($excluded-bps, $bp)) {\n        @include breakpoint($min-breakpoint) {\n          @for $i from 1 through $grid-columns {\n            // Sizing (percentage)\n            > .#{$bp}-#{$i} {\n              @include xy-cell-size($i, $gutter-type: none);\n            }\n          }\n        }\n      } @else {\n        @include breakpoint($bp) {\n          @for $i from 1 through $grid-columns {\n            // Sizing (percentage)\n            > .#{$bp}-#{$i} {\n              @include xy-cell-size($i, $gutter-type: none);\n            }\n          }\n        }\n      }\n    }\n  }\n  @else {\n\n    @include breakpoint($min-breakpoint) {\n      @each $value in $gutter-position {\n        margin-#{$value}: 0;\n      }\n\n      > #{$selector} {\n        @each $value in $gutter-position {\n          padding-#{$value}: 0;\n        }\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Returns the appropriate CSS value to offset a cell.\n///\n/// @param {Number|List} $n - Size to offset by. You can pass in any value accepted by the `xy-cell()` mixin, such as `6`, `50%`, or `1 of 2`.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] Map of gutters or single value to use for responsive gutters.\n/// @param {Keyword} $gutter-type [margin] The type of gutter to use. Can be `margin` or `padding`\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n///\n/// @returns {Number|String} The cell offset property value.\n@function xy-cell-offset(\n  $n,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $breakpoint: null\n) {\n  $breakpoint: -zf-current-breakpoint($breakpoint, $default: $-zf-zero-breakpoint);\n  $size: xy-cell-size($n);\n\n  $offset: $size;\n  @if ($gutter-type == 'margin') {\n    $gutter: rem-calc(xy-cell-gutters($gutters, $breakpoint) / 2);\n    $offset: if($gutter == 0, $size, calc(#{$size} + #{$gutter}));\n  }\n  @return $offset;\n}\n\n/// Offsets a column to the right/bottom by `$n` columns.\n///\n/// @param {Number|List} $n - Size to offset by. You can pass in any value accepted by the `xy-cell()` mixin, such as `6`, `50%`, or `1 of 2`.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] Map of gutters or single value to use for responsive gutters.\n/// @param {Keyword} $gutter-type [margin] The type of gutter to use. Can be `margin` or `padding`\n/// @param {Number|Array|Keyword} $breakpoint [null] - Breakpoint to use for `$gutters`. It can be a breakpoint name, list of breakpoints or `auto` for all breakpoints. If a list is given, media-queries will be generated. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] Sets the direction of the offset. If set to true will apply margin-top instead.\n@mixin xy-cell-offset(\n $n,\n $gutters: $grid-margin-gutters,\n $gutter-type: margin,\n $breakpoint: null,\n $vertical: false\n) {\n  $breakpoint: -zf-current-breakpoint($breakpoint, $default: $-zf-zero-breakpoint);\n  $direction: if($vertical, 'top', $global-left);\n\n  @include -zf-each-breakpoint-in($breakpoint, $media-queries: 'for-lists') {\n    $offset: xy-cell-offset($n, $gutters, $gutter-type);\n    margin-#{$direction}: #{$offset};\n  }\n}\n","/// Modifies a grid to give it \"frame\" behavior (no overflow, no wrap, stretch behavior)\n///\n/// @param {Boolean} $vertical [false] - Is grid vertical or horizontal. Should match grid.\n/// @param {Boolean} $nested [false] - Is grid nested or not. If nested is true this sets the frame to 100% height, otherwise will be 100vh.\n/// @param {Number|Map} $gutters [null] - Map or single value for gutters.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from.\n/// @param {Boolean} $include-base [true] - Include the base styles that don't vary per breakpoint.\n@mixin xy-grid-frame(\n  $vertical: false,\n  $nested: false,\n  $gutters: null,\n  $breakpoint: null,\n  $include-base: true\n) {\n\n  @if $include-base {\n    overflow: hidden;\n    position: relative;\n    flex-wrap: nowrap;\n    align-items: stretch;\n  }\n\n  @if $breakpoint == null and type-of($gutters) == 'map' {\n    @include -zf-each-breakpoint() {\n      @include xy-grid-frame($vertical, $nested, $gutters, $-zf-size, false);\n    }\n  } @else {\n    // Get our gutters if applicable\n    $gutter: -zf-get-bp-val($gutters, $breakpoint);\n\n    // If we have a gutter, add it to the width/height\n    @if $gutter {\n      @if $vertical == true {\n        $unit: if($nested == true, 100%, 100vh);\n        $gutter: rem-calc($gutter);\n        height: calc(#{$unit} + #{$gutter});\n      } @else {\n        $unit: if($nested == true, 100%, 100vw);\n        $gutter: rem-calc($gutter);\n        width: calc(#{$unit} + #{$gutter});\n      }\n    }\n    @else {\n      @if $vertical == true {\n        height: if($nested == true, 100%, 100vh);\n      } @else {\n        width: if($nested == true, 100%, 100vw);\n      }\n    }\n  }\n}\n\n/// Modifies a cell to give it \"block\" behavior (overflow auto, inertial scrolling)\n///\n/// @param {Boolean} $vertical [false] - Is grid vertical or horizontal. Should match grid.\n@mixin xy-cell-block(\n  $vertical: false\n) {\n  $property: if($vertical == true, 'overflow-y', 'overflow-x');\n\n  @if $vertical == true {\n    overflow-y: auto;\n    max-height: 100%;\n    min-height: 100%;\n  } @else {\n    overflow-x: auto;\n    max-width: 100%;\n  }\n\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n\n/// Container for inside a grid frame containing multiple blocks. Typically used\n/// as a modifier for a `.cell` to allow the cell to pass along flex sizing\n/// constraints / from parents to children.\n@mixin xy-cell-block-container() {\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n\n  > .grid-x {\n    max-height: 100%;\n    flex-wrap: nowrap;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group button\n////\n\n/// Font family for button elements.\n/// @type Font\n$button-font-family: inherit !default;\n\n/// Font weight for button elements.\n/// Ignored if null (default)\n/// @type Font-Weight\n$button-font-weight: null !default;\n\n/// Padding inside buttons.\n/// @type List\n$button-padding: 0.85em 1em !default;\n\n/// Margin around buttons.\n/// @type List\n$button-margin: 0 0 $global-margin 0 !default;\n\n/// Default fill for buttons. Can either be `solid` or `hollow`.\n/// @type Keyword\n$button-fill: solid !default;\n\n/// Default background color for buttons.\n/// @type Color\n$button-background: $primary-color !default;\n\n/// Background color on hover for buttons.\n/// @type Color\n$button-background-hover: scale-color($button-background, $lightness: -15%) !default;\n\n/// Font color for buttons.\n/// @type List\n$button-color: $white !default;\n\n/// Alternative font color for buttons.\n/// @type List\n$button-color-alt: $black !default;\n\n/// Border radius for buttons, defaulted to global-radius.\n/// @type Number\n$button-radius: $global-radius !default;\n\n/// Border for buttons, transparent by default\n/// @type List\n$button-border: 1px solid transparent !default;\n\n/// Border width for hollow outline buttons\n/// @type Number\n$button-hollow-border-width: 1px !default;\n\n/// Sizes for buttons.\n/// @type Map\n$button-sizes: (\n  tiny: 0.6rem,\n  small: 0.75rem,\n  default: 0.9rem,\n  large: 1.25rem,\n) !default;\n\n/// Coloring classes. A map of classes to output in your CSS, like `.secondary`, `.success`, and so on.\n/// @type Map\n$button-palette: $foundation-palette !default;\n\n/// opacity for a disabled button.\n/// @type List\n$button-opacity-disabled: 0.25 !default;\n\n/// Background color lightness on hover for buttons.\n/// @type Number\n$button-background-hover-lightness: -20% !default;\n\n/// Color lightness on hover for hollow buttons.\n/// @type Number\n$button-hollow-hover-lightness: -50% !default;\n\n// Internal: flip from margin-right to margin-left for defaults\n@if $global-text-direction == 'rtl' {\n  $button-margin: 0 0 $global-margin $global-margin !default;\n}\n\n/// transitions for buttons.\n/// @type List\n$button-transition: background-color 0.25s ease-out, color 0.25s ease-out !default;\n\n/// Additional responsive classes for .expanded\n/// @type Boolean\n$button-responsive-expanded: false !default;\n\n// TODO: Document button-base() mixin\n@mixin button-base {\n  @include disable-mouse-outline;\n  display: inline-block;\n  vertical-align: middle;\n  margin: $button-margin;\n\n  @if (type-of($button-padding) == 'map') {\n    @each $size, $padding in $button-padding {\n      @include breakpoint($size) {\n        padding: $padding;\n      }\n    }\n  }\n  @else {\n    padding: $button-padding;\n  }\n\n  border: $button-border;\n  border-radius: $button-radius;\n  transition: $button-transition;\n  font-family: $button-font-family;\n  font-size: map-get($button-sizes, default);\n  font-weight: $button-font-weight;\n  -webkit-appearance: none; // sass-lint:disable-line no-vendor-prefixes\n  line-height: 1;\n  text-align: center;\n  cursor: pointer;\n}\n\n/// Expands a button to make it full-width.\n/// @param {Boolean} $expand [true] - Set to `true` to enable the expand behavior. Set to `false` to reverse this behavior.\n@mixin button-expand($expand: true) {\n  @if $expand {\n    display: block;\n    width: 100%;\n    margin-right: 0;\n    margin-left: 0;\n  }\n  @else {\n    display: inline-block;\n    width: auto;\n    margin: $button-margin;\n  }\n}\n\n/// Sets the base styles of a hollow or clear button filling according to `$fill`.\n/// See mixin `button-fill-style` for the filling styles.\n/// @param {Keyword} $fill [$button-fill] - Type of filling between `hollow` and `clear`. `solid` has no effects.\n@mixin button-fill(\n  $fill: $button-fill\n) {\n  @if $fill == hollow {\n    @include button-hollow;\n  }\n  @else if $fill == clear {\n    @include button-clear;\n  }\n}\n\n/// Sets the visual styles of a solid/hollow/clear button filling according to `$fill`.\n/// See mixins `button-style`, `button-hollow-style` and `button-clear-style` for effects of visual styling parameters.\n/// @param {Keyword} $fill [$button-fill] - Type of filling between `hollow` and `clear`.\n/// @param {Color} $background [$button-background] - -\n/// @param {Color} $background-hover [$button-background-hover] - -\n/// @param {Color} $color [$button-color] - -\n@mixin button-fill-style(\n  $fill: $button-fill,\n  $background: $button-background,\n  $background-hover: $button-background-hover,\n  $color: $button-color\n) {\n  @if $fill == solid {\n    @include button-style($background, $background-hover, $color);\n  }\n  @else if $fill == hollow {\n    @include button-hollow-style($background);\n  }\n  @else if $fill == clear {\n    @include button-clear-style($background);\n  }\n}\n\n/// Sets the visual style of a button.\n/// @param {Color} $background [$button-background] - Background color of the button.\n/// @param {Color} $background-hover [$button-background-hover] - Background color of the button on hover. Set to `auto` to have the mixin automatically generate a hover color.\n/// @param {Color} $color [$button-color] - Text color of the button. Set to `auto` to automatically generate a color based on the background color.\n@mixin button-style(\n  $background: $button-background,\n  $background-hover: $button-background-hover,\n  $color: $button-color,\n  $background-hover-lightness: $button-background-hover-lightness\n) {\n  @if $color == auto {\n    $color: color-pick-contrast($background, ($button-color, $button-color-alt));\n  }\n\n  @if $background-hover == auto {\n    $background-hover: scale-color($background, $lightness: $background-hover-lightness);\n  }\n\n  // Default and disabled states\n  &,\n  &.disabled, &[disabled],\n  &.disabled:hover, &[disabled]:hover,\n  &.disabled:focus, &[disabled]:focus {\n    background-color: $background;\n    color: $color;\n  }\n\n  &:hover, &:focus {\n    background-color: $background-hover;\n    color: $color;\n  }\n}\n\n/// Sets the base styles of a hollow button.\n/// See mixin `button-hollow-style` for the filling styles.\n@mixin button-hollow {\n  &, &.disabled, &[disabled] {\n    &, &:hover, &:focus {\n      background-color: transparent;\n    }\n  }\n}\n\n/// Sets the visual style of a hollow button.\n/// @param {Color} $color [$button-background] - Text and border color of the button.\n/// @param {Color} $hover-lightness [$button-hollow-hover-lightness] - Color lightness on hover.\n/// @param {Color} $border-width [$button-hollow-border-width] - Border width of the button.\n@mixin button-hollow-style(\n  $color: $button-background,\n  $hover-lightness: $button-hollow-hover-lightness,\n  $border-width: $button-hollow-border-width\n) {\n  $color-hover: scale-color($color, $lightness: $hover-lightness);\n\n  // Default and disabled states\n  &,\n  &.disabled, &[disabled],\n  &.disabled:hover, &[disabled]:hover,\n  &.disabled:focus, &[disabled]:focus {\n    border: $border-width solid $color;\n    color: $color;\n  }\n\n  &:hover, &:focus {\n    border-color: $color-hover;\n    color: $color-hover;\n  }\n}\n\n/// Sets the base styles of a clear button.\n/// See mixin `button-clear-style` for the filling styles.\n@mixin button-clear {\n  &, &.disabled, &[disabled] {\n    &, &:hover, &:focus {\n      border-color: transparent;\n      background-color: transparent;\n    }\n  }\n}\n\n/// Sets the visual style of a clear button.\n/// @param {Color} $color [$button-background] - Text color of the button.\n/// @param {Color} $hover-lightness [$button-hollow-hover-lightness] - Color lightness on hover.\n@mixin button-clear-style(\n  $color: $button-background,\n  $hover-lightness: $button-hollow-hover-lightness\n) {\n  $color-hover: scale-color($color, $lightness: $hover-lightness);\n\n  // Default and disabled states\n  &,\n  &.disabled, &[disabled],\n  &.disabled:hover, &[disabled]:hover,\n  &.disabled:focus, &[disabled]:focus {\n    color: $color;\n  }\n\n  &:hover, &:focus {\n    color: $color-hover;\n  }\n}\n\n/// Adds disabled styles to a button by fading the element and reseting the cursor.\n/// @param {Number} $opacity [$button-opacity-disabled] - Opacity of the disabled button.\n@mixin button-disabled(\n  $opacity: $button-opacity-disabled\n) {\n  opacity: $button-opacity-disabled;\n  cursor: not-allowed;\n}\n\n/// Adds a dropdown arrow to a button.\n/// @param {Number} $size [0.4em] - Size of the arrow. We recommend using an `em` value so the triangle scales when used inside different sizes of buttons.\n/// @param {Color} $color [white] - Color of the arrow.\n/// @param {Number} $offset [$button-padding] - Distance between the arrow and the text of the button. Defaults to whatever the right padding of a button is.\n@mixin button-dropdown(\n  $size: 0.4em,\n  $color: $white,\n  $offset: get-side($button-padding, right)\n) {\n  &::after {\n    @include css-triangle($size, $color, down);\n    position: relative;\n    top: 0.4em; // Aligns the arrow with the text of the button\n\n    display: inline-block;\n    float: #{$global-right};\n    margin-#{$global-left}: $offset;\n  }\n}\n\n/// Adds all styles for a button. For more granular control over styles, use the individual button mixins.\n/// @param {Boolean} $expand [false] - Set to `true` to make the button full-width.\n/// @param {Color} $background [$button-background] - Background color of the button.\n/// @param {Color} $background-hover [$button-background-hover] - Background color of the button on hover. Set to `auto` to have the mixin automatically generate a hover color.\n/// @param {Color} $color [$button-color] - Text color of the button. Set to `auto` to automatically generate a color based on the background color.\n/// @param {Keyword} $style [solid] - Set to `hollow` to create a hollow button. The color defined in `$background` will be used as the primary color of the button.\n@mixin button(\n  $expand: false,\n  $background: $button-background,\n  $background-hover: $button-background-hover,\n  $color: $button-color,\n  $style: $button-fill\n) {\n  @include button-base;\n  @include button-fill($style);\n  @include button-fill-style($style, $background, $background-hover, $color);\n\n  @if $expand {\n    @include button-expand;\n  }\n}\n\n@mixin foundation-button {\n  .button {\n    @include button($style: none);\n\n    // Sizes\n    @each $size, $value in map-remove($button-sizes, default) {\n      &.#{$size} {\n        font-size: $value;\n      }\n    }\n\n    &.expanded { @include button-expand; }\n\n    @if $button-responsive-expanded {\n      @each $size in $breakpoint-classes {\n        @include breakpoint(#{$size} only) {\n          &.#{$size}-only-expanded {\n            @include button-expand;\n          }\n        }\n        @if $size != $-zf-zero-breakpoint {\n          @include breakpoint(#{$size} down) {\n            &.#{$size}-down-expanded {\n              @include button-expand;\n            }\n          }\n\n          @include breakpoint(#{$size}) {\n            &.#{$size}-expanded {\n              @include button-expand;\n            }\n          }\n        }\n      }\n    }\n\n    // Solid, hollow & clear styles\n    @each $filling in (solid hollow clear) {\n      $selector: if($button-fill == $filling, null, '.#{$filling}');\n\n      &#{$selector} {\n        @include button-fill($filling);\n        @include button-fill-style($filling);\n\n        @each $name, $color in $button-palette {\n          &.#{$name} {\n            @include button-fill-style($filling, $color, auto, auto);\n          }\n        }\n      }\n    }\n\n    // Disabled state\n    &.disabled, &[disabled] {\n      @include button-disabled;\n    }\n\n    // Dropdown arrow\n    &.dropdown {\n      @include button-dropdown;\n\n      @if $button-fill == hollow {\n        &::after {\n          border-top-color: $button-background;\n        }\n      }\n\n      &.hollow, &.clear {\n        &::after {\n          border-top-color: $button-background;\n        }\n\n        @each $name, $color in $button-palette {\n          &.#{$name} {\n            &::after {\n              border-top-color: $color;\n            }\n          }\n        }\n      }\n    }\n\n    // Button with dropdown arrow only\n    &.arrow-only::after {\n      top: -0.1em;\n      float: none;\n      margin-#{$global-left}: 0;\n    }\n  }\n\n  a.button { // sass-lint:disable-line no-qualifying-elements\n    &:hover,\n    &:focus {\n      text-decoration: none;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n@import 'math';\n\n$contrast-warnings: true !default;\n\n////\n/// @group functions\n////\n\n/// Checks the luminance of `$color`.\n///\n/// @param {Color} $color - Color to check the luminance of.\n///\n/// @returns {Number} The luminance of `$color`.\n@function color-luminance($color) {\n  // Adapted from: https://github.com/LeaVerou/contrast-ratio/blob/gh-pages/color.js\n  // Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef\n  $rgba: red($color), green($color), blue($color);\n  $rgba2: ();\n\n  @for $i from 1 through 3 {\n    $rgb: nth($rgba, $i);\n    $rgb: $rgb / 255;\n\n    $rgb: if($rgb < 0.03928, $rgb / 12.92, pow(($rgb + 0.055) / 1.055, 2.4));\n\n    $rgba2: append($rgba2, $rgb);\n  }\n\n  @return 0.2126 * nth($rgba2, 1) + 0.7152 * nth($rgba2, 2) + 0.0722 * nth($rgba2, 3);\n}\n\n/// Checks the contrast ratio of two colors.\n///\n/// @param {Color} $color1 - First color to compare.\n/// @param {Color} $color2 - Second color to compare.\n///\n/// @returns {Number} The contrast ratio of the compared colors.\n@function color-contrast($color1, $color2) {\n  // Adapted from: https://github.com/LeaVerou/contrast-ratio/blob/gh-pages/color.js\n  // Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef\n  $luminance1: color-luminance($color1) + 0.05;\n  $luminance2: color-luminance($color2) + 0.05;\n  $ratio: $luminance1 / $luminance2;\n\n  @if $luminance2 > $luminance1 {\n    $ratio: 1 / $ratio;\n  }\n\n  $ratio: round($ratio * 10) / 10;\n\n  @return $ratio;\n}\n\n/// Checks the luminance of `$base`, and returns the color from `$colors` (list of colors) that has the most contrast.\n///\n/// @param {Color} $base - Color to check luminance.\n/// @param {List} $colors [($white, $black)] - Colors to compare.\n/// @param {Number} $tolerance [$global-color-pick-contrast-tolerance] - Contrast tolerance.\n///\n/// @returns {Color} the color from `$colors` (list of colors) that has the most contrast.\n@function color-pick-contrast($base, $colors: ($white, $black), $tolerance: $global-color-pick-contrast-tolerance) {\n  $contrast: color-contrast($base, nth($colors, 1));\n  $best: nth($colors, 1);\n\n  @for $i from 2 through length($colors) {\n    $current-contrast: color-contrast($base, nth($colors, $i));\n    @if ($current-contrast - $contrast > $tolerance) {\n      $contrast: color-contrast($base, nth($colors, $i));\n      $best: nth($colors, $i);\n    }\n  }\n\n  @if ($contrast-warnings and $contrast < 3) {\n    @warn \"Contrast ratio of #{$best} on #{$base} is pretty bad, just #{$contrast}\";\n  }\n\n  @return $best;\n}\n\n/// Scales a color to be darker if it's light, or lighter if it's dark. Use this function to tint a color appropriate to its lightness.\n///\n/// @param {Color} $color - Color to scale.\n/// @param {Percentage} $scale [5%] - Amount to scale up or down.\n/// @param {Percentage} $threshold [40%] - Threshold of lightness to check against.\n///\n/// @returns {Color} A scaled color.\n@function smart-scale($color, $scale: 5%, $threshold: 40%) {\n  @if lightness($color) > $threshold {\n    $scale: -$scale;\n  }\n  @return scale-color($color, $lightness: $scale);\n}\n\n/// Get color from foundation-palette\n///\n/// @param {key} color key from foundation-palette\n///\n/// @returns {Color} color from foundation-palette\n@function get-color($key) {\n  @if map-has-key($foundation-palette, $key) {\n    @return map-get($foundation-palette, $key);\n  }\n  @else {\n    @error 'given $key is not available in $foundation-palette';\n  }\n}\n\n/// Transfers the colors in the `$foundation-palette` map into variables, such as `$primary-color` and `$secondary-color`. Call this mixin below the Global section of your settings file to properly migrate your codebase.\n@mixin add-foundation-colors() {\n  @if map-has-key($foundation-palette, primary) {\n    $primary-color: map-get($foundation-palette, primary) !global;\n  } @else {\n    $primary-color: #1779ba !global;\n  }\n  @if map-has-key($foundation-palette, secondary) {\n    $secondary-color: map-get($foundation-palette, secondary) !global;\n  } @else {\n    $secondary-color: #767676 !global;\n  }\n  @if map-has-key($foundation-palette, success) {\n    $success-color: map-get($foundation-palette, success) !global;\n  } @else {\n    $success-color: #3adb76 !global;\n  }\n  @if map-has-key($foundation-palette, warning) {\n    $warning-color: map-get($foundation-palette, warning) !global;\n  } @else {\n    $warning-color: #ffae00 !global;\n  }\n  @if map-has-key($foundation-palette, alert) {\n    $alert-color: map-get($foundation-palette, alert) !global;\n  } @else {\n    $alert-color: #cc4b37 !global;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group button-group\n////\n\n/// Margin for button groups.\n/// @type Number\n$buttongroup-margin: 1rem !default;\n\n/// Margin between buttons in a button group.\n/// @type Number\n$buttongroup-spacing: 1px !default;\n\n/// Selector for the buttons inside a button group.\n/// @type String\n$buttongroup-child-selector: '.button' !default;\n\n/// Maximum number of buttons that can be in an even-width button group. (Only needed when $global-flexbox: false;)\n/// @type Number\n$buttongroup-expand-max: 6 !default;\n\n/// Determines if $button-radius is applied to each button or the button group as a whole. Use $global-radius in _settings.scss to change radius.\n/// @type Boolean\n$buttongroup-radius-on-each: true !default;\n\n/// Add styles for a button group container.\n/// @param {String} $child-selector [$buttongroup-child-selector] - Selector for the buttons inside a button group.\n/// @param {Number} $spacing [$buttongroup-spacing] - Spacing between buttons in a button group.\n@mixin button-group(\n  $child-selector: $buttongroup-child-selector,\n  $spacing: $buttongroup-spacing\n) {\n  @include clearfix;\n  margin-bottom: $buttongroup-margin;\n\n  @if $global-flexbox {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    flex-grow: 1;\n\n    &::before,\n    &::after {\n      display: none; // Disable clearfix\n    }\n  }\n  @else {\n    font-size: 0;\n  }\n\n  #{$child-selector} {\n    margin: 0;\n    margin-#{$global-right}: $spacing;\n    margin-bottom: $spacing;\n    font-size: map-get($button-sizes, default);\n\n    @if $global-flexbox {\n      flex: 0 0 auto;\n    }\n\n    &:last-child {\n      margin-#{$global-right}: 0;\n    }\n\n    @if not $buttongroup-radius-on-each {\n      border-radius: 0;\n\n      &:first-child {\n        border-top-#{$global-left}-radius: $button-radius;\n        border-bottom-#{$global-left}-radius: $button-radius;\n      }\n\n      &:last-child {\n        border-top-#{$global-right}-radius: $button-radius;\n        border-bottom-#{$global-right}-radius: $button-radius;\n      }\n    }\n  }\n}\n\n/// Make buttons bonded without gap between them. Borders between buttons are merged\n/// @param {String} $selector [$buttongroup-child-selector] - Selector for the buttons inside a button group.\n@mixin button-group-no-gaps(\n  $selector: $buttongroup-child-selector,\n  $border-width: $button-hollow-border-width\n) {\n  #{$selector} {\n    margin-#{$global-right}: rem-calc(-$border-width);\n\n    + #{$selector} {\n      border-#{$global-left}-color: transparent;\n    }\n  }\n}\n\n/// Creates a full-width button group, making each button equal width.\n/// @param {String} $selector [$buttongroup-child-selector] - Selector for the buttons inside a button group.\n/// @param {Number} $spacing [$buttongroup-spacing] - Spacing between buttons in a button group.\n@mixin button-group-expand(\n  $selector: $buttongroup-child-selector,\n  $spacing: $buttongroup-spacing,\n  $count: null\n) {\n  @if not $global-flexbox {\n    margin-#{$global-right}: -$spacing;\n\n    &::before,\n    &::after {\n      display: none; // Disable clearfix\n    }\n  }\n\n  #{$selector} {\n    @if $global-flexbox {\n      flex: 1 1 0px; // sass-lint:disable-line zero-unit\n      margin-right: 0;\n    }\n    @else {\n      // One child\n      &:first-child {\n        &:last-child {\n          width: calc(100% - #{$spacing});\n        }\n      }\n\n      // Two or more childreen\n      @for $i from 2 through $buttongroup-expand-max {\n        &:first-child:nth-last-child(#{$i}) {\n          &, &:first-child:nth-last-child(#{$i}) ~ #{$selector} {\n            display: inline-block;\n            width: calc(#{percentage(1 / $i)} - #{$spacing});\n            margin-#{$global-right}: $spacing;\n\n            &:last-child {\n              margin-#{$global-right}: $spacing * -$buttongroup-expand-max;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n/// Stacks the buttons in a button group.\n/// @param {String} $selector [$buttongroup-child-selector] - Selector for the buttons inside the button group.\n@mixin button-group-stack(\n  $selector: $buttongroup-child-selector\n) {\n  @if $global-flexbox {\n    flex-wrap: wrap;\n  }\n\n  #{$selector} {\n    @if $global-flexbox {\n      flex: 0 0 100%;\n    }\n    @else {\n      width: 100%;\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @if not $buttongroup-radius-on-each {\n      border-radius: 0;\n\n      &:first-child {\n        border-top-#{$global-left}-radius: $global-radius;\n        border-top-#{$global-right}-radius: $global-radius;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n        border-bottom-#{$global-left}-radius: $global-radius;\n        border-bottom-#{$global-right}-radius: $global-radius;\n      }\n    }\n  }\n}\n\n/// Un-stacks the buttons in a button group.\n/// @param {String} $selector [$buttongroup-child-selector] - Selector for the buttons inside the button group.\n@mixin button-group-unstack(\n  $selector: $buttongroup-child-selector\n) {\n  #{$selector} {\n    @if $global-flexbox {\n      flex: 0 0 auto;\n    }\n    @else {\n      width: auto;\n    }\n    margin-bottom: 0;\n\n    @if not $buttongroup-radius-on-each {\n      &:first-child {\n        border-top-#{$global-left}-radius: $global-radius;\n        border-top-#{$global-right}-radius: 0;\n        border-bottom-#{$global-left}-radius: $global-radius;\n      }\n\n      &:last-child {\n        border-top-#{$global-right}-radius: $global-radius;\n        border-bottom-#{$global-right}-radius: $global-radius;\n        border-bottom-#{$global-left}-radius: 0;\n      }\n    }\n\n  }\n}\n\n@mixin foundation-button-group {\n  .button-group {\n    @include button-group;\n\n    // Sizes\n    @each $size, $value in map-remove($button-sizes, default) {\n      &.#{$size} #{$buttongroup-child-selector} {\n        font-size: $value;\n      }\n    }\n\n    // Even-width Group\n    &.expanded {\n      @include button-group-expand;\n    }\n\n    // Solid, hollow & clear styles\n    @each $filling in (solid hollow clear) {\n      $base-selector: if($button-fill == $filling, null, '.#{$filling}');\n\n      &#{$base-selector} {\n        // Do not generate button base styles for the default filling\n        @if($button-fill != $filling) {\n          #{$buttongroup-child-selector} {\n            @include button-fill($filling);\n            @include button-fill-style($filling);\n          }\n        }\n\n        @each $name, $color in $button-palette {\n          $individual-selector: if($button-fill == $filling, null, ' #{$buttongroup-child-selector}.#{$name}');\n\n          &.#{$name} #{$buttongroup-child-selector}, #{$individual-selector} {\n            @include button-fill-style($filling, $color, auto, auto);\n          }\n        }\n      }\n\n    }\n\n    &.no-gaps {\n      @include button-group-no-gaps;\n    }\n\n    &.stacked,\n    &.stacked-for-small,\n    &.stacked-for-medium {\n      @include button-group-stack;\n\n      &.expanded {\n        @include button-group-expand;\n      }\n    }\n\n    &.stacked-for-small {\n      @include breakpoint(medium) {\n        @include button-group-unstack;\n      }\n    }\n\n    &.stacked-for-medium {\n      @include breakpoint(large) {\n        @include button-group-unstack;\n      }\n    }\n\n    &.stacked-for-small.expanded {\n      @include breakpoint(small only) {\n        display: block;\n\n        #{$buttongroup-child-selector} {\n          display: block;\n          margin-#{$global-right}: 0;\n        }\n      }\n    }\n\n    &.stacked-for-medium.expanded {\n      @include breakpoint(medium down) {\n        display: block;\n\n        #{$buttongroup-child-selector} {\n          display: block;\n          margin-#{$global-right}: 0;\n        }\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group close-button\n////\n\n/// Default position of the close button. The first value should be `right` or `left`, and the second value should be `top` or `bottom`.\n/// @type List\n$closebutton-position: right top !default;\n\n/// Default z-index for a close button.\n/// @type Number\n$closebutton-z-index: 10 !default;\n\n/// Button size to use as default\n/// @type String\n/// @see $closebutton-size\n/// @see $closebutton-offset-horizontal\n/// @see $closebutton-offset-vertical\n$closebutton-default-size: medium !default;\n\n/// Right (or left) offset(s) for a close button.\n/// @type Number|Map\n$closebutton-offset-horizontal: (\n  small: 0.66rem,\n  medium: 1rem,\n) !default;\n\n/// Top (or bottom) offset(s) for a close button.\n/// @type Number|Map\n$closebutton-offset-vertical: (\n  small: 0.33em,\n  medium: 0.5rem,\n) !default;\n\n/// Size(s) of the close button. Used to generate sizing modifiers.\n/// @type Number|Map\n$closebutton-size: (\n  small: 1.5em,\n  medium: 2em,\n) !default;\n\n/// The line-height of the close button. It affects the spacing of the element.\n/// @type Number\n$closebutton-lineheight: 1 !default;\n\n/// Default color of the close button.\n/// @type Color\n$closebutton-color: $dark-gray !default;\n\n/// Default color of the close button when being hovered on.\n/// @type Color\n$closebutton-color-hover: $black !default;\n\n\n/// Get the size and position for a close button. If the input value is a number, the number is returned. If the input value is a config map and the map has the key `$size`, the value is returned.\n///\n/// @param {Number|Map} $value - A number or map that represents the size or position value(s) of the close button.\n/// @param {Keyword} $size - The size of the close button to use.\n///\n/// @return {Number} The given number or the value found in the map.\n@function -zf-get-size-val($value, $size) {\n  // Check if the value is a number\n  @if type-of($value) == 'number' {\n    // If it is, just return the number\n    @return $value;\n  }\n\n  // Check if the size name exists in the value map\n  @else if map-has-key($value, $size) {\n    // If it does, return the value\n    @return map-get($value, $size);\n  }\n}\n\n/// Sets the size and position of a close button.\n/// @param {Keyword} $size [medium] - The size to use. Set to `small` to create a small close button. The 'medium' values defined in `$closebutton-*` variables will be used as the default size and position of the close button.\n@mixin close-button-size($size) {\n  $x: nth($closebutton-position, 1);\n  $y: nth($closebutton-position, 2);\n\n  #{$x}: -zf-get-size-val($closebutton-offset-horizontal, $size);\n  #{$y}: -zf-get-size-val($closebutton-offset-vertical, $size);\n  font-size: -zf-get-size-val($closebutton-size, $size);\n  line-height: -zf-get-size-val($closebutton-lineheight, $size);\n}\n\n/// Adds styles for a close button, using the styles in the settings variables.\n@mixin close-button {\n  $x: nth($closebutton-position, 1);\n  $y: nth($closebutton-position, 2);\n\n  @include disable-mouse-outline;\n  position: absolute;\n  z-index: $closebutton-z-index;\n  color: $closebutton-color;\n  cursor: pointer;\n\n  &:hover,\n  &:focus {\n    color: $closebutton-color-hover;\n  }\n}\n\n@mixin foundation-close-button {\n  .close-button {\n    @include close-button;\n\n    // Generate a placeholder and a class for each size\n    @each $name, $size in $closebutton-size {\n      @at-root {\n        %zf-close-button--#{$name} {\n          @include close-button-size($name);\n        }\n      }\n\n      &.#{$name} {\n        @extend %zf-close-button--#{$name};\n      }\n    }\n\n    // Use by default the placeholder of the default size\n    @extend %zf-close-button--#{$closebutton-default-size};\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group label\n////\n\n/// Default background color for labels.\n/// @type Color\n$label-background: $primary-color !default;\n\n/// Default text color for labels.\n/// @type Color\n$label-color: $white !default;\n\n/// Alternate text color for labels.\n/// @type Color\n$label-color-alt: $black !default;\n\n/// Coloring classes. A map of classes to output in your CSS, like `.secondary`, `.success`, and so on.\n/// @type Map\n$label-palette: $foundation-palette !default;\n\n/// Default font size for labels.\n/// @type Number\n$label-font-size: 0.8rem !default;\n\n/// Default padding inside labels.\n/// @type Number\n$label-padding: 0.33333rem 0.5rem !default;\n\n/// Default radius of labels.\n/// @type Number\n$label-radius: $global-radius !default;\n\n/// Generates base styles for a label.\n@mixin label {\n  display: inline-block;\n  padding: $label-padding;\n\n  border-radius: $label-radius;\n\n  font-size: $label-font-size;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: default;\n}\n\n@mixin foundation-label {\n  .label {\n    @include label;\n\n    background: $label-background;\n    color: $label-color;\n\n    @each $name, $color in $label-palette {\n      &.#{$name} {\n        background: $color;\n        color: color-pick-contrast($color, ($label-color, $label-color-alt));\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n/// Adds styles for a progress bar container.\n@mixin progress-container {\n  height: $progress-height;\n  margin-bottom: $progress-margin-bottom;\n  border-radius: $progress-radius;\n  background-color: $progress-background;\n}\n\n/// Adds styles for the inner meter of a progress bar.\n@mixin progress-meter {\n  position: relative;\n  display: block;\n  width: 0%;\n  height: 100%;\n  background-color: $progress-meter-background;\n\n  @if has-value($progress-radius) {\n    border-radius: $global-radius;\n  }\n}\n\n/// Adds styles for text in the progress meter.\n@mixin progress-meter-text {\n  @include absolute-center;\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: bold;\n  color: $white;\n  white-space: nowrap;\n\n  @if has-value($progress-radius) {\n    border-radius: $progress-radius;\n  }\n}\n\n@mixin foundation-progress-bar {\n  // Progress bar\n  .progress {\n    @include progress-container;\n\n    @each $name, $color in $foundation-palette {\n      &.#{$name} {\n        .progress-meter {\n          background-color: $color;\n        }\n      }\n    }\n  }\n\n  // Inner meter\n  .progress-meter {\n    @include progress-meter;\n  }\n\n  // Inner meter text\n  .progress-meter-text {\n    @include progress-meter-text;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n// [TODO] Check how plugin confirms disabled or vertical status\n// [TODO] Check if transition: all; is necessary\n\n////\n/// @group slider\n////\n\n/// Default slider width of a vertical slider. (Doesn't apply to the native slider.)\n/// @type Number\n$slider-width-vertical: 0.5rem !default;\n\n/// Transition properties to apply to the slider handle and fill. (Doesn't apply to the native slider.)\n/// @type Transition\n$slider-transition: all 0.2s ease-in-out !default;\n\n/// Adds the general styles for sliders.\n@mixin slider-container {\n  position: relative;\n  height: $slider-height;\n  margin-top: 1.25rem;\n  margin-bottom: 2.25rem;\n\n  background-color: $slider-background;\n  cursor: pointer;\n  user-select: none;\n  touch-action: none;\n}\n\n/// Adds the general styles for active fill for sliders.\n@mixin slider-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: inline-block;\n  max-width: 100%;\n  height: $slider-height;\n\n  background-color: $slider-fill-background;\n  transition: $slider-transition;\n\n  &.is-dragging {\n    transition: all 0s linear;\n  }\n}\n\n/// Adds the general styles for the slider handles.\n@mixin slider-handle {\n  @include disable-mouse-outline;\n  @include vertical-center;\n  left: 0;\n  z-index: 1;\n\n  display: inline-block;\n  width: $slider-handle-width;\n  height: $slider-handle-height;\n\n  border-radius: $slider-radius;\n  background-color: $slider-handle-background;\n  transition: $slider-transition;\n  touch-action: manipulation;\n\n  &:hover {\n    background-color: scale-color($slider-handle-background, $lightness: -15%);\n  }\n\n  &.is-dragging {\n    transition: all 0s linear;\n  }\n}\n\n@mixin slider-disabled {\n  opacity: $slider-opacity-disabled;\n  cursor: not-allowed;\n}\n\n@mixin slider-vertical {\n  display: inline-block;\n  width: $slider-width-vertical;\n  height: 12.5rem;\n  margin: 0 1.25rem;\n  transform: scale(1, -1);\n\n  .slider-fill {\n    top: 0;\n    width: $slider-width-vertical;\n    max-height: 100%;\n  }\n\n  .slider-handle {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    width: $slider-handle-height;\n    height: $slider-handle-width;\n    transform: translateX(-50%);\n  }\n}\n\n@mixin foundation-slider {\n  // Container\n  .slider {\n    @include slider-container;\n  }\n\n  // Fill area\n  .slider-fill {\n    @include slider-fill;\n  }\n\n  // Draggable handle\n  .slider-handle {\n    @include slider-handle;\n  }\n\n  // Disabled state\n  .slider.disabled,\n  .slider[disabled] {\n    @include slider-disabled;\n  }\n\n  // Vertical slider\n  .slider.vertical {\n    @include slider-vertical;\n  }\n\n  // RTL support\n  @if $global-text-direction == rtl {\n    .slider:not(.vertical) {\n      transform: scale(-1, 1);\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group switch\n////\n\n/// Background color of a switch.\n/// @type Color\n$switch-background: $medium-gray !default;\n\n/// Background active color of a switch.\n/// @type Color\n$switch-background-active: $primary-color !default;\n\n/// Height of a switch, with no class applied.\n/// @type Number\n$switch-height: 2rem !default;\n\n/// Height of a switch with .tiny class.\n/// @type Number\n$switch-height-tiny: 1.5rem !default;\n\n/// Height of a switch with .small class.\n/// @type Number\n$switch-height-small: 1.75rem !default;\n\n/// Height of a switch with .large class.\n/// @type Number\n$switch-height-large: 2.5rem !default;\n\n/// Border radius of the switch\n/// @type Number\n$switch-radius: $global-radius !default;\n\n/// border around a modal.\n/// @type Number\n$switch-margin: $global-margin !default;\n\n/// Background color for the switch container and paddle.\n/// @type Color\n$switch-paddle-background: $white !default;\n\n/// Spacing between a switch paddle and the edge of the body.\n/// @type Number\n$switch-paddle-offset: 0.25rem !default;\n\n/// border radius of the switch paddle\n/// @type Number\n$switch-paddle-radius: $global-radius !default;\n\n/// switch transition.\n/// @type Number\n$switch-paddle-transition: all 0.25s ease-out !default;\n\n/// Opacity of a disabled switch.\n/// @type Number\n$switch-opacity-disabled: .5 !default;\n\n/// Cursor for a disabled switch.\n/// @type Cursor\n$switch-cursor-disabled: not-allowed !default;\n\n// make them variables\n// ask about accessibility on label\n// change class name for text\n\n/// Adds styles for a switch container. Apply this to a container class.\n@mixin switch-container {\n  position: relative;\n  margin-bottom: $switch-margin;\n  outline: 0;\n\n  // These properties cascade down to the switch text\n  font-size: rem-calc(14);\n  font-weight: bold;\n  color: $white;\n\n  user-select: none;\n}\n\n/// Adds styles for a switch input. Apply this to an `<input>` within a switch.\n@mixin switch-input {\n  position: absolute;\n  margin-bottom: 0;\n  opacity: 0;\n}\n\n/// Adds styles for the background and paddle of a switch. Apply this to a `<label>` within a switch.\n@mixin switch-paddle {\n  $switch-width: $switch-height * 2;\n  $paddle-height: $switch-height - ($switch-paddle-offset * 2);\n  $paddle-width: $switch-height - ($switch-paddle-offset * 2);\n  $paddle-active-offest: $switch-width - $paddle-width - $switch-paddle-offset;\n\n  position: relative;\n  display: block;\n  width: $switch-width;\n  height: $switch-height;\n\n  border-radius: $switch-radius;\n  background: $switch-background;\n  transition: $switch-paddle-transition;\n\n  // Resetting these <label> presets so type styles cascade down\n  font-weight: inherit;\n  color: inherit;\n\n  cursor: pointer;\n\n  // Needed to override specificity\n  input + & {\n    margin: 0;\n  }\n\n  // The paddle itself\n  &::after {\n    position: absolute;\n    top: $switch-paddle-offset;\n    #{$global-left}: $switch-paddle-offset;\n\n    display: block;\n    width: $paddle-width;\n    height: $paddle-height;\n\n    transform: translate3d(0, 0, 0);\n    border-radius: $switch-paddle-radius;\n    background: $switch-paddle-background;\n    transition: $switch-paddle-transition;\n    content: '';\n  }\n\n  // Change the visual style when the switch is active\n  input:checked ~ & {\n    background: $switch-background-active;\n\n    &::after {\n      #{$global-left}: $paddle-active-offest;\n    }\n  }\n\n  // indicate a disabled switch\n  input:disabled ~ & {\n    cursor: $switch-cursor-disabled;\n    opacity: $switch-opacity-disabled;\n  }\n\n  input:focus ~ & {\n    @include disable-mouse-outline;\n  }\n}\n\n/// Adds base styles for active/inactive text inside a switch. Apply this to text elements inside the switch `<label>`.\n@mixin switch-text {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n/// Adds styles for the active state text within a switch.\n@mixin switch-text-active {\n  #{$global-left}: 8%;\n  display: none;\n\n  input:checked + label > & {\n    display: block;\n  }\n}\n\n/// Adds styles for the inactive state text within a switch.\n@mixin switch-text-inactive {\n  #{$global-right}: 15%;\n\n  input:checked + label > & {\n    display: none;\n  }\n}\n\n/// Changes the size of a switch by modifying the size of the body and paddle. Apply this to a switch container.\n/// @param {Number} $font-size [1rem] - Font size of label text within the switch.\n/// @param {Number} $switch-height [2rem] - Height of the switch body.\n/// @param {Number} $paddle-offset [0.25rem] - Spacing between the switch paddle and the edge of the switch body.\n@mixin switch-size(\n  $font-size: 1rem,\n  $switch-height: 2rem,\n  $paddle-offset: 0.25rem\n) {\n\n  $switch-width: $switch-height * 2;\n  $paddle-width: $switch-height - ($paddle-offset * 2);\n  $paddle-height: $switch-height - ($paddle-offset * 2);\n  $paddle-active-offest: $switch-width - $paddle-width - $paddle-offset;\n\n  height: $switch-height;\n\n  .switch-paddle {\n    width: $switch-width;\n    height: $switch-height;\n    font-size: $font-size;\n  }\n\n  .switch-paddle::after {\n    top: $paddle-offset;\n    #{$global-left}: $paddle-offset;\n    width: $paddle-width;\n    height: $paddle-height;\n  }\n\n  input:checked ~ .switch-paddle::after {\n    #{$global-left}: $paddle-active-offest;\n  }\n}\n\n@mixin foundation-switch {\n  // Container class\n  .switch {\n    height: $switch-height;\n    @include switch-container;\n  }\n\n  // <input> element\n  .switch-input {\n    @include switch-input;\n  }\n\n  // <label> element\n  .switch-paddle {\n    @include switch-paddle;\n  }\n\n  // Base label text styles\n  %switch-text {\n    @include switch-text;\n  }\n\n  // Active label text styles\n  .switch-active {\n    @extend %switch-text;\n    @include switch-text-active;\n  }\n\n  // Inactive label text styles\n  .switch-inactive {\n    @extend %switch-text;\n    @include switch-text-inactive;\n  }\n\n  // Switch sizes\n  .switch.tiny {\n    @include switch-size(rem-calc(10), $switch-height-tiny, $switch-paddle-offset);\n  }\n\n  .switch.small {\n    @include switch-size(rem-calc(12), $switch-height-small, $switch-paddle-offset);\n  }\n\n  .switch.large {\n    @include switch-size(rem-calc(16), $switch-height-large, $switch-paddle-offset);\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n// sass-lint:disable no-qualifying-elements\n\n////\n/// @group table\n////\n\n/// Default color for table background.\n/// @type Color\n$table-background: $white  !default;\n\n/// Default scale for darkening the striped table rows and the table border.\n/// @type Number\n$table-color-scale: 5% !default;\n\n/// Default style for table border.\n/// @type List\n$table-border: 1px solid smart-scale($table-background, $table-color-scale) !default;\n\n/// Default padding for table.\n/// @type Number\n$table-padding: rem-calc(8 10 10) !default;\n\n/// Default scale for darkening the table rows on hover.\n/// @type Number\n$table-hover-scale: 2% !default;\n\n/// Default color of standard rows on hover.\n/// @type List\n$table-row-hover: darken($table-background, $table-hover-scale) !default;\n\n/// Default color of striped rows on hover.\n/// @type List\n$table-row-stripe-hover: darken($table-background, $table-color-scale + $table-hover-scale) !default;\n\n/// If `true`, tables are striped by default and an .unstriped class is created. If `false`, a .striped class is created.\n/// @type Boolean\n$table-is-striped: true !default;\n\n/// Default background color for striped rows.\n/// @type Color\n$table-striped-background: smart-scale($table-background, $table-color-scale) !default;\n\n/// Default value for showing the stripe on rows of the tables, excluding the header and footer. If even, the even rows will have a background color. If odd, the odd rows will have a background color. If empty, or any other value, the table rows will have no striping.\n/// @type Keyword\n$table-stripe: even !default;\n\n/// Default color for header background.\n/// @type Color\n$table-head-background: smart-scale($table-background, $table-color-scale / 2) !default;\n\n/// Default color of header rows on hover.\n/// @type List\n$table-head-row-hover: darken($table-head-background, $table-hover-scale) !default;\n\n/// Default color for footer background.\n/// @type Color\n$table-foot-background: smart-scale($table-background, $table-color-scale) !default;\n\n/// Default color of footer rows on hover.\n/// @type List\n$table-foot-row-hover: darken($table-foot-background, $table-hover-scale) !default;\n\n/// Default font color for header.\n/// @type Color\n$table-head-font-color: $body-font-color !default;\n\n/// Default font color for footer.\n/// @type Color\n$table-foot-font-color: $body-font-color !default;\n\n/// Default value for showing the header when using stacked tables.\n/// @type Boolean\n$show-header-for-stacked: false !default;\n\n/// Breakpoint at which stacked table switches from mobile to desktop view.\n/// @type Breakpoint\n$table-stack-breakpoint: medium !default;\n\n@mixin -zf-table-stripe($stripe: $table-stripe) {\n  tr {\n    // If stripe is set to even, darken the even rows.\n    @if $stripe == even {\n      &:nth-child(even) {\n        border-bottom: 0;\n        background-color: $table-striped-background;\n      }\n    }\n\n    // If stripe is set to odd, darken the odd rows.\n    @else if $stripe == odd {\n      &:nth-child(odd) {\n        background-color: $table-striped-background;\n      }\n    }\n  }\n}\n\n@mixin -zf-table-unstripe() {\n  tr {\n    border-bottom: 0;\n    border-bottom: $table-border;\n    background-color: $table-background;\n  }\n}\n\n@mixin -zf-table-children-styles($stripe: $table-stripe, $is-striped: $table-is-striped) {\n  thead,\n  tbody,\n  tfoot {\n    border: $table-border;\n    background-color: $table-background;\n  }\n\n  // Caption\n  caption {\n    padding: $table-padding;\n    font-weight: $global-weight-bold;\n  }\n\n  // Table head\n  thead {\n    background: $table-head-background;\n    color: $table-head-font-color;\n  }\n\n  // Table foot\n  tfoot {\n    background: $table-foot-background;\n    color: $table-foot-font-color;\n  }\n\n  // Table head and foot\n  thead,\n  tfoot {\n    // Rows within head and foot\n    tr {\n      background: transparent;\n    }\n\n    // Cells within head and foot\n    th,\n    td {\n      padding: $table-padding;\n      font-weight: $global-weight-bold;\n      text-align: #{$global-left};\n    }\n  }\n\n  // Table rows\n  tbody {\n    th,\n    td {\n      padding: $table-padding;\n    }\n  }\n\n  // If tables are striped\n  @if $is-striped == true {\n    tbody {\n      @include -zf-table-stripe($stripe);\n    }\n\n    &.unstriped {\n      tbody {\n        @include -zf-table-unstripe();\n        background-color: $table-background;\n      }\n    }\n  }\n\n  // If tables are not striped\n  @else if $is-striped == false {\n    tbody {\n      @include -zf-table-unstripe();\n    }\n\n    &.striped {\n      tbody {\n        @include -zf-table-stripe($stripe);\n      }\n    }\n  }\n}\n\n/// Adds the general styles for tables.\n/// @param {Keyword} $stripe [$table-stripe] - Uses keywords even, odd, or none to darken rows of the table. The default value is even.\n/// @param {Boolean} $nest [false] - Needed if you only want to apply this to a specific table.\n@mixin table(\n  $stripe: $table-stripe,\n  $nest: false\n) {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: $global-margin;\n  border-radius: $global-radius;\n\n  @if $nest {\n    @include -zf-table-children-styles($stripe);\n  }\n  @else {\n    @at-root {\n      @include -zf-table-children-styles($stripe);\n    }\n  }\n}\n\n/// Adds the ability to horizontally scroll the table when the content overflows horizontally.\n@mixin table-scroll {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n}\n\n/// Slightly darkens the table rows on hover.\n@mixin table-hover {\n  thead tr {\n    //Darkens the table header rows on hover.\n    &:hover {\n      background-color: $table-head-row-hover;\n    }\n  }\n\n  tfoot tr {\n    //Darkens the table footer rows on hover.\n    &:hover {\n      background-color: $table-foot-row-hover;\n    }\n  }\n\n  tbody tr {\n    //Darkens the non-striped table rows on hover.\n    &:hover {\n      background-color: $table-row-hover;\n    }\n  }\n\n  @if $table-is-striped == true {\n    // Darkens the even striped table rows.\n    @if($table-stripe == even) {\n      &:not(.unstriped) tr:nth-of-type(even):hover {\n        background-color: $table-row-stripe-hover;\n      }\n    }\n\n    // Darkens the odd striped table rows.\n    @else if($table-stripe == odd) {\n      &:not(.unstriped) tr:nth-of-type(odd):hover {\n        background-color: $table-row-stripe-hover;\n      }\n    }\n  }\n\n  @else if $table-is-striped == false {\n    // Darkens the even striped table rows.\n    @if($table-stripe == even) {\n      &.striped tr:nth-of-type(even):hover {\n        background-color: $table-row-stripe-hover;\n      }\n    }\n\n    // Darkens the odd striped table rows.\n    @else if($table-stripe == odd) {\n      &.striped tr:nth-of-type(odd):hover {\n        background-color: $table-row-stripe-hover;\n      }\n    }\n  }\n}\n\n/// Adds styles for a stacked table. Useful for small-screen layouts.\n/// @param {Boolean} $header [$show-header-for-stacked] - Show the first th of header when stacked.\n@mixin table-stack($header: $show-header-for-stacked) {\n  @if $header {\n    thead {\n      th {\n        display: block;\n      }\n    }\n  }\n  @else {\n    thead {\n      display: none;\n    }\n  }\n\n  tfoot {\n    display: none;\n  }\n\n  tr,\n  th,\n  td {\n    display: block;\n  }\n\n  td {\n    border-top: 0;\n  }\n}\n\n@mixin foundation-table($nest: false) {\n  table {\n    @include table($nest: $nest);\n  }\n\n  table.stack {\n    @include breakpoint($table-stack-breakpoint down) {\n      @include table-stack;\n    }\n  }\n\n  table.scroll {\n    @include table-scroll;\n  }\n\n  table.hover {\n    @include table-hover;\n  }\n\n  .table-scroll {\n    overflow-x: auto;\n\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group badge\n////\n\n/// Default background color for badges.\n/// @type Color\n$badge-background: $primary-color !default;\n\n/// Default text color for badges.\n/// @type Color\n$badge-color: $white !default;\n\n/// Alternate text color for badges.\n/// @type Color\n$badge-color-alt: $black !default;\n\n/// Coloring classes. A map of classes to output in your CSS, like `.secondary`, `.success`, and so on.\n/// @type Map\n$badge-palette: $foundation-palette !default;\n\n/// Default padding inside badges.\n/// @type Number\n$badge-padding: 0.3em !default;\n\n/// Minimum width of a badge.\n/// @type Number\n$badge-minwidth: 2.1em !default;\n\n/// Default font size for badges.\n/// @type Number\n$badge-font-size: 0.6rem !default;\n\n/// Generates the base styles for a badge.\n@mixin badge {\n  display: inline-block;\n  min-width: $badge-minwidth;\n  padding: $badge-padding;\n\n  border-radius: 50%;\n\n  font-size: $badge-font-size;\n  text-align: center;\n}\n\n@mixin foundation-badge {\n  .badge {\n    @include badge;\n\n    background: $badge-background;\n    color: $badge-color;\n\n    @each $name, $color in $badge-palette {\n      &.#{$name} {\n        background: $color;\n        color: color-pick-contrast($color, ($badge-color, $badge-color-alt));\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group breadcrumbs\n////\n\n/// Margin around a breadcrumbs container.\n/// @type Number\n$breadcrumbs-margin: 0 0 $global-margin 0 !default;\n\n/// Font size of breadcrumb links.\n/// @type Number\n$breadcrumbs-item-font-size: rem-calc(11) !default;\n\n/// Color of breadcrumb links.\n/// @type Color\n$breadcrumbs-item-color: $primary-color !default;\n\n/// Color of the active breadcrumb link.\n/// @type Color\n$breadcrumbs-item-color-current: $black !default;\n\n/// Opacity of disabled breadcrumb links.\n/// @type Number\n$breadcrumbs-item-color-disabled: $medium-gray !default;\n\n/// Margin between breadcrumb items.\n/// @type Number\n$breadcrumbs-item-margin: 0.75rem !default;\n\n/// If `true`, makes breadcrumb links uppercase.\n/// @type Boolean\n$breadcrumbs-item-uppercase: true !default;\n\n/// If `true`, adds a seperator between breadcrumb links.\n/// @type Boolean\n$breadcrumbs-item-separator: true !default;\n\n// If it exists $breadcrumbs-item-slash is used to build $breadcrumbs-item-separator. See the documentation.\n@if variable-exists(breadcrumbs-item-slash) {\n  $breadcrumbs-item-separator: $breadcrumbs-item-slash;\n}\n\n/// Used character for the breadcrumb separator.\n/// @type Content\n$breadcrumbs-item-separator-item: '/' !default;\n\n/// Used character for the breadcrumb separator in rtl mode.\n/// @type Content\n$breadcrumbs-item-separator-item-rtl: '\\\\' !default;\n\n/// Color of breadcrumb item.\n/// @type Color\n$breadcrumbs-item-separator-color: $medium-gray !default;\n\n// If it exists $breadcrumbs-item-slash-color is used to build $breadcrumbs-item-separator-color. See the documentation.\n@if variable-exists(breadcrumbs-item-slash-color) {\n  $breadcrumbs-item-separator-color: $breadcrumbs-item-slash-color;\n}\n\n/// Adds styles for a breadcrumbs container, along with the styles for the `<li>` and `<a>` elements inside of it.\n@mixin breadcrumbs-container {\n  @include clearfix;\n  margin: $breadcrumbs-margin;\n  list-style: none;\n\n  // Item wrapper\n  li {\n    float: #{$global-left};\n\n    font-size: $breadcrumbs-item-font-size;\n    color: $breadcrumbs-item-color-current;\n    cursor: default;\n\n    @if $breadcrumbs-item-uppercase {\n      text-transform: uppercase;\n    }\n\n    @if $breadcrumbs-item-separator {\n      // Need to escape the backslash\n      $separator: if($global-text-direction == 'ltr', $breadcrumbs-item-separator-item, $breadcrumbs-item-separator-item-rtl);\n\n      &:not(:last-child) {\n        &::after {\n          position: relative;\n          margin: 0 $breadcrumbs-item-margin;\n          opacity: 1;\n          content: $separator;\n          color: $breadcrumbs-item-separator-color;\n        }\n      }\n    }\n    @else {\n      margin-#{$global-right}: $breadcrumbs-item-margin;\n    }\n  }\n\n  // Page links\n  a {\n    color: $breadcrumbs-item-color;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n@mixin foundation-breadcrumbs {\n  .breadcrumbs {\n    @include breadcrumbs-container;\n\n    .disabled {\n      color: $breadcrumbs-item-color-disabled;\n      cursor: not-allowed;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group callout\n////\n\n/// Default background color.\n/// @type Color\n$callout-background: $white !default;\n\n/// Default fade value for callout backgrounds.\n/// @type Number\n$callout-background-fade: 85% !default;\n\n/// Default border style for callouts.\n/// @type List\n$callout-border: 1px solid rgba($black, 0.25) !default;\n\n/// Default bottom margin for callouts.\n/// @type Number\n$callout-margin: 0 0 1rem 0 !default;\n\n/// Sizes for Callout paddings.\n/// @type Map\n$callout-sizes: (\n  small: 0.5rem,\n  default: 1rem,\n  large: 3rem,\n) !default;\n\n/// Default font color for callouts.\n/// @type Color\n$callout-font-color: $body-font-color !default;\n\n/// Default font color for callouts, if the callout has a dark background.\n/// @type Color\n$callout-font-color-alt: $body-background !default;\n\n/// Default border radius for callouts.\n/// @type Color\n$callout-radius: $global-radius !default;\n\n/// Amount to tint links used within colored panels. Set to `false` to disable this feature.\n/// @type Number | Boolean\n$callout-link-tint: 30% !default;\n\n/// Adds basic styles for a callout, including padding and margin.\n@mixin callout-base() {\n  position: relative;\n  margin: $callout-margin;\n  padding: map-get($callout-sizes, default);\n\n  border: $callout-border;\n  border-radius: $callout-radius;\n\n  // Respect the padding, fool.\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n/// Generate quick styles for a callout using a single color as a baseline.\n/// @param {Color} $color [$callout-background] - Color to use.\n@mixin callout-style($color: $callout-background) {\n  $background: scale-color($color, $lightness: $callout-background-fade);\n\n  background-color: $background;\n  color: color-pick-contrast($background, ($callout-font-color, $callout-font-color-alt));\n}\n\n@mixin callout-size($padding) {\n  padding-top: $padding;\n  padding-right: $padding;\n  padding-bottom: $padding;\n  padding-left: $padding;\n}\n\n\n/// Adds styles for a callout.\n/// @param {Color} $color [$callout-background] - Color to use.\n@mixin callout($color: $callout-background) {\n  @include callout-base;\n  @include callout-style($color);\n}\n\n@mixin foundation-callout {\n  .callout {\n    @include callout;\n\n    @each $name, $color in $foundation-palette {\n      &.#{$name} {\n        @include callout-style($color);\n      }\n    }\n\n    @each $size, $padding in map-remove($callout-sizes, default) {\n      &.#{$size} {\n        @include callout-size($padding);\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group card\n////\n\n/// Default background color.\n/// @type Color\n$card-background: $white !default;\n\n/// Default font color for cards.\n/// @type Color\n$card-font-color: $body-font-color !default;\n\n/// Default background.\n/// @type Color\n$card-divider-background: $light-gray !default;\n\n/// Default border style.\n/// @type List\n$card-border: 1px solid $light-gray !default;\n\n/// Default card shadow.\n/// @type List\n$card-shadow: none !default;\n\n/// Default border radius.\n/// @type List\n$card-border-radius: $global-radius !default;\n\n/// Default padding.\n/// @type Number\n$card-padding: $global-padding !default;\n\n/// Default bottom margin.\n/// @type number\n$card-margin-bottom: $global-margin !default;\n\n/// Adds styles for a card container.\n/// @param {Color} $background - Background color of the card.\n/// @param {Color} $color - font color of the card.\n/// @param {Number} $margin - Bottom margin of the card.\n/// @param {List} $border - Border around the card.\n/// @param {List} $radius - border radius of the card.\n/// @param {List} $shadow - box shadow of the card.\n@mixin card-container(\n  $background: $card-background,\n  $color: $card-font-color,\n  $margin: $card-margin-bottom,\n  $border: $card-border,\n  $radius: $card-border-radius,\n  $shadow: $card-shadow\n) {\n  @if $global-flexbox {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n\n  margin-bottom: $margin;\n\n  border: $border;\n  border-radius: $radius;\n\n  background: $background;\n  box-shadow: $shadow;\n\n  overflow: hidden;\n  color: $color;\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n/// Adds styles for a card divider.\n@mixin card-divider(\n  $background: $card-divider-background,\n  $padding: $card-padding\n) {\n  @if $global-flexbox {\n    display: flex;\n    flex: 0 1 auto;\n  }\n\n  padding: $padding;\n  background: $background;\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n/// Adds styles for a card section.\n@mixin card-section(\n  $padding: $card-padding\n) {\n  @if $global-flexbox {\n    flex: 1 0 auto;\n  }\n\n  padding: $padding;\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n@mixin foundation-card {\n  .card {\n    @include card-container;\n  }\n\n  .card-divider {\n    @include card-divider;\n  }\n\n  .card-section {\n    @include card-section;\n  }\n\n  // For IE 11 - Flexbug\n  // https://github.com/philipwalton/flexbugs/issues/75\n  .card-image {\n    min-height: 1px;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group dropdown\n////\n\n/// Padding for dropdown panes.\n/// @type List\n$dropdown-padding: 1rem !default;\n\n/// Background for dropdown panes.\n/// @type Color\n$dropdown-background: $body-background !default;\n\n/// Border for dropdown panes.\n/// @type List\n$dropdown-border: 1px solid $medium-gray !default;\n\n/// Font size for dropdown panes.\n/// @type List\n$dropdown-font-size: 1rem !default;\n\n/// Width for dropdown panes.\n/// @type Number\n$dropdown-width: 300px !default;\n\n/// Border radius dropdown panes.\n/// @type Number\n$dropdown-radius: $global-radius !default;\n\n/// Sizes for dropdown panes. Each size is a CSS class you can apply.\n/// @type Map\n$dropdown-sizes: (\n  tiny: 100px,\n  small: 200px,\n  large: 400px,\n) !default;\n\n/// Applies styles for a basic dropdown.\n@mixin dropdown-container {\n  position: absolute;\n  z-index: 10;\n\n  display: none;\n\n  width: $dropdown-width;\n  padding: $dropdown-padding;\n\n  visibility: hidden;\n  border: $dropdown-border;\n  border-radius: $dropdown-radius;\n  background-color: $dropdown-background;\n\n  font-size: $dropdown-font-size;\n\n\n  // Allow an intermittent state to do positioning before making visible.\n  &.is-opening {\n    display: block;\n  }\n\n  &.is-open {\n    display: block;\n    visibility: visible;\n  }\n}\n\n@mixin foundation-dropdown {\n  .dropdown-pane {\n    @include dropdown-container;\n  }\n\n  @each $name, $size in $dropdown-sizes {\n    .dropdown-pane {\n      &.#{$name} {\n        width: $size;\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group pagination\n////\n\n/// Font size of pagination items.\n/// @type Number\n$pagination-font-size: rem-calc(14) !default;\n\n/// Default bottom margin of the pagination object.\n/// @type Number\n$pagination-margin-bottom: $global-margin !default;\n\n/// Text color of pagination items.\n/// @type Color\n$pagination-item-color: $black !default;\n\n/// Padding inside of pagination items.\n/// @type Number\n$pagination-item-padding: rem-calc(3 10) !default;\n\n/// Right margin to separate pagination items.\n/// @type Number\n$pagination-item-spacing: rem-calc(1) !default;\n\n/// Default radius for pagination items.\n/// @type Number\n$pagination-radius: $global-radius !default;\n\n/// Background color of pagination items on hover.\n/// @type Color\n$pagination-item-background-hover: $light-gray !default;\n\n/// Background color of pagination item for the current page.\n/// @type Color\n$pagination-item-background-current: $primary-color !default;\n\n/// Text color of the pagination item for the current page.\n/// @type Color\n$pagination-item-color-current: $white !default;\n\n/// Text color of a disabled pagination item.\n/// @type Color\n$pagination-item-color-disabled: $medium-gray !default;\n\n/// Color of the ellipsis in a pagination menu.\n/// @type Color\n$pagination-ellipsis-color: $black !default;\n\n/// If `false`, don't display page number links on mobile, only next/previous links\n/// and optionally current page number.\n/// @type Boolean\n$pagination-mobile-items: false !default;\n\n/// If `true`, display the current page number on mobile even if `$pagination-mobile-items` is set to `false`.\n/// This parameter will only override the visibility setting of the current item for `$pagination-mobile-items: false;`,\n/// it will not affect the current page number visibility when `$pagination-mobile-items` is set to `true`.\n/// @type Boolean\n$pagination-mobile-current-item: false !default;\n\n/// If `true`, arrows are added to the next and previous links of pagination.\n/// @type Boolean\n$pagination-arrows: true !default;\n\n/// Content for the previous arrow when `$pagination-arrows` is `true`\n/// @type String\n$pagination-arrow-previous: '\\00AB' !default;\n\n/// Content for the next arrow when `$pagination-arrows` is `true`\n/// @type String\n$pagination-arrow-next: '\\00BB' !default;\n\n/// Adds styles for a pagination container. Apply this to a `<ul>`.\n@mixin pagination-container (\n  $margin-bottom: $pagination-margin-bottom,\n  $font-size: $pagination-font-size,\n  $spacing: $pagination-item-spacing,\n  $radius: $pagination-radius,\n  $color: $pagination-item-color,\n  $padding: $pagination-item-padding,\n  $background-hover: $pagination-item-background-hover\n) {\n  @include clearfix;\n  margin-#{$global-left}: 0;\n  margin-bottom: $margin-bottom;\n\n  // List item\n  li {\n    margin-#{$global-right}: $spacing;\n    border-radius: $radius;\n    font-size: $font-size;\n\n    @if $pagination-mobile-items {\n      display: inline-block;\n    }\n    @else {\n      display: none;\n\n      &:last-child,\n      &:first-child {\n        display: inline-block;\n      }\n\n      @if $pagination-mobile-current-item {\n        &.current {\n          display: inline-block;\n        }\n      }\n\n      @include breakpoint(medium) {\n        display: inline-block;\n      }\n    }\n  }\n\n  // Page links\n  a,\n  button {\n    display: block;\n    padding: $padding;\n    border-radius: $radius;\n    color: $color;\n\n    &:hover {\n      background: $background-hover;\n    }\n  }\n}\n\n/// Adds styles for the current pagination item. Apply this to an `<a>`.\n@mixin pagination-item-current (\n  $padding: $pagination-item-padding,\n  $background-current: $pagination-item-background-current,\n  $color-current: $pagination-item-color-current\n) {\n  padding: $padding;\n  background: $background-current;\n  color: $color-current;\n  cursor: default;\n}\n\n/// Adds styles for a disabled pagination item. Apply this to an `<a>`.\n@mixin pagination-item-disabled (\n  $padding: $pagination-item-padding,\n  $color: $pagination-item-color-disabled\n) {\n  padding: $padding;\n  color: $color;\n  cursor: not-allowed;\n\n  &:hover {\n    background: transparent;\n  }\n}\n\n/// Adds styles for an ellipsis for use in a pagination list.\n@mixin pagination-ellipsis (\n  $padding: $pagination-item-padding,\n  $color: $pagination-ellipsis-color\n) {\n  padding: $padding;\n  content: '\\2026';\n  color: $color;\n}\n\n@mixin foundation-pagination {\n  .pagination {\n    @include pagination-container;\n\n    .current {\n      @include pagination-item-current;\n    }\n\n    .disabled {\n      @include pagination-item-disabled;\n    }\n\n    .ellipsis::after {\n      @include pagination-ellipsis;\n    }\n  }\n\n  @if $pagination-arrows {\n    .pagination-previous a::before,\n    .pagination-previous.disabled::before {\n      display: inline-block;\n      margin-#{$global-right}: 0.5rem;\n      content: $pagination-arrow-previous;\n    }\n\n    .pagination-next a::after,\n    .pagination-next.disabled::after {\n      display: inline-block;\n      margin-#{$global-left}: 0.5rem;\n      content: $pagination-arrow-next;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group tooltip\n////\n\n/// Default cursor of the defined term.\n/// @type Keyword\n$has-tip-cursor: help !default;\n\n/// Default font weight of the defined term.\n/// @type Keyword | Number\n$has-tip-font-weight: $global-weight-bold !default;\n\n/// Default border bottom of the defined term.\n/// @type List\n$has-tip-border-bottom: dotted 1px $dark-gray !default;\n\n/// Default color of the tooltip background.\n/// @type Color\n$tooltip-background-color: $black !default;\n\n/// Default color of the tooltip font.\n/// @type Color\n$tooltip-color: $white !default;\n\n/// Default padding of the tooltip background.\n/// @type Number\n$tooltip-padding: 0.75rem !default;\n\n/// Default max width for tooltips.\n/// @type Number\n$tooltip-max-width: 10rem !default;\n\n/// Default font size of the tooltip text. By default, we recommend a smaller font size than the body copy.\n/// @type Number\n$tooltip-font-size: $small-font-size !default;\n\n/// Default pip width for tooltips.\n/// @type Number\n$tooltip-pip-width: 0.75rem !default;\n\n/// Default pip height for tooltips. This is helpful for calculating the distance of the tooltip from the tooltip word.\n/// @type Number\n$tooltip-pip-height: $tooltip-pip-width * 0.866 !default;\n\n/// Default radius for tooltips.\n/// @type Number\n$tooltip-radius: $global-radius !default;\n\n@mixin has-tip {\n  position: relative;\n  display: inline-block;\n\n  border-bottom: $has-tip-border-bottom;\n  font-weight: $has-tip-font-weight;\n  cursor: $has-tip-cursor;\n}\n\n@mixin tooltip {\n  position: absolute;\n  top: calc(100% + #{$tooltip-pip-height});\n  z-index: 1200;\n\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding;\n\n  border-radius: $tooltip-radius;\n  background-color: $tooltip-background-color;\n  font-size: $tooltip-font-size;\n  color: $tooltip-color;\n\n  &::before {\n    position: absolute;\n  }\n\n  &.bottom {\n    &::before {\n      @include css-triangle($tooltip-pip-width, $tooltip-background-color, up);\n      bottom: 100%;\n    }\n\n    &.align-center::before {\n      left: 50%;\n      transform: translateX(-50%);\n    }\n  }\n\n  &.top {\n    &::before {\n      @include css-triangle($tooltip-pip-width, $tooltip-background-color, down);\n      top: 100%;\n      bottom: auto;\n    }\n\n    &.align-center::before {\n      left: 50%;\n      transform: translateX(-50%);\n    }\n  }\n\n  &.left {\n    &::before {\n      @include css-triangle($tooltip-pip-width, $tooltip-background-color, right);\n      left: 100%;\n    }\n\n    &.align-center::before {\n      bottom: auto;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  }\n\n  &.right {\n    &::before {\n      @include css-triangle($tooltip-pip-width, $tooltip-background-color, left);\n      right: 100%;\n      left: auto;\n    }\n\n    &.align-center::before {\n      bottom: auto;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  }\n\n  &.align-top::before {\n    bottom: auto;\n    top: 10%;\n  }\n\n  &.align-bottom::before {\n    bottom: 10%;\n    top: auto;\n  }\n\n  &.align-left::before {\n    left: 10%;\n    right: auto;\n  }\n\n  &.align-right::before {\n    left: auto;\n    right: 10%;\n  }\n}\n\n@mixin foundation-tooltip {\n  .has-tip {\n    @include has-tip;\n  }\n\n  .tooltip {\n    @include tooltip;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group accordion\n////\n\n/// Default background color of an accordion group.\n/// @type Color\n$accordion-background: $white !default;\n\n/// If `true`, adds plus and minus icons to the side of each accordion title.\n/// @type Boolean\n$accordion-plusminus: true !default;\n\n/// Content for the plus icon when `$accordion-plusminus` is `true`\n/// @type String\n$accordion-plus-content: '\\002B' !default;\n\n/// Content for the minus icon when `$accordion-plusminus` is `true`\n/// @type String\n$accordion-minus-content: '\\2013' !default;\n\n/// Font size of accordion titles.\n/// @type Number\n$accordion-title-font-size: rem-calc(12) !default;\n\n/// Default text color for items in a Menu.\n/// @type Color\n$accordion-item-color: $primary-color !default;\n\n/// Default background color on hover for items in a Menu.\n/// @type Color\n$accordion-item-background-hover: $light-gray !default;\n\n/// Default padding of an accordion item.\n/// @type Number | List\n$accordion-item-padding: 1.25rem 1rem !default;\n\n/// Default background color of tab content.\n/// @type Color\n$accordion-content-background: $white !default;\n\n/// Default border color of tab content.\n/// @type Color\n$accordion-content-border: 1px solid $light-gray !default;\n\n/// Default text color of tab content.\n/// @type Color\n$accordion-content-color: $body-font-color !default;\n\n/// Default padding for tab content.\n/// @type Number | List\n$accordion-content-padding: 1rem !default;\n\n/// Adds styles for an accordion container. Apply this to the same element that gets `data-accordion`.\n@mixin accordion-container (\n  $background: $accordion-background\n) {\n  margin-#{$global-left}: 0;\n  background: $background;\n  list-style-type: none;\n\n  &[disabled] {\n    .accordion-title {\n      cursor: not-allowed;\n    }\n  }\n}\n\n/// Adds styles for the accordion item. Apply this to the list item within an accordion ul.\n@mixin accordion-item {\n  &:first-child > :first-child {\n    border-radius: $global-radius $global-radius 0 0;\n  }\n\n  &:last-child > :last-child {\n    border-radius: 0 0 $global-radius $global-radius;\n  }\n}\n\n/// Adds styles for the title of an accordion item. Apply this to the link within an accordion item.\n@mixin accordion-title (\n  $padding: $accordion-item-padding,\n  $font-size: $accordion-title-font-size,\n  $color: $accordion-item-color,\n  $border: $accordion-content-border,\n  $background-hover: $accordion-item-background-hover\n) {\n  position: relative;\n  display: block;\n  padding: $padding;\n\n  border: $border;\n  border-bottom: 0;\n\n  font-size: $font-size;\n  line-height: 1;\n  color: $color;\n\n  :last-child:not(.is-active) > & {\n    border-bottom: $border;\n    border-radius: 0 0 $global-radius $global-radius;\n  }\n\n  &:hover,\n  &:focus {\n    background-color: $background-hover;\n  }\n\n  @if $accordion-plusminus {\n    &::before {\n      position: absolute;\n      top: 50%;\n      #{$global-right}: 1rem;\n      margin-top: -0.5rem;\n      content: $accordion-plus-content;\n    }\n\n    .is-active > &::before {\n      content: $accordion-minus-content;\n    }\n  }\n}\n\n/// Adds styles for accordion content. Apply this to the content pane below an accordion item's title.\n@mixin accordion-content (\n  $padding: $accordion-content-padding,\n  $border: $accordion-content-border,\n  $background: $accordion-content-background,\n  $color: $accordion-content-color\n) {\n  display: none;\n  padding: $padding;\n\n  border: $border;\n  border-bottom: 0;\n  background-color: $background;\n\n  color: $color;\n\n  :last-child > &:last-child {\n    border-bottom: $border;\n  }\n}\n\n@mixin foundation-accordion {\n  .accordion {\n    @include accordion-container;\n  }\n\n  .accordion-item {\n    @include accordion-item;\n  }\n\n  .accordion-title {\n    @include accordion-title;\n  }\n\n  .accordion-content {\n    @include accordion-content;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group media-object\n////\n\n/// Bottom margin of a media object.\n/// @type Number\n$mediaobject-margin-bottom: $global-margin !default;\n\n/// Left and right padding on sections within a media object.\n/// @type Number\n$mediaobject-section-padding: $global-padding !default;\n\n/// Width of images within a media object, when the object is stacked vertically. Set to 'auto' to use the image's natural width.\n/// @type Number\n$mediaobject-image-width-stacked: 100% !default;\n\n/// Adds styles for a media object container.\n@mixin media-object-container {\n  display: if($global-flexbox, flex, block);\n  margin-bottom: $mediaobject-margin-bottom;\n\n  @if $global-flexbox {\n    flex-wrap: nowrap;\n  }\n\n  img {\n    max-width: none;\n  }\n\n  @if $global-flexbox {\n    &.stack-for-#{$-zf-zero-breakpoint} {\n      @include breakpoint($-zf-zero-breakpoint only) {\n        flex-wrap: wrap;\n      }\n    }\n  }\n}\n\n/// Adds styles for sections within a media object.\n/// @param {Number} $padding [$mediaobject-section-padding] - Padding between sections.\n@mixin media-object-section($padding: $mediaobject-section-padding) {\n  @if $global-flexbox {\n    flex: 0 1 auto;\n  }\n  @else {\n    display: table-cell;\n    vertical-align: top;\n  }\n\n  &:first-child {\n    padding-#{$global-right}: $padding;\n  }\n\n  &:last-child:not(:nth-child(2)) {\n    padding-#{$global-left}: $padding;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  .stack-for-#{$-zf-zero-breakpoint} & {\n    @include breakpoint($-zf-zero-breakpoint only) {\n      @include media-object-stack;\n    }\n  }\n\n  @if $global-flexbox {\n    &.main-section {\n      flex: 1 1 0px; // sass-lint:disable-line zero-unit\n    }\n  }\n  @else {\n    &.middle {\n      vertical-align: middle;\n    }\n\n    &.bottom {\n      vertical-align: bottom;\n    }\n  }\n}\n\n/// Adds styles to stack sections of a media object. Apply this to the section elements, not the container.\n@mixin media-object-stack {\n  padding: 0;\n  padding-bottom: $mediaobject-section-padding;\n\n  @if $global-flexbox {\n    flex-basis: 100%;\n    max-width: 100%;\n  }\n  @else {\n    display: block;\n  }\n\n  img {\n    width: $mediaobject-image-width-stacked;\n  }\n}\n\n@mixin foundation-media-object {\n  .media-object {\n    @include media-object-container;\n  }\n\n  .media-object-section {\n    @include media-object-section;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group orbit\n////\n\n/// Default color for Orbit's bullets.\n/// @type Color\n$orbit-bullet-background: $medium-gray !default;\n\n/// Default active color for Orbit's bullets.\n/// @type Color\n$orbit-bullet-background-active: $dark-gray !default;\n\n/// Default diameter for Orbit's bullets.\n/// @type Number\n$orbit-bullet-diameter: 1.2rem !default;\n\n/// Default margin between Orbit's bullets.\n/// @type Number\n$orbit-bullet-margin: 0.1rem !default;\n\n/// Default distance from slide region for Orbit's bullets.\n/// @type Number\n$orbit-bullet-margin-top: 0.8rem !default;\n\n/// Default bottom margin from Orbit's bullets to whatever content may lurk below it.\n/// @type Number\n$orbit-bullet-margin-bottom: 0.8rem !default;\n\n/// Default background color for Orbit's caption.\n/// @type Color\n$orbit-caption-background: rgba($black, 0.5) !default;\n\n/// Default padding for Orbit's caption.\n/// @type Number\n$orbit-caption-padding: 1rem !default;\n\n/// Default background color for Orbit's controls when hovered.\n/// @type Color\n$orbit-control-background-hover: rgba($black, 0.5) !default;\n\n/// Default padding for Orbit's controls.\n/// @type Number\n$orbit-control-padding: 1rem !default;\n\n/// Default z-index for Orbit's controls.\n/// @type Number\n$orbit-control-zindex: 10 !default;\n\n/// Adds styles for the outer Orbit wrapper. These styles are used on the `.orbit` class.\n@mixin orbit-wrapper {\n  position: relative;\n}\n\n/// Adds styles for the inner Orbit slide container. These styles are used on the `.orbit-container` class.\n@mixin orbit-container {\n  position: relative;\n  height: 0; // Prevent FOUC by not showing until JS sets height\n  margin: 0;\n  list-style: none;\n  overflow: hidden;\n}\n\n/// Adds styles for the individual slides of an Orbit slider. These styles are used on the `.orbit-slide` class.\n@mixin orbit-slide {\n  width: 100%;\n  position: absolute;\n\n  &.no-motionui {\n    &.is-active {\n      top: 0;\n      left: 0;\n    }\n  }\n}\n\n@mixin orbit-figure {\n  margin: 0;\n}\n\n/// Adds styles for a slide containing an image. These styles are used on the `.orbit-image` class.\n@mixin orbit-image {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n}\n\n/// Adds styles for an orbit slide caption. These styles are used on the `.orbit-caption` class.\n@mixin orbit-caption {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  margin-bottom: 0;\n  padding: $orbit-caption-padding;\n\n  background-color: $orbit-caption-background;\n  color: color-pick-contrast($orbit-caption-background);\n}\n\n/// Adds base styles for the next/previous buttons in an Orbit slider. These styles are shared between the `.orbit-next` and `.orbit-previous` classes in the default CSS.\n@mixin orbit-control {\n  @include disable-mouse-outline;\n  @include vertical-center;\n  z-index: $orbit-control-zindex;\n  padding: $orbit-control-padding;\n  color: $white;\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: $orbit-control-background-hover;\n  }\n}\n\n/// Adds styles for the Orbit previous button. These styles are used on the `.orbit-previous` class.\n@mixin orbit-previous {\n  #{$global-left}: 0;\n}\n\n/// Adds styles for the Orbit next button. These styles are used on the `.orbit-next` class.\n@mixin orbit-next {\n  #{$global-left}: auto;\n  #{$global-right}: 0;\n}\n\n/// Adds styles for a container of Orbit bullets. /// Adds styles for the Orbit previous button. These styles are used on the `.orbit-bullets` class.\n@mixin orbit-bullets {\n  @include disable-mouse-outline;\n  position: relative;\n  margin-top: $orbit-bullet-margin-top;\n  margin-bottom: $orbit-bullet-margin-bottom;\n  text-align: center;\n\n  button {\n    width: $orbit-bullet-diameter;\n    height: $orbit-bullet-diameter;\n    margin: $orbit-bullet-margin;\n\n    border-radius: 50%;\n    background-color: $orbit-bullet-background;\n\n    &:hover {\n      background-color: $orbit-bullet-background-active;\n    }\n\n    &.is-active {\n      background-color: $orbit-bullet-background-active;\n    }\n  }\n}\n\n@mixin foundation-orbit {\n  .orbit {\n    @include orbit-wrapper;\n  }\n\n  .orbit-container {\n    @include orbit-container;\n  }\n\n  .orbit-slide {\n    @include orbit-slide;\n  }\n\n  .orbit-figure {\n    @include orbit-figure;\n  }\n\n  .orbit-image {\n    @include orbit-image;\n  }\n\n  .orbit-caption {\n    @include orbit-caption;\n  }\n\n  %orbit-control {\n    @include orbit-control;\n  }\n\n  .orbit-previous {\n    @extend %orbit-control;\n    @include orbit-previous;\n  }\n\n  .orbit-next {\n    @extend %orbit-control;\n    @include orbit-next;\n  }\n\n  .orbit-bullets {\n    @include orbit-bullets;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group responsive-embed\n////\n\n/// Margin below a responsive embed container.\n/// @type Number\n$responsive-embed-margin-bottom: rem-calc(16) !default;\n\n/// Aspect ratios used to determine padding-bottom of responsive embed containers.\n/// @type Map\n$responsive-embed-ratios: (\n  default: 4 by 3,\n  widescreen: 16 by 9,\n) !default;\n\n/// Creates a responsive embed container.\n/// @param {String|List} $ratio [default] - Ratio of the container. Can be a key from the `$responsive-embed-ratios` map or a list formatted as `x by y`.\n@mixin responsive-embed($ratio: default) {\n  @if type-of($ratio) == 'string' {\n    $ratio: map-get($responsive-embed-ratios, $ratio);\n  }\n  position: relative;\n  height: 0;\n  margin-bottom: $responsive-embed-margin-bottom;\n  padding-bottom: ratio-to-percentage($ratio);\n  overflow: hidden;\n\n  iframe,\n  object,\n  embed,\n  video {\n    position: absolute;\n    top: 0;\n    #{$global-left}: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@mixin foundation-responsive-embed {\n  .responsive-embed,\n  .flex-video {\n    @include responsive-embed($ratio: default);\n\n    $ratios: map-remove($responsive-embed-ratios,default);\n\n    @each $name, $ratio in $ratios {\n      &.#{$name} {\n        padding-bottom: ratio-to-percentage($ratio);\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group tabs\n////\n\n/// Default margin of the tab bar.\n/// @type Number\n$tab-margin: 0 !default;\n\n/// Default background color of a tab bar.\n/// @type Color\n$tab-background: $white !default;\n\n/// Font color of tab item.\n/// @type Color\n$tab-color: $primary-color !default;\n\n/// Active background color of a tab bar.\n/// @type Color\n$tab-background-active: $light-gray !default;\n\n/// Active font color of tab item.\n/// @type Color\n$tab-active-color: $primary-color !default;\n\n/// Font size of tab items.\n/// @type Number\n$tab-item-font-size: rem-calc(12) !default;\n\n/// Default background color on hover for items in a Menu.\n$tab-item-background-hover: $white !default;\n\n/// Default padding of a tab item.\n/// @type Number\n$tab-item-padding: 1.25rem 1.5rem !default;\n\n/// Default background color of tab content.\n/// @type Color\n$tab-content-background: $white !default;\n\n/// Default border color of tab content.\n/// @type Color\n$tab-content-border: $light-gray !default;\n\n/// Default text color of tab content.\n/// @type Color\n$tab-content-color: $body-font-color !default;\n\n/// Default padding for tab content.\n/// @type Number | List\n$tab-content-padding: 1rem !default;\n\n/// Adds styles for a tab container. Apply this to a `<ul>`.\n@mixin tabs-container (\n  $margin: $tab-margin,\n  $background: $tab-background,\n  $border-color: $tab-content-border\n) {\n  @include clearfix;\n  margin: $margin;\n  border: 1px solid $border-color;\n  background: $background;\n  list-style-type: none;\n}\n\n/// Augments a tab container to have vertical tabs. Use this in conjunction with `tabs-container()`.\n@mixin tabs-container-vertical {\n  > li {\n    display: block;\n    float: none;\n    width: auto;\n  }\n}\n\n/// Adds styles for the links within a tab container. Apply this to the `<li>` elements inside a tab container.\n@mixin tabs-title (\n  $padding: $tab-item-padding,\n  $font-size: $tab-item-font-size,\n  $color: $tab-color,\n  $color-active: $tab-active-color,\n  $background-hover: $tab-item-background-hover,\n  $background-active: $tab-background-active\n) {\n  float: #{$global-left};\n\n  > a {\n    @include disable-mouse-outline;\n    display: block;\n    padding: $padding;\n    font-size: $font-size;\n    line-height: 1;\n    color: $color;\n\n    &:hover {\n      background: $background-hover;\n      color: scale-color($color, $lightness: -14%);\n    }\n\n    &:focus,\n    &[aria-selected='true'] {\n      background: $background-active;\n      color: $color-active;\n    }\n  }\n}\n\n/// Adds styles for the wrapper that surrounds a tab group's content panes.\n@mixin tabs-content (\n  $background: $tab-content-background,\n  $color: $tab-content-color,\n  $border-color: $tab-content-border\n) {\n  border: 1px solid $border-color;\n  border-top: 0;\n  background: $background;\n  color: $color;\n  transition: all 0.5s ease;\n}\n\n/// Augments a tab content container to have a vertical style, by shifting the border around. Use this in conjunction with `tabs-content()`.\n@mixin tabs-content-vertical (\n  $border-color: $tab-content-border\n) {\n  border: 1px solid $border-color;\n  border-#{$global-left}: 0;\n}\n\n/// Adds styles for an individual tab content panel within the tab content container.\n@mixin tabs-panel (\n  $padding: $tab-content-padding\n) {\n  display: none;\n  padding: $padding;\n\n  &.is-active {\n    display: block;\n  }\n}\n\n@mixin foundation-tabs {\n  .tabs {\n    @include tabs-container;\n  }\n\n  // Vertical\n  .tabs.vertical {\n    @include tabs-container-vertical;\n  }\n\n  // Simple\n  .tabs.simple {\n    > li > a {\n      padding: 0;\n\n      &:hover {\n        background: transparent;\n      }\n    }\n  }\n\n  // Primary color\n  .tabs.primary {\n    background: $primary-color;\n\n    > li > a {\n      color: color-pick-contrast($primary-color);\n\n      &:hover,\n      &:focus {\n        background: smart-scale($primary-color);\n      }\n    }\n  }\n\n  .tabs-title {\n    @include tabs-title;\n  }\n\n  .tabs-content {\n    @include tabs-content;\n  }\n\n  .tabs-content.vertical {\n    @include tabs-content-vertical;\n  }\n\n  .tabs-panel {\n    @include tabs-panel;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group thumbnail\n////\n\n/// Border around thumbnail images.\n/// @type Border\n$thumbnail-border: 4px solid $white !default;\n\n/// Bottom margin for thumbnail images.\n/// @type Length\n$thumbnail-margin-bottom: $global-margin !default;\n\n/// Box shadow under thumbnail images.\n/// @type Shadow\n$thumbnail-shadow: 0 0 0 1px rgba($black, 0.2) !default;\n\n/// Box shadow under thumbnail images.\n/// @type Shadow\n$thumbnail-shadow-hover: 0 0 6px 1px rgba($primary-color, 0.5) !default;\n\n/// Transition proprties for thumbnail images.\n/// @type Transition\n$thumbnail-transition: box-shadow 200ms ease-out !default;\n\n/// Default radius for thumbnail images.\n/// @type Number\n$thumbnail-radius: $global-radius !default;\n\n/// Adds thumbnail styles to an element.\n@mixin thumbnail {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: $thumbnail-margin-bottom;\n\n  border: $thumbnail-border;\n  border-radius: $thumbnail-radius;\n  box-shadow: $thumbnail-shadow;\n\n  line-height: 0;\n}\n\n@mixin thumbnail-link {\n  transition: $thumbnail-transition;\n\n  &:hover,\n  &:focus {\n    box-shadow: $thumbnail-shadow-hover;\n  }\n\n  image {\n    box-shadow: none;\n  }\n}\n\n@mixin foundation-thumbnail {\n  .thumbnail {\n    @include thumbnail;\n  }\n\n  a.thumbnail {\n    @include thumbnail-link;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group menu\n////\n\n/// Margin of a menu.\n/// @type Number\n$menu-margin: 0 !default;\n\n/// Left-hand margin of a nested menu.\n/// @type Number\n$menu-nested-margin: $global-menu-nested-margin !default;\n\n/// Padding for items in a pill menu.\n/// @type Number\n$menu-items-padding: $global-menu-padding !default;\n\n/// margin for items in a simple menu.\n/// @type Number\n$menu-simple-margin: 1rem !default;\n\n/// Text color of an active menu item.\n/// @type Color\n$menu-item-color-active: $white !default;\n\n/// Alternative text color of an active menu item..\n/// @type Color\n$menu-item-color-alt-active: $black !default;\n\n/// Background color of an active menu item.\n/// @type Color\n$menu-item-background-active: get-color(primary) !default;\n\n/// Spacing between an icon and text in a menu item.\n/// @type Number\n$menu-icon-spacing: 0.25rem !default;\n\n/// Backward compatibility for menu state. If true, this duplicate `active` with `is-active`. \n/// But please note that `active` will be removed in upcoming versions.\n/// @type Boolean\n$menu-state-back-compat: true !default;\n\n/// Backward compatibility for menu centered. If true, this duplicate `.menu-centered > .menu` with `.menu.align-center`. \n/// But please note that `menu-centered` will be removed in upcoming versions.\n/// @type Boolean\n$menu-centered-back-compat: true !default;\n\n/// Backward compatibility for using `icon-*` classes without `.icons` classes\n/// But please note that this backward compatibility will be removed in upcoming versions.\n/// @type Boolean\n$menu-icons-back-compat: true !default;\n\n/// Creates the base styles for a Menu.\n@mixin menu-base {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  position: relative;\n\n  @if $global-flexbox {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  li {\n    @include disable-mouse-outline;\n  }\n\n  a,\n  .button {\n    line-height: 1;\n    text-decoration: none;\n    display: block;\n    padding: $menu-items-padding;\n  }\n\n  // Reset styles of inner elements\n  input,\n  select,\n  a,\n  button {\n    margin-bottom: 0;\n  }\n\n  input {\n    display: inline-block;\n  }\n}\n\n/// Expands the items of a Menu, so each item is the same width.\n@mixin menu-expand {\n  @if $global-flexbox {\n    li {\n      flex: 1 1 0px; // sass-lint:disable-line zero-unit\n    }\n  }\n  @else {\n    display: table;\n    width: 100%;\n\n    > li {\n      display: table-cell;\n      vertical-align: middle;\n    }\n  }\n}\n\n/// Align menu items.\n@mixin menu-align($alignment) {\n  @if $alignment == left {\n    @if $global-flexbox {\n      justify-content: flex-start;\n    }\n    @else {\n      text-align: $global-left;\n    }\n  }\n  @else if $alignment == right {\n    @if $global-flexbox {\n      li {\n        display: flex;\n        justify-content: flex-end;\n\n        .submenu li {\n          justify-content: flex-start;\n        }\n      }\n\n      &.vertical li {\n        display: block;\n        text-align: $global-right;\n\n        .submenu li {\n          text-align: $global-right;\n        }\n      }\n    }\n    @else {\n      text-align: $global-right;\n\n      .submenu li {\n        text-align: $global-left;\n      }\n\n      &.vertical {\n        .submenu li {\n          text-align: $global-right;\n        }\n      }\n    }\n  }\n  @else if $alignment == center {\n    @if $global-flexbox {\n      li {\n        display: flex;\n        justify-content: center;\n\n        .submenu li {\n          justify-content: flex-start;\n        }\n      }\n    }\n    @else {\n      text-align: center;\n\n      .submenu li {\n        text-align: $global-left;\n      }\n    }\n  }\n}\n\n/// Sets the direction of a Menu.\n/// @param {Keyword} $dir [horizontal] - Direction of the Menu. Can be `horizontal` or `vertical`.\n@mixin menu-direction($dir: horizontal) {\n  @if $dir == horizontal {\n    @if $global-flexbox {\n      flex-wrap: wrap;\n      flex-direction: row;\n    }\n    @else {\n      li {\n        display: inline-block;\n      }\n    }\n  }\n  @else if $dir == vertical {\n    @if $global-flexbox {\n      flex-wrap: nowrap;\n      flex-direction: column;\n    }\n    @else {\n      li {\n        display: block;\n      }\n    }\n  }\n  @else {\n    @warn 'The direction used for menu-direction() must be horizontal or vertical.';\n  }\n}\n\n/// Creates a simple Menu, which has no padding or hover state.\n/// @param {Keyword} $dir [$global-left] - Direction of the menu. This effects the side of the `<li>` that receives the margin.\n/// @param {Number} $margin [$menu-simple-margin] - The margin to apply to each `<li>`.\n@mixin menu-simple($dir: $global-left, $margin: $menu-simple-margin) {\n  @if $global-flexbox {\n    align-items: center;\n  }\n\n  li + li {\n    margin-#{$dir}: $margin;\n  }\n\n  a {\n    padding: 0;\n  }\n}\n\n/// Adds styles for a nested Menu, by adding `margin-left` to the menu.\n/// @param {Keyword|Number} $margin [$menu-nested-margin] - Length of the margin.\n/// @param {Keyword} $nested-alignment [left] - Alignment of the nested class\n@mixin menu-nested(\n  $margin: $menu-nested-margin,\n  $nested-alignment: left\n) {\n  @if $nested-alignment == right {\n    margin-#{$global-right}: $margin;\n    margin-#{$global-left}: 0;\n  }\n  @else {\n    margin-#{$global-right}: 0;\n    margin-#{$global-left}: $margin;\n  }\n\n}\n\n/// Adds basic styles for icons in menus.\n@mixin menu-icons() {\n  @if $global-flexbox {\n    a {\n      display: flex;\n    }\n  }\n  @else {\n    img,\n    i,\n    svg {\n      vertical-align: middle;\n\n      + span {\n        vertical-align: middle;\n      }\n    }\n  }\n}\n\n/// Adds position classes for icons within a menu.\n@mixin menu-icon-position($position: left, $spacing: $menu-icon-spacing) {\n  @if $position == left {\n    li a {\n      @if $global-flexbox {\n        flex-flow: row nowrap;\n      }\n\n      img,\n      i,\n      svg {\n        margin-#{$global-right}: $spacing;\n\n        @if not $global-flexbox {\n          display: inline-block;\n        }\n      }\n    }\n  }\n  @else if $position == right {\n    li a {\n      @if $global-flexbox {\n        flex-flow: row nowrap;\n      }\n\n      img,\n      i,\n      svg {\n        margin-#{$global-left}: $spacing;\n\n        @if not $global-flexbox {\n          display: inline-block;\n        }\n      }\n    }\n  }\n  @else if $position == top {\n    li a {\n      @if $global-flexbox {\n        flex-flow: column nowrap;\n      }\n      @else {\n        text-align: center;\n      }\n\n      img,\n      i,\n      svg {\n        @if not $global-flexbox {\n          display: block;\n          margin: 0 auto $spacing;\n        }\n        @else {\n          align-self: stretch;\n          margin-bottom: $spacing;\n          text-align: center;\n        }\n      }\n    }\n  }\n  @else if $position == bottom {\n    li a {\n      @if $global-flexbox {\n        flex-flow: column nowrap;\n      }\n      @else {\n        text-align: center;\n      }\n\n      img,\n      i,\n      svg {\n        @if not $global-flexbox {\n          display: block;\n          margin: $spacing auto 0;\n        }\n        @else {\n          align-self: stretch;\n          margin-bottom: $spacing;\n          text-align: center;\n        }\n      }\n    }\n  }\n}\n\n@mixin menu-text {\n  padding: $global-menu-padding;\n\n  font-weight: bold;\n  line-height: 1;\n  color: inherit;\n}\n\n@mixin menu-state-active {\n  background: $menu-item-background-active;\n  color: color-pick-contrast($menu-item-background-active, ($menu-item-color-active, $menu-item-color-alt-active));\n}\n\n@mixin foundation-menu {\n  .menu {\n    @include menu-base;\n\n    // Default orientation: horizontal\n    &, &.horizontal {\n      @include menu-direction(horizontal);\n    }\n\n    // Vertical orientation modifier\n    &.vertical {\n      @include menu-direction(vertical);\n    }\n\n    // Even-width modifier for horizontal orientation\n    &.expanded {\n      @include menu-expand;\n    }\n\n    // Simple\n    &.simple {\n      @include menu-simple;\n    }\n\n    // Breakpoint specific versions\n    @include -zf-each-breakpoint($small: false) {\n      &.#{$-zf-size}-horizontal {\n        @include menu-direction(horizontal);\n      }\n\n      &.#{$-zf-size}-vertical {\n        @include menu-direction(vertical);\n      }\n\n      &.#{$-zf-size}-expanded {\n        @include menu-expand;\n      }\n\n      &.#{$-zf-size}-simple {\n        @include menu-expand;\n      }\n    }\n\n    // Nesting\n    &.nested {\n      @include menu-nested;\n    }\n\n    // Icon Base Styles\n    &.icons {\n      @include menu-icons;\n    }\n\n    // Backward Compatibility for active state\n    @if $menu-icons-back-compat {\n      &.icon-top,\n      &.icon-right,\n      &.icon-bottom,\n      &.icon-left {\n        @include menu-icons;\n      }\n    }\n\n    // Icon Left\n    &.icon-left {\n      @include menu-icon-position(left);\n    }\n\n    // Icon Right\n    &.icon-right {\n      @include menu-icon-position(right);\n    }\n\n    // Icon Top\n    &.icon-top {\n      @include menu-icon-position(top);\n    }\n\n    // Icon Bottom\n    &.icon-bottom {\n      @include menu-icon-position(bottom);\n    }\n\n    // Active state\n    .is-active > a {\n      @include menu-state-active;\n    }\n    \n    // Backward Compatibility for active state\n    @if $menu-state-back-compat {\n      .active > a {\n        @include menu-state-active;\n      }\n    }\n\n    // Align left\n    &.align-#{$global-left} {\n      @include menu-align(left);\n    }\n\n    // Align right\n    &.align-#{$global-right} {\n      @include menu-align(right);\n\n      .nested {\n        @include menu-nested($nested-alignment: right);\n      }\n    }\n\n    // Align center\n    &.align-center {\n      @include menu-align(center);\n    }\n\n    .menu-text {\n      @include menu-text;\n    }\n  }\n\n  @if $menu-centered-back-compat {\n    .menu-centered {\n      > .menu {\n        @if $global-flexbox {\n          justify-content: center;\n        }\n        \n        @include menu-align(center);\n      }\n    }\n  }\n\n  // Prevent FOUC when using the Responsive Menu plugin\n  .no-js [data-responsive-menu] ul {\n    display: none;\n  }\n}\n","@mixin foundation-menu-icon {\n  .menu-icon {\n    @include hamburger($color: $titlebar-icon-color, $color-hover: $titlebar-icon-color-hover);\n  }\n\n  .menu-icon.dark {\n    @include hamburger;\n  }\n}\n","////\n/// @group accordion-menu\n////\n\n/// Sets accordion menu padding.\n/// @type Number\n$accordionmenu-padding: $global-menu-padding !default;\n\n/// Sets accordion menu nested margin\n/// @type Number\n$accordionmenu-nested-margin: $global-menu-nested-margin !default;\n\n/// Sets accordion menu submenu padding.\n/// @type Number\n$accordionmenu-submenu-padding: $accordionmenu-padding !default;\n\n/// Sets if accordion menus have the default arrow styles.\n/// @type Boolean\n$accordionmenu-arrows: true !default;\n\n/// Sets accordion menu arrow color if arrow is used.\n/// @type Color\n$accordionmenu-arrow-color: $primary-color !default;\n\n/// Sets accordion menu item padding.\n/// @type Color\n$accordionmenu-item-background: null !default;\n\n/// Sets accordion menu item border.\n/// @type Color\n$accordionmenu-border: null !default;\n\n/// Sets accordion menu item padding.\n/// @type Color\n$accordionmenu-submenu-toggle-background: null !default;\n\n/// Sets accordion menu item padding.\n/// @type List\n$accordion-submenu-toggle-border: $accordionmenu-border !default;\n\n/// Sets accordion menu submenu toggle background width.\n/// @type Number\n$accordionmenu-submenu-toggle-width: 40px !default;\n\n/// Sets accordion menu submenu toggle background height.\n/// @type Number\n$accordionmenu-submenu-toggle-height: $accordionmenu-submenu-toggle-width !default;\n\n/// Sets accordion menu arrow size if arrow is used.\n/// @type Length\n$accordionmenu-arrow-size: 6px !default;\n\n@mixin zf-accordion-menu-left-right-arrows {\n  .is-accordion-submenu-parent:not(.has-submenu-toggle) > a {\n    position: relative;\n\n    &::after {\n      @include css-triangle($accordionmenu-arrow-size, $accordionmenu-arrow-color, down);\n      position: absolute;\n      top: 50%;\n      margin-top: -1 * ($accordionmenu-arrow-size / 2);\n      #{$global-right}: 1rem;\n    }\n  }\n\n  &.align-left .is-accordion-submenu-parent > a::after {\n    right: 1rem;\n    left: auto;\n  }\n\n  &.align-right .is-accordion-submenu-parent > a::after {\n    right: auto;\n    left: 1rem;\n  }\n}\n@mixin foundation-accordion-menu {\n\n  .accordion-menu {\n    @if $accordionmenu-border {\n      border-bottom: $accordionmenu-border;\n    }\n\n    li {\n      @if $accordionmenu-border {\n        border-top: $accordionmenu-border;\n        border-right: $accordionmenu-border;\n        border-left: $accordionmenu-border;\n      }\n      width: 100%;\n    }\n\n    a {\n      @if $accordionmenu-item-background {\n        background: $accordionmenu-item-background;\n      }\n      padding: $accordionmenu-padding;\n    }\n\n    .is-accordion-submenu a {\n      padding: $accordionmenu-submenu-padding;\n    }\n\n    .nested.is-accordion-submenu {\n      @include menu-nested($accordionmenu-nested-margin);\n    }\n\n    &.align-#{$global-right} {\n      .nested.is-accordion-submenu {\n        @include menu-nested($accordionmenu-nested-margin, right);\n      }\n    }\n\n    @if $accordionmenu-arrows {\n      @include zf-accordion-menu-left-right-arrows;\n\n      .is-accordion-submenu-parent[aria-expanded='true'] > a::after {\n        transform: rotate(180deg);\n        transform-origin: 50% 50%;\n      }\n    }\n  }\n\n  .is-accordion-submenu li {\n    @if $accordionmenu-border {\n      border-right: 0;\n      border-left: 0;\n    }\n  }\n\n  .is-accordion-submenu-parent {\n    position: relative;\n  }\n\n  .has-submenu-toggle > a {\n    margin-#{$global-right}: $accordionmenu-submenu-toggle-width;\n  }\n\n  // Submenu toggle\n  .submenu-toggle {\n    position: absolute;\n    top: 0;\n    #{$global-right}: 0;\n\n    width: $accordionmenu-submenu-toggle-width;\n    height: $accordionmenu-submenu-toggle-height;\n\n    cursor: pointer;\n\n    border-#{$global-left}: $accordion-submenu-toggle-border;\n\n    @if $accordionmenu-submenu-toggle-background {\n      background: $accordionmenu-submenu-toggle-background;\n    }\n\n    // Add the arrow to the toggle\n    &::after {\n      @include css-triangle(6px, $accordionmenu-arrow-color, down);\n\n      top: 0;\n      bottom: 0;\n      margin: auto;\n    }\n  }\n\n  // Rotate the arrow when menu is open\n  .submenu-toggle[aria-expanded='true']::after {\n    transform: scaleY(-1);\n    transform-origin: 50% 50%;\n  }\n\n  .submenu-toggle-text {\n    @include element-invisible;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group drilldown\n////\n\n/// Transition property to use for animating menus.\n/// @type Transition\n$drilldown-transition: transform 0.15s linear !default;\n\n/// Adds arrows to drilldown items with submenus, as well as the back button.\n/// @type Boolean\n$drilldown-arrows: true !default;\n\n/// Sets drilldown menu item padding.\n/// @type Number\n$drilldown-padding: $global-menu-padding !default;\n\n/// Sets drilldown menu nested margin\n/// @type Number\n$drilldown-nested-margin: 0 !default;\n\n/// Background color for drilldown top level items.\n/// @type Color\n$drilldown-background: $white !default;\n\n/// Sets drilldown menu item padding in the submenu.\n/// @type Number\n$drilldown-submenu-padding: $drilldown-padding !default;\n\n/// Background color for drilldown submenus.\n/// @type Color\n$drilldown-submenu-background: $white !default;\n\n/// Sets drilldown arrow color if arrow is used.\n/// @type Color\n$drilldown-arrow-color: $primary-color !default;\n\n/// Sets drilldown arrow size if arrow is used.\n/// @type Length\n$drilldown-arrow-size: 6px !default;\n\n@mixin zf-drilldown-left-right-arrows {\n  .is-drilldown-submenu-parent > a {\n    position: relative;\n\n    &::after {\n      @include css-triangle($drilldown-arrow-size, $drilldown-arrow-color, $global-right);\n      position: absolute;\n      top: 50%;\n      margin-top: -1 * $drilldown-arrow-size;\n      #{$global-right}: 1rem;\n    }\n  }\n\n  &.align-left .is-drilldown-submenu-parent > a::after {\n    @include css-triangle($dropdownmenu-arrow-size, $dropdownmenu-arrow-color, right);\n    right: 1rem;\n    left: auto;\n  }\n\n  &.align-right .is-drilldown-submenu-parent > a::after {\n    @include css-triangle($dropdownmenu-arrow-size, $dropdownmenu-arrow-color, left);\n    right: auto;\n    left: 1rem;\n  }\n\n}\n\n@mixin foundation-drilldown-menu {\n  // Applied to the Menu container\n  .is-drilldown {\n    position: relative;\n    overflow: hidden;\n\n    li {\n      display: block;\n    }\n\n    &.animate-height {\n      transition: height 0.5s;\n    }\n  }\n\n  // The top level <ul>\n  .drilldown {\n    a {\n      padding: $drilldown-padding;\n      background: $drilldown-background;\n    }\n\n    // Applied to submenu <ul>s\n    .is-drilldown-submenu {\n      position: absolute;\n      top: 0;\n      #{$global-left}: 100%;\n      z-index: -1;\n\n      width: 100%;\n      background: $drilldown-submenu-background;\n      transition: $drilldown-transition;\n\n      &.is-active {\n        z-index: 1;\n        display: block;\n        transform: translateX(if($global-text-direction == ltr, -100%, 100%));\n      }\n\n      &.is-closing {\n        transform: translateX(if($global-text-direction == ltr, 100%, -100%));\n      }\n\n      // Submenu item padding\n      a {\n        padding: $drilldown-submenu-padding;\n      }\n    }\n\n    .nested.is-drilldown-submenu {\n      @include menu-nested($drilldown-nested-margin);\n    }\n\n    .drilldown-submenu-cover-previous {\n      min-height: 100%;\n    }\n\n    @if $drilldown-arrows {\n      @include zf-drilldown-left-right-arrows;\n\n      .js-drilldown-back > a::before {\n        @include css-triangle($drilldown-arrow-size, $drilldown-arrow-color, $global-left);\n        display: inline-block;\n        vertical-align: middle;\n        margin-#{$global-right}: 0.75rem; // Creates space between the arrow and the text\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group dropdown-menu\n////\n\n/// Enables arrows for items with dropdown menus.\n/// @type Boolean\n$dropdownmenu-arrows: true !default;\n\n/// Sets dropdown menu arrow color if arrow is used.\n/// @type Color\n$dropdownmenu-arrow-color: $anchor-color !default;\n\n/// Sets dropdown menu arrow size if arrow is used.\n/// @type Length\n$dropdownmenu-arrow-size: 6px !default;\n\n/// Sets dropdown menu arrow padding for aligning the arrow correctly.\n/// @type Length\n$dropdownmenu-arrow-padding: 1.5rem !default;\n\n/// Minimum width of dropdown sub-menus.\n/// @type Length\n$dropdownmenu-min-width: 200px !default;\n\n/// Background color for top level items.\n/// @type Color\n$dropdownmenu-background: null !default;\n\n/// Background color for dropdowns.\n/// @type Color\n$dropdownmenu-submenu-background: $white !default;\n\n/// Padding for top level items.\n/// @type Number\n$dropdownmenu-padding: $global-menu-padding !default;\n\n/// Sets dropdown menu nested margin\n/// @type Number\n$dropdownmenu-nested-margin: 0 !default;\n\n/// Padding for sub-menu items.\n/// @type Number\n$dropdownmenu-submenu-padding: $dropdownmenu-padding !default;\n\n/// Border for dropdown sub-menus.\n/// @type List\n$dropdownmenu-border: 1px solid $medium-gray !default;\n\n// Border width for dropdown sub-menus.\n// Used to adjust top margin of a sub-menu if a border is used.\n// @type Length\n$dropdownmenu-border-width: nth($dropdownmenu-border, 1);\n\n/// Text color of an active dropdown menu item. Explicit override for menu defaults\n/// @type Color\n$dropdown-menu-item-color-active: get-color(primary) !default;\n\n/// Background color of an active dropdown menu item. Explicit override for menu defaults\n/// @type Color\n$dropdown-menu-item-background-active: transparent !default;\n\n@mixin zf-dropdown-left-right-arrows {\n  > a::after {\n    #{$global-right}: 14px;\n  }\n\n  &.opens-left > a::after {\n    @include css-triangle($dropdownmenu-arrow-size, $dropdownmenu-arrow-color, left);\n    right: auto;\n    left: 5px;\n  }\n\n  &.opens-right > a::after {\n    @include css-triangle($dropdownmenu-arrow-size, $dropdownmenu-arrow-color, right);\n  }\n}\n\n@mixin dropdown-menu-direction($dir: horizontal) {\n  @if $dir == horizontal {\n    > li.opens-left { // sass-lint:disable-line no-qualifying-elements\n      > .is-dropdown-submenu {\n        top: 100%;\n        right: 0;\n        left: auto;\n      }\n    }\n\n    > li.opens-right { // sass-lint:disable-line no-qualifying-elements\n      > .is-dropdown-submenu {\n        top: 100%;\n        right: auto;\n        left: 0;\n      }\n    }\n\n    @if $dropdownmenu-arrows {\n      > li.is-dropdown-submenu-parent > a { // sass-lint:disable-line no-qualifying-elements\n        position: relative;\n        padding-#{$global-right}: $dropdownmenu-arrow-padding;\n      }\n\n      > li.is-dropdown-submenu-parent > a::after { // sass-lint:disable-line no-qualifying-elements\n        @include css-triangle($dropdownmenu-arrow-size, $dropdownmenu-arrow-color, down);\n        #{$global-right}: 5px;\n        #{$global-left}: auto;\n        margin-top: -1 * ($dropdownmenu-arrow-size / 2);\n      }\n    }\n  }\n  @else if $dir == vertical {\n    > li {\n      .is-dropdown-submenu {\n        top: 0;\n      }\n\n      &.opens-left {\n        > .is-dropdown-submenu {\n          top: 0;\n          right: 100%;\n          left: auto;\n        }\n      }\n\n      &.opens-right {\n        > .is-dropdown-submenu {\n          right: auto;\n          left: 100%;\n        }\n      }\n\n      @if $dropdownmenu-arrows {\n        @include zf-dropdown-left-right-arrows;\n      }\n    }\n  }\n  @else {\n    @warn 'The direction used for dropdown-menu-direction() must be horizontal or vertical.';\n  }\n}\n\n@mixin foundation-dropdown-menu {\n  .dropdown.menu {\n    @include dropdown-menu-direction(horizontal);\n\n    a {\n      @include disable-mouse-outline;\n    }\n\n    // Top-level item\n    > li > a {\n      background: $dropdownmenu-background;\n      padding: $dropdownmenu-padding;\n    }\n\n    // Top-level item active state\n    > li.is-active > a {\n      background: $dropdown-menu-item-background-active;\n      color: $dropdown-menu-item-color-active;\n    }\n\n    .no-js & ul {\n      display: none;\n    }\n\n    .nested.is-dropdown-submenu {\n      @include menu-nested($dropdownmenu-nested-margin);\n    }\n\n    &.vertical {\n      @include dropdown-menu-direction(vertical);\n    }\n\n    @each $size in $breakpoint-classes {\n      @if $size != $-zf-zero-breakpoint {\n        @include breakpoint($size) {\n          &.#{$size}-horizontal {\n            @include dropdown-menu-direction(horizontal);\n          }\n\n          &.#{$size}-vertical {\n            @include dropdown-menu-direction(vertical);\n          }\n        }\n      }\n    }\n\n    &.align-right {\n      .is-dropdown-submenu.first-sub {\n        top: 100%;\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n\n  .is-dropdown-menu.vertical {\n    width: 100px;\n\n    &.align-right {\n      float: right;\n    }\n  }\n\n  .is-dropdown-submenu-parent {\n    position: relative;\n\n    a::after {\n      position: absolute;\n      top: 50%;\n      #{$global-right}: 5px;\n      #{$global-left}: auto;\n      margin-top: -1 * $dropdownmenu-arrow-size;\n    }\n\n    &.opens-inner > .is-dropdown-submenu {\n\n      top: 100%;\n      @if $global-text-direction == 'rtl' {\n        right: auto;\n      }\n      @else {\n        left: auto;\n      }\n    }\n\n    &.opens-left > .is-dropdown-submenu {\n      right: 100%;\n      left: auto;\n    }\n\n    &.opens-right > .is-dropdown-submenu {\n      right: auto;\n      left: 100%;\n    }\n  }\n\n  .is-dropdown-submenu {\n    position: absolute;\n    top: 0;\n    #{$global-left}: 100%;\n    z-index: 1;\n\n    display: none;\n    min-width: $dropdownmenu-min-width;\n\n    border: $dropdownmenu-border;\n    background: $dropdownmenu-submenu-background;\n\n    .dropdown & a {\n      padding: $dropdownmenu-submenu-padding;\n    }\n\n    .is-dropdown-submenu-parent {\n      @if $dropdownmenu-arrows {\n        @include zf-dropdown-left-right-arrows;\n      }\n    }\n\n    @if (type-of($dropdownmenu-border-width) == 'number') {\n      .is-dropdown-submenu {\n        margin-top: (-$dropdownmenu-border-width);\n      }\n    }\n\n    > li {\n      width: 100%;\n    }\n\n    // [TODO] Cut back specificity\n    //&:not(.js-dropdown-nohover) > .is-dropdown-submenu-parent:hover > &, // why is this line needed? Opening is handled by JS and this causes some ugly flickering when the sub is re-positioned automatically...\n    &.js-dropdown-active {\n      display: block;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group off-canvas\n////\n\n/// Width map of a left/right off-canvas panel.\n/// @type Map\n$offcanvas-sizes: (\n  small: 250px,\n) !default;\n\n/// Height map of a top/bottom off-canvas panel.\n/// @type Map\n$offcanvas-vertical-sizes: (\n  small: 250px,\n) !default;\n\n/// Background color of an off-canvas panel.\n/// @type Color\n$offcanvas-background: $light-gray !default;\n\n/// Box shadow for the off-canvas overlap panel.\n/// @type Shadow\n$offcanvas-shadow: 0 0 10px rgba($black, 0.7) !default;\n\n/// Inner box shadow size for the off-canvas push panel.\n/// @type Number\n$offcanvas-inner-shadow-size: 20px !default;\n\n/// Inner box shadow color for the off-canvas push panel.\n/// @type Color\n$offcanvas-inner-shadow-color: rgba($black, 0.25) !default;\n\n/// Z-index of an off-canvas content overlay.\n/// @type Number\n$offcanvas-overlay-zindex: 11 !default;\n\n/// Z-index of an off-canvas panel with the `push` transition.\n/// @type Number\n$offcanvas-push-zindex: 12 !default;\n\n/// Z-index of an off-canvas panel with the `overlap` transition.\n/// @type Number\n$offcanvas-overlap-zindex: 13 !default;\n\n/// Z-index of an off-canvas panel using the `reveal-for-*` classes or mixin.\n/// @type Number\n$offcanvas-reveal-zindex: 12 !default;\n\n/// Length of the animation on an off-canvas panel.\n/// @type Number\n$offcanvas-transition-length: 0.5s !default;\n\n/// Timing function of the animation on an off-canvas panel.\n/// @type Keyword\n$offcanvas-transition-timing: ease !default;\n\n/// If `true`, a revealed off-canvas will be fixed-position, and scroll with the screen.\n/// @type Bool\n$offcanvas-fixed-reveal: true !default;\n\n/// Background color for the overlay that appears when an off-canvas panel is open.\n/// @type Color\n$offcanvas-exit-background: rgba($white, 0.25) !default;\n\n/// CSS class used for the main content area. The off-canvas mixins use this to target the page content.\n$maincontent-class: 'off-canvas-content' !default;\n\n/// Adds baseline styles for off-canvas. This CSS is required to make the other pieces work.\n@mixin off-canvas-basics {\n\n  /// Transform deprecated size settings into map & show warning\n  @if variable-exists(offcanvas-size) {\n    $offcanvas-sizes: (small: $offcanvas-size, medium: $offcanvas-size) !global;\n    @warn '$offcanvas-size is deprecated and not used anymore! Please update your settings and use the map $offcanvas-sizes instead';\n  }\n  @if variable-exists(offcanvas-vertical-size) {\n    $offcanvas-vertical-sizes: (small: $offcanvas-vertical-size, medium: $offcanvas-vertical-size) !global;\n    @warn '$offcanvas-vertical-size is deprecated and not used anymore! Please update your settings and use the map $offcanvas-vertical-sizes instead';\n  }\n\n  // Checks the z-indexes and increase them due to backwards compatibility.\n  // This is necessary because the overlay's z-index is new since v6.4 and may be identical to the user custom settings of the push z-index.\n  @if $offcanvas-push-zindex <= $offcanvas-overlay-zindex { $offcanvas-push-zindex: $offcanvas-overlay-zindex + 1 !global; }\n  @if $offcanvas-overlap-zindex <= $offcanvas-push-zindex { $offcanvas-overlap-zindex: $offcanvas-push-zindex + 1 !global; }\n  @if $offcanvas-reveal-zindex <= $offcanvas-overlay-zindex { $offcanvas-reveal-zindex: $offcanvas-overlay-zindex + 1 !global; }\n\n  // Hides overflow on body when an off-canvas panel is open.\n  .is-off-canvas-open {\n    overflow: hidden;\n  }\n\n  // Off-canvas overlay (generated by JavaScript)\n  .js-off-canvas-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: $offcanvas-overlay-zindex;\n\n    width: 100%;\n    height: 100%;\n\n    transition: opacity $offcanvas-transition-length $offcanvas-transition-timing, visibility $offcanvas-transition-length $offcanvas-transition-timing;\n\n    background: $offcanvas-exit-background;\n\n    opacity: 0;\n    visibility: hidden;\n\n    overflow: hidden;\n\n    &.is-visible {\n      opacity: 1;\n      visibility: visible;\n    }\n\n    &.is-closable {\n      cursor: pointer;\n    }\n\n    &.is-overlay-absolute {\n      position: absolute;\n    }\n\n    &.is-overlay-fixed {\n      position: fixed;\n    }\n  }\n}\n\n// Adds basic styles for an off-canvas wrapper.\n@mixin off-canvas-wrapper() {\n  position: relative;\n  overflow: hidden;\n}\n\n/// Adds basic styles for an off-canvas panel.\n@mixin off-canvas-base(\n  $background: $offcanvas-background,\n  $transition: $offcanvas-transition-length $offcanvas-transition-timing,\n  $fixed: true\n) {\n  @include disable-mouse-outline;\n\n  @if $fixed == true {\n    position: fixed;\n  }\n  @else {\n    position: absolute;\n  }\n\n  // Set the off-canvas z-index.\n  z-index: $offcanvas-push-zindex;\n\n  // Increase CSS specificity\n  &.is-transition-push {\n    z-index: $offcanvas-push-zindex;\n  }\n\n  transition: transform $transition;\n  backface-visibility: hidden;\n\n  background: $background;\n\n  // Hide inactive off-canvas within the content that have the same position\n  &.is-closed {\n    visibility: hidden;\n  }\n\n  // Overlap only styles.\n  &.is-transition-overlap {\n    z-index: $offcanvas-overlap-zindex;\n\n    &.is-open {\n      box-shadow: $offcanvas-shadow;\n    }\n  }\n\n  // Sets transform to 0 to show an off-canvas panel.\n  &.is-open {\n    transform: translate(0, 0);\n  }\n}\n\n/// Adds styles to position an off-canvas panel to the left/right/top/bottom.\n@mixin off-canvas-position(\n  $position: left,\n  $orientation: horizontal,\n  $sizes: if($orientation == horizontal, $offcanvas-sizes, $offcanvas-vertical-sizes)\n) {\n  @if $position == left {\n    top: 0;\n    left: 0;\n    height: 100%;\n    overflow-y: auto;\n\n    @each $name, $size in $sizes {\n      @include breakpoint($name) {\n        width: $size;\n        transform: translateX(-$size);\n      }\n    }\n\n    // Sets the position for nested off-canvas element\n    @at-root .#{$maincontent-class} .off-canvas.position-#{$position} {\n\n      @each $name, $size in $sizes {\n        @include breakpoint($name) {\n          transform: translateX(-$size);\n        }\n      }\n      &.is-transition-overlap.is-open {\n        transform: translate(0, 0);\n      }\n    }\n\n    // Sets the open position for the content\n    @at-root .#{$maincontent-class}.is-open-#{$position} {\n      &.has-transition-push {\n        @each $name, $size in $sizes {\n          @include breakpoint($name) {\n            transform: translateX($size);\n          }\n        }\n      }\n    }\n  }\n  @else if $position == right {\n    top: 0;\n    right: 0;\n    height: 100%;\n    overflow-y: auto;\n\n    @each $name, $size in $sizes {\n      @include breakpoint($name) {\n        width: $size;\n        transform: translateX($size);\n      }\n    }\n\n    // Sets the position for nested off-canvas element\n    @at-root .#{$maincontent-class} .off-canvas.position-#{$position} {\n\n      @each $name, $size in $sizes {\n        @include breakpoint($name) {\n          transform: translateX($size);\n        }\n      }\n      &.is-transition-overlap.is-open {\n        transform: translate(0, 0);\n      }\n    }\n\n    // Sets the open position for the content\n    @at-root .#{$maincontent-class}.is-open-#{$position} {\n      &.has-transition-push {\n        @each $name, $size in $sizes {\n          @include breakpoint($name) {\n            transform: translateX(-$size);\n          }\n        }\n      }\n    }\n  }\n  @else if $position == top {\n    top: 0;\n    left: 0;\n    width: 100%;\n    overflow-x: auto;\n\n    @each $name, $size in $sizes {\n      @include breakpoint($name) {\n        height: $size;\n        transform: translateY(-$size);\n      }\n    }\n\n    // Sets the position for nested off-canvas element\n    @at-root .#{$maincontent-class} .off-canvas.position-#{$position} {\n      @each $name, $size in $sizes {\n        @include breakpoint($name) {\n          transform: translateY(-$size);\n        }\n      }\n      &.is-transition-overlap.is-open {\n        transform: translate(0, 0);\n      }\n    }\n\n    // Sets the open position for the content\n    @at-root .#{$maincontent-class}.is-open-#{$position} {\n      &.has-transition-push {\n        @each $name, $size in $sizes {\n          @include breakpoint($name) {\n            transform: translateY($size);\n          }\n        }\n      }\n    }\n  }\n  @else if $position == bottom {\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    overflow-x: auto;\n\n    @each $name, $size in $sizes {\n      @include breakpoint($name) {\n        height: $size;\n        transform: translateY($size);\n      }\n    }\n\n    // Sets the position for nested off-canvas element\n    @at-root .#{$maincontent-class} .off-canvas.position-#{$position} {\n      @each $name, $size in $sizes {\n        @include breakpoint($name) {\n          transform: translateY($size);\n        }\n      }\n      &.is-transition-overlap.is-open {\n        transform: translate(0, 0);\n      }\n    }\n\n    // Sets the open position for the content\n    @at-root .#{$maincontent-class}.is-open-#{$position} {\n      &.has-transition-push {\n        @each $name, $size in $sizes {\n          @include breakpoint($name) {\n            transform: translateY(-$size);\n          }\n        }\n      }\n    }\n  }\n\n  // If $offcanvas-inner-shadow-size is set, add inner box-shadow.\n  // This mimics the off-canvas panel having a lower z-index, without having to have one.\n  @if $offcanvas-inner-shadow-size {\n    &.is-transition-push {\n      @if $position == left {\n        @include inner-side-shadow(right, $offcanvas-inner-shadow-size, $offcanvas-inner-shadow-color);\n      }\n      @else if $position == right {\n        @include inner-side-shadow(left, $offcanvas-inner-shadow-size, $offcanvas-inner-shadow-color);\n      }\n      @else if $position == top {\n        @include inner-side-shadow(bottom, $offcanvas-inner-shadow-size, $offcanvas-inner-shadow-color);\n      }\n      @else if $position == bottom {\n        @include inner-side-shadow(top, $offcanvas-inner-shadow-size, $offcanvas-inner-shadow-color);\n      }\n    }\n  }\n\n}\n\n/// Sets the styles for the content container.\n@mixin off-canvas-content() {\n  transform: none;\n  backface-visibility: hidden;\n\n  // Bind to has-transition-X class to prevent transition for transform:none\n  &.has-transition-overlap,\n  &.has-transition-push {\n    transition: transform $offcanvas-transition-length $offcanvas-transition-timing;\n  }\n\n  // Transform scope until the element is closed (makes sure transitionend gets triggered)\n  &.has-transition-push {\n    transform: translate(0, 0);\n  }\n\n  // Consider element & content, nested in another content\n  .off-canvas.is-open {\n    transform: translate(0, 0);\n  }\n}\n\n/// Adds styles that reveal an off-canvas panel.\n@mixin off-canvas-reveal(\n$position: left,\n$zindex: $offcanvas-reveal-zindex,\n$content: $maincontent-class,\n$breakpoint: small\n) {\n  transform: none;\n  z-index: $zindex;\n  transition: none;\n  visibility: visible;\n\n  @if not $offcanvas-fixed-reveal {\n    position: absolute;\n  }\n\n  .close-button {\n    display: none;\n  }\n\n  // Consider revealed element is nested in content\n  .#{$maincontent-class} & {\n    transform: none;\n  }\n\n  @at-root .#{$content}.has-reveal-#{$position} {\n    margin-#{$position}: -zf-get-bp-val($offcanvas-sizes, $breakpoint);\n  }\n\n  // backwards compatibility (prior to v6.4)\n  & ~ .#{$content} {\n    margin-#{$position}: -zf-get-bp-val($offcanvas-sizes, $breakpoint);\n  }\n}\n\n/// Overrides the off-canvas styles\n@mixin in-canvas() {\n  visibility: visible;\n  height: auto;\n  position: static;\n  background: none;\n  width: auto;\n  overflow: visible;\n  transition: none;\n\n  // Increase CSS specificity\n  &.position-left,\n  &.position-right,\n  &.position-top,\n  &.position-bottom {\n    box-shadow: none;\n    transform: none;\n  }\n\n  .close-button {\n    display: none;\n  }\n}\n\n@mixin foundation-off-canvas {\n  @include off-canvas-basics;\n\n  // Off-canvas wrapper\n  .off-canvas-wrapper {\n    @include off-canvas-wrapper;\n  }\n\n  // Off-canvas container\n  .off-canvas {\n    @include off-canvas-base;\n\n    // Force position absolute for nested off-canvas because fixed doesn't work for push transition within the transform scope.\n    @at-root .#{$maincontent-class} & {\n      // NOTE: since overlap transition is currently forced if nested, there's no need to force position absolute until nested push transition is supported.\n      // position: absolute;\n    }\n  }\n\n  // Off-canvas container with absolute position\n  .off-canvas-absolute {\n    @include off-canvas-base($fixed: false);\n  }\n\n  // Off-canvas position classes\n  .position-left    { @include off-canvas-position(left,   horizontal); }\n  .position-right   { @include off-canvas-position(right,  horizontal); }\n  .position-top     { @include off-canvas-position(top,    vertical); }\n  .position-bottom  { @include off-canvas-position(bottom, vertical); }\n\n  .off-canvas-content {\n    @include off-canvas-content;\n  }\n\n  // Reveal off-canvas panel on larger screens\n  @each $name, $value in $breakpoint-classes {\n    @if $name != $-zf-zero-breakpoint {\n      @include breakpoint($name) {\n        .position-left.reveal-for-#{$name} {\n          @include off-canvas-reveal(left, $offcanvas-reveal-zindex, $maincontent-class, $name);\n        }\n\n        .position-right.reveal-for-#{$name} {\n          @include off-canvas-reveal(right, $offcanvas-reveal-zindex, $maincontent-class, $name);\n        }\n\n        .position-top.reveal-for-#{$name} {\n          @include off-canvas-reveal(top, $offcanvas-reveal-zindex, $maincontent-class, $name);\n        }\n\n        .position-bottom.reveal-for-#{$name} {\n          @include off-canvas-reveal(bottom, $offcanvas-reveal-zindex, $maincontent-class, $name);\n        }\n      }\n    }\n  }\n\n  // Move in-canvas for larger screens\n  @each $name, $value in $breakpoint-classes {\n    @if $name != $-zf-zero-breakpoint {\n      @include breakpoint($name) {\n        .off-canvas.in-canvas-for-#{$name} {\n          @include in-canvas;\n        }\n      }\n    }\n  }\n}\n\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n@mixin foundation-sticky {\n  .sticky-container {\n    position: relative;\n  }\n\n  .sticky {\n    position: relative;\n    z-index: 0;\n    transform: translate3d(0, 0, 0);\n  }\n\n  .sticky.is-stuck {\n    position: fixed;\n    z-index: 5;\n    width: 100%;\n\n    &.is-at-top {\n      top: 0;\n    }\n\n    &.is-at-bottom {\n      bottom: 0;\n    }\n  }\n\n  .sticky.is-anchored {\n    position: relative;\n    right: auto;\n    left: auto;\n\n    &.is-at-bottom {\n      bottom: 0;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group title-bar\n////\n\n/// Background color of a title bar.\n/// @type Color\n$titlebar-background: $black !default;\n\n/// Color of text inside a title bar.\n/// @type Color\n$titlebar-color: $white !default;\n\n/// Padding inside a title bar.\n/// @type Length\n$titlebar-padding: 0.5rem !default;\n\n/// Font weight of text inside a title bar.\n/// @type Weight\n$titlebar-text-font-weight: bold !default;\n\n/// Color of menu icons inside a title bar.\n/// @type Color\n$titlebar-icon-color: $white !default;\n\n/// Color of menu icons inside a title bar on hover.\n/// @type Color\n$titlebar-icon-color-hover: $medium-gray !default;\n\n/// Spacing between the menu icon and text inside a title bar.\n/// @type Length\n$titlebar-icon-spacing: 0.25rem !default;\n\n@mixin foundation-title-bar {\n  .title-bar {\n    padding: $titlebar-padding;\n    background: $titlebar-background;\n    color: $titlebar-color;\n\n    @if $global-flexbox {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n    }\n    @else {\n      @include clearfix;\n    }\n\n    .menu-icon {\n      margin-#{$global-left}: $titlebar-icon-spacing;\n      margin-#{$global-right}: $titlebar-icon-spacing;\n    }\n  }\n\n  @if $global-flexbox {\n    .title-bar-left,\n    .title-bar-right {\n      flex: 1 1 0px; // sass-lint:disable-line zero-unit\n    }\n\n    .title-bar-right {\n      text-align: right;\n    }\n  }\n  @else {\n    .title-bar-left {\n      float: left;\n    }\n\n    .title-bar-right {\n      float: right;\n      text-align: right;\n    }\n  }\n\n  .title-bar-title {\n    display: inline-block;\n    vertical-align: middle;\n    font-weight: $titlebar-text-font-weight;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group top-bar\n////\n\n/// Padding for the top bar.\n/// @type Number\n$topbar-padding: 0.5rem !default;\n\n/// Background color for the top bar. This color also cascades to menus within the top bar.\n/// @type Color\n$topbar-background: $light-gray !default;\n\n/// Background color submenus within the top bar. Usefull if $topbar-background is transparent.\n/// @type Color\n$topbar-submenu-background: $topbar-background !default;\n\n/// Spacing for the top bar title.\n/// @type Number\n$topbar-title-spacing: 0.5rem 1rem 0.5rem 0 !default;\n\n/// Maximum width of `<input>` elements inside the top bar.\n/// @type Number\n$topbar-input-width: 200px !default;\n\n/// Breakpoint at which top bar switches from mobile to desktop view.\n/// @type Breakpoint\n$topbar-unstack-breakpoint: medium !default;\n\n/// Adds styles for a top bar container.\n@mixin top-bar-container {\n  @if $global-flexbox {\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n  }\n  @else {\n    @include clearfix;\n  }\n\n  padding: $topbar-padding;\n\n  &,\n  ul {\n    background-color: $topbar-background;\n  }\n\n  // Check if $topbar-background is differnt from $topbar-background-submenu\n  @if ($topbar-background != $topbar-submenu-background) {\n    ul ul {\n      background-color: $topbar-submenu-background;\n    }\n  }\n\n  // Restrain width of inputs by default to make them easier to arrange\n  input {\n    max-width: $topbar-input-width;\n    margin-#{$global-right}: 1rem;\n  }\n\n  // The above styles shouldn't apply to input group fields\n  .input-group-field {\n    width: 100%;\n    margin-#{$global-right}: 0;\n  }\n\n  input.button { // sass-lint:disable-line no-qualifying-elements\n    width: auto;\n  }\n}\n\n/// Makes sections of a top bar stack on top of each other.\n@mixin top-bar-stacked {\n  @if $global-flexbox {\n    flex-wrap: wrap;\n\n    // Sub-sections\n    .top-bar-left,\n    .top-bar-right {\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n  }\n  @else {\n    // Sub-sections\n    .top-bar-left,\n    .top-bar-right {\n      width: 100%;\n    }\n  }\n}\n\n/// Undoes the CSS applied by the `top-bar-stacked()` mixin.\n@mixin top-bar-unstack {\n  @if $global-flexbox {\n    flex-wrap: nowrap;\n\n    .top-bar-left {\n      flex: 1 1 auto;\n      margin-right: auto;\n    }\n\n    .top-bar-right {\n      flex: 0 1 auto;\n      margin-left: auto;\n    }\n  }\n  @else {\n    .top-bar-left,\n    .top-bar-right {\n      width: auto;\n    }\n  }\n}\n\n@mixin foundation-top-bar {\n  // Top bar container\n  .top-bar {\n    @include top-bar-container;\n\n    // Stack on small screens by default\n    @include top-bar-stacked;\n\n    @include breakpoint($topbar-unstack-breakpoint) {\n      @include top-bar-unstack;\n    }\n\n    // Generate classes for stacking on each screen size (defined in $breakpoint-classes)\n    @each $size in $breakpoint-classes {\n      @if $size != $-zf-zero-breakpoint {\n        &.stacked-for-#{$size} {\n          @include breakpoint($size down) {\n            @include top-bar-stacked;\n          }\n        }\n      }\n    }\n  }\n\n  // Sub-sections\n  @if $global-flexbox {\n    .top-bar-title {\n      flex: 0 0 auto;\n      margin: $topbar-title-spacing;\n    }\n\n    .top-bar-left,\n    .top-bar-right {\n      flex: 0 0 auto;\n    }\n  }\n  @else {\n    .top-bar-title {\n      display: inline-block;\n      float: left;\n      padding: $topbar-title-spacing;\n\n      .menu-icon {\n        bottom: 2px;\n      }\n    }\n\n    .top-bar-left {\n      float: left;\n    }\n\n    .top-bar-right {\n      float: right;\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group float\n////\n\n@mixin foundation-float-classes {\n  .float-left {\n    float: left !important;\n  }\n\n  .float-right {\n    float: right !important;\n  }\n\n  .float-center {\n    display: block;\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .clearfix {\n    @include clearfix;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group Flexbox Utilities\n////\n//\n/// Default value for the count of source ordering`\n/// @type Number\n$flex-source-ordering-count: 6 !default;\n\n/// Quickly disable/enable Responsive breakpoints for Vanilla Flex Helpers.\n/// @type Boolean\n$flexbox-responsive-breakpoints: true !default;\n\n@mixin flex-helpers {\n  .flex-container {\n    @include flex;\n  }\n\n  .flex-child-auto {\n    flex: 1 1 auto;\n  }\n\n  .flex-child-grow {\n    flex: 1 0 auto;\n  }\n\n  .flex-child-shrink {\n    flex: 0 1 auto;\n  }\n\n  @each $dir, $prop in $-zf-flex-direction {\n    .flex-dir-#{$dir} {\n      @include flex-direction($prop);\n    }\n  }\n\n  @if ($flexbox-responsive-breakpoints) {\n    // Loop through Responsive Breakpoints\n    @each $size in $breakpoint-classes {\n      @include breakpoint($size) {\n        @if $size != $-zf-zero-breakpoint {\n          .#{$size}-flex-container {\n            @include flex;\n          }\n\n          .#{$size}-flex-child-auto {\n            flex: 1 1 auto;\n          }\n\n          .#{$size}-flex-child-grow {\n            flex: 1 0 auto;\n          }\n\n          .#{$size}-flex-child-shrink {\n            flex: 0 1 auto;\n          }\n\n          @each $dir, $prop in $-zf-flex-direction {\n            .#{$size}-flex-dir-#{$dir} {\n              @include flex-direction($prop);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@mixin foundation-flex-classes {\n  // Horizontal alignment using justify-content\n  @each $hdir, $prop in $-zf-flex-justify {\n    .align-#{$hdir} {\n      @include flex-align($x: $hdir);\n    }\n  }\n  \n  // Horizontal alignment Specifically for Vertical Menu\n  @each $hdir, $prop in map-remove($-zf-flex-justify, 'justify', 'spaced') {\n    .align-#{$hdir} {\n      &.vertical {\n        &.menu > li > a {\n          @include flex-align($x: $hdir);\n        }\n      }\n    }\n  }\n\n  // Vertical alignment using align-items and align-self\n  @each $vdir, $prop in $-zf-flex-align {\n    .align-#{$vdir} {\n      @include flex-align($y: $vdir);\n    }\n\n    .align-self-#{$vdir} {\n      @include flex-align-self($y: $vdir);\n    }\n  }\n\n  // Central alignment of content\n  .align-center-middle {\n    @include flex-align($x: center, $y: middle);\n    align-content: center;\n  }\n\n  // Source ordering\n  @include -zf-each-breakpoint {\n    @for $i from 1 through $flex-source-ordering-count {\n      .#{$-zf-size}-order-#{$i} {\n        @include flex-order($i);\n      }\n    }\n  }\n\n  // Vanilla Flexbox Helpers\n  @include flex-helpers;\n}\n","@function -zf-flex-justify($text-direction){\n  $-zf-flex-justify: (\n    'left': if($text-direction == rtl, flex-end, flex-start),\n    'right': if($text-direction == rtl, flex-start, flex-end),\n    'center': center,\n    'justify': space-between,\n    'spaced': space-around,\n  );\n\n  @return $-zf-flex-justify;\n}\n\n\n$-zf-flex-align: (\n  'top': flex-start,\n  'bottom': flex-end,\n  'middle': center,\n  'stretch': stretch,\n);\n\n$-zf-flex-direction: (\n  'row': row,\n  'row-reverse': row-reverse,\n  'column': column,\n  'column-reverse': column-reverse,\n);\n\n/// Enables flexbox by adding `display: flex` to the element.\n@mixin flex {\n  display: flex;\n}\n\n/// Horizontally or vertically aligns the items within a flex container.\n///\n/// @param {Keyword} $x [null] - Horizontal alignment to use. Can be `left`, `right`, `center`, `justify`, or `spaced`. Or, set it to `null` (the default) to not set horizontal alignment.\n/// @param {Keyword} $y [null] - Vertical alignment to use. Can be `top`, `bottom`, `middle`, or `stretch`. Or, set it to `null` (the default) to not set vertical alignment.\n@mixin flex-align($x: null, $y: null) {\n  @if $x {\n    @if map-has-key($-zf-flex-justify, $x) {\n      $x: map-get($-zf-flex-justify, $x);\n    }\n    @else {\n      @warn 'flex-grid-row-align(): #{$x} is not a valid value for horizontal alignment. Use left, right, center, justify, or spaced.';\n    }\n  }\n\n  @if $y {\n    @if map-has-key($-zf-flex-align, $y) {\n      $y: map-get($-zf-flex-align, $y);\n    }\n    @else {\n      @warn 'flex-grid-row-align(): #{$y} is not a valid value for vertical alignment. Use top, bottom, middle, or stretch.';\n    }\n  }\n\n  justify-content: $x;\n  align-items: $y;\n}\n\n/// Vertically align a single column within a flex row. Apply this mixin to a flex column.\n///\n/// @param {Keyword} $y [null] - Vertical alignment to use. Can be `top`, `bottom`, `middle`, or `stretch`. Or, set it to `null` (the default) to not set vertical alignment.\n@mixin flex-align-self($y: null) {\n  @if $y {\n    @if map-has-key($-zf-flex-align, $y) {\n      $y: map-get($-zf-flex-align, $y);\n    }\n    @else {\n      @warn 'flex-grid-column-align(): #{$y} is not a valid value for alignment. Use top, bottom, middle, or stretch.';\n    }\n  }\n\n  align-self: $y;\n}\n\n/// Changes the source order of a flex child. Children with lower numbers appear first in the layout.\n/// @param {Number} $order [0] - Order number to apply.\n@mixin flex-order($order: 0) {\n  order: $order;\n}\n\n/// Change flex-direction\n/// @param {Keyword} $direction [row] - Flex direction to use. Can be\n///   - row (default): same as text direction\n///   - row-reverse: opposite to text direction\n///   - column: same as row but top to bottom\n///   - column-reverse: same as row-reverse top to bottom\n@mixin flex-direction($direction: row) {\n  flex-direction: $direction;\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n/// Hide an element by default, only displaying it above a certain screen size.\n/// @param {Keyword} $size - Breakpoint to use. **Must be a breakpoint defined in `$breakpoints`.**\n@mixin show-for($size) {\n  $size: map-get($breakpoints, $size);\n  // Max value is 0.2px under the next breakpoint (0.02 / 16 = 0.00125).\n  // Use a precision under 1px to support browser zoom, but not to low to avoid rounding.\n  // See https://github.com/foundation/foundation-sites/issues/11313\n  $size: -zf-bp-to-em($size) - .00125;\n\n  @include breakpoint($size down) {\n    display: none !important;\n  }\n}\n\n/// Hide an element by default, only displaying it within a certain breakpoint.\n/// @param {Keyword} $size - Breakpoint to use. **Must be a breakpoint defined in `$breakpoints`.**\n@mixin show-for-only($size) {\n  $lower-bound-size: map-get($breakpoints, $size);\n  $upper-bound-size: -zf-map-next($breakpoints, $size);\n\n  // more often than not this will be correct, just one time round the loop it won't so set in scope here\n  $lower-bound: -zf-bp-to-em($lower-bound-size) - .00125;\n  // test actual lower-bound-size, if 0 set it to 0em\n  @if strip-unit($lower-bound-size) == 0 {\n    $lower-bound: -zf-bp-to-em($lower-bound-size);\n  }\n\n  @if $upper-bound-size == null {\n    @media screen and (max-width: $lower-bound) {\n      display: none !important;\n    }\n  }\n  @else {\n    $upper-bound: -zf-bp-to-em($upper-bound-size);\n\n    @media screen and (max-width: $lower-bound), screen and (min-width: $upper-bound) {\n      display: none !important;\n    }\n  }\n}\n\n\n/// Show an element by default, and hide it above a certain screen size.\n/// @param {Keyword} $size - Breakpoint to use. **Must be a breakpoint defined in `$breakpoints`.**\n@mixin hide-for($size) {\n  @include breakpoint($size) {\n    display: none !important;\n  }\n}\n\n/// Show an element by default, and hide it above a certain screen size.\n/// @param {Keyword} $size - Breakpoint to use. **Must be a breakpoint defined in `$breakpoints`.**\n@mixin hide-for-only($size) {\n  @include breakpoint($size only) {\n    display: none !important;\n  }\n}\n\n@mixin foundation-visibility-classes {\n  // Basic hiding classes\n  .hide {\n    display: none !important;\n  }\n\n  .invisible {\n    visibility: hidden;\n  }\n\n  // Responsive visibility classes\n  @each $size in $breakpoint-classes {\n    @if $size != $-zf-zero-breakpoint {\n      .hide-for-#{$size} {\n        @include hide-for($size);\n      }\n\n      .show-for-#{$size} {\n        @include show-for($size);\n      }\n    }\n\n    .hide-for-#{$size}-only {\n      @include hide-for-only($size);\n    }\n\n    .show-for-#{$size}-only {\n      @include show-for-only($size);\n    }\n  }\n\n  // Screen reader visibility classes\n  // Need a \"hide-for-sr\" class? Add aria-hidden='true' to the element\n  .show-for-sr,\n  .show-on-focus {\n    @include element-invisible;\n  }\n\n  // Only display the element when it's focused\n  .show-on-focus {\n    &:active,\n    &:focus {\n      @include element-invisible-off;\n    }\n  }\n\n  // Landscape and portrait visibility\n  .show-for-landscape,\n  .hide-for-portrait {\n    display: block !important;\n\n    @include breakpoint(landscape) {\n      display: block !important;\n    }\n\n    @include breakpoint(portrait) {\n      display: none !important;\n    }\n  }\n\n  .hide-for-landscape,\n  .show-for-portrait {\n    display: none !important;\n\n    @include breakpoint(landscape) {\n      display: none !important;\n    }\n\n    @include breakpoint(portrait) {\n      display: block !important;\n    }\n  }\n}\n","@keyframes headerTransition {\n  0% {\n    background-color: transparent;\n  }\n  35% {\n    background-color: rgba(#FFF, 0.5);\n    color: rgba(#333, 0.5);\n    fill: rgba(#333, 0.5);\n  }\n  100% {\n    background-color: #FFF;\n    color: #333;\n    fill: rgba(#333, 0.5);\n  }\n}\n","@import 't-variables';\n@import 't-animations';\n\n.u-hidden {\n\tdisplay: none;\n}","p {\n  @include breakpoint(medium) {\n    font-size: $font-large;    \n  }\n}\n\na {\n  transition: 300ms ease all;\n}\n\ninput[type=\"text\"]{\n  box-sizing: border-box;\n  width: 100%;\n  height: 2.3375rem;\n  margin: 0 0 1rem;\n  padding: 0.5rem;\n  border: 1px solid rgba(51, 51, 51, 0.2);\n  border-radius: 3px;\n  background-color: #ffffff;\n  box-shadow: inset 0 1px 2px rgba(51, 51, 51, 0.1);\n}\n\ninput[type=\"submit\"]{\n  height: 2.3375rem;\n  vertical-align: middle;\n}","$u-bold: 600;\n$white: #FFFFFF;\n$font-small: 0.875rem;\n$font-large: 1.25rem;\n","%u-link {\n  transition: 300ms ease all;\n\n  .c-icon {\n    transition: 300ms ease all;\n  }\n}\n\n.u-link--primary-hover {\n  color: inherit;\n  transition: 300ms ease all;\n  &:hover {\n    color: $primary-color;\n  }\n}\n\n.u-title {\n  margin-bottom: 0.5rem;\n  font-weight: $u-bold;\n}\n\n.u-title--small {\n  font-size: 1rem;\n}\n\n\n.u-subtitle {\n  opacity: 0.5;\n  text-transform: uppercase;\n  font-weight: $u-bold;\n  letter-spacing: 0.5px;\n\n  &.white{\n    opacity: 0.5;\n    color: $white;\n  }\n}\n\n.u-bold {\n  font-weight: $u-bold;\n}\n\n.u-text--white {\n  color: $white;\n}\n\n.u-text--o70 {\n  opacity: 0.7;\n}\n\n.u-text--o50 {\n  opacity: 0.5;\n}\n\n.u-text--light {\n  color: $medium-gray;\n}\n\n.u-center {\n text-align: center;\n}\n\n.u-text--secondary {\n  color: get-color(secondary);\n}\n\n.u-text--small {\n  font-size: 1rem;\n}\n\n.u-text--success {\n  color: get-color(success)\n}\n\n.u-text--alert {\n  color: get-color(alert)\n}\n\n.u-text--info {\n  color: get-color(info);\n}\n\n.u-text--primary {\n  color: $primary-color;\n}\n\n.u-description {\n  margin-top: 1rem;\n}\n\n.u-description--center {\n  text-align: center;\n  margin: 0 auto 1rem;\n  max-width: 800px;\n}\n\n.u-text--large {\n  font-size: 1.25rem;\n}\n\n.u-link--underline {\n  text-decoration: underline;\n}\n\n.u-text--mt50 {\n  margin-top: 0.5rem;\n}\n\n.u-text--mb0 {\n  margin-bottom: 0;\n}\n\n\n.u-text--mb50 {\n  margin-bottom: 0.5rem;\n}\n\n.u-text--mb1 {\n  margin-bottom: 1rem;\n}\n\n.u-text--mb2 {\n  margin-bottom: 2rem;\n}\n\n.u-text--mr1 {\n  margin-right: 1rem;\n}\n\n.u-text-block {\n  margin: 0.5rem;\n}\n\n","@keyframes gradient {\n\t0% {\n\t\tbackground-position: 0% 50%;\n\t}\n\t50% {\n\t\tbackground-position: 100% 50%;\n\t}\n\t100% {\n\t\tbackground-position: 0% 50%;\n\t}\n}\n\n.u-gradient--home {\n  background: linear-gradient(-45deg, rgba(7,200,122,1), rgba(0,186,239,1), #00BAEF, #8338EC);\n  background: linear-gradient(-45deg, rgba(7,200,122,1), rgba(0,186,239,1), #00BAEF, #8338EC);\n  background: linear-gradient(-45deg, rgba(7,200,122,1), rgba(0,186,239,1), #00BAEF, #8338EC);\n  background-size: 400% 400%;\n  animation: gradient 10s ease infinite;\n}\n\n\n.u-gradient--crewForAll {\n\tbackground: linear-gradient(-45deg, rgba(250,136,0,1), rgba(254,203,0,1), #FA5700, #FFBA00);\n\tbackground: linear-gradient(-45deg, rgba(250,136,0,1), rgba(254,203,0,1) #FA5700, #FFBA00);\n\tbackground: linear-gradient(-45deg, rgba(250,136,0,1), rgba(254,203,0,1) #FA5700, #FFBA00);\n\n  background-size: 400% 400%;\n  animation: gradient 10s ease infinite;\n}\n\n\n.u-gradient--about {\n\tbackground: rgb(255,126,69);\n\tbackground: linear-gradient(90deg, rgba(255,126,69,1) 0%, rgba(254,122,75,1) 33%, rgba(248,88,118,1) 63%, rgba(244,66,147,1) 100%);\n}\n\n.u-gradient--membership {\n\tbackground: linear-gradient(-45deg, rgba(11,124,227,1), rgba(38,148,238,1), rgba(90,97,237,1), rgba(131,56,236,1));\n\tbackground: linear-gradient(-45deg, rgba(11,124,227,1), rgba(38,148,238,1), rgba(90,97,237,1), rgba(131,56,236,1));\n\tbackground: linear-gradient(-45deg, rgba(11,124,227,1), rgba(38,148,238,1), rgba(90,97,237,1), rgba(131,56,236,1));\n\tbackground-size: 400% 400%;\n\tanimation: gradient 10s ease infinite;\n}\n\n.u-gradient--features {\n\tbackground: rgb(255,255,255);\n\tbackground: -moz-radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,240,1) 25%, rgba(249,249,239,1) 50%, rgba(255,255,240,1) 75%, rgba(255,255,255,1) 100%);\n\tbackground: -webkit-radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,240,1) 25%, rgba(249,249,239,1) 50%, rgba(255,255,240,1) 75%, rgba(255,255,255,1) 100%);\n\tbackground: radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,240,1) 25%, rgba(249,249,239,1) 50%, rgba(255,255,240,1) 75%, rgba(255,255,255,1) 100%);\n\tbackground-size: 400% 400%;\n}\n\n.u-gradient--gray {\n\tbackground: linear-gradient(-45deg, #f2f3f4, #f3f3f3);\n}\n\n.u-gradient--turquoiseGreen {\n\tbackground: linear-gradient(-45deg, rgba(7,200,122,1), rgba(0,186,239,1));\n}\n\n.u-gradient--pinkOrange {\n\tbackground: linear-gradient(-45deg, rgba(251, 55, 128,1), rgba(250,136,0,1));\n}\n\n.u-gradient--pinkPurple {\n\tbackground: linear-gradient(-45deg, rgba(251, 55, 128,1), rgba(131,35,236,1));\n}\n\n.u-background--white {\n\tbackground-color: rgba($white, 0.5);\n\tpadding: 1rem;\n\tborder-radius: 5px;\n}","@import 'u-typography';\n@import 'u-colors';\n\n.u-flex-bottom {\n  align-self: flex-end;\n}\n\n.u-flex-center {\n  padding: 0.5rem;\n  align-self: center;\n}\n",".o-section--large {\n  padding: 4rem 3rem;\n}\n\n.o-section--medium {\n  padding: 2rem;\n}\n\n.o-section--small {\n  padding: 1rem;\n}\n\n.o-section--image {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  position: relative;\n}\n\n.o-section--center{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  &.top {\n    justify-content: flex-start;\n  }\n\n  &.space-between {\n    justify-content: space-between;\n  }\n}\n\n.o-row-section {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  &.medium {\n  flex-direction: column;\n\n    @include breakpoint(medium){\n      flex-direction: row;\n      justify-content: center;\n    }\n  }\n\n  &.left {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n}\n\n.o-inner-section {\n  width: 100%\n}\n\n.c-wrapper--900 {\n  max-width: 900px;\n}\n\n.o-section__headline {\n  max-width: 700px;\n  @include breakpoint(xlarge){\n    max-width: 1000px;\n  }\n}\n","@import 'o-section';\n\n.sticky {\n  padding-top: 76.15px; //header height\n}\n\n.o-spectrum {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n","@mixin c-banner($color, $radius: 0) {\n  background-color: rgba($color, 0.1);\n  color: $color;\n  padding: 1rem;\n  border-radius: $radius;\n  width: 100%;\n}\n\n.c-banner--info {\n  @include c-banner(get-color(info));\n}\n\n.c-banner--default {\n  @include c-banner($black, 3px);\n}\n\n.c-banner--success {\n  @include c-banner(get-color(success), 3px);\n  margin-bottom: 1rem;\n}\n",".c-big-statement {\n  position: relative;\n  z-index: 1;\n}\n\n.c-big-statement__wrapper {\n  display: flex;\n  flex-direction: column;\n\n  &.horizontal {\n    @include breakpoint(medium) {\n      flex-direction: row;\n      align-items: center;\n    }\n  }\n}\n",".button.primary,\na.button.primary {\n  &:hover, &:focus, &:active {\n    color: $white;\n    background-color: darken(get-color(primary), 15%);\n  }\n}\n\n.c-button--center {\n  display: block;\n  margin: 0 auto 1rem;\n\n  &.expanded {\n    width: 100%;\n  }\n}\n\n.button.primary-inverse {\n  color: $primary-color;\n  background-color: $white;\n  transition: 600ms ease all;\n\n  &:hover {\n    background-color:$primary-color;\n    color:$white;  \n    border: $primary-color 1px solid;\n\n  }\n\n  &.border {\n    border: $primary-color 1px solid;\n  }\n}\n\n.c-button-group {\n  .button {\n    width: 100%;\n    margin-bottom: 1rem;\n  }\n\n  @include breakpoint(1050px){\n    .button {\n      width: auto;\n      margin-bottom: 0;\n    }\n    .button + .button {\n      margin-left: 1rem;\n    }\n\n  }\n}\n",".c-card {\n  margin: 0.5rem;\n  display: flex;\n  flex-direction: column;\n\n  @include breakpoint(medium) {\n    margin: 1rem;\n  }\n\n  &.center {\n    align-items: center;\n    justify-items: center;\n  }\n\n  &.horizontal {\n    flex-direction: row;\n    .c-icon--main {\n      margin-right: 1rem;\n    }\n  }\n\n  &.success {\n    background-color: rgba(get-color(success), 0.2);\n  }\n\n  &.alert {\n    background-color: rgba(get-color(alert), 0.2);\n  }\n\n}\n.c-card__header {\n  border-radius: 10px 10px 0 0;\n  padding: 1rem;\n  width: 100%;\n}\n\n.c-card__body {\n  padding: 1rem;\n  height: 100%;\n}\n\n.c-card__footer {\n  width: 100%;\n  padding: 0 1rem;\n}\n\n.c-card--column {\n  border: 1px solid $light-gray;\n  border-radius: 10px;\n  margin: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n\n  .c-card__header {\n    border-radius: 10px 10px 0 0;\n    min-height: 200px;\n  }\n}\n\n.c-card--shadow {\n  transition: 500ms ease all;\n  padding: 1rem;\n  box-shadow:  0 1px 4px $medium-gray;\n  border-radius: 5px;\n}\n\n.c-card-button {\n  margin-bottom: 2rem; \n  padding: 1rem 0;\n  border-radius: 3px;\n  transition: 300ms ease all;\n  \n  .c-card {\n    margin: 0;\n  }\n}\n\nbutton.c-card-button:hover {\n  cursor: pointer;\n  background-color: get-color(default);\n  opacity: 1;\n}\n\nbutton.c-card-button.active {\n  cursor: pointer;\n  background-color: get-color(default);\n  opacity: 1;\n}\n","%c-feature__active-title {\n  opacity: 1;\n  cursor: pointer;\n  color: get-color(primary);\n  .c-icon {\n    fill: get-color(primary);\n  }\n}\n\n.c-feature__graphic-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.c-feature__link {\n  padding: 0.7rem 1rem;\n  transition: 500ms ease all;\n\n  &.active {\n    box-shadow:  0 1px 4px $medium-gray;\n    margin: 0.3rem 0;\n\n    .c-feature__title {\n      @extend %c-feature__active-title;\n       margin-bottom: 0.25rem;\n    }\n  }\n}\n\n.c-feature__title {\n  @extend %u-link;\n  font-weight: $u-bold;\n  display: flex;\n  text-align: left;\n  line-height: 1.3;\n  align-items: center;\n  opacity: 0.4;\n  &:hover {\n    @extend %c-feature__active-title;\n  }\n}\n\n.c-feature__description {\n  opacity: 0.4;\n}\n\n.c-feature__graphic {\n  transition: 500ms ease all;\n}\n","//Header\n.c-header {\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  a {\n    transition: 300ms ease all;\n  }\n}\n\n.c-header__dropdown {\n  display: none;\n}\n\n.c-header__dropdown.is-active {\n  display: block;\n}\n\n.c-header__wrapper {\n  position: fixed;\n  width: 100%;\n  z-index: 10;\n}\n\n.c-header.dark {\n    a:hover(&:not(.c-header__cta)) {\n      color: $primary-color;\n    }\n\n    .active {\n      color: $primary-color;\n    }\n\n    .logo-wrapper  {\n      path {\n        fill: #333;\n      }\n    }\n}\n\n.c-header.light {\n\n    a {\n      color: $white;\n\n      &:hover{\n        color: $white;\n        background-color: rgba($white, 0.2);\n        border-radius: 3px;\n      }\n    }\n\n    .c-header__button {\n      color: $white;\n      background-color: rgba($white, 0.2);\n      border: none;\n\n      &:hover {\n        color: $primary-color;\n        background-color: rgba($white, 1);\n      }\n    }\n\n    .active {\n      color: $white;\n      background-color: rgba($white, 0.2);\n    }\n\n    .logo-wrapper {\n      path {\n        fill: #FFF;\n      }\n\n      &:hover {\n        background-color: transparent;\n      }\n    }\n}\n\n.c-header__cta {\n  margin-left: auto;\n  display:inline-flex;\n}\n\n.c-header__button.primary-inverse {\n  border: 1px solid $primary-color;\n}\n\n.scrollHeader {\n  transition: transform 6s ease;\n  background-color: $white;\n  box-shadow: 0 3px 4px rgba(#333, 0.3);\n  animation: headerTransition 500ms;\n\n  .c-header.light {\n    .logo-wrapper path {\n        fill: #333;\n      }\n\n    a {\n    color: $black;\n\n      &:hover{\n        color: $primary-color;\n      }\n    }\n\n    .c-header__button {\n      background-color: $primary-color;\n      color: $white;\n      &:hover{\n        background-color: darken($primary-color, 15%);\n        color: $white;\n      }\n    }\n\n      .c-header__button.primary-inverse {\n        background-color: $white;\n        color: $primary-color;\n        border: 1px solid $primary-color;\n      &:hover{\n        background-color: $primary-color;\n        color: $white;\n      }\n    }\n  }\n}\n\n\n.c-footer__wrapper {\n  background-color: $black;\n  color: $white;\n  padding: 1rem;\n}\n\n.c-footer-row {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.c-footer__menu{\n  color: $white;\n\n  .logo-wrapper path {\n    fill: $white;\n  }\n}\n\n.c-footer__link {\n  color: $white;\n  transition: 300ms ease all;\n  border-radius: 3px;\n\n  &:hover {\n    color: $white;\n    background-color: rgba($white, 0.2);\n  }\n}\n\n.c-footer__icon-link{\n  opacity: 0.5;\n  transition: 300ms ease all;\n  margin: 0.5rem;\n  padding: 0 !important;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.c-footer__item{\n  padding: $menu-items-padding;\n}\n","//Hero\n\n.c-image-hero__headline {\n  position: absolute;\n  max-width: 790px;\n  margin: 0 auto; \n  left: 0;\n  right: 0;\n  top: 30%;\n  padding: 0 1rem;\n}\n\n.c-image-hero {\n  position: relative;\n  width: 100%;\n  max-height: 550px;\n  overflow-y: hidden;\n}\n\n\n.c-image-hero__caption{\n  font-size: rem-calc(12);\n  background-color: get-color(default);\n  padding: 0.5rem;\n  width: 100%;\n\n  @include breakpoint(medium) {\n    background-color: transparent;\n    padding: 0;\n    position: absolute;\n    max-width: 350px;\n    font-size: rem-calc(14);\n    text-align: right;\n    color: $white;\n    font-weight: 600;\n    left: auto;\n    bottom: 1rem;\n    right: 1rem;\n  }\n}\n",".logo {\n  width: 100px;\n  max-width: 100px;\n}\n\n.c-icon {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.c-icon--white {\n  fill: $white;\n}\n\n.c-icon--w1 {\n  width: 1rem;\n  height: 1rem;\n}\n\n.c-icon--w1_5 {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n\n.c-icon--w2 {\n  width: 2rem;\n  height: 2rem;\n}\n\n.c-icon--w2_5 {\n  width: 2.5rem;\n  height: 2.5rem;\n}\n\n.c-icon--w3 {\n  width: 3rem;\n  height: 3rem;\n}\n\n.c-icon--w4 {\n  width: 4rem;\n  height: 4rem;\n}\n\n.c-icon--left {\n  margin-right: 0.3rem;\n}\n\n.c-icon--main {\n  margin-bottom: 1rem;\n  display: block;\n}\n\n.c-icon--center {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}",".c-responsive-image {\n  width: 100%;\n}\n\n.c-image--150 {\n  max-width: 150px;\n  max-height: 150px;\n}\n\n\n.c-image--main {\n  margin-bottom: 1rem;\n}\n\n\n.c-image--100 {\n  min-width: 100px;\n  max-width: 100px;\n  height: auto;\n}\n\n.c-image--200 {\n  max-width: 200px;\n  max-height: 200px;\n}\n\n.c-image--300 {\n  max-width: 300px;\n  max-height: 300px;\n}\n\n.c-image--400 {\n  max-width: 400px;\n  max-height: 400px;\n}\n\n.c-image--500 {\n  max-width: 500px;\n  max-height: 500px;\n}\n\n\n.c-image--rounded {\n  border-radius: 10px;\n}\n\n.c-image--friends {\n  background-image: url('../../img/graphics/friends2.svg');\n  min-height: 600px;\n}\n\n.c-image--crewForAll {\n  background-image: url('../../img/graphics/crewForAll.svg');\n  @include breakpoint(large) {\n    min-height: 800px;\n  }\n}\n\n.c-image--yarnMovement {\n  background-image: url('../../img/heros/yarnMovement.png');\n  object-fit: cover;\n  background-position: -200px center;\n  min-height: 300px;\n  transition: 300ms ease margin-top;\n  @include breakpoint(1500px) {\n    background-size: cover;\n    object-fit: none;\n    background-repeat: no-repeat;\n    background-position: center center;\n    min-height: 550px;\n    margin-top: -6rem;\n  }\n}\n","\n.menu a.c-menu-link--inline {\n  display: inline;\n  padding: 0;\n}\n\n.c-menu--nested {\n  margin-left: 1rem;\n}\n\n.c-menu--bullets li {\n  list-style-type: circle;\n}\n\n.c-menu--nested.menu.vertical li {\n  padding: $menu-items-padding;\n}\n\n.c-dropdown-menu {\n  background-color: $white;\n  padding: 0.5rem;\n  position: absolute;\n  top: 100%;\n  right: 1rem;\n  width: 250px;\n  z-index: 2;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);\n}\n","\n.c-overlay {\n\tposition: fixed;\n\tz-index: 2;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: rgba(0,0,0, 0.5);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.c-modal {\n\tbackground-color: $white;\n\tpadding: 2rem;\n\twidth: 42rem;\n\tborder-radius: 5px;\n\tposition: relative;\n}\n\n.c-modal__close {\n\tposition: absolute;\n\tpadding: 1rem;\n\ttop: 0;\n\tright: 0;\n\tcursor: pointer;\n\tfont-size: 2rem;\n\tcolor: $black;\n\tline-height: 0.5;\n\topacity: 0.5;\n\ttransition: 500ms ease all;\n\n\t&:hover {\n\t\topacity: 1;\n\t}\n}",".c-form--one-field {\n  max-width: 400px;\n}\n\n.c-input__sign-up{\n  display: flex;\n  margin: 0 auto; \n  input[type='email']{\n    border-radius: 3px 0 0 3px;\n    border: 1px solid $light-gray;\n\n  }\n  input[type='submit']{\n    border-radius: 0 3px 3px 0;\n  }\n}",".c-testimonial {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n\n  @include breakpoint(xmedium) {\n    flex-direction: row;\n  }\n\n  &--bubbles {\n    margin: 4rem 0;\n  }\n}\n\n.c-card.c-testimonial__card {\n  margin-left: 1rem;\n  padding: 2rem;\n  background-color: $white;\n  max-width: 700px;\n  z-index: 1;\n}\n\n.c-testimonial__left-bubble {\n  width: 100%;\n  max-width: 300px;\n  position: absolute;\n  left: -5rem;\n}\n\n.c-testimonial__right-bubble {\n  width: 100%;\n  max-width: 100px;\n  position: absolute;\n  right: -2rem;\n  bottom: -1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
